{
 " ao(à) paciente {nome}{cpf}": " (রোগী: {nome}{cpf})",
 " junto ao plano de saúde {c}": " (স্বাস্থ্য বিমা {c})",
 " às {h}": " {h}টায়",
 "\"1\", \"1 / 10\" ou \"Página 1 de 10\", no canto que quiser.": "\"1\", \"1 / 10\" বা \"পৃষ্ঠা 1 / 10\", যে কোণে চান।",
 "\"{nome}\" está no {provedor}.": "\"{nome}\" {provedor}-এ আছে।",
 "\"{nome}\" não é JPG nem PNG. Converta para JPG e tente de novo.": "\"{nome}\" JPG বা PNG নয়। এটিকে JPG-তে রূপান্তর করে আবার চেষ্টা করুন।",
 "\"{nome}\" não é um PDF.": "\"{nome}\" PDF নয়।",
 "\"{nova}\" às {hora} coincide com: {outras}.": "\"{nova}\" {hora}-এ এগুলোর সাথে মিলে যাচ্ছে: {outras}।",
 "\"{n}\" agora é do grupo. Em até 1 minuto os outros membros veem tudo.": "\"{n}\" এখন গ্রুপের। ১ মিনিটের মধ্যে অন্য সদস্যরা সবকিছু দেখতে পাবেন।",
 "\"{titulo}\" foi criada com os mesmos dados.": "\"{titulo}\" একই তথ্য দিয়ে তৈরি করা হয়েছে।",
 "\"{titulo}\" já foi adicionado em {data}.": "\"{titulo}\" {data} তারিখে আগেই যোগ করা হয়েছে।",
 "% ao mês": "% প্রতি মাসে",
 "(No computador do administrador: 32-LIGAR-DRIVE-ONEDRIVE.bat.)": "(অ্যাডমিনের কম্পিউটারে: 32-LIGAR-DRIVE-ONEDRIVE.bat।)",
 "(cópia)": "(কপি)",
 "(sem título)": "(শিরোনামহীন)",
 "+ Adicionar alerta": "+ অ্যালার্ট যোগ করুন",
 "+ Adicionar outra OAB": "+ আরেকটি OAB যোগ করুন",
 "+ Adicionar pausa": "+ বিরতি যোগ করুন",
 "+ Adicionar subtarefa": "+ উপকাজ যোগ করুন",
 "+ Matéria em {nome}": "+ {nome}-এ বিষয়",
 "+ Perfil": "+ প্রোফাইল",
 "+ Subtarefa": "+ উপকাজ",
 "+5 min": "+৫ মিনিট",
 "+{n} acompanhante(s)": "+{n} জন সঙ্গী",
 "+{n} páginas acima da meta": "লক্ষ্যের চেয়ে +{n} পৃষ্ঠা বেশি",
 ", carteirinha nº {n},": ", কার্ড নং {n},",
 ", pago em {d}{f}": ", {d} তারিখে পরিশোধিত{f}",
 "1 cápsula": "1টি ক্যাপসুল",
 "1 dose": "1 ডোজ",
 "1 dose (30 g)": "1 ডোজ (30 g)",
 "1 pessoa": "১ জন",
 "1 publicação nova": "1টি নতুন প্রকাশনা",
 "1 página": "1 পৃষ্ঠা",
 "1 tarja no documento": "নথিতে 1টি কালো দাগ",
 "1. Instale o My Planner e crie sua conta.  2. Abra este link de novo (ou digite o código em Ajustes › Grupos e convites).": "1. My Planner ইনস্টল করে আপনার অ্যাকাউন্ট তৈরি করুন।  2. এই লিংকটি আবার খুলুন (অথবা সেটিংস › গ্রুপ ও আমন্ত্রণ-এ কোড লিখুন)।",
 "1. Quais dados tratamos": "1. আমরা কোন ডেটা প্রক্রিয়া করি",
 "1. Sobre o app": "1. অ্যাপ সম্পর্কে",
 "1ª dose": "১ম ডোজ",
 "2 por folha": "প্রতি শিটে 2",
 "2 xícaras de farinha\n3 ovos\n1 colher de fermento": "২ কাপ ময়দা\n৩টি ডিম\n১ চামচ বেকিং পাউডার",
 "2, 4, 6 ou 9 páginas em cada folha (para imprimir).": "প্রতি শিটে 2, 4, 6 বা 9 পৃষ্ঠা (প্রিন্টের জন্য)।",
 "2. Para que usamos": "2. আমরা কী কাজে ব্যবহার করি",
 "2. Sua conta": "2. আপনার অ্যাকাউন্ট",
 "2ª dose": "২য় ডোজ",
 "3 a 5 g": "3 থেকে 5 g",
 "3. Bases legais (LGPD)": "3. আইনি ভিত্তি (LGPD)",
 "3. Uso correto": "3. সঠিক ব্যবহার",
 "3ª dose": "৩য় ডোজ",
 "4 por folha": "প্রতি শিটে 4",
 "4. Com quem compartilhamos": "4. আমরা কার সঙ্গে শেয়ার করি",
 "4. Planos e testes": "4. প্ল্যান ও ট্রায়াল",
 "5. Limites": "5. সীমাবদ্ধতা",
 "5. Segurança": "5. নিরাপত্তা",
 "6 por folha": "প্রতি শিটে 6",
 "6. Por quanto tempo": "6. কত দিন রাখা হয়",
 "7. Seus direitos (art. 18 da LGPD)": "7. আপনার অধিকার (LGPD-এর art. 18)",
 "8. Crianças e adolescentes": "8. শিশু ও কিশোর",
 "9 por folha": "প্রতি শিটে 9",
 "9. Mudanças": "9. পরিবর্তন",
 "@letra-dom": "র",
 "@letra-qua": "বু",
 "@letra-qui": "বৃ",
 "@letra-sab": "শ",
 "@letra-seg": "সো",
 "@letra-sex": "শু",
 "@letra-ter": "ম",
 "A IA está classificando...": "AI শ্রেণিবিন্যাস করছে...",
 "A IA está lendo a caixa...": "AI বাক্সটি পড়ছে...",
 "A IA lê as páginas e o PDF passa a aceitar busca e cópia.": "AI পৃষ্ঠাগুলো পড়ে, আর PDF-এ খোঁজা ও কপি করা যায়।",
 "A IA lê o PDF e sugere um nome claro.": "AI PDF পড়ে একটি পরিষ্কার নাম প্রস্তাব করে।",
 "A IA não devolveu uma resposta no formato esperado. Tente de novo.": "AI প্রত্যাশিত ফরম্যাটে উত্তর দেয়নি। আবার চেষ্টা করুন।",
 "A IA não encontrou dados para esta ficha no arquivo.": "AI ফাইলে এই কার্ডের কোনো তথ্য পায়নি।",
 "A IA não encontrou tarefas nesta caixa.": "AI এই বাক্সে কোনো কাজ খুঁজে পায়নি।",
 "A IA resume o PDF e responde perguntas.": "AI PDF-এর সারাংশ দেয় এবং প্রশ্নের উত্তর দেয়।",
 "A SEFAZ registra que a nota chegou ao seu conhecimento (não confirma nem recusa a compra) e libera o XML completo na próxima busca, em até 1 hora.": "SEFAZ রেকর্ড করে যে ইনভয়েসটি আপনার নজরে এসেছে (এটি কেনাকাটা নিশ্চিত বা প্রত্যাখ্যান করে না) এবং পরের খোঁজে, ১ ঘণ্টার মধ্যে, সম্পূর্ণ XML দেয়।",
 "A VENCER (7 DIAS)": "শিগগির বাকি (৭ দিন)",
 "A aba inteira": "পুরো ট্যাব",
 "A aba {aba} está perto do limite. Arquive ou apague itens antigos dela.": "{aba} ট্যাব সীমার কাছাকাছি। এর পুরোনো আইটেম আর্কাইভ করুন বা মুছে ফেলুন।",
 "A aba {aba} não está assinada. O vínculo fica guardado e volta ao assinar.": "{aba} ট্যাবটি সাবস্ক্রাইব করা নেই। লিংকটি সংরক্ষিত থাকবে এবং সাবস্ক্রাইব করলে ফিরে আসবে।",
 "A busca de \"{nome}\" está ampla demais. Use o nome completo.": "\"{nome}\"-এর অনুসন্ধান খুব বিস্তৃত। পুরো নাম ব্যবহার করুন।",
 "A busca de GIFs ainda não foi ligada neste app. Enquanto isso, use as figurinhas animadas (🎉).": "এই অ্যাপে GIF খোঁজা এখনও চালু হয়নি। ততক্ষণ অ্যানিমেটেড স্টিকার (🎉) ব্যবহার করুন।",
 "A cada": "প্রতি",
 "A cada N páginas": "প্রতি N পৃষ্ঠায়",
 "A cada quantos dias": "কত দিন পরপর",
 "A cada {n} dia(s)": "প্রতি {n} দিনে",
 "A cada {n} mês(es)": "প্রতি {n} মাসে",
 "A cada {n} mês(es) · dia {d}": "প্রতি {n} মাসে · {d} তারিখ",
 "A cada {n} semana(s)": "প্রতি {n} সপ্তাহে",
 "A cada {n} semana(s) · {dia}": "প্রতি {n} সপ্তাহে · {dia}",
 "A caixa está em {aba}, em \"Anotações recebidas\".": "বাক্সটি {aba}-এ, \"প্রাপ্ত নোট\"-এর মধ্যে আছে।",
 "A caixa foi para {destino}.": "বাক্সটি {destino}-এ পাঠানো হয়েছে।",
 "A chave fica guardada só neste dispositivo, no cofre do sistema. Em outro dispositivo, cadastre de novo.": "কী শুধু এই ডিভাইসে, সিস্টেমের নিরাপদ ভল্টে রাখা থাকে। অন্য ডিভাইসে আবার যোগ করুন।",
 "A chave fica guardada só neste navegador. Use num computador pessoal.": "কী শুধু এই ব্রাউজারে রাখা থাকে। ব্যক্তিগত কম্পিউটারে ব্যবহার করুন।",
 "A conexão é criptografada. O cofre usa criptografia de ponta a ponta (AES-256): nem o suporte consegue ler. O app pode ser bloqueado com senha, desenho ou biometria.": "সংযোগ এনক্রিপ্ট করা। ভল্টে এন্ড-টু-এন্ড এনক্রিপশন (AES-256) ব্যবহার হয়: সাপোর্ট টিমও তা পড়তে পারে না। অ্যাপটি পাসওয়ার্ড, প্যাটার্ন বা বায়োমেট্রিক দিয়ে লক করা যায়।",
 "A confirmação pelo WhatsApp ainda não foi ligada no servidor.": "WhatsApp-এর মাধ্যমে নিশ্চিতকরণ এখনও সার্ভারে চালু করা হয়নি।",
 "A conta e todos os dados guardados na nuvem: tarefas, anotações, abas, fichas, mensagens, arquivos enviados ao app e configurações. Também são apagados os dados deste dispositivo. Não há como desfazer.": "অ্যাকাউন্ট এবং ক্লাউডে রাখা সব ডেটা: কাজ, নোট, ট্যাব, রেকর্ড, বার্তা, অ্যাপে পাঠানো ফাইল ও সেটিংস। এই ডিভাইসের ডেটাও মুছে যায়। এটি ফেরানো যায় না।",
 "A cor aparece na barra, nos títulos e nas tarefas ligadas a esta aba.": "রংটি বার, শিরোনাম এবং এই ট্যাবের সাথে যুক্ত কাজগুলোতে দেখা যায়।",
 "A cor do My Planner é a cor de destaque do app. Cada tarefa pode ter uma cor própria na ficha.": "My Planner-এর রং হলো অ্যাপের প্রধান হাইলাইট রং। প্রতিটি কাজের বিবরণে আলাদা রং দেওয়া যায়।",
 "A data de fim é anterior à de início.": "শেষের তারিখ শুরুর তারিখের আগে।",
 "A data inicial precisa ser antes da final.": "শুরুর তারিখ শেষের তারিখের আগে হতে হবে।",
 "A equipe vai olhar o erro e corrigir numa próxima atualização.": "দল ত্রুটিটি দেখে পরের আপডেটে ঠিক করবে।",
 "A equipe vê e altera conforme o papel de cada um": "দল প্রত্যেকের ভূমিকা অনুযায়ী দেখে ও পরিবর্তন করে",
 "A fazer": "করতে হবে",
 "A foto passa de 8 MB.": "ছবিটি 8 MB-এর বেশি।",
 "A foto é grande demais. Instale o app novo para recortar a foto.": "ছবিটি অনেক বড়। ছবি ক্রপ করতে অ্যাপের নতুন সংস্করণ ইনস্টল করুন।",
 "A função \"nuvem\" ainda não foi publicada no servidor. Rode o 32-LIGAR-DRIVE-ONEDRIVE.bat.": "\"nuvem\" ফাংশনটি এখনও সার্ভারে প্রকাশিত হয়নি। 32-LIGAR-DRIVE-ONEDRIVE.bat চালান।",
 "A função \"nuvem\" ainda não foi publicada no servidor. Rode o 9-LIGAR-DRIVE-ONEDRIVE.bat (veja COMO RODAR, versão 0.15.1).": "\"nuvem\" ফাংশন এখনও সার্ভারে প্রকাশিত হয়নি। 9-LIGAR-DRIVE-ONEDRIVE.bat চালান (COMO RODAR, সংস্করণ 0.15.1 দেখুন)।",
 "A gravação ainda está sendo preparada. Tente de novo em alguns minutos.": "রেকর্ডিং এখনও তৈরি হচ্ছে। কয়েক মিনিট পরে আবার চেষ্টা করুন।",
 "A hora fica marcada neste fuso. Em outro fuso, o app mostra e avisa no horário convertido.": "সময় এই টাইম জোনে নির্ধারিত থাকে। অন্য টাইম জোনে অ্যাপ রূপান্তরিত সময়ে দেখায় ও জানায়।",
 "A imagem original não está neste dispositivo.": "মূল ছবিটি এই ডিভাইসে নেই।",
 "A pagar": "দেওয়া বাকি",
 "A pagar: {v}": "দেওয়া বাকি: {v}",
 "A permissão da agenda foi retirada. Libere de novo nas configurações do celular.": "ক্যালেন্ডারের অনুমতি সরিয়ে নেওয়া হয়েছে। ফোনের সেটিংসে গিয়ে আবার অনুমতি দিন।",
 "A pessoa sai do grupo e deixa de receber os envios.": "ব্যক্তিটি গ্রুপ ছেড়ে যাবেন এবং আর কিছু পাবেন না।",
 "A receber": "পাওনা",
 "A receber: {v}": "পাওনা: {v}",
 "A reunião ainda está sendo gravada.": "মিটিং এখনও রেকর্ড হচ্ছে।",
 "A senha atual não confere.": "বর্তমান পাসওয়ার্ড মিলছে না।",
 "A senha do cofre precisa ter 6 caracteres ou mais.": "ভল্টের পাসওয়ার্ড কমপক্ষে ৬ অক্ষরের হতে হবে।",
 "A senha precisa ter 8 caracteres ou mais.": "পাসওয়ার্ডে ৮ বা তার বেশি অক্ষর থাকতে হবে।",
 "A senha precisa ter pelo menos 8 caracteres.": "পাসওয়ার্ডে কমপক্ষে ৮টি অক্ষর থাকতে হবে।",
 "A senha é a mesma no celular e no My Planner Web.": "ফোন এবং My Planner Web-এ পাসওয়ার্ড একই।",
 "A sincronização roda ao abrir o app e depois de cada alteração. Tarefas ligadas à agenda mostram 📆.": "অ্যাপ খুললে এবং প্রতিটি পরিবর্তনের পরে সিঙ্ক হয়। ক্যালেন্ডারের সাথে যুক্ত কাজে 📆 দেখা যায়।",
 "A sua equipe num lugar só": "আপনার টিম এক জায়গায়",
 "A tarefa da casa não entra no My Planner sozinha. \"Enviar para o My Planner\" abre a ficha completa para escolher dia, horário, frequência, pausas e alertas.": "ঘরের কাজ নিজে থেকে My Planner-এ যায় না। \"My Planner-এ পাঠান\" পুরো ফর্ম খোলে, যেখানে দিন, সময়, পুনরাবৃত্তি, বিরতি ও অ্যালার্ট বেছে নিতে পারেন।",
 "A validade não pode ser antes da emissão.": "মেয়াদ ইস্যুর তারিখের আগে হতে পারে না।",
 "A versão para iPhone chega em breve na App Store. Enquanto isso, use o My Planner Web.": "iPhone সংস্করণ শিগগিরই App Store-এ আসছে। ততদিন My Planner Web ব্যবহার করুন।",
 "A versão para iPhone chega em breve na App Store. Enquanto isso, use o My Planner Web: no Safari, toque em Compartilhar > Adicionar à Tela de Início para ele virar um ícone no celular.": "iPhone সংস্করণ শিগগিরই App Store-এ আসছে। ততদিন My Planner Web ব্যবহার করুন: Safari-তে শেয়ার করুন > হোম স্ক্রিনে যোগ করুন ট্যাপ করুন, তাহলে এটি মোবাইলে একটি আইকন হয়ে যাবে।",
 "A4, Carta, A5 ou Ofício, sem cortar nada.": "A4, লেটার, A5 বা লিগ্যাল, কিছু না কেটে।",
 "ADICIONAR AMIGO": "বন্ধু যোগ করুন",
 "AGUARDANDO RESPOSTA": "উত্তরের অপেক্ষায়",
 "AMIGOS": "বন্ধুরা",
 "ANOTAÇÕES": "নোট",
 "ANOTAÇÕES RECEBIDAS · {aba}": "প্রাপ্ত নোট · {aba}",
 "ATIVIDADE": "কার্যকলাপ",
 "ATIVIDADE FÍSICA": "শারীরিক কার্যকলাপ",
 "ATRASADAS": "বিলম্বিত",
 "Aba": "ট্যাব",
 "Aba bloqueada": "ট্যাব লক করা",
 "Aba {nome}": "{nome} ট্যাব",
 "Abas": "ট্যাব",
 "Abas liberadas pelo suporte": "সাপোর্ট দ্বারা খোলা ট্যাব",
 "Abas para comprar": "কেনার জন্য ট্যাব",
 "Abas que você já tem": "আপনার কাছে থাকা ট্যাব",
 "Abastecimento": "জ্বালানি ভরা",
 "Abastecimentos": "জ্বালানি ভরা",
 "Abdominal": "ক্রাঞ্চ",
 "Abertura do prazo da declaração do IR": "আয়কর রিটার্ন জমার সময় শুরু",
 "Abra a empresa e toque em \"Buscar notas\" para digitar a senha do cofre.": "প্রতিষ্ঠান খুলে ভল্টের পাসওয়ার্ড দিতে \"ইনভয়েস খুঁজুন\"-এ ট্যাপ করুন।",
 "Abra o My Planner Anne e entre com o seu CPF e senha.": "My Planner Anne খুলে আপনার পরিচয় নম্বর ও পাসওয়ার্ড দিয়ে প্রবেশ করুন।",
 "Abra o My Planner no celular.": "মোবাইলে My Planner খুলুন।",
 "Abra o cofre": "ভল্ট খুলুন",
 "Abra um PDF para começar.": "শুরু করতে একটি PDF খুলুন।",
 "Abra uma matéria e toque em \"Estudar agora\" para cronometrar. Defina metas semanais em cada matéria.": "সময় মাপতে একটি বিষয় খুলে \"এখন পড়ুন\" ট্যাপ করুন। প্রতিটি বিষয়ে সাপ্তাহিক লক্ষ্য ঠিক করুন।",
 "Abraço": "আলিঙ্গন",
 "Abre a janela do celular: WhatsApp, e-mail, Google Drive, OneDrive, salvar em Arquivos e outros.": "ফোনের শেয়ার মেনু খোলে: WhatsApp, ইমেল, Google Drive, OneDrive, Files-এ সেভ এবং আরও।",
 "Abre o PDF para ler aqui mesmo.": "PDF এখানেই পড়ার জন্য খোলে।",
 "Abre o Scanner PDF (bordas e sombras corrigidas).": "PDF স্ক্যানার খোলে (কিনারা ও ছায়া ঠিক করা)।",
 "Abrir": "খুলুন",
 "Abrir Ajustes": "সেটিংস খুলুন",
 "Abrir PDF": "PDF খুলুন",
 "Abrir PDF do celular, Drive ou OneDrive": "মোবাইল, Drive বা OneDrive থেকে PDF খুলুন",
 "Abrir a aba": "ট্যাব খুলুন",
 "Abrir a cópia guardada": "সংরক্ষিত কপি খুলুন",
 "Abrir a pasta no Drive": "Drive-এ ফোল্ডার খুলুন",
 "Abrir com outro app": "অন্য অ্যাপে খুলুন",
 "Abrir configurações": "সেটিংস খুলুন",
 "Abrir em outro app": "অন্য অ্যাপে খুলুন",
 "Abrir no DJEN": "DJEN-এ খুলুন",
 "Abrir no modo seguro": "নিরাপদ মোডে খুলুন",
 "Abrir normalmente": "স্বাভাবিকভাবে খুলুন",
 "Abrir nota fiscal": "চালান খুলুন",
 "Abrir o PDF": "PDF খুলুন",
 "Abrir o PDF no {nome}": "{nome}-এ PDF খুলুন",
 "Abrir o XML": "XML খুলুন",
 "Abrir o app": "অ্যাপ খুলুন",
 "Abrir o app My Planner": "My Planner অ্যাপ খুলুন",
 "Abrir o cartão": "কার্ড খুলুন",
 "Abrir o cofre": "ভল্ট খুলুন",
 "Abrir o cofre para ver": "দেখতে ভল্ট খুলুন",
 "Abrir o diário oficial": "সরকারি গেজেট খুলুন",
 "Abrir ou baixar": "খুলুন বা ডাউনলোড করুন",
 "Abrir página": "পৃষ্ঠা খুলুন",
 "Abrir site": "ওয়েবসাইট খুলুন",
 "Abrir {nome}": "{nome} খুলুন",
 "Acabamento": "ফিনিশিং",
 "Acabou": "শেষ হয়ে গেছে",
 "Academia": "জিম",
 "Aceitar": "গ্রহণ",
 "Aceitar, editar ou recusar": "গ্রহণ, সম্পাদনা বা প্রত্যাখ্যান",
 "Aceite os termos para continuar.": "চালিয়ে যেতে শর্তাবলি গ্রহণ করুন।",
 "Aceito": "গৃহীত",
 "Aceito com alterações": "পরিবর্তনসহ গৃহীত",
 "Acerto de contas": "হিসাব মেটানো",
 "Acerto de contas: {v}": "হিসাব মেটানো: {v}",
 "Acessibilidade": "প্রবেশযোগ্যতা",
 "Acesso ilimitado": "সীমাহীন অ্যাক্সেস",
 "Acesso ilimitado a todas as funções, sem prazo": "সব ফিচারে সীমাহীন অ্যাক্সেস, কোনো মেয়াদ ছাড়া",
 "Achatar": "ফ্ল্যাট করুন",
 "Acompanha tudo, inclusive os gastos, e registra no diário.": "খরচসহ সবকিছু দেখেন এবং ডায়েরিতে লেখেন।",
 "Acompanhamento": "সাইড ডিশ",
 "Acompanhantes": "সঙ্গী",
 "Acrescentar no fim da página": "পৃষ্ঠার শেষে যোগ করুন",
 "Adaptador de tomada": "প্লাগ অ্যাডাপ্টার",
 "Adestramento": "প্রশিক্ষণ",
 "Adicionar": "যোগ করুন",
 "Adicionar amigo": "বন্ধু যোগ করুন",
 "Adicionar amigos do app": "অ্যাপের বন্ধুদের যোগ করুন",
 "Adicionar ao Planner?": "Planner-এ যোগ করবেন?",
 "Adicionar arquivo": "ফাইল যোগ করুন",
 "Adicionar cômodo": "ঘর যোগ করুন",
 "Adicionar fotos e vídeos": "ছবি ও ভিডিও যোগ করুন",
 "Adicionar imagem": "ছবি যোগ করুন",
 "Adicionar item (ex.: 2 ovos mexidos)": "আইটেম যোগ করুন (যেমন: ২টি ডিম ভাজা)",
 "Adicionar na página": "পৃষ্ঠায় যোগ করুন",
 "Adicionar passo": "ধাপ যোগ করুন",
 "Adicionar país": "দেশ যোগ করুন",
 "Adicionar página": "পৃষ্ঠা যোগ করুন",
 "Adicionar texto": "লেখা যোগ করুন",
 "Adicionar {nome}": "{nome} যোগ করুন",
 "Adicionar à equipe": "টিমে যোগ করুন",
 "Adicione um amigo pelo código dele ou mande o seu código para quem você quer.": "বন্ধুর কোড দিয়ে তাকে যোগ করুন, অথবা যাকে চান তাকে আপনার কোড পাঠান।",
 "Admin": "অ্যাডমিন",
 "Administração": "ব্যবস্থাপনা",
 "Adubar a cada quantos dias": "কত দিন পরপর সার দেবেন",
 "Adubar: {p}": "সার দিন: {p}",
 "Adubei hoje": "আজ সার দিয়েছি",
 "Advogado": "আইনজীবী",
 "Advogados": "আইনজীবী",
 "Afundo": "লাঞ্জ",
 "Agachamento": "স্কোয়াট",
 "Agenda do Google": "Google ক্যালেন্ডার",
 "Agenda limpa": "এজেন্ডা খালি",
 "Agenda não liberada": "ক্যালেন্ডারের অনুমতি নেই",
 "Agenda sincronizada ✓": "ক্যালেন্ডার সিঙ্ক হয়েছে ✓",
 "Agenda, anotações, finanças, estudos, mensagens e muito mais num app só.": "এজেন্ডা, নোট, অর্থ, পড়াশোনা, মেসেজ এবং আরও অনেক কিছু এক অ্যাপেই।",
 "Agenda, cadastro dos pacientes e pagamentos, sem o prontuário.": "অ্যাপয়েন্টমেন্ট, রোগীর তথ্য ও পেমেন্ট, মেডিকেল রেকর্ড ছাড়া।",
 "Agendado": "নির্ধারিত",
 "Agendado no My Planner": "My Planner-এ নির্ধারিত",
 "Agendamento no pet shop": "পেট শপে অ্যাপয়েন্টমেন্ট",
 "Agendar": "সময়সূচিতে রাখুন",
 "Agendar no My Planner": "My Planner-এ নির্ধারণ করুন",
 "Agendar no My Planner (dias e horários)": "My Planner-এ নির্ধারণ করুন (দিন ও সময়)",
 "Agora não": "এখন নয়",
 "Agora o verso do documento.": "এবার নথির পেছনের দিক।",
 "Agora, {hora}": "এখন, {hora}",
 "Agora: {ml}": "এখন: {ml}",
 "Aguardando o celular · {s}s": "মোবাইলের অপেক্ষায় · {s} সে.",
 "Aguarde": "অপেক্ষা করুন",
 "Aguarde um pouco": "একটু অপেক্ষা করুন",
 "Aguarde...": "অপেক্ষা করুন...",
 "Ainda a pagar no mês": "এই মাসে এখনও দিতে বাকি",
 "Ainda a receber no mês": "এই মাসে এখনও পেতে বাকি",
 "Ainda não confirmado": "এখনও নিশ্চিত করা হয়নি",
 "Ainda não disponível: falta configurar no servidor.": "এখনও উপলব্ধ নয়: সার্ভারে সেটআপ বাকি আছে।",
 "Ainda não guardou nada este mês. Que tal separar {v} (10% do que entrou) assim que o dinheiro cair?": "এই মাসে এখনো কিছু জমাননি। টাকা আসামাত্র {v} (আয়ের 10%) আলাদা করে রাখলে কেমন হয়?",
 "Ainda não há feriados deste país para este ano.": "এই দেশের এ বছরের ছুটির দিন এখনও নেই।",
 "Ainda não há nada nesta aba para compartilhar. Crie primeiro (ex.: a viagem) e volte aqui.": "এই ট্যাবে এখনো শেয়ার করার মতো কিছু নেই। আগে তৈরি করুন (যেমন: ভ্রমণ) তারপর এখানে ফিরে আসুন।",
 "Ainda não há outras pessoas no grupo (ou você não vê a lista de membros).": "গ্রুপে এখনো অন্য কেউ নেই (অথবা আপনি সদস্যদের তালিকা দেখতে পাচ্ছেন না)।",
 "Ainda não marcado como feito. Toque para abrir.": "এখনও সম্পন্ন হিসেবে চিহ্নিত নয়। খুলতে ট্যাপ করুন।",
 "Ainda não sincronizado": "এখনো সিঙ্ক হয়নি",
 "Ainda sem chave neste dispositivo.": "এই ডিভাইসে এখনও কোনো কী নেই।",
 "Airbnb": "Airbnb",
 "Airbnb, Booking ou direto: reservas, limpeza no check-out, receitas, despesas e lucro do mês": "Airbnb, Booking বা সরাসরি: বুকিং, চেক-আউটে পরিষ্কার, আয়, খরচ ও মাসের লাভ",
 "Ajuda na organização": "আয়োজনে সহায়তা",
 "Ajudante": "সহকারী",
 "Ajustar": "সম্পাদনা",
 "Ajustar a data final": "শেষের তারিখ ঠিক করুন",
 "Ajustar a folha": "পাতা ঠিক করুন",
 "Ajustar tamanho da página": "পৃষ্ঠার আকার ঠিক করুন",
 "Ajuste visual": "দেখার সমন্বয়",
 "Ajustes": "সেটিংস",
 "Alarme dos remédios": "ওষুধের অ্যালার্ম",
 "Alarme que insiste até marcar como tomado": "নেওয়া হয়েছে চিহ্নিত না করা পর্যন্ত বাজতে থাকা অ্যালার্ম",
 "Alemão": "জার্মান",
 "Alergia": "অ্যালার্জি",
 "Alergias": "অ্যালার্জি",
 "Alergias e alertas": "অ্যালার্জি ও সতর্কতা",
 "Alertas": "অ্যালার্ট",
 "Alertas das tarefas": "কাজের অ্যালার্ট",
 "Alertas dos compromissos": "অ্যাপয়েন্টমেন্টের সতর্কবার্তা",
 "Algo deu errado, mas o app continua aberto": "কিছু সমস্যা হয়েছে, তবে অ্যাপ খোলা আছে",
 "Alguns arquivos foram guardados em outro dispositivo.": "কিছু ফাইল অন্য ডিভাইসে সংরক্ষিত আছে।",
 "Alguns relógios (como os da Huawei) podem não enviar dados para o Health Connect. Nesse caso, digite à mão.": "কিছু ঘড়ি (যেমন Huawei-এর) Health Connect-এ ডেটা পাঠাতে না-ও পারে। সেক্ষেত্রে হাতে লিখে দিন।",
 "Alguém": "কেউ একজন",
 "Alguém indicou o app para você?": "কেউ কি আপনাকে অ্যাপটি সুপারিশ করেছেন?",
 "Alimentação": "খাবার",
 "Alimentação & Despensa": "খাবার ও ভাঁড়ার",
 "Alimentação {semana}": "খাবার {semana}",
 "Alimento": "খাবার",
 "Alinhamento e balanceamento": "অ্যালাইনমেন্ট ও ব্যালান্সিং",
 "Almoço": "দুপুরের খাবার",
 "Alongamento": "স্ট্রেচিং",
 "Alta": "উচ্চ",
 "Alterado por último por {nome}": "শেষ পরিবর্তন করেছেন {nome}",
 "Alterar metadados": "মেটাডেটা বদলান",
 "Alterar o valor pago": "পরিশোধিত অর্থ পরিবর্তন",
 "Alterações": "পরিবর্তন",
 "Alto-falante": "স্পিকার",
 "Aluga como": "যেভাবে ভাড়া দেন",
 "Alugar a casa ou um cômodo": "বাড়ি বা একটি ঘর ভাড়া দিন",
 "Aluguel": "ভাড়া",
 "Aluguel & Hospedagem": "ভাড়া ও হোমস্টে",
 "Aluguel de carro": "গাড়ি ভাড়া",
 "Aluno": "শিক্ষার্থী",
 "Alunos": "শিক্ষার্থীরা",
 "Alvará ou licença": "অনুমতিপত্র বা লাইসেন্স",
 "Alvenaria": "গাঁথুনি",
 "Alvo": "লক্ষ্য অঙ্ক",
 "Alíquota do ISS (%)": "ISS হার (%)",
 "Alíquota do ISS deste serviço (%)": "এই সেবার ISS হার (%)",
 "Amanhã": "আগামীকাল",
 "Ambiente": "পরিবেশ",
 "Ameno": "মনোরম",
 "Amigos": "বন্ধুরা",
 "Amor": "ভালোবাসা",
 "Amortização": "আসল পরিশোধ",
 "Ampliar a foto": "ছবি বড় করুন",
 "Amém": "আমিন",
 "Analisar com IA": "AI দিয়ে বিশ্লেষণ",
 "Anamnese e histórico (no cofre)": "রোগের বিবরণ ও ইতিহাস (ভল্টে)",
 "Anexar arquivos": "ফাইল সংযুক্ত করুন",
 "Anexar comprovante": "রসিদ যুক্ত করুন",
 "Anexar documentos, importar extratos e salvar relatórios, PDFs e cópias de segurança.": "ডকুমেন্ট সংযুক্ত করা, ব্যাংক স্টেটমেন্ট ইমপোর্ট করা এবং রিপোর্ট, PDF ও ব্যাকআপ সেভ করা।",
 "Anexos": "সংযুক্তি",
 "Anexos guardados aqui no dispositivo: {n}": "এই ডিভাইসে রাখা সংযুক্তি: {n}",
 "Animais e natureza": "প্রাণী ও প্রকৃতি",
 "Animação": "অ্যানিমেশন",
 "Anime": "অ্যানিমে",
 "Aniversário": "জন্মদিন",
 "Aniversário de Campo Grande": "Campo Grande-এর প্রতিষ্ঠা দিবস",
 "Aniversário de São Paulo": "São Paulo-এর প্রতিষ্ঠা দিবস",
 "Ano": "বছর",
 "Ano anterior": "আগের বছর",
 "Ano de lançamento": "মুক্তির বছর",
 "Ano de {ano}": "{ano} সাল",
 "Ano passado": "গত বছর",
 "Anotar pela foto da página": "পাতার ছবি থেকে নোট নিন",
 "Anotação": "নোট",
 "Anotação de {data}": "{data}-এর নোট",
 "Anotação do professor": "শিক্ষকের নোট",
 "Anotação à mão": "হাতে লেখা নোট",
 "Anotações": "নোট",
 "Anotações Rápidas": "দ্রুত নোট",
 "Anotações arquivadas": "আর্কাইভ করা নোট",
 "Anotações arquivadas ({n})": "আর্কাইভ করা নোট ({n})",
 "Anote cada reserva com as datas, a origem e os valores. A limpeza do check-out entra sozinha na lista de limpezas.": "প্রতিটি বুকিংয়ের তারিখ, উৎস ও টাকার পরিমাণ লিখুন। চেক-আউটের পরিষ্কার নিজে থেকেই পরিষ্কারের তালিকায় যোগ হয়।",
 "Anote o dia a dia da obra com fotos. Marque as fotos como Antes ou Depois para ver a evolução.": "নির্মাণকাজের প্রতিদিনের খবর ছবিসহ লিখুন। অগ্রগতি দেখতে ছবিগুলোকে আগে বা পরে হিসেবে চিহ্নিত করুন।",
 "Anote o que emprestou ou pegou emprestado, com foto e prazo. O app avisa no dia da devolução.": "যা ধার দিয়েছেন বা নিয়েছেন, ছবি ও সময়সীমাসহ লিখে রাখুন। ফেরতের দিনে অ্যাপ মনে করিয়ে দেবে।",
 "Anote os lugares que quer conhecer. Pesquise no Google Maps ou no Waze, trace a rota passando por todos e coloque no roteiro do dia.": "যেসব জায়গায় যেতে চান, লিখে রাখুন। Google Maps বা Waze-এ খুঁজুন, সবগুলো ছুঁয়ে যাওয়ার রুট তৈরি করুন এবং দিনের ভ্রমণসূচিতে যোগ করুন।",
 "Anteriores ({n})": "আগের ({n})",
 "Antes": "আগে",
 "Antes de começar, confira o que o app usa e por quê. Você pode mudar tudo depois em Ajustes > Privacidade e termos.": "শুরু করার আগে দেখে নিন অ্যাপটি কী ব্যবহার করে এবং কেন। পরে সেটিংস > গোপনীয়তা ও শর্তাবলি থেকে সব বদলাতে পারবেন।",
 "Antes de uma data": "একটি তারিখের আগে",
 "Antes do início": "শুরুর আগে",
 "Antes e depois": "আগে ও পরে",
 "Antes: {lista}": "আগে: {lista}",
 "Antipulgas": "মাছিনাশক",
 "Anual": "বার্ষিক",
 "Ao ar livre": "বাইরে",
 "Ao cancelar, a aba fica em preto e branco e os vínculos somem das tarefas, mas nada é apagado.": "বাতিল করলে ট্যাবটি সাদা-কালো হয়ে যাবে এবং কাজ থেকে লিংকগুলো সরে যাবে, তবে কিছুই মুছবে না।",
 "Ao criar a conta ou continuar usando o app, você concorda com estes termos e com a política de privacidade abaixo.": "অ্যাকাউন্ট তৈরি করে বা অ্যাপটি ব্যবহার চালিয়ে গিয়ে আপনি এই শর্তাবলি এবং নিচের গোপনীয়তা নীতিতে সম্মত হচ্ছেন।",
 "Ao fechar, a página é salva.": "বন্ধ করলে পৃষ্ঠাটি সংরক্ষিত হবে।",
 "Ao salvar, você cria a senha do cofre. Este campo é criptografado no dispositivo.": "সংরক্ষণ করলে ভল্টের পাসওয়ার্ড তৈরি হবে। এই ঘরটি ডিভাইসেই এনক্রিপ্ট করা হয়।",
 "Ao tocar em \"Arquivo\" ou \"Foto\" em Estudos e Documentos, o seletor do celular mostra o Google Drive, o OneDrive e o Dropbox (quando os apps estão instalados). Escolha o arquivo direto de lá.": "পড়াশোনা ও নথি-তে \"ফাইল\" বা \"ছবি\" ট্যাপ করলে ফোনের নির্বাচক Google Drive, OneDrive ও Dropbox দেখায় (অ্যাপগুলো ইনস্টল থাকলে)। সরাসরি সেখান থেকে ফাইল বেছে নিন।",
 "Ao tocar num arquivo anexado, ele abre no app do celular que você escolher (no Android, \"Apenas uma vez\" ou \"Sempre\"). O que você editar lá fica salvo no próprio arquivo.": "সংযুক্ত ফাইলে ট্যাপ করলে আপনার বেছে নেওয়া ফোনের অ্যাপে খুলবে (Android-এ \"শুধু একবার\" বা \"সবসময়\")। সেখানে যা সম্পাদনা করবেন তা ফাইলেই সংরক্ষিত হবে।",
 "Apaga a conta e todos os vencimentos dela.": "বিলটি এবং এর সব নির্ধারিত তারিখ মুছে দেয়।",
 "Apaga as matérias e páginas deste fichário. As tarefas do planner continuam.": "এই বাইন্ডারের বিষয় ও পৃষ্ঠাগুলো মুছে ফেলে। প্ল্যানারের কাজগুলো থেকে যাবে।",
 "Apaga as páginas desta matéria. O tempo estudado continua no histórico.": "এই বিষয়ের পৃষ্ঠাগুলো মুছে ফেলে। পড়ার সময় ইতিহাসে থেকে যাবে।",
 "Apaga o cartão e as compras dele.": "কার্ড এবং এর কেনাকাটা মুছে দেয়।",
 "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Não há como desfazer.": "অ্যাকাউন্ট এবং ক্লাউড ও এই ডিভাইসের সব তথ্য চিরতরে মুছে ফেলে। এটি ফেরানো যাবে না।",
 "Apaga todas as tarefas da agenda, passadas e futuras.": "এজেন্ডার সব কাজ মুছে দেয়, অতীতের ও ভবিষ্যতের।",
 "Apaga todas as {n} parcelas.": "সব {n}টি কিস্তি মুছে ফেলে।",
 "Apaga todos os meses desta conta.": "এই বিলের সব মাস মুছে যাবে।",
 "Apagar": "মুছুন",
 "Apagar \"{nome}\"?": "\"{nome}\" মুছবেন?",
 "Apagar a caixa?": "বাক্সটি মুছবেন?",
 "Apagar a chave": "কী মুছুন",
 "Apagar a chave deste dispositivo?": "এই ডিভাইস থেকে কী মুছবেন?",
 "Apagar a conta?": "অ্যাকাউন্ট মুছবেন?",
 "Apagar a lista de erros?": "ত্রুটির তালিকা মুছবেন?",
 "Apagar a pasta (os documentos continuam)": "ফোল্ডার মুছুন (নথিগুলো থেকে যাবে)",
 "Apagar as da agenda": "ক্যালেন্ডারেরগুলো মুছুন",
 "Apagar caixa": "বাক্স মুছুন",
 "Apagar de verdade (as páginas com tarja viram imagem)": "সত্যিই মুছুন (কালো দাগের পৃষ্ঠাগুলো ছবি হয়ে যায়)",
 "Apagar de vez": "স্থায়ীভাবে মুছুন",
 "Apagar desenho": "আঁকা মুছুন",
 "Apagar envio": "পাঠানোটি মুছুন",
 "Apagar lista": "তালিকা মুছুন",
 "Apagar minha conta": "আমার অ্যাকাউন্ট মুছুন",
 "Apagar minha conta e todos os dados": "আমার অ্যাকাউন্ট ও সব তথ্য মুছুন",
 "Apagar o escritório": "অফিস মুছুন",
 "Apagar o escritório?": "অফিস মুছবেন?",
 "Apagar o grupo": "গ্রুপ মুছুন",
 "Apagar o grupo?": "গ্রুপ মুছবেন?",
 "Apagar o lançamento?": "এই এন্ট্রি মুছবেন?",
 "Apagar para todos": "সবার জন্য মুছুন",
 "Apagar tudo": "সব মুছুন",
 "Apagar tudo antes de": "এর আগের সব মুছুন",
 "Apague de uma vez as tarefas de hoje, do mês, de um período ou pelo nome. Antes de apagar, o app mostra o que vai sair e pede a sua senha.": "আজকের, এই মাসের, একটি সময়কালের বা নাম অনুযায়ী কাজ একবারে মুছে ফেলুন। মোছার আগে অ্যাপ দেখায় কী মুছে যাবে এবং আপনার পাসওয়ার্ড চায়।",
 "Aparece na barra quando estiver liberada": "চালু হলে বারে দেখা যাবে",
 "Aparecem no Planner, junto com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpus Christi).": "Planner-এ দেখা যায়, ঐচ্ছিক ছুটির দিনগুলোর সঙ্গে (কার্নিভাল, অ্যাশ ওয়েনেসডে ও কর্পাস ক্রিস্টি)।",
 "Aplicar": "প্রয়োগ করুন",
 "Aponte a câmera do celular para este QR Code.": "এই QR Code-এর দিকে মোবাইলের ক্যামেরা ধরুন।",
 "Aponte para o QR Code na tela do computador": "কম্পিউটারের স্ক্রিনের QR Code-এর দিকে ধরুন",
 "Apostila": "হ্যান্ডআউট",
 "Apostilas, listas, slides, vídeos, links e recados. Pelo ⋮ › Enviar para um grupo, cada aluno recebe no app dele.": "হ্যান্ডআউট, অনুশীলনী, স্লাইড, ভিডিও, লিংক ও বার্তা। ⋮ › একটি গ্রুপে পাঠান দিয়ে প্রত্যেক শিক্ষার্থী নিজের অ্যাপে পায়।",
 "App usado no botão \"Rota\" dos endereços (tarefas, consultas, roteiro da viagem, obras, escola...).": "ঠিকানার \"রুট\" বোতামে ব্যবহৃত অ্যাপ (কাজ, অ্যাপয়েন্টমেন্ট, ভ্রমণসূচি, নির্মাণকাজ, স্কুল...)।",
 "Apple Saúde": "Apple Health",
 "Apple Watch: já grava tudo no app Saúde do iPhone. Não precisa fazer nada.": "Apple Watch: এটি আগে থেকেই সবকিছু iPhone-এর Health অ্যাপে সেভ করে। কিছু করার দরকার নেই।",
 "Apresentação": "উপস্থাপনা",
 "Aprovação": "অনুমোদন",
 "Aqui": "এখানে",
 "Ar-condicionado": "এয়ার কন্ডিশনার",
 "Arco-íris": "রংধনু",
 "Arenoso": "বেলে মাটি",
 "Armazenamento": "স্টোরেজ",
 "Armário": "আলমারি",
 "Arquivadas ({n})": "আর্কাইভ করা ({n})",
 "Arquivados ({n})": "আর্কাইভ ({n})",
 "Arquivar": "আর্কাইভ করুন",
 "Arquivar a caixa de anotações?": "নোটের বাক্সটি আর্কাইভ করবেন?",
 "Arquivar conversa": "চ্যাট আর্কাইভ করুন",
 "Arquivo": "ফাইল",
 "Arquivo (Drive, OneDrive, Dropbox ou do dispositivo)": "ফাইল (Drive, OneDrive, Dropbox বা ডিভাইস থেকে)",
 "Arquivo OFX ou CSV do banco": "ব্যাংকের OFX বা CSV ফাইল",
 "Arquivo adicionado": "ফাইল যোগ করা হয়েছে",
 "Arquivo menor (para WhatsApp e e-mail)": "ছোট ফাইল (WhatsApp ও ইমেলের জন্য)",
 "Arquivo menor para WhatsApp e e-mail.": "WhatsApp ও ইমেলের জন্য ছোট ফাইল।",
 "Arquivo não encontrado.": "ফাইল পাওয়া যায়নি।",
 "Arquivo ou PDF": "ফাইল বা PDF",
 "Arquivo ou documento": "ফাইল বা ডকুমেন্ট",
 "Arquivos": "ফাইল",
 "Arquivos (frente, verso, PDF)": "ফাইল (সামনে, পেছনে, PDF)",
 "Arquivos (importar e exportar)": "ফাইল (ইমপোর্ট ও এক্সপোর্ট)",
 "Arquivos de {nome}": "{nome}-এর ফাইল",
 "Arquivos na nuvem e cópias de segurança": "ক্লাউডে ফাইল ও ব্যাকআপ",
 "Arrasou!": "দুর্দান্ত!",
 "Arraste as bolinhas até as 4 pontas da folha. O app recorta e endireita a página.": "বিন্দুগুলো পাতার 4 কোণে টেনে আনুন। অ্যাপ পৃষ্ঠাটি কেটে সোজা করে দেবে।",
 "Arraste o dedo sobre o que quer esconder. Toque numa tarja para tirar.": "যা লুকাতে চান তার ওপর আঙুল টানুন। দাগ সরাতে তাতে ট্যাপ করুন।",
 "Arraste para a direita para excluir, ou para a esquerda para enviar a outra aba.": "মুছতে ডানে সোয়াইপ করুন, অন্য ট্যাবে পাঠাতে বাঁয়ে।",
 "Arraste para a direita para excluir.": "মুছতে ডানদিকে সোয়াইপ করুন।",
 "Arraste para mudar a ordem, gire, duplique, apague e ponha página em branco.": "ক্রম বদলাতে টানুন, ঘোরান, ডুপ্লিকেট করুন, মুছুন এবং ফাঁকা পৃষ্ঠা যোগ করুন।",
 "Arraste para ver o resto do quadro. Ele cresce para baixo e para a direita.": "বোর্ডের বাকি অংশ দেখতে টেনে আনুন। এটি নিচে ও ডানদিকে বাড়ে।",
 "Arraste um documento para a direita para excluir.": "মুছতে কোনো নথি ডানদিকে সোয়াইপ করুন।",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir.": "আর্কাইভ করতে বাক্সটি বাঁদিকে আর মুছতে ডানদিকে সোয়াইপ করুন।",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir. Segure ⋮⋮ para mudar a ordem.": "আর্কাইভ করতে বক্সটি বাঁ দিকে, মুছতে ডান দিকে টানুন। ক্রম বদলাতে ⋮⋮ চেপে ধরে রাখুন।",
 "Arroz": "ভাত",
 "Artes": "শিল্পকলা",
 "As assinaturas Claude Pro, ChatGPT Plus e Gemini Advanced não podem ser usadas por outros apps. Para ligar a IA aqui, crie uma chave de API na sua conta (o Gemini tem uso gratuito; Claude e ChatGPT cobram por uso, centavos por análise).": "Claude Pro, ChatGPT Plus ও Gemini Advanced সাবস্ক্রিপশন অন্য অ্যাপ ব্যবহার করতে পারে না। এখানে AI চালু করতে আপনার অ্যাকাউন্টে একটি API কী তৈরি করুন (Gemini বিনামূল্যে ব্যবহার করা যায়; Claude ও ChatGPT ব্যবহার অনুযায়ী চার্জ নেয়, প্রতি বিশ্লেষণে সামান্য খরচ)।",
 "As chamadas ainda não foram ligadas no servidor (17-LIGAR-MENSAGENS.bat).": "সার্ভারে কল এখনও চালু করা হয়নি (17-LIGAR-MENSAGENS.bat)।",
 "As compras dele também saem das Finanças.": "এর কেনাকাটাগুলোও অর্থায়ন থেকে মুছে যাবে।",
 "As compras parceladas entram com todas as parcelas: as próximas já aparecem nas faturas seguintes.": "কিস্তিতে কেনাকাটা সব কিস্তিসহ যোগ হয়: পরের কিস্তিগুলো পরবর্তী কার্ড বিলে দেখা যায়।",
 "As fotos deste documento estão no dispositivo onde ele foi escaneado. Lá dá para editar, compartilhar e ler o texto.": "এই নথির ছবিগুলো সেই ডিভাইসে আছে যেখানে এটি স্ক্যান করা হয়েছিল। সেখানে আপনি সম্পাদনা, শেয়ার এবং লেখা পড়তে পারবেন।",
 "As imagens vão só para a IA que você escolheu, com a sua chave.": "ছবিগুলো শুধু আপনার বেছে নেওয়া AI-এর কাছে, আপনার নিজের কী দিয়ে যায়।",
 "As limpezas dos check-outs aparecem aqui sozinhas, com checklist e fotos de antes e depois.": "চেক-আউটের পরিষ্কার এখানে নিজে থেকেই দেখা যায়, চেকলিস্ট ও আগে-পরের ছবিসহ।",
 "As notas emitidas aqui, as encontradas na busca e os XML importados aparecem nesta lista.": "এখানে ইস্যু করা ইনভয়েস, খোঁজে পাওয়া ইনভয়েস এবং আমদানি করা XML এই তালিকায় দেখা যায়।",
 "As parcelas aparecem aqui. Anexe o comprovante (foto, PDF ou print do PIX) em cada uma.": "কিস্তিগুলো এখানে দেখা যায়। প্রতিটিতে প্রমাণপত্র (ছবি, PDF বা PIX-এর স্ক্রিনশট) যুক্ত করুন।",
 "As parcelas dos próximos 12 meses já estão no My Planner.": "আগামী ১২ মাসের কিস্তি My Planner-এ আগেই যোগ করা আছে।",
 "As parcelas em aberto são refeitas com o valor, os juros e o prazo atuais do contrato. As pagas não mudam.": "বাকি কিস্তিগুলো চুক্তির বর্তমান পরিমাণ, সুদ ও মেয়াদ দিয়ে আবার তৈরি হয়। পরিশোধিত কিস্তি বদলায় না।",
 "As páginas deste documento estão no dispositivo onde ele foi escaneado. Abra por lá ou use a cópia guardada no Drive ou no OneDrive.": "এই নথির পৃষ্ঠাগুলো সেই ডিভাইসে আছে যেখানে এটি স্ক্যান করা হয়েছিল। সেখানে খুলুন অথবা Drive বা OneDrive-এ সেভ করা কপি ব্যবহার করুন।",
 "As páginas viram imagem mais leve: ótimo para PDFs escaneados. O texto deixa de ser pesquisável (use o OCR depois, se precisar).": "পৃষ্ঠাগুলো হালকা ছবি হয়ে যায়: স্ক্যান করা PDF-এর জন্য দারুণ। লেখা আর খোঁজা যাবে না (দরকার হলে পরে OCR ব্যবহার করুন)।",
 "As páginas vão só para a IA que você escolheu, com a sua chave.": "পৃষ্ঠাগুলো শুধু আপনার বেছে নেওয়া AI-তে, আপনার নিজের কী দিয়ে যায়।",
 "As receitas do cardápio já têm tudo na despensa.": "মেনুর রেসিপির সব উপকরণ ভাঁড়ারে আছে।",
 "As senhas novas não conferem.": "নতুন পাসওয়ার্ড দুটি মিলছে না।",
 "As senhas não conferem.": "পাসওয়ার্ড মিলছে না।",
 "As tarefas continuam no My Planner. Quer apagar também as que vieram da agenda do Google?": "কাজগুলো My Planner-এ থেকে যাবে। Google ক্যালেন্ডার থেকে আসা কাজগুলোও কি মুছতে চান?",
 "As tarefas do cômodo continuam em Minha Casa, sem cômodo.": "ঘরের কাজগুলো কোনো ঘর ছাড়াই আমার বাড়িতে থেকে যাবে।",
 "As tarefas vinculadas continuam no My Planner.": "লিংক করা কাজগুলো My Planner-এ থেকে যাবে।",
 "Aspirar e passar pano": "ভ্যাকুয়াম ও মোছা",
 "Assinada": "সাবস্ক্রাইব করা",
 "Assinar": "স্বাক্ষর করুন",
 "Assinar (simulação de teste)": "সাবস্ক্রাইব (পরীক্ষামূলক সিমুলেশন)",
 "Assinar o documento": "নথিতে স্বাক্ষর করুন",
 "Assinatura": "স্বাক্ষর",
 "Assinatura do profissional": "পেশাদারের স্বাক্ষর",
 "Assinatura e segurança": "স্বাক্ষর ও নিরাপত্তা",
 "Assinaturas (simulação de teste)": "সাবস্ক্রিপশন (পরীক্ষামূলক সিমুলেশন)",
 "Assine a aba em Ajustes para enviar anotações para ela.": "এই ট্যাবে নোট পাঠাতে সেটিংসে ট্যাবটি সাবস্ক্রাইব করুন।",
 "Assine a aba em Ajustes para vincular.": "লিংক করতে সেটিংসে ট্যাবটি সাবস্ক্রাইব করুন।",
 "Assine a aba em Ajustes › Compras para enviar anotações para ela.": "এই ট্যাবে নোট পাঠাতে সেটিংস › কেনাকাটা থেকে ট্যাবটি সাবস্ক্রাইব করুন।",
 "Assine a aba em Ajustes › Compras para vincular.": "লিংক করতে সেটিংস › কেনাকাটা থেকে ট্যাবটি সাবস্ক্রাইব করুন।",
 "Assine a aba para abrir o vínculo.": "লিংক খুলতে ট্যাবটি সাবস্ক্রাইব করুন।",
 "Assisti mais uma aula": "আরও একটি ক্লাস দেখেছি",
 "Assistido": "দেখা হয়েছে",
 "Assistindo": "দেখছি",
 "Assistência técnica (nome)": "সার্ভিস সেন্টার (নাম)",
 "Assistência: {nome}": "সার্ভিস সেন্টার: {nome}",
 "Assunto": "বিষয়",
 "Assunto (ex.: Reunião semanal)": "বিষয় (যেমন: সাপ্তাহিক মিটিং)",
 "Atender": "ধরুন",
 "Atendimento": "অ্যাপয়েন্টমেন্ট",
 "Atendimentos": "অ্যাপয়েন্টমেন্ট",
 "Ativar avisos": "বিজ্ঞপ্তি চালু করুন",
 "Ativar monitor": "মনিটর চালু করুন",
 "Ativas": "সক্রিয়",
 "Atividade": "কাজ",
 "Atividade do roteiro": "ভ্রমণসূচির কার্যক্রম",
 "Atividade hoje": "আজকের অ্যাক্টিভিটি",
 "Atividade: {blocos}": "কার্যকলাপ: {blocos}",
 "Atividades": "কার্যকলাপ",
 "Atividades de hoje": "আজকের কার্যকলাপ",
 "Atividades e materiais": "কার্যক্রম ও উপকরণ",
 "Atividades físicas e saúde": "শরীরচর্চা ও স্বাস্থ্য",
 "Atrasada": "বকেয়া",
 "Atrasada há {n} dia(s)": "{n} দিন বিলম্বিত",
 "Atrasadas": "বকেয়া",
 "Atrasados": "বিলম্বিত",
 "Atuais": "বর্তমান",
 "Atualidades": "সাম্প্রতিক বিষয়",
 "Atualizar": "হালনাগাদ করুন",
 "Atualizar agora": "এখনই আপডেট করুন",
 "Atualizar alarmes no My Planner": "My Planner-এ অ্যালার্ম হালনাগাদ করুন",
 "Atualizar rega e adubo na agenda": "সময়সূচিতে পানি ও সার হালনাগাদ করুন",
 "Atualização automática disponível no app instalado (APK).": "ইনস্টল করা অ্যাপে (APK) স্বয়ংক্রিয় আপডেট পাওয়া যায়।",
 "Atualização baixada. Entra ao reabrir o app ou ao tocar no aviso.": "আপডেট ডাউনলোড হয়েছে। অ্যাপ আবার খুললে বা নোটিশে ট্যাপ করলে চালু হবে।",
 "Atualização pronta": "আপডেট প্রস্তুত",
 "Atualizações": "আপডেট",
 "Até": "পর্যন্ত",
 "Audiência": "শুনানি",
 "Aula dada": "ক্লাস নেওয়া হয়েছে",
 "Aula {a} de {n} ({p}%)": "ক্লাস {a} / {n} ({p}%)",
 "Aulas assistidas": "দেখা ক্লাস",
 "Autoajuda": "আত্মউন্নয়ন",
 "Autor": "লেখক",
 "Avaliação": "মূল্যায়ন",
 "Avaliações e notas": "মূল্যায়ন ও নম্বর",
 "Avançado": "উন্নত",
 "Aveia": "ওটস",
 "Avisar a hora de sair": "বের হওয়ার সময় মনে করিয়ে দিন",
 "Avisar antes de vencer": "মেয়াদ শেষের আগে জানান",
 "Avisar no celular quando alguém incluir algo": "কেউ কিছু যোগ করলে ফোনে জানান",
 "Aviso": "নোটিশ",
 "Aviso com as tarefas do dia": "দিনের কাজসহ নোটিফিকেশন",
 "Aviso de teste enviado pelo servidor. Ele chega em alguns segundos; saia do app para ver na barra do celular.": "সার্ভার থেকে টেস্ট নোটিফিকেশন পাঠানো হয়েছে। কয়েক সেকেন্ডের মধ্যে আসবে; ফোনের নোটিফিকেশন বারে দেখতে অ্যাপ থেকে বের হন।",
 "Aviso enviado": "নোটিফিকেশন পাঠানো হয়েছে",
 "Aviso {dias} dia(s) antes e no dia": "{dias} দিন আগে ও সেদিন সতর্কতা",
 "Avisos no celular": "ফোনে নোটিফিকেশন",
 "Avisos no celular passam pelos serviços da Expo, da Google e da Apple.": "ফোনের নোটিফিকেশন Expo, Google ও Apple-এর সেবার মধ্য দিয়ে যায়।",
 "Ação": "অ্যাকশন",
 "Ações": "শেয়ার",
 "BOLETO E DOCUMENTOS": "বোলেটো ও নথি",
 "Backup importado.": "ব্যাকআপ ইমপোর্ট হয়েছে।",
 "Bairro": "এলাকা",
 "Baixa": "নিম্ন",
 "Baixando atualização...": "আপডেট ডাউনলোড হচ্ছে...",
 "Baixar": "ডাউনলোড",
 "Baixar a versão {v}": "সংস্করণ {v} ডাউনলোড করুন",
 "Baixar agora": "এখনই ডাউনলোড করুন",
 "Baixar o My Planner para Android": "Android-এর জন্য My Planner ডাউনলোড করুন",
 "Baixar o My Planner para Android (versão {v})": "Android-এর জন্য My Planner ডাউনলোড করুন (সংস্করণ {v})",
 "Baixar o My Planner para iPhone": "iPhone-এর জন্য My Planner ডাউনলোড করুন",
 "Baixar o PDF da nota (DANFSe)": "ইনভয়েসের PDF ডাউনলোড করুন (DANFSe)",
 "Baixar o PDF?": "PDF ডাউনলোড করবেন?",
 "Baixar o XML completo (dá ciência na SEFAZ)": "সম্পূর্ণ XML ডাউনলোড করুন (SEFAZ-কে অবগতি জানায়)",
 "Baixe a versão mais recente para Android: {apk}": "সর্বশেষ Android সংস্করণ ডাউনলোড করুন: {apk}",
 "Baixe aqui a versão mais recente: {link}": "সর্বশেষ সংস্করণ এখানে ডাউনলোড করুন: {link}",
 "Balança": "দোলা",
 "Balanço e relatórios": "ব্যালান্স শিট ও রিপোর্ট",
 "Banana": "কলা",
 "Banco": "ব্যাংক",
 "Banco, financeira ou pessoa": "ব্যাংক, আর্থিক প্রতিষ্ঠান বা ব্যক্তি",
 "Bandeiras": "পতাকা",
 "Banheiro": "বাথরুম",
 "Banho": "গোসল",
 "Banho e tosa": "গোসল ও গ্রুমিং",
 "Barra": "বার",
 "Bateria": "ব্যাটারি",
 "Batimentos (média)": "হৃদস্পন্দন (গড়)",
 "Batizado": "ব্যাপটিজম",
 "Bebida": "পানীয়",
 "Bebê": "শিশু",
 "Beijo": "চুমু",
 "Bem": "সম্পদ",
 "Bem clara": "খুব হালকা",
 "Bem-Estar": "সুস্থতা",
 "Bem-Estar · Cronograma alimentar": "সুস্থতা · খাদ্য পরিকল্পনা",
 "Bens": "সম্পদ",
 "Bichos e diversão": "প্রাণী ও বিনোদন",
 "Bicicleta": "সাইকেল",
 "Bicicleta ergométrica": "এক্সারসাইজ বাইক",
 "Biografia": "জীবনী",
 "Biologia": "জীববিজ্ঞান",
 "Biometria (digital ou rosto)": "বায়োমেট্রিক (আঙুলের ছাপ বা মুখ)",
 "Biometria ({tipos})": "বায়োমেট্রিক ({tipos})",
 "Biometria não confirmada.": "বায়োমেট্রিক নিশ্চিত হয়নি।",
 "Bloqueado": "ব্লক করা",
 "Bloquear": "ব্লক করুন",
 "Bloquear agora": "এখনই লক করুন",
 "Bloqueio": "ব্লক",
 "Blusas de frio": "শীতের জামা",
 "Boa noite": "শুভ রাত্রি",
 "Boa sorte!": "শুভকামনা!",
 "Boas-vindas ao My Planner": "My Planner-এ স্বাগতম",
 "Boas-vindas pelo WhatsApp": "WhatsApp-এ স্বাগত বার্তা",
 "Boleto": "বোলেটো (বিল)",
 "Boleto anexado": "বোলেটো যুক্ত হয়েছে",
 "Boleto do banco {b}": "{b} ব্যাংকের বোলেটো",
 "Boleto e documentos (foto, PDF ou arquivo)": "বোলেটো ও নথি (ছবি, PDF বা ফাইল)",
 "Boleto ou conta (foto, PDF ou arquivo)": "বোলেটো বা বিল (ছবি, PDF বা ফাইল)",
 "Boleto por foto": "ছবি থেকে বোলেটো",
 "Bolinha": "বিন্দু",
 "Bom dia": "সুপ্রভাত",
 "Bom dia!": "সুপ্রভাত!",
 "Bom dia! Seu dia no My Planner": "সুপ্রভাত! My Planner-এ আপনার দিন",
 "Booking": "Booking",
 "Bora!": "চলো!",
 "Borboleta": "প্রজাপতি",
 "Borracha": "ইরেজার",
 "Botas para neve": "বরফের বুট",
 "Brasil": "ব্রাজিল",
 "Braços acima da cabeça": "হাত মাথার উপরে তুলুন",
 "Brilho": "ঝলক",
 "Brinquedo ou livro para a viagem": "যাত্রার জন্য খেলনা বা বই",
 "Busca de notas": "ইনভয়েস খোঁজা",
 "Busca o nome nos diários municipais reunidos pelo Querido Diário (Open Knowledge Brasil). Nem todos os municípios estão incluídos, e os diários oficiais não fazem parte do DJEN.": "Querido Diário (Open Knowledge Brasil)-এর সংগ্রহ করা পৌর গেজেটে নামটি খোঁজে। সব পৌরসভা অন্তর্ভুক্ত নয়, এবং সরকারি গেজেট DJEN-এর অংশ নয়।",
 "Buscando...": "খোঁজা হচ্ছে...",
 "Buscar": "খুঁজুন",
 "Buscar GIF (ex.: parabéns, bom dia)": "GIF খুঁজুন (যেমন: অভিনন্দন, সুপ্রভাত)",
 "Buscar cidade, país ou GMT": "শহর, দেশ বা GMT খুঁজুন",
 "Buscar conversa": "চ্যাট খুঁজুন",
 "Buscar documento, titular ou órgão": "নথি, ধারক বা ইস্যুকারী খুঁজুন",
 "Buscar em {nome}": "{nome}-এ খুঁজুন",
 "Buscar emoji (ex.: coração, risada)": "ইমোজি খুঁজুন (যেমন: হৃদয়, হাসি)",
 "Buscar figurinha": "স্টিকার খুঁজুন",
 "Buscar notas": "ইনভয়েস খুঁজুন",
 "Buscar ou digitar um alimento": "খাবার খুঁজুন বা লিখুন",
 "Buscar país": "দেশ খুঁজুন",
 "Buscar pelo nome ou pelo texto": "নাম বা লেখা দিয়ে খুঁজুন",
 "Buscar produto, loja ou observação": "পণ্য, দোকান বা মন্তব্য খুঁজুন",
 "Buscar tarefas": "কাজ খুঁজুন",
 "Buscar: processo, parte, tribunal, palavra...": "খুঁজুন: মামলা, পক্ষ, আদালত, শব্দ...",
 "CAIXA {n}": "বাক্স {n}",
 "CARDS DE ANOTAÇÕES": "নোট কার্ড",
 "CARTÕES": "কার্ড",
 "CEP": "CEP (পোস্ট কোড)",
 "CID (se o paciente pedir na declaração)": "CID (রোগী ঘোষণাপত্রে চাইলে)",
 "CID: {c}": "CID: {c}",
 "CNH": "CNH (ড্রাইভিং লাইসেন্স)",
 "CNPJ (se tiver)": "CNPJ (থাকলে)",
 "CNPJ ou CPF": "CNPJ বা CPF",
 "COMPROVANTE DE PAGAMENTO": "পেমেন্টের রসিদ",
 "COMPROVANTE DE RECEBIMENTO": "প্রাপ্তির রসিদ",
 "COMPROVANTES ANTERIORES": "আগের রসিদ",
 "CONTAS DO MÊS": "এই মাসের বিল",
 "CPF": "CPF",
 "CPF (Brasil)": "CPF (ব্রাজিল)",
 "CPF de quem paga": "যিনি পরিশোধ করেন তাঁর CPF",
 "CPF do paciente": "রোগীর CPF",
 "CPF do pagador": "পরিশোধকারীর CPF",
 "CPF inválido": "CPF সঠিক নয়",
 "CPF ou CNPJ de quem recebeu": "প্রাপকের CPF বা CNPJ",
 "CPF ou senha incorretos.": "CPF বা পাসওয়ার্ড ভুল।",
 "CRIAR CÔMODO": "ঘর তৈরি করুন",
 "CRIAR UM GRUPO": "গ্রুপ তৈরি করুন",
 "CRONOGRAMA ALIMENTAR": "খাদ্য সময়সূচি",
 "CUIDADOS PESSOAIS": "ব্যক্তিগত যত্ন",
 "Cabeleireiro": "হেয়ারড্রেসার",
 "Cabelo": "চুল",
 "Cachorro": "কুকুর",
 "Cactos e suculentas": "ক্যাকটাস ও সাকুলেন্ট",
 "Cada aba extra: {n} dias grátis; depois {preco} por ano.": "প্রতিটি অতিরিক্ত ট্যাব: {n} দিন বিনামূল্যে; তারপর বছরে {preco}।",
 "Cada arquivo pronto vai para o {nome}. Os PDFs abertos ficam também neste dispositivo, na lista abaixo.": "প্রতিটি তৈরি ফাইল {nome}-এ যায়। খোলা PDF-গুলো এই ডিভাইসে নিচের তালিকাতেও থাকে।",
 "Cada dia da semana": "সপ্তাহের প্রতিটি দিন",
 "Cada documento novo vai para o {nome} quando você sai dele. As fotos das páginas ficam só neste dispositivo.": "প্রতিটি নতুন নথি আপনি বের হলে {nome}-এ চলে যায়। পৃষ্ঠার ছবিগুলো শুধু এই ডিভাইসেই থাকে।",
 "Cada pessoa da equipe recebe a reunião em Recebidos e coloca no Planner com um toque, com o alerta.": "টিমের প্রত্যেকে মিটিংটি প্রাপ্ত-তে পান এবং এক ট্যাপে অ্যালার্টসহ Planner-এ যোগ করেন।",
 "Cada pessoa do grupo recebe e decide se aceita.": "গ্রুপের প্রত্যেকে এটি পাবেন এবং গ্রহণ করবেন কিনা ঠিক করবেন।",
 "Cada página guarda um resumo, aula ou capítulo. Marque como revisada quando terminar.": "প্রতিটি পৃষ্ঠায় একটি সারাংশ, ক্লাস বা অধ্যায় রাখা যায়। শেষ হলে রিভিশন হয়েছে বলে চিহ্নিত করুন।",
 "Cada página vira uma imagem JPG.": "প্রতিটি পৃষ্ঠা একটি JPG ছবি হয়ে যায়।",
 "Cada refeição se repete nos dias dela": "প্রতিটি খাবার তার নির্ধারিত দিনগুলোতে পুনরাবৃত্তি হয়",
 "Cadastrar": "যোগ করুন",
 "Cadastrar cartão de crédito": "ক্রেডিট কার্ড যোগ করুন",
 "Cadastrar pela foto (página do curso, certificado, folheto)": "ছবি থেকে যোগ করুন (কোর্সের পাতা, সনদ, লিফলেট)",
 "Cadastrar pela foto da capa": "প্রচ্ছদের ছবি থেকে যোগ করুন",
 "Cadastre \"Meus dados\" para os recibos saírem com seu nome, conselho e número.": "\"আমার তথ্য\" পূরণ করুন, যাতে রসিদে আপনার নাম, কাউন্সিল ও নম্বর থাকে।",
 "Cadastre RG, CNH, passaporte, contratos e certidões. O app avisa antes de vencer e envia o documento com um toque.": "RG, CNH, পাসপোর্ট, চুক্তি ও সনদ যোগ করুন। মেয়াদ শেষের আগে অ্যাপ জানাবে এবং এক ট্যাপে নথি পাঠাবে।",
 "Cadastre a empresa (ou você, como profissional) com CNPJ ou CPF, município e regime. Depois ligue o certificado A1 para emitir NFS-e pelo Padrão Nacional e buscar as notas emitidas e recebidas.": "প্রতিষ্ঠান (বা পেশাজীবী হিসেবে নিজেকে) CNPJ বা CPF, পৌরসভা ও কর ব্যবস্থাসহ নিবন্ধন করুন। এরপর A1 সার্টিফিকেট যুক্ত করুন, যাতে Padrão Nacional দিয়ে NFS-e ইস্যু করতে এবং ইস্যু করা ও প্রাপ্ত ইনভয়েস খুঁজতে পারেন।",
 "Cadastre a obra e, dentro dela, as etapas com orçamento, o diário com fotos, os profissionais e as entregas de material.": "নির্মাণকাজ যোগ করুন, তার ভেতরে বাজেটসহ ধাপ, ছবিসহ ডায়েরি, কারিগর ও মালামাল সরবরাহ যোগ করুন।",
 "Cadastre a viagem e, dentro dela, o roteiro de cada dia, as reservas e a mala. Durante a viagem, o roteiro aparece no My Planner.": "ভ্রমণ যোগ করুন, তার ভেতরে প্রতিদিনের ভ্রমণসূচি, বুকিং ও লাগেজ যোগ করুন। ভ্রমণের সময় ভ্রমণসূচি My Planner-এ দেখা যায়।",
 "Cadastre apenas o seu próprio nome e a sua OAB.": "শুধু আপনার নিজের নাম ও আপনার OAB নিবন্ধন করুন।",
 "Cadastre as crianças: provas, reuniões, consultas e vacinas ficam dentro de cada uma.": "শিশুদের যোগ করুন: পরীক্ষা, মিটিং, ডাক্তার দেখানো ও টিকা প্রত্যেকের ভেতরে থাকে।",
 "Cadastre cada pet: carteira de vacinação, vermífugos, remédios e pet shop ficam dentro dele.": "প্রতিটি পোষা প্রাণী যোগ করুন: টিকার কার্ড, কৃমিনাশক, ওষুধ ও পেট শপ তার ভেতরেই থাকে।",
 "Cadastre cada planta com luz, solo e de quantos em quantos dias regar e adubar. O app monta o calendário na agenda.": "প্রতিটি গাছ আলো, মাটি এবং কত দিন পরপর পানি ও সার দিতে হবে তা দিয়ে যোগ করুন। অ্যাপ সময়সূচিতে ক্যালেন্ডার বানিয়ে দেয়।",
 "Cadastre cada veículo. Dentro dele ficam as manutenções (com aviso por km e por data) e os vencimentos de IPVA, licenciamento e seguro.": "প্রতিটি যানবাহন যোগ করুন। তার ভেতরে রক্ষণাবেক্ষণ (কিমি ও তারিখ অনুযায়ী সতর্কতা) এবং IPVA, লাইসেন্সিং ও বিমার মেয়াদ থাকে।",
 "Cadastre digital ou rosto no aparelho para usar.": "ব্যবহার করতে ডিভাইসে আঙুলের ছাপ বা ফেস নিবন্ধন করুন।",
 "Cadastre o cartão primeiro": "আগে কার্ড যোগ করুন",
 "Cadastre o financiamento ou empréstimo com o valor, os juros e o número de parcelas. O app calcula as parcelas, o saldo devedor e avisa os vencimentos.": "ফাইন্যান্সিং বা ঋণ পরিমাণ, সুদ ও কিস্তির সংখ্যাসহ যোগ করুন। অ্যাপ কিস্তি ও বকেয়া হিসাব করে এবং নির্ধারিত তারিখ মনে করিয়ে দেয়।",
 "Cadastre o imóvel inteiro ou cada quarto que você aluga. Dentro de cada um ficam as reservas, a limpeza e as despesas.": "পুরো প্রপার্টি বা ভাড়া দেওয়া প্রতিটি ঘর যোগ করুন। প্রত্যেকটির ভেতরে বুকিং, পরিষ্কার ও খরচ থাকে।",
 "Cadastre o livro com o total de páginas e a meta por dia. Toque em ⋮ para somar as páginas lidas.": "বইয়ের মোট পৃষ্ঠা ও দৈনিক লক্ষ্য দিয়ে যোগ করুন। পড়া পৃষ্ঠা যোগ করতে ⋮ ট্যাপ করুন।",
 "Cadastre o remédio com os horários e toque em ⋮ para colocar na linha do tempo com alarme.": "ওষুধ ও তার সময় যোগ করুন, তারপর অ্যালার্মসহ টাইমলাইনে রাখতে ⋮ ট্যাপ করুন।",
 "Cadastre os alunos da turma na aba Alunos.": "শিক্ষার্থী ট্যাবে ক্লাসের শিক্ষার্থীদের যোগ করুন।",
 "Cadastre os clientes para separar as horas.": "ঘণ্টা আলাদা রাখতে ক্লায়েন্টদের যোগ করুন।",
 "Cadastre os clientes que recebem as suas notas. O endereço é opcional (se preencher, informe CEP, código IBGE, rua, número e bairro).": "যেসব ক্লায়েন্ট আপনার ইনভয়েস পান তাদের নিবন্ধন করুন। ঠিকানা ঐচ্ছিক (দিলে CEP, IBGE কোড, রাস্তা, নম্বর ও এলাকা দিন)।",
 "Cadastre os serviços que você mais emite, com o código de tributação nacional. Na hora de emitir é só tocar.": "যেসব সেবার ইনভয়েস সবচেয়ে বেশি ইস্যু করেন, সেগুলো জাতীয় কর কোডসহ নিবন্ধন করুন। ইস্যু করার সময় শুধু ট্যাপ করুন।",
 "Cadastre primeiro em {nome}.": "আগে {nome}-এ যোগ করুন।",
 "Cadastre seu nome, conselho e número do registro. Eles saem nos recibos e nas declarações.": "আপনার নাম, কাউন্সিল ও নিবন্ধন নম্বর যোগ করুন। এগুলো রসিদ ও ঘোষণাপত্রে থাকে।",
 "Cadastre seus clientes na aba \"Tomadores\" da empresa para escolher aqui.": "এখানে বেছে নিতে প্রতিষ্ঠানের \"সেবা গ্রহীতা\" ট্যাবে আপনার ক্লায়েন্টদের নিবন্ধন করুন।",
 "Cadastre seus dados profissionais (nome, conselho e número) em \"Meus dados\" para sair no documento.": "নথিতে দেখাতে \"আমার তথ্য\"-তে আপনার পেশাগত তথ্য (নাম, কাউন্সিল ও নম্বর) যোগ করুন।",
 "Cadastre seus dados profissionais (nome, conselho e número) em \"Meus dados\" para sair no recibo.": "রসিদে দেখাতে \"আমার তথ্য\"-তে আপনার পেশাগত তথ্য (নাম, কাউন্সিল ও নম্বর) যোগ করুন।",
 "Cadastre seus pacientes. Dentro de cada um ficam os atendimentos com evolução, prescrição, pagamento, recibo e declaração para o plano de saúde.": "আপনার রোগীদের যোগ করুন। প্রত্যেকের ভেতরে অ্যাপয়েন্টমেন্ট থাকে, অগ্রগতি নোট, প্রেসক্রিপশন, পেমেন্ট, রসিদ ও বিমার ঘোষণাপত্রসহ।",
 "Cadastre você e cada pessoa da família. Dentro de cada uma ficam consultas, exames, vacinas e remédios. Dados sensíveis vão para o cofre criptografado.": "নিজেকে ও পরিবারের প্রত্যেককে যোগ করুন। প্রত্যেকের ভেতরে ডাক্তার দেখানো, পরীক্ষা, টিকা ও ওষুধ থাকে। সংবেদনশীল তথ্য এনক্রিপ্ট করা ভল্টে যায়।",
 "Cadastro aguardando liberação: desligue \"Confirm email\" no Supabase (veja COMO RODAR).": "নিবন্ধন অনুমোদনের অপেক্ষায়: Supabase-এ \"Confirm email\" বন্ধ করুন (COMO RODAR দেখুন)।",
 "Cadastro recebido": "নিবন্ধন গৃহীত হয়েছে",
 "Cadastro: nome, CPF ou e-mail, senha (guardada só em forma protegida) e e-mail de contato.": "নিবন্ধন: নাম, CPF বা ইমেইল, পাসওয়ার্ড (শুধু সুরক্ষিত রূপে রাখা হয়) এবং যোগাযোগের ইমেইল।",
 "Cadastros": "নিবন্ধন",
 "Cadastros e comprovantes": "নিবন্ধন ও রসিদ",
 "Cadeira extensora": "লেগ এক্সটেনশন",
 "Café": "কফি",
 "Café da manhã": "সকালের নাশতা",
 "Café ou bar": "ক্যাফে বা বার",
 "Café?": "কফি?",
 "Cafés": "ক্যাফে",
 "Caixa": "বাক্স",
 "Caixa arquivada": "আর্কাইভ করা বাক্স",
 "Caixa com checklist, lista ou texto livre": "চেকলিস্ট, তালিকা বা মুক্ত লেখার বক্স",
 "Caixa {n}": "বাক্স {n}",
 "Caixas": "বাক্স",
 "Caixas e cronograma da mudança.": "বাক্স ও বাসা বদলের সময়সূচি।",
 "Caixas por cômodo com etiqueta, troca de água, luz e internet, vistorias e o cronograma dos dias.": "ঘর অনুযায়ী লেবেলসহ বাক্স, পানি, বিদ্যুৎ ও ইন্টারনেট স্থানান্তর, পরিদর্শন এবং দিনের সময়সূচি।",
 "Calculadora": "ক্যালকুলেটর",
 "Calculando...": "হিসাব করা হচ্ছে...",
 "Calendário": "ক্যালেন্ডার",
 "Calendário da planta": "গাছের ক্যালেন্ডার",
 "Calendário do imposto": "করের ক্যালেন্ডার",
 "Calendários": "ক্যালেন্ডার",
 "Calorias em atividade": "অ্যাক্টিভিটি ক্যালরি",
 "Calorias gastas em atividade (kcal)": "অ্যাক্টিভিটিতে খরচ হওয়া ক্যালরি (kcal)",
 "Calça térmica (segunda pele)": "থার্মাল প্যান্ট (ইনার)",
 "Calças ou bermudas": "প্যান্ট বা হাফপ্যান্ট",
 "Cama": "বিছানা",
 "Caminhada": "হাঁটা",
 "Caminhão": "ট্রাক",
 "Camisetas": "টি-শার্ট",
 "Campo Grande": "Campo Grande",
 "Campo Grande (MS)": "Campo Grande (MS)",
 "Campos de formulário": "ফর্মের ঘর",
 "Cancelada": "বাতিল",
 "Canceladas": "বাতিল",
 "Cancelar": "বাতিল",
 "Cancelar a NFS-e": "NFS-e বাতিল করুন",
 "Cancelar a NFS-e {n}?": "NFS-e {n} বাতিল করবেন?",
 "Cancelar a nota": "ইনভয়েস বাতিল করুন",
 "Cancelar a reunião \"{nome}\"?": "\"{nome}\" মিটিং বাতিল করবেন?",
 "Cancelar reunião": "মিটিং বাতিল করুন",
 "Caneta": "কলম",
 "Captura automática do servidor: de 2 em 2 horas, das 08h às 20h": "সার্ভারের স্বয়ংক্রিয় সংগ্রহ: প্রতি ২ ঘণ্টায়, ০৮:০০ থেকে ২০:০০",
 "Captura automática: todos os dias às 08h e 12h": "স্বয়ংক্রিয় সংগ্রহ: প্রতিদিন 08:00 ও 12:00-এ",
 "Card": "কার্ড",
 "Cardápio": "মেনু",
 "Cardápio da semana, receitas, lista de compras automática e validade da despensa.": "সপ্তাহের মেনু, রেসিপি, স্বয়ংক্রিয় বাজারের তালিকা ও ভাঁড়ারের মেয়াদ।",
 "Cardápio só para este dia. Os outros dias continuam com o da semana.": "মেনু শুধু এই দিনের জন্য। অন্য দিনগুলোতে সপ্তাহের মেনুই থাকবে।",
 "Carga (kg)": "ওজন (kg)",
 "Carimbo": "সিল",
 "Carnaval": "কার্নিভাল",
 "Carne magra": "চর্বিহীন মাংস",
 "Carregando feriados...": "ছুটির দিন লোড হচ্ছে...",
 "Carregando...": "লোড হচ্ছে...",
 "Carro": "গাড়ি",
 "Carta": "লেটার",
 "Carteira": "ওয়ালেট",
 "Carteira de trabalho": "কর্ম কার্ড",
 "Carteira profissional (OAB, CRC, CREA...)": "পেশাগত কার্ড (OAB, CRC, CREA...)",
 "Cartão": "কার্ড",
 "Cartão de contato das Mensagens: a foto, o telefone, o e-mail e a frase que você mesmo escolher pôr. Só quem conversa com você, os seus amigos e quem divide um grupo do app com você veem.": "বার্তার কন্টাক্ট কার্ড: ছবি, ফোন, ই-মেইল এবং যে স্ট্যাটাস আপনি নিজে যোগ করতে চান। শুধু যারা আপনার সঙ্গে চ্যাট করেন, আপনার বন্ধুরা এবং যারা অ্যাপের কোনো গ্রুপে আপনার সঙ্গে আছেন, তারাই দেখতে পান।",
 "Cartão de crédito": "ক্রেডিট কার্ড",
 "Cartão de débito": "ডেবিট কার্ড",
 "Cartão parcelado": "কার্ডে কিস্তি",
 "Cartões": "কার্ড",
 "Cartões de visita": "ভিজিটিং কার্ড",
 "Cartões e dinheiro": "কার্ড ও নগদ টাকা",
 "Casa": "বাড়ি",
 "Casa e rotina": "ঘর ও দৈনন্দিন",
 "Casa, família e veículos": "বাড়ি, পরিবার ও যানবাহন",
 "Casaco leve": "হালকা জ্যাকেট",
 "Casaco pesado": "ভারী কোট",
 "Casamento": "বিয়ে",
 "Castanhas": "বাদাম",
 "Categoria": "বিভাগ",
 "Categoria de \"{d}\"": "\"{d}\"-এর বিভাগ",
 "Categorias": "বিভাগসমূহ",
 "Caução": "জামানত",
 "Ceia": "রাতের হালকা খাবার",
 "Celular": "মোবাইল",
 "Celular confirmado": "মোবাইল নিশ্চিত হয়েছে",
 "Celular e carregador": "ফোন ও চার্জার",
 "Certidão": "সনদ",
 "Certificado digital": "ডিজিটাল সার্টিফিকেট",
 "Certificado digital A1": "A1 ডিজিটাল সার্টিফিকেট",
 "Certificado ligado": "সার্টিফিকেট যুক্ত",
 "Chamada": "হাজিরা",
 "Chamada ainda não feita neste dia. Toque em quem faltou ou confirme todos presentes.": "এই দিনের হাজিরা এখনও নেওয়া হয়নি। যে অনুপস্থিত তাকে ট্যাপ করুন বা সবাই উপস্থিত নিশ্চিত করুন।",
 "Chamada, notas, planos de aula e materiais.": "হাজিরা, নম্বর, পাঠ পরিকল্পনা ও উপকরণ।",
 "Chamadas": "কল",
 "Chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada e sem gravação.": "অডিও ও ভিডিও কল LiveKit-এর সার্ভারের মাধ্যমে যায়, শুধু কলের সময় এবং কোনো রেকর্ডিং ছাড়া।",
 "Chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada. Só há gravação nas reuniões do Escritório, quando o administrador grava, e o arquivo vai direto para o armazenamento do app.": "অডিও ও ভিডিও কল শুধু কল চলাকালীন LiveKit-এর সার্ভারের মধ্য দিয়ে যায়। রেকর্ডিং হয় শুধু অফিসের মিটিংয়ে, যখন অ্যাডমিনিস্ট্রেটর রেকর্ড করেন, এবং ফাইলটি সরাসরি অ্যাপের স্টোরেজে যায়।",
 "Chamando...": "কল করা হচ্ছে...",
 "Chapéu ou boné": "টুপি বা ক্যাপ",
 "Chave da IA não cadastrada neste dispositivo (Ajustes › Inteligência artificial).": "এই ডিভাইসে AI কী যোগ করা হয়নি (সেটিংস › কৃত্রিম বুদ্ধিমত্তা)।",
 "Chave de acesso": "অ্যাক্সেস কী",
 "Check-in": "চেক-ইন",
 "Check-in: {d} a partir das {h}": "চেক-ইন: {d}, {h}টা থেকে",
 "Check-in: {h} · {e}": "চেক-ইন: {h} · {e}",
 "Check-out": "চেক-আউট",
 "Check-out: {d} até as {h}": "চেক-আউট: {d}, {h}টার মধ্যে",
 "Check-out: {h} · {e}": "চেক-আউট: {h} · {e}",
 "Checklist": "চেকলিস্ট",
 "Chinelo": "স্লিপার",
 "Chá de bebê": "বেবি শাওয়ার",
 "Cidade": "শহর",
 "Cidade (para a data dos recibos)": "শহর (রসিদের তারিখের জন্য)",
 "Cidade de {nome}": "{nome} শহর",
 "Cidades": "শহর",
 "Cifrão": "ডলার চিহ্ন",
 "Cinza": "ধূসর",
 "Cirurgia": "অস্ত্রোপচার",
 "Ciências": "বিজ্ঞান",
 "Clara": "হালকা",
 "Clareia PDFs escaneados: fundo branco, cinza ou preto e branco.": "স্ক্যান করা PDF উজ্জ্বল করে: সাদা, ধূসর বা সাদা-কালো পটভূমি।",
 "Claro": "লাইট",
 "Classificar categorias com IA": "AI দিয়ে বিভাগ নির্ধারণ করুন",
 "Claude, ChatGPT ou Gemini": "Claude, ChatGPT বা Gemini",
 "Cliente": "ক্লায়েন্ট",
 "Clientes": "ক্লায়েন্ট",
 "Clima esperado": "প্রত্যাশিত আবহাওয়া",
 "Co-anfitrião": "সহ-হোস্ট",
 "Cobrança": "চার্জ",
 "Cobranças": "চার্জ",
 "Coelho": "খরগোশ",
 "Cofre (criptografia de ponta a ponta)": "ভল্ট (এন্ড-টু-এন্ড এনক্রিপশন)",
 "Cofre aberto (fecha sozinho em 5 minutos sem uso)": "ভল্ট খোলা (৫ মিনিট ব্যবহার না হলে নিজেই বন্ধ হয়)",
 "Cofre ainda não criado": "ভল্ট এখনও তৈরি হয়নি",
 "Cofre com criptografia para RG, CNH, passaporte, contratos e certidões, com contagem até vencer e envio com um toque.": "পরিচয়পত্র, ড্রাইভিং লাইসেন্স, পাসপোর্ট, চুক্তি ও সনদের জন্য এনক্রিপ্ট করা ভল্ট, মেয়াদ শেষ হওয়ার কাউন্টডাউন ও এক ট্যাপে পাঠানোর সুবিধাসহ।",
 "Cofre fechado": "ভল্ট বন্ধ",
 "Cofrinho": "পিগি ব্যাংক",
 "Cole aqui a chave ({ini}...)": "এখানে কী পেস্ট করুন ({ini}...)",
 "Cole o link (https://...)": "লিংক পেস্ট করুন (https://...)",
 "Cole ou digite o código de barras (ou o Pix copia e cola) no campo do código: o app calcula o valor e o vencimento sozinho. Com a sua IA ligada, ele lê tudo pela foto.": "কোডের ঘরে বারকোড (বা Pix কপি-পেস্ট কোড) পেস্ট করুন বা টাইপ করুন: অ্যাপ নিজেই টাকার পরিমাণ ও শেষ তারিখ হিসাব করে। আপনার AI চালু থাকলে এটি ছবি থেকে সব পড়ে নেয়।",
 "Coloca arquivos dentro do PDF.": "PDF-এর ভেতরে ফাইল রাখে।",
 "Colocar na agenda": "সময়সূচিতে রাখুন",
 "Colocar na linha do tempo com alarme": "অ্যালার্মসহ টাইমলাইনে রাখুন",
 "Colocar no My Planner": "My Planner-এ রাখুন",
 "Colocar rega e adubo na agenda": "পানি ও সার সময়সূচিতে রাখুন",
 "Coloque o valor da mensalidade na turma (Editar) ou no aluno. As cobranças deste mês que já existem não se repetem.": "মাসিক ফি-র পরিমাণ ক্লাসে (সম্পাদনা) বা শিক্ষার্থীর মধ্যে দিন। এই মাসের আগে থেকে থাকা চার্জ আবার তৈরি হয় না।",
 "Coluna": "কলাম",
 "Colágeno": "কোলাজেন",
 "Com a biometria ligada, ela aparece primeiro. Se falhar, use o desenho ou a senha.": "বায়োমেট্রিক চালু থাকলে এটি প্রথমে আসে। ব্যর্থ হলে প্যাটার্ন বা পাসওয়ার্ড ব্যবহার করুন।",
 "Com convênio": "বিমাসহ",
 "Com o código do país e o DDD. Ex.: +55 41 99999-0000": "দেশের কোড ও এলাকার কোডসহ। যেমন: +55 41 99999-0000",
 "Com outras pessoas": "অন্যদের কাছে",
 "Com prazo, o app calcula quanto guardar por mês. O dinheiro guardado conta como \"Guardou\" no mês.": "সময়সীমা দিলে অ্যাপ হিসাব করে প্রতি মাসে কত জমাতে হবে। জমানো টাকা সেই মাসে \"জমিয়েছেন\" হিসেবে গোনা হয়।",
 "Com quem": "কার সঙ্গে",
 "Com quem pagou, o paciente, a data e o valor de cada atendimento pago. Como pessoa física, lance cada um no app Receita Federal › Receita Saúde; com CNPJ, emita a nota de serviço.": "প্রতিটি পরিশোধিত অ্যাপয়েন্টমেন্টের পরিশোধকারী, রোগী, তারিখ ও পরিমাণসহ। ব্যক্তি হিসেবে প্রতিটি Receita Federal অ্যাপ › Receita Saúde-এ এন্ট্রি দিন; CNPJ থাকলে সেবার ইনভয়েস দিন।",
 "Com valor a receber": "পাওনা আছে",
 "Com vencimento": "নির্ধারিত তারিখসহ",
 "Combinado": "ঠিক আছে",
 "Combinado 👍": "ঠিক আছে 👍",
 "Combustível": "জ্বালানি",
 "Comece cadastrando as contas fixas do mês (aluguel, luz, internet) e o seu cartão. Eu aviso antes de cada vencimento.": "মাসের নির্দিষ্ট বিলগুলো (ভাড়া, বিদ্যুৎ, ইন্টারনেট) আর আপনার কার্ড যোগ করে শুরু করুন। প্রতিটি শেষ তারিখের আগে আমি জানিয়ে দেব।",
 "Comecei em": "শুরু করেছি",
 "Comentários": "মন্তব্য",
 "Começa amanhã": "আগামীকাল শুরু",
 "Começa às {hora} (em {m} min)": "{hora}-এ শুরু ({m} মিনিট পরে)",
 "Começar": "শুরু করুন",
 "Começar com o modelo: café, lanche, almoço, lanche e jantar": "টেমপ্লেট দিয়ে শুরু করুন: নাশতা, হালকা খাবার, দুপুরের খাবার, হালকা খাবার ও রাতের খাবার",
 "Começar em": "শুরু হবে",
 "Começar o teste grátis": "বিনামূল্যে ট্রায়াল শুরু করুন",
 "Comi outros alimentos ou quantidades": "অন্য খাবার বা পরিমাণ খেয়েছি",
 "Comida": "খাবার",
 "Comidas e bebidas": "খাবার ও পানীয়",
 "Comido": "খাওয়া",
 "Comido / alterações": "খাওয়া / পরিবর্তন",
 "Comido conta as refeições marcadas como feitas (ou com alterações) até hoje.": "\"খাওয়া\" অংশে আজ পর্যন্ত সম্পন্ন (বা পরিবর্তনসহ) চিহ্নিত খাবার গোনা হয়।",
 "Comigo": "আমার কাছে",
 "Comissão da plataforma": "প্ল্যাটফর্ম কমিশন",
 "Como apagar a sua conta e os seus dados": "আপনার অ্যাকাউন্ট ও ডেটা কীভাবে মুছবেন",
 "Como chegar": "কীভাবে যাবেন",
 "Como ela está": "অবস্থা কেমন",
 "Como estou comparado ao mês passado?": "গত মাসের তুলনায় আমি কেমন করছি?",
 "Como funciona": "কীভাবে কাজ করে",
 "Como planejado": "পরিকল্পনা অনুযায়ী",
 "Compartilhado no grupo": "গ্রুপে শেয়ার করা",
 "Compartilhado no grupo · só leitura": "গ্রুপে শেয়ার করা · শুধু পড়ার জন্য",
 "Compartilhamento indisponível neste dispositivo.": "এই ডিভাইসে শেয়ার করা যাচ্ছে না।",
 "Compartilhar": "শেয়ার করুন",
 "Compartilhar PDF": "PDF শেয়ার করুন",
 "Compartilhar a limpeza": "পরিষ্কারের কাজ শেয়ার করুন",
 "Compartilhar os dados": "ডেটা শেয়ার করুন",
 "Compartilhar os dados com a equipe": "দলের সাথে ডেটা শেয়ার করুন",
 "Compartilhar os dados com o grupo?": "গ্রুপের সাথে ডেটা শেয়ার করবেন?",
 "Compartilhar texto": "লেখা শেয়ার করুন",
 "Competência (mês de referência)": "সংশ্লিষ্ট মাস (রেফারেন্স মাস)",
 "Competência {d}": "সংশ্লিষ্ট মাস {d}",
 "Complemento": "ঠিকানার বাকি অংশ",
 "Complete seus dados": "আপনার তথ্য পূরণ করুন",
 "Compra": "কেনাকাটা",
 "Compra e venda de imóveis, veículos e ações, recibos dedutíveis e o calendário do imposto.": "বাড়ি, যানবাহন ও শেয়ার কেনাবেচা, কর-ছাড়যোগ্য রসিদ এবং করের ক্যালেন্ডার।",
 "Compra feita": "কেনা হয়েছে",
 "Compra no cartão": "কার্ডে কেনাকাটা",
 "Compras": "কেনাকাটা",
 "Compras da semana": "সপ্তাহের বাজার",
 "Comprimir": "কম্প্রেস করুন",
 "Compromisso": "অ্যাপয়েন্টমেন্ট",
 "Compromisso da escola": "স্কুলের কাজ",
 "Comprovante": "রসিদ",
 "Comprovante guardado": "রসিদ সংরক্ষিত হয়েছে",
 "Comprovantes": "রসিদ",
 "Computador": "কম্পিউটার",
 "Comédia": "কমেডি",
 "Concedi": "আমি দিয়েছি",
 "Concluir": "সম্পন্ন করুন",
 "Concluir (esquerda)": "সম্পন্ন (বামে)",
 "Concluída": "সম্পন্ন",
 "Concluído": "সম্পন্ন",
 "Concluído (%)": "সম্পন্ন (%)",
 "Concluído!": "সম্পন্ন!",
 "Concordo que meu nome, CPF e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes › Segurança.": "আমি সম্মত যে আমার নাম, CPF ও ইমেল শুধু আমার অ্যাকাউন্ট শনাক্ত করতে ব্যবহার হবে, এবং আমার কাজ ও নোট সেখানে সংরক্ষিত থাকবে। আমি যেকোনো সময় সেটিংস › নিরাপত্তা থেকে অ্যাকাউন্ট ও সব ডেটা মুছে ফেলতে পারি।",
 "Concordo que meu nome, CPF e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes.": "আমি সম্মত যে আমার নাম, CPF ও ই-মেইল শুধু আমার অ্যাকাউন্ট শনাক্ত করতে ব্যবহার হবে, এবং আমার কাজ ও নোট সেখানে সংরক্ষিত থাকবে। আমি যেকোনো সময় সেটিংসে গিয়ে অ্যাকাউন্ট ও সব তথ্য মুছে ফেলতে পারব।",
 "Concordo que meu nome, documento e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes › Segurança.": "আমি সম্মত যে আমার নাম, নথি ও ই-মেইল শুধু আমার অ্যাকাউন্ট শনাক্ত করতে ব্যবহার হবে, এবং আমার কাজ ও নোট সেখানে সংরক্ষিত থাকবে। আমি যেকোনো সময় সেটিংস › নিরাপত্তা থেকে অ্যাকাউন্ট ও সব ডেটা মুছতে পারি।",
 "Concursos": "সরকারি চাকরির পরীক্ষা",
 "Condicionador": "কন্ডিশনার",
 "Condomínio": "সার্ভিস চার্জ",
 "Condomínio e IPTU": "সার্ভিস চার্জ ও সম্পত্তি কর",
 "Conectado": "সংযুক্ত",
 "Conectando...": "সংযোগ হচ্ছে...",
 "Conectar": "সংযুক্ত করুন",
 "Conectar navegador": "ব্রাউজার সংযুক্ত করুন",
 "Conectar o {nome}": "{nome} সংযুক্ত করুন",
 "Conectar relógio ou app de saúde": "ঘড়ি বা হেলথ অ্যাপ সংযুক্ত করুন",
 "Conectar {nome}": "{nome} সংযুক্ত করুন",
 "Conecte o {nome} em Ajustes › Google Drive e OneDrive.": "সেটিংস › Google Drive ও OneDrive-এ {nome} সংযুক্ত করুন।",
 "Conferindo...": "যাচাই হচ্ছে...",
 "Conferir controles, chaves e Wi-Fi": "রিমোট, চাবি ও Wi-Fi দেখে নিন",
 "Conferir o prazo no sistema oficial": "অফিসিয়াল সিস্টেমে সময়সীমা যাচাই করুন",
 "Confete": "কনফেটি",
 "Configuração geral": "সাধারণ সেটিংস",
 "Confira a senha da sua conta e tente de novo.": "আপনার অ্যাকাউন্টের পাসওয়ার্ড যাচাই করে আবার চেষ্টা করুন।",
 "Confira as datas oficiais no site da Receita Federal e ajuste se precisar.": "সরকারি তারিখগুলো Receita Federal (ব্রাজিলের কর বিভাগ)-এর ওয়েবসাইটে মিলিয়ে নিন এবং দরকার হলে বদলান।",
 "Confira o código. Ele tem 6 letras e números.": "কোডটি যাচাই করুন। এতে 6টি অক্ষর ও সংখ্যা আছে।",
 "Confira o e-mail ou deixe em branco.": "ই-মেইল যাচাই করুন বা ফাঁকা রাখুন।",
 "Confira o e-mail.": "ই-মেইল যাচাই করুন।",
 "Confira o prazo no sistema oficial.": "অফিসিয়াল সিস্টেমে সময়সীমা যাচাই করুন।",
 "Confira os 11 números.": "১১টি সংখ্যা যাচাই করুন।",
 "Confira os campos antes de salvar.": "সংরক্ষণের আগে ঘরগুলো যাচাই করুন।",
 "Confira se a sua conta Google está adicionada no celular e com a agenda sincronizando.": "দেখে নিন আপনার Google অ্যাকাউন্ট ফোনে যোগ করা আছে এবং ক্যালেন্ডার সিঙ্ক হচ্ছে।",
 "Confirmada": "নিশ্চিত",
 "Confirmado": "নিশ্চিত",
 "Confirmar": "নিশ্চিত করুন",
 "Confirme a declaração sobre a empresa.": "প্রতিষ্ঠান সম্পর্কিত ঘোষণাটি নিশ্চিত করুন।",
 "Confirme o seu celular": "আপনার মোবাইল নিশ্চিত করুন",
 "Confirme para ativar a biometria": "বায়োমেট্রিক চালু করতে নিশ্চিত করুন",
 "Confirme para excluir": "মুছতে নিশ্চিত করুন",
 "Confirme sua senha para sincronizar": "সিঙ্ক করতে আপনার পাসওয়ার্ড নিশ্চিত করুন",
 "Confraternização": "মিলনমেলা",
 "Confraternização Universal": "নববর্ষ দিবস",
 "Conselho": "কাউন্সিল",
 "Consignado": "বেতন-কর্তন ঋণ",
 "Consulta": "ডাক্তার দেখানো",
 "Consulta ou vacina": "ডাক্তার দেখানো বা টিকা",
 "Consultas": "ডাক্তার দেখানো",
 "Consultório": "ক্লিনিক",
 "Consumo médio: {v} km/L": "গড় খরচ: {v} km/L",
 "Conta": "অ্যাকাউন্ট",
 "Conta a pagar": "দেয় বিল",
 "Conta a receber": "প্রাপ্য অর্থ",
 "Conta de consumo ou tributo": "ইউটিলিটি বিল বা কর",
 "Conta os dias em que cada item estava previsto (pelos dias da semana dele) e os que foram marcados como feitos.": "প্রতিটি আইটেম কত দিন নির্ধারিত ছিল (তার সপ্তাহের দিন অনুযায়ী) এবং কত দিন সম্পন্ন হিসেবে চিহ্নিত হয়েছে তা গোনে।",
 "Conta paga": "বিল পরিশোধিত",
 "Conta recebida": "অর্থ পাওয়া গেছে",
 "Conta vence hoje": "বিল আজ পরিশোধের শেষ দিন",
 "Conta vencendo": "বিলের শেষ তারিখ ঘনিয়ে আসছে",
 "Contabilidade": "হিসাববিজ্ঞান",
 "Contando os acompanhantes. Toque no status do convidado para mudar.": "সঙ্গীসহ গণনা। বদলাতে অতিথির অবস্থায় ট্যাপ করুন।",
 "Contando: {cliente}": "গণনা চলছে: {cliente}",
 "Contas": "বিল",
 "Contas a pagar": "দেনা বিল",
 "Contas a pagar e a receber, gastos do mês, aviso de vencimento e controle do MEI (Mestre Achado).": "দেয় ও প্রাপ্য বিল, মাসের খরচ, শেষ তারিখের সতর্কতা এবং MEI নিয়ন্ত্রণ (Mestre Achado)।",
 "Contas a receber": "পাওনা অর্থ",
 "Contas fixas": "নির্দিষ্ট বিল",
 "Contato": "কন্টাক্ট",
 "Contato de emergência": "জরুরি যোগাযোগ",
 "Contato do encarregado de dados:": "ডেটা সুরক্ষা কর্মকর্তার যোগাযোগ:",
 "Conte a sua ideia para o app ficar melhor.": "অ্যাপটি আরও ভালো করতে আপনার আইডিয়া জানান।",
 "Conte o que está difícil ou não funciona como deveria.": "কী কঠিন লাগছে বা ঠিকমতো কাজ করছে না তা জানান।",
 "Conte o que você fez, o que esperava e o que apareceu. Se tiver uma mensagem de erro, copie aqui.": "আপনি কী করেছেন, কী আশা করেছিলেন এবং কী দেখা গেছে তা জানান। কোনো এরর মেসেজ থাকলে এখানে কপি করুন।",
 "Conte para a gente problemas, erros e ideias de melhoria. Sua mensagem vai direto para a equipe do My Planner.": "সমস্যা, এরর ও উন্নতির আইডিয়া আমাদের জানান। আপনার মেসেজ সরাসরি My Planner টিমের কাছে যায়।",
 "Conteúdo": "বিষয়বস্তু",
 "Conteúdo que você cria: tarefas, anotações, finanças, documentos, fotos, anexos e dados das abas.": "আপনার তৈরি কনটেন্ট: কাজ, নোট, ফাইন্যান্স, ডকুমেন্ট, ছবি, অ্যাটাচমেন্ট এবং ট্যাবের ডেটা।",
 "Conteúdo, matéria, tarefa de casa...": "বিষয়বস্তু, বিষয়, বাড়ির কাজ...",
 "Continuar": "চালিয়ে যান",
 "Continue usando o My Planner e as Anotações por {preco} por ano. Seus dados continuam guardados.": "বছরে {preco}-তে My Planner ও নোট ব্যবহার চালিয়ে যান। আপনার ডেটা সংরক্ষিত থাকবে।",
 "Contratado": "চুক্তিবদ্ধ",
 "Contratado: {v}": "চুক্তিবদ্ধ: {v}",
 "Contrato": "চুক্তি",
 "Conversa": "চ্যাট",
 "Conversa do grupo": "গ্রুপ চ্যাট",
 "Conversar": "চ্যাট করুন",
 "Conversar com o Mestre (precisa da sua IA)": "মাস্টারের সাথে কথা বলুন (আপনার AI লাগবে)",
 "Converse com amigos e grupos, e faça chamadas de áudio e vídeo.": "বন্ধু ও গ্রুপের সাথে চ্যাট করুন, আর অডিও ও ভিডিও কল করুন।",
 "Converter de PDF": "PDF থেকে রূপান্তর",
 "Converter para PDF": "PDF-এ রূপান্তর",
 "Convidado": "অতিথি",
 "Convidados": "অতিথিরা",
 "Convidados com confirmação de presença, fornecedores e o cronograma do grande dia.": "উপস্থিতি নিশ্চিতকরণসহ অতিথি, সরবরাহকারী এবং বিশেষ দিনের সময়সূচি।",
 "Convidados e cronograma do dia, sem os valores.": "অতিথি ও দিনের সময়সূচি, টাকার পরিমাণ ছাড়া।",
 "Convidar": "আমন্ত্রণ",
 "Convidar pelo WhatsApp": "WhatsApp-এ আমন্ত্রণ জানান",
 "Convite": "আমন্ত্রণ",
 "Convite copiado. Cole onde quiser enviar.": "আমন্ত্রণ কপি হয়েছে। যেখানে পাঠাতে চান সেখানে পেস্ট করুন।",
 "Convite inválido ou trocado pelo administrador. Peça um link novo.": "আমন্ত্রণটি অবৈধ বা অ্যাডমিন বদলে দিয়েছেন। নতুন লিংক চেয়ে নিন।",
 "Convite para o My Planner": "My Planner-এ আমন্ত্রণ",
 "Convênio": "বিমা",
 "Copiar": "কপি করুন",
 "Copiar a lista para uma tarefa": "তালিকাটি একটি কাজে কপি করুন",
 "Copiar o código": "কোড কপি করুন",
 "Copiar para hoje": "আজকে কপি করুন",
 "Copo de outro tamanho": "অন্য মাপের গ্লাস",
 "Copo {n}": "গ্লাস {n}",
 "Cor": "রং",
 "Cor do fichário": "বাইন্ডারের রং",
 "Cor do tema": "থিমের রং",
 "Cor do tema de cada aba": "প্রতিটি ট্যাবের থিম রং",
 "Coração": "হৃদয়",
 "Corações": "হৃদয়",
 "Cores das abas": "ট্যাবের রং",
 "Cores das conversas": "চ্যাটের রং",
 "Cores e opções desta aba": "এই ট্যাবের রং ও বিকল্প",
 "Corpo": "শরীর",
 "Corporativo": "কর্পোরেট",
 "Corpus Christi": "কর্পাস ক্রিস্টি",
 "Corredor": "করিডোর",
 "Correia dentada": "টাইমিং বেল্ট",
 "Corrida": "দৌড়",
 "Corta as bordas em branco ou partes da página.": "ফাঁকা কিনারা বা পৃষ্ঠার অংশ কেটে ফেলে।",
 "Cortesia": "বিনামূল্যে",
 "Coxa e sobrecoxa": "মুরগির রান ও উরু",
 "Cozinha": "রান্নাঘর",
 "Creatina": "ক্রিয়েটিন",
 "Criada em {data}": "{data} তারিখে তৈরি",
 "Criado com": "যা দিয়ে তৈরি",
 "Criado em": "তৈরির তারিখ",
 "Criança": "শিশু",
 "Crianças": "শিশুরা",
 "Criar": "তৈরি করুন",
 "Criar animada": "অ্যানিমেটেড বানান",
 "Criar conta": "অ্যাকাউন্ট তৈরি করুন",
 "Criar do zero": "শূন্য থেকে তৈরি করুন",
 "Criar documento, planilha ou apresentação": "ডকুমেন্ট, স্প্রেডশিট বা প্রেজেন্টেশন তৈরি করুন",
 "Criar em outro app": "অন্য অ্যাপে তৈরি করুন",
 "Criar escritório": "অফিস তৈরি করুন",
 "Criar fichário": "বাইন্ডার তৈরি করুন",
 "Criar figurinha": "স্টিকার বানান",
 "Criar grupo": "গ্রুপ তৈরি করুন",
 "Criar grupo e convidar pessoas": "গ্রুপ তৈরি করে লোকদের আমন্ত্রণ জানান",
 "Criar minha chave de API": "আমার API কী তৈরি করুন",
 "Criar o cofre": "ভল্ট তৈরি করুন",
 "Criar o grupo e convidar": "গ্রুপ তৈরি করে আমন্ত্রণ জানান",
 "Criar os prazos do IR de {ano}": "{ano} সালের আয়করের সময়সীমা তৈরি করুন",
 "Criar uma meta (viagem, reserva, carro...)": "লক্ষ্য তৈরি করুন (ভ্রমণ, সঞ্চয়, গাড়ি...)",
 "Criar uma senha nova": "নতুন পাসওয়ার্ড তৈরি করুন",
 "Criar {n} tarefa(s)": "{n}টি কাজ তৈরি করুন",
 "Criação do Estado de MS": "MS রাজ্য প্রতিষ্ঠা দিবস",
 "Crie a mudança e o app já monta a lista de transferências (luz, água, internet...). Depois cadastre as caixas por cômodo, as vistorias e o cronograma dos dias.": "স্থানান্তর তৈরি করুন, অ্যাপ নিজেই স্থানান্তরের তালিকা (বিদ্যুৎ, পানি, ইন্টারনেট...) বানিয়ে দেবে। তারপর ঘর অনুযায়ী বাক্স, পরিদর্শন ও দিনের সময়সূচি যোগ করুন।",
 "Crie a pasta de cada cliente, convide o cliente pelo link (ele só vê a pasta dele) e troquem documentos nos dois sentidos: notas, guias, folha, extratos, contratos.": "প্রতিটি ক্লায়েন্টের ফোল্ডার তৈরি করুন, লিংক দিয়ে ক্লায়েন্টকে আমন্ত্রণ জানান (তিনি শুধু নিজের ফোল্ডার দেখেন) এবং দুই দিক থেকেই নথি আদান-প্রদান করুন: ইনভয়েস, কর চালান, বেতন তালিকা, স্টেটমেন্ট, চুক্তি।",
 "Crie a turma (ou grupo de mentoria, treino, curso) e, dentro dela, os alunos, a chamada, as notas, os planos de aula, os materiais e as cobranças.": "ক্লাস (বা মেন্টরিং, ট্রেনিং, কোর্সের গ্রুপ) তৈরি করুন এবং তার ভেতরে শিক্ষার্থী, হাজিরা, নম্বর, পাঠ পরিকল্পনা, উপকরণ ও চার্জ যোগ করুন।",
 "Crie a turma e, dentro dela, os alunos, a chamada, as avaliações com notas e os planos de aula.": "ক্লাস তৈরি করুন, তার ভেতরে শিক্ষার্থী, হাজিরা, নম্বরসহ মূল্যায়ন ও পাঠ পরিকল্পনা যোগ করুন।",
 "Crie as tarefas da casa (limpar banheiro, trocar roupa de cama...) com a frequência. O app avisa quando estão atrasadas, sem encher o My Planner.": "ঘরের কাজ (বাথরুম পরিষ্কার, বিছানার চাদর বদলানো...) পুনরাবৃত্তিসহ তৈরি করুন। দেরি হলে অ্যাপ জানাবে, My Planner ভরিয়ে না ফেলে।",
 "Crie cards com checklist, lista, texto livre ou desenho para esta matéria. Arraste para a direita para excluir e para a esquerda para arquivar.": "এই বিষয়ের জন্য চেকলিস্ট, তালিকা, মুক্ত লেখা বা আঁকা দিয়ে কার্ড বানান। মুছতে ডানে, আর্কাইভ করতে বাঁয়ে সোয়াইপ করুন।",
 "Crie o escritório, chame a equipe (amigos do app ou convite pelo link) e troquem mensagens e documentos, marquem reuniões e façam reunião de vídeo. Você, que administra, pode gravar as reuniões.": "অফিস তৈরি করুন, টিমকে ডাকুন (অ্যাপের বন্ধু বা লিংকে আমন্ত্রণ), তারপর বার্তা ও নথি আদান-প্রদান করুন, মিটিং ঠিক করুন এবং ভিডিও মিটিং করুন। অ্যাডমিন হিসেবে আপনি মিটিং রেকর্ড করতে পারেন।",
 "Crie o evento e, dentro dele, a lista de convidados com confirmação de presença, os fornecedores e o cronograma do dia.": "ইভেন্ট তৈরি করুন, তার ভেতরে উপস্থিতি নিশ্চিতকরণসহ অতিথি তালিকা, সরবরাহকারী ও দিনের সময়সূচি যোগ করুন।",
 "Crie o grupo e mande o link: quem entrar recebe data, local, avisos e tudo o que você enviar, e aceita, edita ou recusa.": "গ্রুপ তৈরি করে লিংক পাঠান: যে যোগ দেবে সে তারিখ, স্থান, নোটিশ এবং আপনার পাঠানো সবকিছু পাবে, এবং গ্রহণ, সম্পাদনা বা প্রত্যাখ্যান করতে পারবে।",
 "Crie o grupo e mande o link: quem entrar vê e participa conforme o papel que você escolher. Só quem administra coloca ou tira pessoas.": "গ্রুপ তৈরি করে লিংক পাঠান: যে যোগ দেবে সে আপনার বেছে নেওয়া ভূমিকা অনুযায়ী দেখতে ও অংশ নিতে পারবে। শুধু অ্যাডমিনরাই লোক যোগ বা সরাতে পারেন।",
 "Crie o grupo e mande o link: quem entrar vê tudo o que está aqui dentro e participa (inclui, edita, põe fotos). Só quem administra coloca ou tira pessoas.": "গ্রুপ তৈরি করে লিংক পাঠান: যে যোগ দেবে সে এখানকার সবকিছু দেখবে ও অংশ নেবে (যোগ, সম্পাদনা, ছবি দেওয়া)। শুধু অ্যাডমিনরাই লোক যোগ বা সরাতে পারেন।",
 "Crie sua conta. Seus dados ficam salvos na nuvem e neste dispositivo.": "আপনার অ্যাকাউন্ট তৈরি করুন। আপনার তথ্য ক্লাউডে ও এই ডিভাইসে সংরক্ষিত থাকবে।",
 "Crie um fichário (ex.: Doutorado, Inglês, Concurso) e dentro dele as matérias e páginas.": "একটি বাইন্ডার তৈরি করুন (যেমন: ডক্টরেট, ইংরেজি, চাকরির পরীক্ষা) এবং তার ভেতরে বিষয় ও পৃষ্ঠা।",
 "Crie um grupo (turma, pacientes, equipe, convidados, clientes), mande o link de convite e envie compromissos, materiais e avisos. Cada pessoa aceita, edita ou recusa o que recebe.": "একটি গ্রুপ তৈরি করুন (ক্লাস, রোগী, টিম, অতিথি, ক্লায়েন্ট), আমন্ত্রণ লিংক পাঠান এবং অ্যাপয়েন্টমেন্ট, উপকরণ ও নোটিশ পাঠান। প্রত্যেকে যা পান তা গ্রহণ, সম্পাদনা বা প্রত্যাখ্যান করেন।",
 "Crie um perfil com nome e, se for advogado, a OAB.": "নাম দিয়ে একটি প্রোফাইল তৈরি করুন এবং আইনজীবী হলে OAB দিন।",
 "Criptografado no cofre, só neste dispositivo": "ভল্টে এনক্রিপ্ট করা, শুধু এই ডিভাইসে",
 "Criptomoedas": "ক্রিপ্টোকারেন্সি",
 "Cronograma": "সময়সূচি",
 "Cronograma alimentar, cuidados pessoais com passo a passo e água do dia.": "খাদ্য সময়সূচি, ধাপে ধাপে ব্যক্তিগত যত্ন এবং দিনের পানি।",
 "Cronograma do dia": "দিনের সময়সূচি",
 "Cronograma físico-financeiro": "ভৌত-আর্থিক সময়সূচি",
 "Cronograma físico-financeiro por etapa, diário da obra com antes e depois, profissionais e entregas.": "ধাপ অনুযায়ী ভৌত-আর্থিক সময়সূচি, আগে ও পরের ছবিসহ কাজের ডায়েরি, কারিগর ও সরবরাহ।",
 "Cronômetro de horas": "ঘণ্টার টাইমার",
 "Crédito empresarial": "ব্যবসায়িক ঋণ",
 "Créditos": "ক্রেডিট",
 "Cuida das reservas, da limpeza e das despesas.": "বুকিং, পরিষ্কার ও খরচ দেখাশোনা করেন।",
 "Cuidado": "যত্ন",
 "Cuidado pessoal": "ব্যক্তিগত যত্ন",
 "Cuidados": "যত্ন",
 "Cupom do mercado": "সুপারমার্কেটের রসিদ",
 "Cupom do mercado (foto)": "সুপারমার্কেটের রসিদ (ছবি)",
 "Cupom lançado": "রসিদ যোগ হয়েছে",
 "Curitiba": "Curitiba",
 "Curitiba (PR)": "Curitiba (PR)",
 "Curso": "কোর্স",
 "Cursos": "কোর্স",
 "Cursos livres e certificações": "স্বাধীন কোর্স ও সার্টিফিকেশন",
 "Cuscuz": "ভুট্টার কুসকুস",
 "CÓDIGO PARA PAGAR": "পেমেন্ট কোড",
 "CÔMODOS": "ঘরসমূহ",
 "Câmera": "ক্যামেরা",
 "Câmera e galeria": "ক্যামেরা ও গ্যালারি",
 "Câmera não liberada": "ক্যামেরার অনুমতি নেই",
 "Código IBGE do município": "পৌরসভার IBGE কোড",
 "Código IBGE do município (7 números)": "পৌরসভার IBGE কোড (৭ সংখ্যা)",
 "Código NBS (9 números, opcional)": "NBS কোড (৯ সংখ্যা, ঐচ্ছিক)",
 "Código copiado": "কোড কপি হয়েছে",
 "Código da reserva (localizador)": "বুকিং কোড (PNR)",
 "Código de barras, linha digitável ou Pix copia e cola (opcional)": "বারকোড, ডিজিটাল লাইন বা Pix কপি-পেস্ট (ঐচ্ছিক)",
 "Código de indicação": "রেফারেল কোড",
 "Código de indicação (opcional)": "রেফারেল কোড (ঐচ্ছিক)",
 "Código de quem convidou você": "যিনি আপনাকে আমন্ত্রণ জানিয়েছেন তাঁর কোড",
 "Código de tributação nacional (6 números)": "জাতীয় কর কোড (৬ সংখ্যা)",
 "Código de tributação nacional (6 números, ex.: 171901)": "জাতীয় কর কোড (৬ সংখ্যা, যেমন: 171901)",
 "Código do amigo": "বন্ধুর কোড",
 "Código do convite": "আমন্ত্রণ কোড",
 "Código do procedimento (TUSS ou do plano)": "প্রক্রিয়ার কোড (TUSS বা বিমার)",
 "Código errado. Confira e tente de novo.": "ভুল কোড। যাচাই করে আবার চেষ্টা করুন।",
 "Código não encontrado. Confira as letras e os números.": "কোড পাওয়া যায়নি। অক্ষর ও সংখ্যাগুলো যাচাই করুন।",
 "Código não reconhecido. Confira os números (boleto: 47 ou 48 números).": "কোড চেনা যায়নি। সংখ্যাগুলো যাচাই করুন (বোলেটো: 47 বা 48 সংখ্যা)।",
 "Código: {c}": "কোড: {c}",
 "Cópia automática toda semana": "প্রতি সপ্তাহে স্বয়ংক্রিয় ব্যাকআপ",
 "Cópia criada.": "কপি তৈরি হয়েছে।",
 "Cópia de segurança": "ব্যাকআপ",
 "Cópia feita": "ব্যাকআপ হয়েছে",
 "Cópia restaurada.": "ব্যাকআপ পুনরুদ্ধার হয়েছে।",
 "Cômodo": "ঘর",
 "Cômodo ou quarto": "একটি ঘর",
 "Cômodos da casa e as tarefas de cada um.": "বাড়ির ঘরগুলো এবং প্রতিটির কাজ।",
 "DAS de {mes} pago": "{mes}-এর DAS পরিশোধিত",
 "DAS de {mes}: vence dia {dia}": "{mes}-এর DAS: {dia} তারিখে শেষ দিন",
 "DAS do MEI": "MEI-এর DAS",
 "DECLARAÇÃO DE ATENDIMENTO": "চিকিৎসা ঘোষণাপত্র",
 "DICA DO MESTRE ACHADO": "MESTRE ACHADO-র পরামর্শ",
 "DPS nº {n}, série {s}": "DPS নং {n}, সিরিজ {s}",
 "Da galeria ou dos arquivos": "গ্যালারি বা ফাইল থেকে",
 "Da meta de passos": "ধাপের লক্ষ্যের",
 "Dados compartilhados": "শেয়ার করা ডেটা",
 "Dados compartilhados com o grupo": "গ্রুপের সাথে শেয়ার করা ডেটা",
 "Dados compartilhados · seu papel: {p}": "শেয়ার করা ডেটা · আপনার ভূমিকা: {p}",
 "Dados de saúde que você mesmo registra são tratados só para você e para quem você compartilhar, com o seu consentimento (art. 11, I).": "আপনি নিজে যে স্বাস্থ্য ডেটা লেখেন তা শুধু আপনার জন্য এবং যাদের সঙ্গে আপনি শেয়ার করেন তাদের জন্য, আপনার সম্মতিতে, প্রক্রিয়া করা হয় (art. 11, I)।",
 "Dados do dispositivo: idioma, país e fuso horário (para datas, feriados e moeda), modelo do dispositivo e o código para avisos no celular.": "ডিভাইসের ডেটা: ভাষা, দেশ ও টাইম জোন (তারিখ, ছুটি ও মুদ্রার জন্য), ডিভাইসের মডেল এবং ফোনে নোটিফিকেশনের কোড।",
 "Dados do relógio e de saúde não são usados para publicidade nem repassados a ninguém. Você pode desconectar e revogar a permissão a qualquer momento.": "ঘড়ি ও স্বাস্থ্যের ডেটা বিজ্ঞাপনে ব্যবহার করা হয় না এবং কারও সাথে শেয়ার করা হয় না। আপনি যেকোনো সময় সংযোগ বিচ্ছিন্ন করে অনুমতি প্রত্যাহার করতে পারেন।",
 "Dança": "নাচ",
 "Dar ciência": "অবগতি দিন",
 "Dar ciência da operação?": "লেনদেনের অবগতি দেবেন?",
 "Data": "তারিখ",
 "Data (embarque ou check-in)": "তারিখ (যাত্রা বা চেক-ইন)",
 "Data agendada": "নির্ধারিত তারিখ",
 "Data da aplicação": "প্রয়োগের তারিখ",
 "Data da compra": "কেনার তারিখ",
 "Data da entrega": "সরবরাহের তারিখ",
 "Data da venda": "বিক্রির তারিখ",
 "Data de nascimento": "জন্মতারিখ",
 "Data do empréstimo": "ধারের তারিখ",
 "Data do pagamento": "পরিশোধের তারিখ",
 "Data em que foi feita": "সম্পন্ন হওয়ার তারিখ",
 "Data sugerida com 2 dias úteis de folga. Confira no sistema oficial.": "প্রস্তাবিত তারিখে ২ কর্মদিবসের অবকাশ রাখা হয়েছে। সরকারি সিস্টেমে যাচাই করুন।",
 "De": "থেকে",
 "De uma foto": "ছবি থেকে",
 "De {de} para {para} ({p}% menor).": "{de} থেকে {para} ({p}% ছোট)।",
 "Declaração": "ঘোষণাপত্র",
 "Declaração de atendimento": "চিকিৎসা ঘোষণাপত্র",
 "Declaração para reembolso (PDF)": "রিইমবার্সমেন্টের ঘোষণাপত্র (PDF)",
 "Declaro que esta empresa é minha ou de cliente que autorizou o acompanhamento.": "আমি ঘোষণা করছি যে এই প্রতিষ্ঠানটি আমার, অথবা এমন ক্লায়েন্টের যিনি পর্যবেক্ষণের অনুমতি দিয়েছেন।",
 "Declaro, para fins de reembolso{conv}, que o(a) paciente {nome}{cpf}{cart} foi atendido(a) por mim em {data}{hora}, em {tipo}.": "আমি রিইমবার্সমেন্টের উদ্দেশ্যে{conv} ঘোষণা করছি যে রোগী {nome}{cpf}{cart} {data} তারিখে{hora} {tipo} হিসেবে আমার কাছে চিকিৎসা নিয়েছেন।",
 "Defina a meta de aulas por dia ou por semana em Editar.": "সম্পাদনায় দিনে বা সপ্তাহে ক্লাসের লক্ষ্য ঠিক করুন।",
 "Defina a meta de páginas por dia em Editar.": "সম্পাদনায় দিনে পৃষ্ঠার লক্ষ্য ঠিক করুন।",
 "Defina um horário": "একটি সময় ঠিক করুন",
 "Defina um horário para usar pausas.": "বিরতি ব্যবহার করতে একটি সময় ঠিক করুন।",
 "Demaquilante ou água micelar": "মেকআপ রিমুভার বা মাইসেলার ওয়াটার",
 "Demolição": "ভাঙা",
 "Demonstração": "ডেমো",
 "Dentista": "দন্তচিকিৎসক",
 "Dependentes": "নির্ভরশীল",
 "Depois": "পরে",
 "Depois da aula": "ক্লাসের পরে",
 "Depois de apagadas, as tarefas não voltam. Digite a senha da sua conta para confirmar.": "মুছে ফেলা কাজ আর ফিরে আসে না। নিশ্চিত করতে আপনার অ্যাকাউন্টের পাসওয়ার্ড দিন।",
 "Depois de baixar, abra o arquivo e toque em Instalar. Se o celular pedir, permita instalar apps desta fonte.": "ডাউনলোডের পর ফাইলটি খুলে ইনস্টল ট্যাপ করুন। মোবাইল অনুমতি চাইলে এই উৎস থেকে অ্যাপ ইনস্টলের অনুমতি দিন।",
 "Depois de criar": "তৈরি করার পর",
 "Depois de {nome}. Toque para pular.": "{nome}-এর পরে। এড়িয়ে যেতে ট্যাপ করুন।",
 "Depois é só ajustar horários e o que comer em cada um.": "এরপর শুধু সময় এবং প্রতিবার কী খাবেন তা ঠিক করে নিন।",
 "Desarquivar": "আর্কাইভ থেকে সরান",
 "Desbloquear": "আনলক করুন",
 "Desbloquear com": "আনলক করার উপায়",
 "Desbloquear com biometria": "বায়োমেট্রিক দিয়ে আনলক করুন",
 "Desbloquear o My Planner": "My Planner আনলক করুন",
 "Desbloqueio do app": "অ্যাপ আনলক",
 "Descanso": "বিশ্রাম",
 "Descartadas": "বাতিলকৃত",
 "Descartar": "বাদ দিন",
 "Descartar este tempo?": "এই সময় বাদ দেবেন?",
 "Descobrir lugares em {d}": "{d}-এ জায়গা খুঁজুন",
 "Desconectar": "সংযোগ বিচ্ছিন্ন করুন",
 "Desconectar o {nome}?": "{nome}-এর সংযোগ বিচ্ছিন্ন করবেন?",
 "Desconto": "ছাড়",
 "Desconto de {v}": "{v} ছাড়",
 "Descontos obtidos": "প্রাপ্ত ছাড়",
 "Descrição": "বিবরণ",
 "Descrição (cliente, nota fiscal...)": "বিবরণ (গ্রাহক, চালান...)",
 "Descrição do serviço (sai na nota)": "সেবার বিবরণ (ইনভয়েসে থাকবে)",
 "Descrição que sai na nota": "ইনভয়েসে যে বিবরণ থাকবে",
 "Desenhar a assinatura": "স্বাক্ষর আঁকুন",
 "Desenhar com caneta ou dedo": "কলম বা আঙুল দিয়ে আঁকুন",
 "Desenhe a assinatura e escolha a página e o lugar.": "স্বাক্ষর আঁকুন এবং পৃষ্ঠা ও জায়গা বেছে নিন।",
 "Desenhe a assinatura primeiro.": "আগে স্বাক্ষর আঁকুন।",
 "Desenhe com o dedo ou com a caneta (S Pen, Apple Pencil ou caneta de tablet).": "আঙুল বা কলম (S Pen, Apple Pencil বা ট্যাবলেট পেন) দিয়ে আঁকুন।",
 "Desenhe com o dedo ou com a caneta. Para rolar o quadro, toque em Mover.": "আঙুল বা কলম দিয়ে আঁকুন। বোর্ড স্ক্রল করতে সরান-এ ট্যাপ করুন।",
 "Desenhe de novo para confirmar.": "নিশ্চিত করতে আবার আঁকুন।",
 "Desenhe o seu padrão": "আপনার প্যাটার্ন আঁকুন",
 "Desenhe pelo menos uma tarja.": "অন্তত একটি দাগ আঁকুন।",
 "Desenhe um padrão ligando pelo menos 4 pontos.": "কমপক্ষে ৪টি বিন্দু যুক্ত করে একটি প্যাটার্ন আঁকুন।",
 "Desenho": "আঁকা",
 "Desenho com caneta ou dedo": "কলম বা আঙুল দিয়ে আঁকা",
 "Desenho incorreto": "ভুল প্যাটার্ন",
 "Desenho padrão": "প্যাটার্ন",
 "Desenho padrão salvo.": "প্যাটার্ন সংরক্ষিত হয়েছে।",
 "Desenvolvimento": "শোল্ডার প্রেস",
 "Desfazer": "পূর্বাবস্থায় ফেরান",
 "Desfazer amizade": "বন্ধুত্ব বাতিল করুন",
 "Desligar": "বন্ধ করুন",
 "Desligar a sincronização?": "সিঙ্ক বন্ধ করবেন?",
 "Deslize para os lados para ver outros dias (até 60 dias à frente). Toque numa refeição para planejar o cardápio só daquele dia. Arraste para a direita para excluir.": "অন্য দিন দেখতে দুই পাশে সোয়াইপ করুন (৬০ দিন পর্যন্ত সামনে)। শুধু সেই দিনের মেনু পরিকল্পনা করতে কোনো খাবারে ট্যাপ করুন। মুছতে ডান দিকে টানুন।",
 "Desmarcado": "বাতিল করা হয়েছে",
 "Desmarcar como recebida": "প্রাপ্ত চিহ্ন সরান",
 "Desmarcar feita hoje": "আজকের সম্পন্ন চিহ্ন সরান",
 "Desmarcar grupo": "গ্রুপের নির্বাচন বাতিল করুন",
 "Desmarcar pagamento": "পরিশোধ চিহ্ন সরান",
 "Desodorante": "ডিওডোরেন্ট",
 "Despensa": "ভাঁড়ার ঘর",
 "Despesa": "খরচ",
 "Despesas": "খরচ",
 "Destino": "গন্তব্য",
 "Detalhes": "বিস্তারিত",
 "Devolver até": "ফেরতের শেষ তারিখ",
 "Devolver: {i} ({p})": "ফেরত দিন: {i} ({p})",
 "Devolvido": "ফেরত দেওয়া হয়েছে",
 "Devolvidos": "ফেরত দেওয়া",
 "Dia": "দিন",
 "Dia a dia": "দৈনন্দিন",
 "Dia da mudança": "স্থানান্তরের দিন",
 "Dia de vencimento do DAS": "DAS-এর শেষ তারিখ",
 "Dia do Trabalho": "শ্রমিক দিবস",
 "Dia do vencimento": "নির্ধারিত দিন",
 "Dia em que a fatura fecha": "কার্ড বিল বন্ধ হওয়ার দিন",
 "Dia planejado": "পরিকল্পিত দিন",
 "Dia {d} de {total}": "দিন {d} / {total}",
 "Diagnóstico": "রোগনির্ণয়",
 "Dias e horários": "দিন ও সময়",
 "Dias específicos": "নির্দিষ্ট দিন",
 "Dias úteis": "কর্মদিবস",
 "Dias: {dias}": "দিন: {dias}",
 "Dicas e observações": "টিপস ও মন্তব্য",
 "Diesel": "ডিজেল",
 "Diferença": "পার্থক্য",
 "Digitado": "হাতে লেখা",
 "Digitar": "টাইপ করুন",
 "Digitar à mão": "হাতে লিখুন",
 "Digite a senha do cofre. Ele fecha sozinho depois de 5 minutos sem uso.": "ভল্টের পাসওয়ার্ড দিন। ৫ মিনিট ব্যবহার না হলে এটি নিজেই বন্ধ হয়।",
 "Digite em minutos (90) ou em horas e minutos (1:30 ou 01:30) e toque em OK.": "মিনিটে (90) বা ঘণ্টা ও মিনিটে (1:30 বা 01:30) লিখুন এবং ঠিক আছে-তে ট্যাপ করুন।",
 "Digite no formato HH:MM, por exemplo 13:30.": "HH:MM ফরম্যাটে লিখুন, যেমন 13:30।",
 "Digite o código e ganhe 10 dias com todas as abas liberadas. Se não tiver, deixe em branco.": "কোড দিন এবং সব ট্যাব খোলা অবস্থায় 10 দিন পান। কোড না থাকলে ফাঁকা রাখুন।",
 "Digite o nome da tarefa.": "কাজের নাম লিখুন।",
 "Dinheiro": "টাকা",
 "Dinheiro e documentos": "টাকা ও নথি",
 "Direita": "ডান",
 "Direito": "আইন",
 "Direito Administrativo": "প্রশাসনিক আইন",
 "Direito Civil": "দেওয়ানি আইন",
 "Direito Constitucional": "সাংবিধানিক আইন",
 "Direito Empresarial": "বাণিজ্যিক আইন",
 "Direito Penal": "ফৌজদারি আইন",
 "Direito Tributário": "কর আইন",
 "Direito do Trabalho": "শ্রম আইন",
 "Direto": "সরাসরি",
 "Disciplina": "বিষয়",
 "Dispensar": "সরিয়ে দিন",
 "Dispensar o aviso": "নোটিশ বন্ধ করুন",
 "Dispensar todas": "সব বন্ধ করুন",
 "Disponibilizada em": "প্রকাশের তারিখ",
 "Disponível no app novo": "নতুন অ্যাপে পাওয়া যাবে",
 "Distância": "দূরত্ব",
 "Divida o curso em matérias ou módulos. Em cada uma, marque em que aula parou e crie cards de anotações.": "কোর্সটি বিষয় বা মডিউলে ভাগ করুন। প্রতিটিতে কোন ক্লাসে থেমেছেন চিহ্নিত করুন এবং নোট কার্ড বানান।",
 "Dividir": "ভাগ করুন",
 "Dividir entre (nenhum marcado = todos)": "কাদের মধ্যে ভাগ (কেউ না বাছলে = সবাই)",
 "Divisão das despesas": "খরচ ভাগাভাগি",
 "Diária": "প্রতি রাতের ভাড়া",
 "Diária padrão": "সাধারণ প্রতি রাতের ভাড়া",
 "Diário": "ডায়েরি",
 "Diários municipais": "পৌর গেজেট",
 "Do celular, do Google Drive ou do OneDrive": "মোবাইল, Google Drive বা OneDrive থেকে",
 "Do cliente": "ক্লায়েন্টের",
 "Do escritório": "অফিসের",
 "Doações": "দান",
 "Docs": "ডকস",
 "Documento": "নথি",
 "Documento (fundo branco)": "নথি (সাদা পটভূমি)",
 "Documento do veículo (CRLV)": "যানবাহনের নথি (CRLV)",
 "Documento pessoal": "ব্যক্তিগত নথি",
 "Documento vence hoje": "নথির মেয়াদ আজ শেষ",
 "Documento vencendo": "নথির মেয়াদ শেষ হচ্ছে",
 "Documento: {o}": "নথি: {o}",
 "Documentos": "নথি",
 "Documentos (contrato, nota, recibo...)": "নথি (চুক্তি, ইনভয়েস, রসিদ...)",
 "Documentos (passaporte, identidade, carteira de motorista)": "নথি (পাসপোর্ট, পরিচয়পত্র, ড্রাইভিং লাইসেন্স)",
 "Documentos e autorização das crianças": "শিশুদের নথি ও অনুমতিপত্র",
 "Documentos protegidos, exames, histórico de saúde e outros campos com 🔒 são criptografados aqui no aparelho (AES-256) com a senha do cofre. Nem o suporte consegue ler. Sem a senha, esses dados não podem ser recuperados.": "সুরক্ষিত নথি, পরীক্ষা, স্বাস্থ্য ইতিহাস ও 🔒 চিহ্নিত অন্যান্য ঘর এখানেই ডিভাইসে ভল্টের পাসওয়ার্ড দিয়ে এনক্রিপ্ট হয় (AES-256)। সাপোর্টও এগুলো পড়তে পারে না। পাসওয়ার্ড ছাড়া এই তথ্য উদ্ধার করা যায় না।",
 "Documentos, recibos, cadernos e quadros, com várias páginas": "নথি, রসিদ, খাতা ও বোর্ড, একাধিক পৃষ্ঠাসহ",
 "Documentos, reuniões e gravações são apagados para todos. A conversa continua no Mensagens.": "নথি, মিটিং ও রেকর্ডিং সবার জন্য মুছে যাবে। কথোপকথন বার্তা-তে থেকে যাবে।",
 "Documentário": "ডকুমেন্টারি",
 "Doenças, cirurgias e observações": "রোগ, অস্ত্রোপচার ও মন্তব্য",
 "Dois dedos ou toque duplo para ampliar": "বড় করতে দুই আঙুল বা ডাবল ট্যাপ",
 "Domingo": "রবিবার",
 "Dono da obra": "নির্মাণের মালিক",
 "Dose": "ডোজ",
 "Dose (ex.: 1 cápsula, 5 g)": "ডোজ (যেমন: 1টি ক্যাপসুল, 5 g)",
 "Dose única": "একক ডোজ",
 "Drama": "ড্রামা",
 "Duplicar": "ডুপ্লিকেট করুন",
 "Duplicar tarefa": "কাজের কপি তৈরি করুন",
 "Duração": "সময়কাল",
 "Duração de cada sessão": "প্রতিটি সেশনের সময়কাল",
 "Duração {dur}": "সময়কাল {dur}",
 "Dá para comprar algo de 3 mil em 10 vezes?": "3 হাজারের জিনিস কি 10 কিস্তিতে কেনা যায়?",
 "Débito automático": "অটো ডেবিট",
 "Débito, Pix ou dinheiro": "ডেবিট, Pix বা নগদ",
 "Dê um nome ao cartão.": "কার্ডের একটি নাম দিন।",
 "Dê um nome ao cuidado.": "যত্নের একটি নাম দিন।",
 "Dê um nome ao cômodo.": "ঘরের একটি নাম দিন।",
 "Dê um nome ao fichário.": "বাইন্ডারের একটি নাম দিন।",
 "Dê um nome ao grupo.": "গ্রুপের একটি নাম দিন।",
 "Dê um nome ao suplemento.": "সাপ্লিমেন্টের একটি নাম দিন।",
 "Dê um nome ao treino.": "ওয়ার্কআউটের একটি নাম দিন।",
 "Dê um nome à conta.": "বিলের একটি নাম দিন।",
 "Dê um nome à matéria.": "বিষয়ের একটি নাম দিন।",
 "Dê um nome à meta.": "লক্ষ্যের একটি নাম দিন।",
 "Dê um nome à refeição.": "খাবারের একটি নাম দিন।",
 "Dê um nome à tarefa.": "কাজের একটি নাম দিন।",
 "E-MAIL (OPCIONAL)": "ই-মেইল (ঐচ্ছিক)",
 "E-mail": "ই-মেইল",
 "E-mail (recebe a nota)": "ইমেইল (ইনভয়েস পাবে)",
 "E-mail de contato": "যোগাযোগের ইমেল",
 "E-mail do responsável": "অভিভাবকের ইমেল",
 "E-mail inválido": "ই-মেইল সঠিক নয়",
 "E-mail inválido.": "ই-মেইল সঠিক নয়।",
 "E-mail ou WhatsApp para resposta (opcional)": "উত্তরের জন্য ইমেইল বা WhatsApp (ঐচ্ছিক)",
 "E-mail para contato (opcional)": "যোগাযোগের ই-মেইল (ঐচ্ছিক)",
 "E-mail salvo.": "ইমেল সংরক্ষিত হয়েছে।",
 "EM ATRASO": "বকেয়া",
 "ENTRAR COM UM CÓDIGO": "কোড দিয়ে যোগ দিন",
 "ENVIADOS": "পাঠানো",
 "ESCOLHA AS ATIVIDADES": "কার্যকলাপ বেছে নিন",
 "ESTA SEMANA": "এই সপ্তাহ",
 "EXERCÍCIO FÍSICO": "ব্যায়াম",
 "Economia": "অর্থনীতি",
 "Edita tudo": "সবকিছু সম্পাদনা করেন",
 "Edita tudo: etapas, orçamento, diário e entregas.": "সবকিছু সম্পাদনা করেন: ধাপ, বাজেট, ডায়েরি ও ডেলিভারি।",
 "Editar": "সম্পাদনা",
 "Editar cartão": "কার্ড সম্পাদনা",
 "Editar compra": "কেনাকাটা সম্পাদনা",
 "Editar cômodo": "ঘর সম্পাদনা",
 "Editar desenho": "আঁকা সম্পাদনা",
 "Editar documento": "নথি সম্পাদনা",
 "Editar fichário": "বাইন্ডার সম্পাদনা",
 "Editar garantia": "ওয়ারেন্টি সম্পাদনা",
 "Editar matéria": "বিষয় সম্পাদনা",
 "Editar meta": "লক্ষ্য সম্পাদনা",
 "Editar perfil": "প্রোফাইল সম্পাদনা করুন",
 "Editar tarefa": "কাজ সম্পাদনা",
 "Editar {nome}": "{nome} সম্পাদনা করুন",
 "Educação": "শিক্ষা",
 "Educação Física": "শারীরিক শিক্ষা",
 "Efeito de scanner": "স্ক্যানার ইফেক্ট",
 "Ela sai da lista e dos Recebidos da equipe.": "এটি তালিকা থেকে এবং টিমের প্রাপ্ত থেকে সরে যাবে।",
 "Ela também fica guardada em \"Minhas figurinhas\" para mandar de novo.": "এটি \"আমার স্টিকার\"-এও সংরক্ষিত থাকে, যাতে আবার পাঠাতে পারেন।",
 "Ela vem da aba Empréstimos & Financiamentos. Marque aqui como paga ou abra a aba para ver o contrato.": "এটি ঋণ ও ফাইন্যান্সিং ট্যাব থেকে আসে। এখানে পরিশোধিত চিহ্নিত করুন বা চুক্তি দেখতে ট্যাবটি খুলুন।",
 "Ela vem da aba Notas Fiscais. Marque como recebida quando o dinheiro entrar.": "এটি ইনভয়েস (NF) ট্যাব থেকে আসে। টাকা এলে প্রাপ্ত হিসেবে চিহ্নিত করুন।",
 "Eleitorais": "নির্বাচনী",
 "Eletrodoméstico": "গৃহস্থালি যন্ত্র",
 "Eletrodomésticos": "গৃহস্থালি যন্ত্র",
 "Eletrodomésticos, eletrônicos e móveis: nota fiscal, assistência técnica e aviso 15 dias antes de a garantia acabar.": "গৃহস্থালি যন্ত্র, ইলেকট্রনিক্স ও আসবাব: চালান, সার্ভিস সেন্টার এবং ওয়ারেন্টি শেষ হওয়ার ১৫ দিন আগে সতর্কতা।",
 "Eletrônico": "ইলেকট্রনিক",
 "Elétrica": "বৈদ্যুতিক কাজ",
 "Elétrico": "বৈদ্যুতিক",
 "Em Editar, cole o link do calendário (iCal) do anúncio. No Airbnb: Calendário › Disponibilidade › Conectar calendários › Exportar calendário. No Booking: Tarifas e disponibilidade › Sincronizar calendários.": "সম্পাদনায় লিস্টিংয়ের ক্যালেন্ডার (iCal) লিংক পেস্ট করুন। Airbnb-তে: ক্যালেন্ডার › প্রাপ্যতা › ক্যালেন্ডার সংযুক্ত করুন › ক্যালেন্ডার এক্সপোর্ট করুন। Booking-এ: রেট ও প্রাপ্যতা › ক্যালেন্ডার সিঙ্ক করুন।",
 "Em aberto": "বাকি",
 "Em alta": "ট্রেন্ডিং",
 "Em andamento": "চলছে",
 "Em atraso": "বকেয়া",
 "Em branco": "ফাঁকা",
 "Em casa": "বাড়িতে",
 "Em cima": "ওপরে",
 "Em construção": "নির্মাণাধীন",
 "Em dia. As melhorias chegam sozinhas quando o app abre.": "আপ টু ডেট। অ্যাপ খুললেই উন্নতিগুলো নিজে থেকে চলে আসে।",
 "Em limpeza": "পরিষ্কার চলছে",
 "Em quais páginas": "কোন পৃষ্ঠায়",
 "Em qual agenda criar os eventos:": "কোন ক্যালেন্ডারে ইভেন্ট তৈরি হবে:",
 "Em qual página e onde": "কোন পৃষ্ঠায় এবং কোথায়",
 "Em tratamento": "চিকিৎসাধীন",
 "Em um horário específico": "নির্দিষ্ট সময়ে",
 "Em uso: {ia}": "ব্যবহৃত হচ্ছে: {ia}",
 "Em {n} dia(s)": "{n} দিনে",
 "Embaixo": "নিচে",
 "Embaixo à esquerda": "নিচে বাঁদিকে",
 "Emissão": "ইস্যু",
 "Emissão +": "ইস্যু +",
 "Emissão: {data}": "ইস্যু: {data}",
 "Emitida": "ইস্যু করা",
 "Emitida em {data}": "{data} তারিখে ইস্যু করা",
 "Emitida ou recebida": "ইস্যু করা বা প্রাপ্ত",
 "Emitidas": "ইস্যু করা",
 "Emitidas: {v} · Recebidas: {r} · {n} nota(s)": "ইস্যু করা: {v} · প্রাপ্ত: {r} · {n}টি ইনভয়েস",
 "Emitir": "ইস্যু করুন",
 "Emitir NFS-e": "NFS-e ইস্যু করুন",
 "Emitir NFS-e pelo Padrão Nacional com o certificado A1, buscar as notas emitidas e recebidas e exportar XML, planilha e PDF.": "A1 সার্টিফিকেট দিয়ে Padrão Nacional-এ NFS-e ইস্যু করুন, ইস্যু করা ও প্রাপ্ত ইনভয়েস খুঁজুন এবং XML, স্প্রেডশিট ও PDF রপ্তানি করুন।",
 "Emitir a nota de verdade?": "আসল ইনভয়েস ইস্যু করবেন?",
 "Emitir no ambiente de teste?": "পরীক্ষা পরিবেশে ইস্যু করবেন?",
 "Emojis": "ইমোজি",
 "Emojis animados": "অ্যানিমেটেড ইমোজি",
 "Emojis animados: Noto, do Google (CC BY 4.0).": "অ্যানিমেটেড ইমোজি: Google-এর Noto (CC BY 4.0)।",
 "Emojis, GIFs e figurinhas": "ইমোজি, GIF ও স্টিকার",
 "Empresa": "প্রতিষ্ঠান",
 "Empresa de mudança": "মুভিং কোম্পানি",
 "Empresa ou pessoa": "প্রতিষ্ঠান বা ব্যক্তি",
 "Empresa, hotel ou voo": "প্রতিষ্ঠান, হোটেল বা ফ্লাইট",
 "Empresas": "প্রতিষ্ঠান",
 "Emprestei": "ধার দিয়েছি",
 "Empréstimo": "ধার",
 "Empréstimo entre pessoas": "ব্যক্তিগত লেনদেনের ঋণ",
 "Empréstimo pessoal": "পার্সোনাল লোন",
 "Empréstimos": "ধার",
 "Empréstimos & Financiamentos": "ঋণ ও ফাইন্যান্সিং",
 "Encaminhada para {nome}.": "{nome}-কে ফরোয়ার্ড করা হয়েছে।",
 "Encaminhar": "ফরোয়ার্ড করুন",
 "Encaminhar para": "কাকে ফরোয়ার্ড করবেন",
 "Encerrar e salvar": "শেষ করে সংরক্ষণ করুন",
 "Encontrada para {perfil}": "{perfil}-এর জন্য পাওয়া গেছে",
 "Endereço": "ঠিকানা",
 "Endereço (opcional)": "ঠিকানা (ঐচ্ছিক)",
 "Endereço (se for presencial)": "ঠিকানা (সশরীরে হলে)",
 "Endereço atual": "বর্তমান ঠিকানা",
 "Endereço da escola": "স্কুলের ঠিকানা",
 "Endereço da oficina": "ওয়ার্কশপের ঠিকানা",
 "Endereço de quem está com o item": "যার কাছে জিনিসটি আছে তার ঠিকানা",
 "Endereço do consultório": "ক্লিনিকের ঠিকানা",
 "Endereço do imóvel": "সম্পত্তির ঠিকানা",
 "Endereço do laboratório": "ল্যাবের ঠিকানা",
 "Endereço do veterinário": "পশুচিকিৎসকের ঠিকানা",
 "Endereço no trabalho e na escola": "অফিস ও স্কুলে ঠিকানা",
 "Endereço nos Correios e entregas": "ডাক ও ডেলিভারিতে ঠিকানা",
 "Endereço nos bancos e cartões": "ব্যাংক ও কার্ডে ঠিকানা",
 "Endereço novo": "নতুন ঠিকানা",
 "Endereço ou nome do lugar": "ঠিকানা বা জায়গার নাম",
 "Endereço ou terminal": "ঠিকানা বা টার্মিনাল",
 "Energia": "এনার্জি",
 "Enfermeiro": "নার্স",
 "Engenharia": "প্রকৌশল",
 "Engenheiro ou arquiteto": "প্রকৌশলী বা স্থপতি",
 "Enquadre o documento e toque no botão": "নথিটি ফ্রেমের মধ্যে রাখুন এবং বোতামে ট্যাপ করুন",
 "Enquadre o rosto e toque no botão. 🔄 vira a câmera.": "মুখ ফ্রেমে রাখুন এবং বোতামে ট্যাপ করুন। 🔄 ক্যামেরা ঘোরায়।",
 "Ensino Fundamental": "প্রাথমিক ও নিম্ন মাধ্যমিক",
 "Ensino Médio e ENEM": "উচ্চ মাধ্যমিক ও ENEM",
 "Entendi e concordo em usar o monitor nessas condições.": "আমি বুঝেছি এবং এই শর্তে মনিটর ব্যবহারে সম্মত।",
 "Entra direto no Planner, com horário, dias e a lista de itens. Se o horário já estiver ocupado, você escolhe: substituir, manter as duas ou cancelar.": "সময়, দিন ও আইটেমের তালিকাসহ সরাসরি Planner-এ যোগ হয়। সেই সময় আগে থেকেই ব্যস্ত থাকলে আপনি বেছে নেবেন: প্রতিস্থাপন, দুটোই রাখা বা বাতিল।",
 "Entrada": "আয়",
 "Entrada (imóvel novo)": "প্রবেশ (নতুন বাড়ি)",
 "Entrada de dinheiro": "টাকা জমা",
 "Entrando...": "প্রবেশ করা হচ্ছে...",
 "Entrar": "প্রবেশ করুন",
 "Entrar com CPF e senha": "CPF ও পাসওয়ার্ড দিয়ে প্রবেশ করুন",
 "Entrar com outra conta": "অন্য অ্যাকাউন্ট দিয়ে প্রবেশ করুন",
 "Entrar de novo": "আবার সাইন ইন করুন",
 "Entrar na chamada": "কলে যোগ দিন",
 "Entrar na reunião": "মিটিংয়ে যোগ দিন",
 "Entrar na sala online": "অনলাইন রুমে ঢুকুন",
 "Entrar no grupo": "গ্রুপে যোগ দিন",
 "Entrar no navegador?": "ব্রাউজারে প্রবেশ করবেন?",
 "Entre com seu CPF e sua senha.": "আপনার CPF ও পাসওয়ার্ড দিয়ে প্রবেশ করুন।",
 "Entre com seu e-mail e sua senha.": "আপনার ই-মেইল ও পাসওয়ার্ড দিয়ে লগ ইন করুন।",
 "Entre na sua conta de novo.": "আবার সাইন ইন করুন।",
 "Entre na sua conta para usar as notas fiscais.": "ইনভয়েস ব্যবহার করতে আপনার অ্যাকাউন্টে লগ ইন করুন।",
 "Entre no app com o seu e-mail e a senha nova.": "আপনার ই-মেইল ও নতুন পাসওয়ার্ড দিয়ে অ্যাপে লগ ইন করুন।",
 "Entrega de material": "মালামাল সরবরাহ",
 "Entrega prevista": "সম্ভাব্য সরবরাহ",
 "Entregas": "সরবরাহ",
 "Entregue": "জমা দেওয়া হয়েছে",
 "Entrou": "এসেছে",
 "Entrou no total da semana.": "সপ্তাহের মোট সময়ে যোগ হয়েছে।",
 "Enviada": "পাঠানো হয়েছে",
 "Enviado": "পাঠানো হয়েছে",
 "Enviado para o Planner": "Planner-এ পাঠানো হয়েছে",
 "Enviado pelo cliente": "ক্লায়েন্ট পাঠিয়েছেন",
 "Enviado pelo escritório": "অফিস পাঠিয়েছে",
 "Enviado por {quem} no grupo {g}": "{quem} গ্রুপ {g}-এ পাঠিয়েছেন",
 "Enviando {f} de {n}...": "{n}টির মধ্যে {f}টি পাঠানো হচ্ছে...",
 "Enviando...": "পাঠানো হচ্ছে...",
 "Enviar": "পাঠান",
 "Enviar \"{nome}\"": "\"{nome}\" পাঠান",
 "Enviar \"{nome}\" para…": "\"{nome}\" পাঠান…",
 "Enviar \"{titulo}\" para": "\"{titulo}\" পাঠান",
 "Enviar ao grupo": "গ্রুপে পাঠান",
 "Enviar convite": "আমন্ত্রণ পাঠান",
 "Enviar convite para {nome}": "{nome}-কে আমন্ত্রণ পাঠান",
 "Enviar convite pelo WhatsApp": "WhatsApp-এ আমন্ত্রণ পাঠান",
 "Enviar documento": "নথি পাঠান",
 "Enviar instruções ao hóspede": "অতিথিকে নির্দেশনা পাঠান",
 "Enviar o convite": "আমন্ত্রণ পাঠান",
 "Enviar ou copiar o código": "কোড পাঠান বা কপি করুন",
 "Enviar ou imprimir a etiqueta": "লেবেল পাঠান বা প্রিন্ট করুন",
 "Enviar para Estudos": "পড়াশোনায় পাঠান",
 "Enviar para My Planner": "My Planner-এ পাঠান",
 "Enviar para a equipe": "দলের কাছে পাঠান",
 "Enviar para o My Planner": "My Planner-এ পাঠান",
 "Enviar para o Planner": "Planner-এ পাঠান",
 "Enviar para o grupo": "গ্রুপে পাঠান",
 "Enviar para o grupo de estudos": "পড়াশোনার দলে পাঠান",
 "Enviar para o {nome} os {n} arquivo(s) deste dispositivo": "এই ডিভাইসের {n}টি ফাইল {nome}-এ পাঠান",
 "Enviar para um grupo": "কোনো গ্রুপে পাঠান",
 "Enviar para {g}": "{g}-এ পাঠান",
 "Enviar para…": "পাঠান…",
 "Enviar por e-mail": "ইমেইলে পাঠান",
 "Enviar relatório": "রিপোর্ট পাঠান",
 "Enviar relatório para a equipe": "দলের কাছে রিপোর্ট পাঠান",
 "Enviar também as tarefas que já existem (de hoje em diante)": "আগে থেকে থাকা কাজগুলোও পাঠান (আজ থেকে পরের)",
 "Enviar tarefas do My Planner para a agenda": "My Planner-এর কাজ ক্যালেন্ডারে পাঠান",
 "Envie guias, notas e relatórios para o cliente, ou veja o que ele mandou. Cada documento aceita fotos, PDFs e links.": "ক্লায়েন্টকে কর চালান, ইনভয়েস ও রিপোর্ট পাঠান, বা তিনি কী পাঠিয়েছেন দেখুন। প্রতিটি নথিতে ছবি, PDF ও লিংক যোগ করা যায়।",
 "Enxaguante": "মাউথওয়াশ",
 "Episódio": "পর্ব",
 "Equipe": "টিম",
 "Equipe ({n})": "টিম ({n})",
 "Equipe de limpeza": "পরিষ্কার দল",
 "Equipe do consultório": "ক্লিনিকের টিম",
 "Equipe do imóvel (limpeza e co-anfitrião)": "প্রপার্টির টিম (পরিষ্কার ও কো-হোস্ট)",
 "Erro": "এরর",
 "Erro na emissão": "ইস্যু করতে ত্রুটি",
 "Erro: {erro}": "ত্রুটি: {erro}",
 "Erros registrados neste dispositivo ({n})": "এই ডিভাইসে নথিভুক্ত ত্রুটি ({n})",
 "Escanear documento": "নথি স্ক্যান করুন",
 "Escanear o verso": "পেছনের দিক স্ক্যান করুন",
 "Escanear para PDF": "স্ক্যান করে PDF",
 "Escaneie documentos, recibos, cadernos e quadros: bordas e sombras corrigidas, várias páginas, identidade frente e verso, assinatura e PDF guardado no celular, no Google Drive ou no OneDrive.": "নথি, রসিদ, খাতা ও বোর্ড স্ক্যান করুন: প্রান্ত ও ছায়া ঠিক করা, একাধিক পৃষ্ঠা, পরিচয়পত্রের সামনে ও পেছনে, স্বাক্ষর এবং ফোন, Google Drive বা OneDrive-এ সেভ করা PDF।",
 "Escaneie, deixe a imagem mais clara, organize em pastas e mande o PDF por WhatsApp, e-mail ou Drive. Com a sua IA ligada, o app lê o texto, resume e responde perguntas sobre o documento.": "স্ক্যান করুন, ছবি আরও পরিষ্কার করুন, ফোল্ডারে সাজান এবং WhatsApp, ইমেল বা Drive-এ PDF পাঠান। আপনার AI চালু থাকলে অ্যাপ লেখা পড়ে, সারাংশ করে এবং নথি নিয়ে প্রশ্নের উত্তর দেয়।",
 "Escola": "স্কুল",
 "Escolha a aba:": "ট্যাব বেছে নিন:",
 "Escolha a data do compromisso.": "অ্যাপয়েন্টমেন্টের তারিখ বেছে নিন।",
 "Escolha a imagem.": "ছবি বেছে নিন।",
 "Escolha a matéria": "বিষয় বেছে নিন",
 "Escolha a pasta do celular (ex.: Documentos). O app guarda lá sozinho.": "ফোনের ফোল্ডার বেছে নিন (যেমন: Documents)। অ্যাপ নিজে থেকেই সেখানে সেভ করবে।",
 "Escolha a página": "পৃষ্ঠা বেছে নিন",
 "Escolha ao menos um tribunal ou marque \"Todos os tribunais\".": "অন্তত একটি আদালত বেছে নিন অথবা \"সব আদালত\" চিহ্নিত করুন।",
 "Escolha ao menos uma agenda.": "অন্তত একটি ক্যালেন্ডার বেছে নিন।",
 "Escolha o PDF": "PDF বেছে নিন",
 "Escolha o arquivo .pfx (ou .p12) do certificado A1 da empresa e digite a senha dele. Ele fica criptografado no seu cofre.": "প্রতিষ্ঠানের A1 সার্টিফিকেটের .pfx (বা .p12) ফাইল বেছে নিন এবং এর পাসওয়ার্ড দিন। এটি আপনার ভল্টে এনক্রিপ্ট করে রাখা হয়।",
 "Escolha o arquivo .xml da NFS-e, NF-e ou CT-e.": "NFS-e, NF-e বা CT-e-এর .xml ফাইল বেছে নিন।",
 "Escolha o fichário": "বাইন্ডার বেছে নিন",
 "Escolha o grupo para enviar: {t}": "পাঠানোর গ্রুপ বেছে নিন: {t}",
 "Escolha os PDFs": "PDF-গুলো বেছে নিন",
 "Escolha os arquivos.": "ফাইল বেছে নিন।",
 "Escolha os feriados que aparecem no Planner e no botão 🎉 Feriados.": "Planner ও 🎉 ছুটির দিন বোতামে কোন ছুটির দিন দেখাবে তা বেছে নিন।",
 "Escolha para quem enviar.": "কাকে পাঠাবেন বেছে নিন।",
 "Escolha pelo menos um dia.": "অন্তত একটি দিন বেছে নিন।",
 "Escolha pelo menos uma página que exista no PDF (ex.: 1-3, 5).": "PDF-এ আছে এমন অন্তত একটি পৃষ্ঠা বেছে নিন (যেমন: 1-3, 5)।",
 "Escolha quem participa:": "কে কে থাকবে বেছে নিন:",
 "Escolher": "বেছে নিন",
 "Escolher a imagem": "ছবি বেছে নিন",
 "Escolher a pasta": "ফোল্ডার বেছে নিন",
 "Escolher agendas": "ক্যালেন্ডার বেছে নিন",
 "Escolher alimento": "খাবার বেছে নিন",
 "Escolher arquivo": "ফাইল বেছে নিন",
 "Escolher arquivos": "ফাইল বেছে নিন",
 "Escolher arquivos do Drive ou do OneDrive": "Drive বা OneDrive থেকে ফাইল বেছে নিন",
 "Escolher as imagens e criar o PDF": "ছবি বেছে নিয়ে PDF তৈরি করুন",
 "Escolher da galeria": "গ্যালারি থেকে বেছে নিন",
 "Escolher da galeria ou arquivo (foto ou PDF)": "গ্যালারি বা ফাইল থেকে বেছে নিন (ছবি বা PDF)",
 "Escolher data": "তারিখ বেছে নিন",
 "Escolher fuso": "টাইম জোন বেছে নিন",
 "Escolher hora": "সময় বেছে নিন",
 "Escolher horário": "সময় বেছে নিন",
 "Escolher o certificado": "সার্টিফিকেট বেছে নিন",
 "Escolher outro": "অন্যটি বেছে নিন",
 "Escolher pessoas": "লোক বেছে নিন",
 "Escolher tribunais": "আদালত বেছে নিন",
 "Escolher ícone": "আইকন বেছে নিন",
 "Esconder da equipe (só administradores)": "টিম থেকে লুকান (শুধু অ্যাডমিন)",
 "Esconder detalhes": "বিস্তারিত লুকান",
 "Esconder o texto completo": "পুরো লেখা লুকান",
 "Escondido de {n} pessoa(s)": "{n} জনের কাছ থেকে লুকানো",
 "Escondido de: {n}": "যাদের কাছ থেকে লুকানো: {n}",
 "Escondidos no Planner.": "Planner-এ লুকানো।",
 "Escova e pasta de dente": "টুথব্রাশ ও টুথপেস্ট",
 "Escovar os dentes": "দাঁত ব্রাশ করুন",
 "Escreva aqui": "এখানে লিখুন",
 "Escreva e dê Enter (ex.: lavar a máquina)": "লিখে Enter চাপুন (যেমন: মেশিন ধোয়া)",
 "Escreva em uma ou em todas as páginas.": "একটি বা সব পৃষ্ঠায় লিখুন।",
 "Escreva o motivo em \"Motivo do cancelamento\" na ficha da nota (pelo menos 15 letras) e toque aqui de novo.": "ইনভয়েসের বিবরণে \"বাতিলের কারণ\" লিখুন (কমপক্ষে ১৫ অক্ষর) এবং আবার এখানে ট্যাপ করুন।",
 "Escreva o resumo, tópicos, dúvidas...": "সারাংশ, বিষয়বস্তু, প্রশ্ন লিখুন...",
 "Escreva o texto da marca d'água.": "ওয়াটারমার্কের লেখা লিখুন।",
 "Escreva o texto.": "লেখাটি লিখুন।",
 "Escreva o título.": "শিরোনাম লিখুন।",
 "Escreva ou cole o texto. Linha começando com \"# \" vira título.": "লেখা লিখুন বা পেস্ট করুন। \"# \" দিয়ে শুরু হওয়া লাইন শিরোনাম হয়।",
 "Escreva ou cole um texto e gere o PDF.": "লেখা লিখুন বা পেস্ট করুন এবং PDF তৈরি করুন।",
 "Escritório": "অফিস",
 "Escritório: documentos e reuniões da equipe. Só o administrador do escritório pode gravar uma reunião, e todos na reunião veem o aviso \"Gravando\" enquanto ela é gravada. A gravação fica nos documentos do escritório, visível só para o administrador até ele liberar para a equipe.": "অফিস: টিমের ডকুমেন্ট ও মিটিং। শুধু অফিসের অ্যাডমিনিস্ট্রেটর মিটিং রেকর্ড করতে পারেন, এবং রেকর্ডিং চলাকালীন মিটিংয়ের সবাই \"রেকর্ড হচ্ছে\" বার্তাটি দেখতে পান। রেকর্ডিং অফিসের ডকুমেন্টে থাকে এবং অ্যাডমিনিস্ট্রেটর টিমের জন্য উন্মুক্ত না করা পর্যন্ত শুধু তিনিই তা দেখতে পান।",
 "Escuro": "ডার্ক",
 "Espanhol": "স্প্যানিশ",
 "Espaço": "প্রপার্টি",
 "Espaço livre, dados de cada aba e anexos": "খালি জায়গা, প্রতিটি ট্যাবের ডেটা ও সংযুক্তি",
 "Especialidade": "বিশেষত্ব",
 "Espécie": "প্রজাতি",
 "Esquadro": "সেট স্কোয়ার",
 "Esqueci a senha": "পাসওয়ার্ড ভুলে গেছি",
 "Esquerda": "বাম",
 "Esse código é o seu.": "এই কোডটি আপনার নিজের।",
 "Esse código é o seu. Use o código de quem indicou o app para você.": "এটি আপনার নিজের কোড। যিনি আপনাকে অ্যাপটি সুপারিশ করেছেন তাঁর কোড ব্যবহার করুন।",
 "Esse endereço não respondeu como servidor de notas. Confira e tente de novo.": "এই ঠিকানা ইনভয়েস সার্ভারের মতো সাড়া দেয়নি। যাচাই করে আবার চেষ্টা করুন।",
 "Esta aba ainda não está no seu plano.": "এই ট্যাবটি এখনও আপনার প্ল্যানে নেই।",
 "Esta e todas as futuras": "এটি এবং ভবিষ্যতের সবগুলো",
 "Esta ferramenta precisa ver as páginas do PDF, o que chega com o app novo (versão 0.50). Use o navegador ou instale o APK novo.": "এই টুলটির PDF-এর পৃষ্ঠা দেখা দরকার, যা নতুন অ্যাপে (ভার্সন 0.50) আসছে। ব্রাউজার ব্যবহার করুন বা নতুন APK ইনস্টল করুন।",
 "Esta imagem foi guardada em outro dispositivo.": "এই ছবিটি অন্য ডিভাইসে সংরক্ষিত আছে।",
 "Esta janela pode ser fechada.": "এই উইন্ডোটি বন্ধ করতে পারেন।",
 "Esta pessoa ainda não preencheu o cartão de contato.": "এই ব্যক্তি এখনও কন্টাক্ট কার্ড পূরণ করেননি।",
 "Esta semana: {a} de {m} aulas ({p}%)": "এই সপ্তাহে: {m}টির মধ্যে {a}টি ক্লাস ({p}%)",
 "Esta senha é de outra conta.": "এই পাসওয়ার্ডটি অন্য একটি অ্যাকাউন্টের।",
 "Esta tarefa não tem horário: \"No início\" e \"Antes do início\" não se aplicam. Use \"Em um horário específico\".": "এই কাজের কোনো সময় নেই: \"শুরুতে\" ও \"শুরুর আগে\" প্রযোজ্য নয়। \"নির্দিষ্ট সময়ে\" ব্যবহার করুন।",
 "Esta tarefa se repete. O que excluir?": "এই কাজটি পুনরাবৃত্ত হয়। কী মুছবেন?",
 "Esta tela teve um problema": "এই স্ক্রিনে সমস্যা হয়েছে",
 "Estado (UF) do registro": "নিবন্ধনের রাজ্য (UF)",
 "Estado de Mato Grosso do Sul": "Mato Grosso do Sul রাজ্য",
 "Estado de São Paulo": "São Paulo রাজ্য",
 "Estado do Paraná": "Paraná রাজ্য",
 "Estados": "রাজ্য",
 "Estaduais": "রাজ্য",
 "Estadual": "রাজ্য",
 "Estas abas aparecem na barra de baixo, nesta ordem. My Planner, Abas e Ajustes ficam sempre. As outras continuam aqui na tela Abas.": "এই ট্যাবগুলো এই ক্রমে নিচের বারে দেখা যায়। My Planner, ট্যাব ও সেটিংস সবসময় থাকে। বাকিগুলো এই ট্যাব স্ক্রিনেই থাকে।",
 "Estatística": "পরিসংখ্যান",
 "Este CPF já tem cadastro. Use \"Entrar\".": "এই CPF আগেই নিবন্ধিত। \"প্রবেশ করুন\" ব্যবহার করুন।",
 "Este PDF está no dispositivo onde foi aberto.": "এই PDF সেই ডিভাইসে আছে যেখানে এটি খোলা হয়েছিল।",
 "Este PDF está no dispositivo onde foi aberto. Abra por lá, ou abra de novo a cópia guardada no Drive ou no OneDrive.": "এই PDF সেই ডিভাইসে আছে যেখানে এটি খোলা হয়েছিল। সেখানে খুলুন, অথবা Drive বা OneDrive-এ সংরক্ষিত কপি আবার খুলুন।",
 "Este PDF está protegido com senha. Tire a senha no programa onde ele foi criado e tente de novo.": "এই PDF পাসওয়ার্ড দিয়ে সুরক্ষিত। যে প্রোগ্রামে এটি তৈরি হয়েছে সেখানে পাসওয়ার্ড সরিয়ে আবার চেষ্টা করুন।",
 "Este PDF não tem campos de formulário. Use \"Adicionar texto\" para escrever nele.": "এই PDF-এ ফর্মের ঘর নেই। এতে লিখতে \"লেখা যোগ করুন\" ব্যবহার করুন।",
 "Este ano": "এই বছর",
 "Este dispositivo": "এই ডিভাইস",
 "Este dispositivo não consegue abrir o arquivo.": "এই ডিভাইস ফাইলটি খুলতে পারছে না।",
 "Este dispositivo não consegue compartilhar arquivos.": "এই ডিভাইস ফাইল শেয়ার করতে পারে না।",
 "Este dispositivo não tem dados de saúde. Dá para digitar à mão.": "এই ডিভাইসে স্বাস্থ্যের ডেটা নেই। আপনি হাতে লিখতে পারেন।",
 "Este arquivo foi guardado em outro dispositivo.": "এই ফাইলটি অন্য ডিভাইসে সংরক্ষিত আছে।",
 "Este arquivo foi guardado no celular. Abra pelo app no celular.": "এই ফাইলটি ফোনে সংরক্ষিত আছে। ফোনের অ্যাপ থেকে খুলুন।",
 "Este arquivo não é um backup do My Planner.": "এই ফাইলটি My Planner-এর ব্যাকআপ নয়।",
 "Este celular ainda não recebe avisos com o app fechado. Instale o app {v} ou mais novo (APK com os avisos do servidor). Com o app aberto, os avisos já funcionam.": "অ্যাপ বন্ধ থাকলে এই ফোন এখনো নোটিফিকেশন পায় না। অ্যাপ {v} বা নতুন সংস্করণ ইনস্টল করুন (সার্ভার নোটিফিকেশনসহ APK)। অ্যাপ খোলা থাকলে নোটিফিকেশন এখনই কাজ করে।",
 "Este certificado é de {doc}, diferente do CNPJ/CPF da empresa ({emp}).": "এই সার্টিফিকেটটি {doc}-এর, যা প্রতিষ্ঠানের CNPJ/CPF ({emp}) থেকে আলাদা।",
 "Este fichário ainda não tem matérias.": "এই বাইন্ডারে এখনো কোনো বিষয় নেই।",
 "Este grupo já está cheio.": "এই গ্রুপটি ইতিমধ্যে পূর্ণ।",
 "Este mês": "এই মাস",
 "Este mês: emitidas {e} · recebidas {r}": "এই মাসে: ইস্যু {e} · প্রাপ্ত {r}",
 "Este mês: {h}": "এই মাসে: {h}",
 "Este navegador": "এই ব্রাউজার",
 "Este país só tem feriados nacionais.": "এই দেশে শুধু জাতীয় ছুটির দিন আছে।",
 "Esteira": "ট্রেডমিল",
 "Esteticista": "বিউটিশিয়ান",
 "Estou usando o My Planner para organizar a agenda, as finanças e muito mais. Baixe o app e, ao criar a sua conta, use o meu código {codigo} para ganhar 10 dias com todas as abas liberadas.": "আমি এজেন্ডা, ফাইন্যান্স এবং আরও অনেক কিছু গোছাতে My Planner ব্যবহার করছি। অ্যাপটি ডাউনলোড করুন এবং অ্যাকাউন্ট তৈরির সময় আমার কোড {codigo} ব্যবহার করে সব ট্যাব খোলা অবস্থায় 10 দিন পান।",
 "Estratégia": "কৌশল",
 "Estrela": "তারা",
 "Estudando": "পড়ছেন",
 "Estudar agora": "এখন পড়ুন",
 "Estudar {nome}": "{nome} পড়ুন",
 "Estudar: {c}": "পড়ুন: {c}",
 "Estudo": "অধ্যয়ন",
 "Estudos": "পড়াশোনা",
 "Estudos e exatas": "পড়াশোনা ও বিজ্ঞান",
 "Estudos, lazer e viagens": "পড়াশোনা, অবসর ও ভ্রমণ",
 "Está em Patrimônio & IR › Recibos dedutíveis. Abra lá para anexar a foto do recibo e o CPF ou CNPJ de quem recebeu.": "এটি সম্পদ ও আয়কর › কর-ছাড়যোগ্য রসিদ-এ আছে। সেখানে রসিদের ছবি এবং প্রাপকের CPF বা CNPJ যুক্ত করুন।",
 "Está na página \"{titulo}\" e em \"Ver arquivos\".": "এটি \"{titulo}\" পৃষ্ঠায় এবং \"ফাইল দেখুন\"-এ আছে।",
 "Etanol": "ইথানল",
 "Etapa": "ধাপ",
 "Etapa do cronograma": "সময়সূচির ধাপ",
 "Etapas": "ধাপ",
 "Evento": "ইভেন্ট",
 "Eventos": "ইভেন্ট",
 "Eventos & Celebrações": "ইভেন্ট ও উৎসব",
 "Evolução (no cofre)": "অগ্রগতি নোট (ভল্টে)",
 "Ex.: 08:00 e 20:00": "যেমন: 08:00 ও 20:00",
 "Ex.: 08:00, 14:00 e 20:00": "যেমন: 08:00, 14:00 ও 20:00",
 "Ex.: 09/2026": "যেমন: 09/2026",
 "Ex.: 1 comprimido": "যেমন: ১টি ট্যাবলেট",
 "Ex.: 1-3, 4-10, 11-": "যেমন: 1-3, 4-10, 11-",
 "Ex.: 1-3, 5, 8-10": "যেমন: 1-3, 5, 8-10",
 "Ex.: 171901 (consultoria), 010101 (programação)": "যেমন: 171901 (পরামর্শ), 010101 (প্রোগ্রামিং)",
 "Ex.: 40 sacos de cimento": "যেমন: ৪০ বস্তা সিমেন্ট",
 "Ex.: 4106902 (Curitiba), 5002704 (Campo Grande), 3550308 (São Paulo)": "যেমন: 4106902 (Curitiba), 5002704 (Campo Grande), 3550308 (São Paulo)",
 "Ex.: 8º ano B": "যেমন: অষ্টম শ্রেণি B",
 "Ex.: Alongamento lombar, Dieta 1.800 kcal": "যেমন: কোমরের স্ট্রেচিং, ১,৮০০ kcal ডায়েট",
 "Ex.: Aniversário de 30 anos da Ana": "যেমন: Ana-র ৩০তম জন্মদিন",
 "Ex.: Apartamento da praia, Suíte 1, Edícula": "যেমন: সৈকতের অ্যাপার্টমেন্ট, স্যুট ১, আউটহাউস",
 "Ex.: Apartamento na Rua X, 100 ações PETR4": "যেমন: X রোডের অ্যাপার্টমেন্ট, PETR4-এর ১০০টি শেয়ার",
 "Ex.: Aula de revisão, Consulta de retorno": "যেমন: রিভিশন ক্লাস, ফলো-আপ অ্যাপয়েন্টমেন্ট",
 "Ex.: Buffet, DJ, decoração, fotógrafo": "যেমন: ক্যাটারিং, DJ, সাজসজ্জা, ফটোগ্রাফার",
 "Ex.: CONFIDENCIAL, CÓPIA, RASCUNHO": "যেমন: গোপনীয়, কপি, খসড়া",
 "Ex.: Cardiologista": "যেমন: হৃদরোগ বিশেষজ্ঞ",
 "Ex.: Consultoria mensal": "যেমন: মাসিক পরামর্শ",
 "Ex.: Costela-de-adão da sala": "যেমন: বসার ঘরের মনস্টেরা",
 "Ex.: DAS de setembro, Extrato do Itaú": "যেমন: সেপ্টেম্বরের DAS, Itaú স্টেটমেন্ট",
 "Ex.: Desmontar os móveis do quarto": "যেমন: শোবার ঘরের আসবাব খোলা",
 "Ex.: Disponível · Em aula até 18h · Bora viajar!": "যেমন: ফ্রি আছি · সন্ধ্যা ৬টা পর্যন্ত ক্লাসে · চলো ঘুরতে যাই!",
 "Ex.: Eletricista, loja de material": "যেমন: ইলেকট্রিশিয়ান, নির্মাণসামগ্রীর দোকান",
 "Ex.: Entrada dos noivos": "যেমন: বর-কনের প্রবেশ",
 "Ex.: Financiamento do carro": "যেমন: গাড়ির লোন",
 "Ex.: Fisioterapeuta, Nutricionista, Cardiologista": "যেমন: ফিজিওথেরাপিস্ট, পুষ্টিবিদ, কার্ডিওলজিস্ট",
 "Ex.: Furadeira, livro, R$ 200": "যেমন: ড্রিল মেশিন, বই, R$ 200",
 "Ex.: Hemograma": "যেমন: CBC (রক্ত পরীক্ষা)",
 "Ex.: IPVA 2027, parcela 1": "যেমন: IPVA 2027, কিস্তি ১",
 "Ex.: Lisboa, Portugal": "যেমন: লিসবন, পর্তুগাল",
 "Ex.: Mala da Ana": "যেমন: Ana-র স্যুটকেস",
 "Ex.: Mensalidade de outubro, material": "যেমন: অক্টোবরের মাসিক ফি, উপকরণ",
 "Ex.: Netflix, cinema": "যেমন: Netflix, সিনেমা হল",
 "Ex.: Notas de compra de setembro": "যেমন: সেপ্টেম্বরের ক্রয় ইনভয়েস",
 "Ex.: Onix 2022": "যেমন: Onix 2022",
 "Ex.: Prova 1, Trabalho em grupo": "যেমন: পরীক্ষা ১, দলগত কাজ",
 "Ex.: Prova de matemática": "যেমন: গণিত পরীক্ষা",
 "Ex.: Pôr do sol no Tejo": "যেমন: তেজো নদীর সূর্যাস্ত",
 "Ex.: Reforma da cozinha": "যেমন: রান্নাঘর সংস্কার",
 "Ex.: TAP TP 108": "যেমন: TAP TP 108",
 "Ex.: Torre de Belém": "যেমন: বেলেম টাওয়ার",
 "Ex.: Troca da fiação da sala": "যেমন: বসার ঘরের তার বদলানো",
 "Ex.: V10, antirrábica": "যেমন: V10, জলাতঙ্কের টিকা",
 "Ex.: Visita ao Mosteiro dos Jerónimos": "যেমন: জেরোনিমোস মঠ দর্শন",
 "Ex.: cerâmica 30 cm": "যেমন: ৩০ সেমি টাইল",
 "Ex.: kg, pacotes, latas": "যেমন: kg, প্যাকেট, ক্যান",
 "Ex.: seg e qua, 07:30": "যেমন: সোম ও বুধ, 07:30",
 "Ex.: troquei o arroz por batata doce": "যেমন: ভাতের বদলে মিষ্টি আলু খেয়েছি",
 "Ex.: varanda, sala": "যেমন: বারান্দা, বসার ঘর",
 "Exame": "পরীক্ষা",
 "Exame da OAB": "OAB পরীক্ষা",
 "Exames": "পরীক্ষা",
 "Excel": "Excel",
 "Excluir": "মুছুন",
 "Excluir \"{nome}\"?": "\"{nome}\" মুছবেন?",
 "Excluir \"{titulo}\"?": "\"{titulo}\" মুছবেন?",
 "Excluir a caixa?": "বাক্সটি মুছবেন?",
 "Excluir a compra": "কেনাকাটা মুছুন",
 "Excluir a compra?": "কেনাকাটা মুছবেন?",
 "Excluir a meta \"{m}\"?": "লক্ষ্য \"{m}\" মুছবেন?",
 "Excluir cartão": "কার্ড মুছুন",
 "Excluir conta": "বিল মুছুন",
 "Excluir cuidado": "যত্ন মুছুন",
 "Excluir cômodo": "ঘর মুছুন",
 "Excluir esta página?": "এই পৃষ্ঠা মুছবেন?",
 "Excluir fichário": "বাইন্ডার মুছুন",
 "Excluir matéria": "বিষয় মুছুন",
 "Excluir o cartão \"{c}\"?": "কার্ড \"{c}\" মুছবেন?",
 "Excluir o documento": "নথি মুছুন",
 "Excluir o fichário {nome}": "বাইন্ডার {nome} মুছুন",
 "Excluir página": "পৃষ্ঠা মুছুন",
 "Excluir refeição": "খাবার মুছুন",
 "Excluir suplemento": "সাপ্লিমেন্ট মুছুন",
 "Excluir tarefa": "কাজ মুছুন",
 "Excluir tarefa repetida": "পুনরাবৃত্ত কাজ মুছুন",
 "Excluir tarefa?": "কাজ মুছবেন?",
 "Excluir treino": "ওয়ার্কআউট মুছুন",
 "Excluir {nome}?": "{nome} মুছবেন?",
 "Excluídas em definitivo 30 dias depois do descarte.": "বাতিল করার 30 দিন পরে স্থায়ীভাবে মুছে ফেলা হয়।",
 "Executivo e profissional": "এক্সিকিউটিভ ও পেশাদার",
 "Execução do contrato (art. 7º, V), para entregar o serviço; consentimento (art. 7º, I), para câmera, galeria, microfone e localização; cumprimento de obrigação legal (art. 7º, II); e legítimo interesse (art. 7º, IX), para segurança e prevenção de fraudes.": "চুক্তি সম্পাদন (art. 7º, V), সেবা দেওয়ার জন্য; সম্মতি (art. 7º, I), ক্যামেরা, গ্যালারি, মাইক্রোফোন ও লোকেশনের জন্য; আইনি বাধ্যবাধকতা পালন (art. 7º, II); এবং বৈধ স্বার্থ (art. 7º, IX), নিরাপত্তা ও প্রতারণা প্রতিরোধের জন্য।",
 "Exemplos: 13:30, 1330, 9:05": "উদাহরণ: 13:30, 1330, 9:05",
 "Exercício": "ব্যায়াম",
 "Exercício físico": "ব্যায়াম",
 "Experimente grátis por {n} dias": "{n} দিন বিনামূল্যে ব্যবহার করে দেখুন",
 "Explique o motivo (para cancelar)": "কারণ লিখুন (বাতিলের জন্য)",
 "Exportar arquivo": "ফাইল এক্সপোর্ট করুন",
 "Exportar para o contador": "হিসাবরক্ষকের জন্য রপ্তানি করুন",
 "Extrair páginas": "পৃষ্ঠা বের করুন",
 "Extras (pet, check-in tardio...)": "অতিরিক্ত (পোষা প্রাণী, দেরিতে চেক-ইন...)",
 "Extrato": "স্টেটমেন্ট",
 "Extrato bancário": "ব্যাংক স্টেটমেন্ট",
 "Extrato do banco (foto ou PDF)": "ব্যাংক স্টেটমেন্ট (ছবি বা PDF)",
 "Extrato importado": "স্টেটমেন্ট ইমপোর্ট হয়েছে",
 "Extrato por foto": "ছবি থেকে স্টেটমেন্ট",
 "FRASE": "স্ট্যাটাস",
 "FRÁGIL": "ভঙ্গুর",
 "Fabricante ou estendida: {n} meses": "প্রস্তুতকারক বা বর্ধিত: {n} মাস",
 "Facultativo": "ঐচ্ছিক",
 "Falar com a limpeza": "পরিষ্কারকর্মীর সাথে কথা বলুন",
 "Fale conosco": "যোগাযোগ করুন",
 "Falta": "অনুপস্থিত",
 "Falta XML": "XML নেই",
 "Falta ligar o servidor de notas: no computador, dê dois cliques em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar.": "ইনভয়েস সার্ভার এখনো চালু হয়নি: কম্পিউটারে 13-LIGAR-NOTAS.bat-এ ডাবল-ক্লিক করুন এবং যে ঠিকানা দেখায় তা এখানে পেস্ট করুন।",
 "Falta o Health Connect, o app do Google que junta os dados dos relógios e apps de saúde.": "Health Connect নেই। এটি Google-এর অ্যাপ, যা ঘড়ি ও হেলথ অ্যাপের ডেটা একত্র করে।",
 "Faltam": "বাকি",
 "Faltam {ml} ({n} copo(s))": "আরও {ml} বাকি ({n} গ্লাস)",
 "Faltam {n} dia(s) do seu período grátis": "আপনার বিনামূল্যের সময়ের আর {n} দিন বাকি",
 "Faltam {n} dias": "আর {n} দিন বাকি",
 "Faltou": "আসেননি",
 "Família": "পরিবার",
 "Fantasia": "ফ্যান্টাসি",
 "Fatura": "কার্ড বিল",
 "Fatura com vencimento em {d}.": "{d} তারিখে দেয় কার্ড বিল।",
 "Fatura de {mes}": "{mes}-এর কার্ড বিল",
 "Fatura de {mes}: vence {data}": "{mes}-এর কার্ড বিল: শেষ তারিখ {data}",
 "Fatura do cartão (foto ou PDF)": "কার্ড বিল (ছবি বা PDF)",
 "Fatura importada": "কার্ড বিল ইমপোর্ট হয়েছে",
 "Fatura paga (toque para desfazer)": "বিল পরিশোধিত (বাতিল করতে ট্যাপ করুন)",
 "Fatura {c}": "{c} কার্ড বিল",
 "Faturamento em {ano}: {v} de {lim}": "{ano}-এ আয়: {lim}-এর মধ্যে {v}",
 "Faturas dos cartões": "কার্ড বিল",
 "Fazer agora, passo a passo": "এখনই করুন, ধাপে ধাপে",
 "Fazer com este PDF": "এই PDF দিয়ে করুন",
 "Fazer cópia agora": "এখনই ব্যাকআপ নিন",
 "Fecha dia {f} · vence dia {v}": "{f} তারিখে বন্ধ · {v} তারিখে শেষ সময়",
 "Fecha {f} · vence {v}": "বন্ধ {f} · দেয় {v}",
 "Fechar": "বন্ধ করুন",
 "Fechar o cofre": "ভল্ট বন্ধ করুন",
 "Feche e abra o app de novo": "অ্যাপ বন্ধ করে আবার খুলুন",
 "Federais": "ফেডারেল",
 "Feijão": "বিনস",
 "Feita em {data}": "{data} তারিখে সম্পন্ন",
 "Feita hoje": "আজ সম্পন্ন",
 "Feitas": "সম্পন্ন",
 "Feitas (não se repetem) · {n}": "সম্পন্ন (পুনরাবৃত্তি নেই) · {n}",
 "Feito": "সম্পন্ন",
 "Feito!": "হয়ে গেছে!",
 "Feliz aniversário": "শুভ জন্মদিন",
 "Feminino": "নারী",
 "Feminino e suave": "নারীসুলভ ও কোমল",
 "Feriado escolar": "স্কুল ছুটি",
 "Feriado estadual": "রাজ্য ছুটি",
 "Feriado estadual: {nome}": "রাজ্য ছুটি: {nome}",
 "Feriado municipal": "পৌর ছুটি",
 "Feriado municipal: {nome}": "পৌর ছুটি: {nome}",
 "Feriado nacional": "জাতীয় ছুটি",
 "Feriado nacional: {nome}": "জাতীয় ছুটি: {nome}",
 "Feriado regional": "আঞ্চলিক ছুটি",
 "Feriado regional: {nome}": "আঞ্চলিক ছুটি: {nome}",
 "Feriados": "ছুটির দিন",
 "Feriados nacionais": "জাতীয় ছুটির দিন",
 "Feriados no planner": "প্ল্যানারে ছুটির দিন",
 "Feriados, cotações, sugestões da inteligência artificial e leituras automáticas de boletos e notas podem ter erros. Confira antes de usar.": "ছুটির দিন, বিনিময় হার, কৃত্রিম বুদ্ধিমত্তার পরামর্শ এবং বিল ও রসিদের স্বয়ংক্রিয় পাঠে ভুল থাকতে পারে। ব্যবহারের আগে যাচাই করুন।",
 "Ferramenta": "যন্ত্রপাতি",
 "Ferramentas": "যন্ত্রপাতি",
 "Ficha de cada planta, replantio e calendário de rega e adubo na agenda.": "প্রতিটি গাছের তথ্য, টব বদল এবং সময়সূচিতে পানি ও সারের ক্যালেন্ডার।",
 "Ficha preenchida": "ফর্ম পূরণ হয়েছে",
 "Fichários, matérias e páginas, cronômetro de estudo e metas por semana.": "বাইন্ডার, বিষয় ও পৃষ্ঠা, পড়ার টাইমার এবং সাপ্তাহিক লক্ষ্য।",
 "Ficção": "কথাসাহিত্য",
 "Figurinha": "স্টিকার",
 "Figurinhas": "স্টিকার",
 "Filme": "সিনেমা",
 "Filme ou série": "সিনেমা বা সিরিজ",
 "Filmes e séries": "সিনেমা ও সিরিজ",
 "Filosofia": "দর্শন",
 "Filtros": "ফিল্টার",
 "Fim": "শেষ",
 "Fim (vazio = uso contínuo)": "শেষ (ফাঁকা = নিয়মিত সেবন)",
 "Fim da garantia": "ওয়ারেন্টির শেষ",
 "Fim da garantia:": "ওয়ারেন্টির শেষ:",
 "Fim da pausa. Continue: {tarefa}": "বিরতি শেষ। চালিয়ে যান: {tarefa}",
 "Fim de semana": "সপ্তাহান্ত",
 "Fim previsto": "সম্ভাব্য শেষ",
 "Fina": "সরু",
 "Finados": "মৃত আত্মাদের দিবস",
 "Finalizador": "ফিনিশার",
 "Financeiro": "অর্থ",
 "Financeiro: {gasto} de {orcado} ({p}%)": "আর্থিক: {orcado}-এর মধ্যে {gasto} ({p}%)",
 "Financiamento": "ঋণ",
 "Financiamento de veículo": "গাড়ির লোন",
 "Financiamento imobiliário": "হোম লোন",
 "Financiamentos": "ফাইন্যান্সিং",
 "Financiamentos e empréstimos": "ফাইন্যান্সিং ও ঋণ",
 "Financiamentos e empréstimos com parcelas, juros, saldo devedor e comprovantes; objetos emprestados com foto e aviso da devolução.": "কিস্তি, সুদ, বকেয়া ও প্রমাণপত্রসহ ফাইন্যান্সিং ও ঋণ; ধার দেওয়া জিনিস ছবি ও ফেরতের রিমাইন্ডারসহ।",
 "Finanças": "অর্থায়ন",
 "Finanças {p}": "অর্থায়ন {p}",
 "Finanças · {p}": "অর্থায়ন · {p}",
 "Fins de semana": "সপ্তাহান্তগুলো",
 "Fio dental": "ডেন্টাল ফ্লস",
 "Flex": "ফ্লেক্স",
 "Flexão de braço": "পুশ-আপ",
 "Flor": "ফুল",
 "Flutua": "ভাসা",
 "Foguete": "রকেট",
 "Fogão": "চুলা",
 "Foi no cartão de crédito? Lançar como compra no cartão": "ক্রেডিট কার্ডে দিয়েছেন? কার্ডে কেনাকাটা হিসেবে যোগ করুন",
 "Foi para {destino}.": "{destino}-এ পাঠানো হয়েছে।",
 "Foi para {destino}. Quer tirar daqui?": "{destino}-এ পাঠানো হয়েছে। এখান থেকে সরাবেন?",
 "Folha de pagamento": "বেতন তালিকা",
 "Fone": "ইয়ারপিস",
 "Fone de ouvido": "হেডফোন",
 "Fontes: Brasil, calculado no app a partir da portaria federal de feriados e das leis de cada estado. Outros países: base pública Nager.Date (date.nager.at), baixada pela internet e guardada no aparelho.": "উৎস: ব্রাজিল, ফেডারেল ছুটির প্রজ্ঞাপন ও প্রতিটি রাজ্যের আইন থেকে অ্যাপে হিসাব করা। অন্যান্য দেশ: পাবলিক ডেটাবেস Nager.Date (date.nager.at), ইন্টারনেট থেকে ডাউনলোড করে ডিভাইসে সংরক্ষিত।",
 "Fontes: Brasil, calculado no app a partir da portaria federal de feriados, das leis de cada estado e dos calendários oficiais das capitais. Outros países: base pública Nager.Date (date.nager.at), baixada pela internet e guardada no dispositivo.": "উৎস: ব্রাজিল, ছুটির দিন সংক্রান্ত ফেডারেল অধ্যাদেশ, প্রতিটি রাজ্যের আইন এবং রাজধানীগুলোর সরকারি ক্যালেন্ডার থেকে অ্যাপে হিসাব করা। অন্যান্য দেশ: পাবলিক ডেটাবেস Nager.Date (date.nager.at), ইন্টারনেট থেকে ডাউনলোড করে ডিভাইসে রাখা।",
 "Forma": "পদ্ধতি",
 "Forma das parcelas": "কিস্তির ধরন",
 "Forma de pagamento": "পেমেন্টের পদ্ধতি",
 "Forma de pagamento: {f}.": "পেমেন্টের পদ্ধতি: {f}।",
 "Formas": "আকৃতি",
 "Formato": "ফরম্যাট",
 "Formatos": "ফরম্যাট",
 "Formatura": "সমাবর্তন",
 "Fornecedor": "সরবরাহকারী",
 "Fornecedores": "সরবরাহকারী",
 "Forte": "গাঢ়",
 "Foto": "ছবি",
 "Foto da galeria": "গ্যালারি থেকে ছবি",
 "Foto do contato": "কন্টাক্টের ছবি",
 "Foto inteira": "পুরো ছবি",
 "Foto ou PDF (lido pela sua IA)": "ছবি বা PDF (আপনার AI পড়বে)",
 "Fotografe cada cômodo na vistoria de saída e na de entrada. As fotos protegem você na hora de devolver o imóvel.": "বের হওয়া ও ঢোকার পরিদর্শনে প্রতিটি ঘরের ছবি তুলুন। বাড়ি ফেরত দেওয়ার সময় এই ছবিগুলো আপনাকে সুরক্ষা দেয়।",
 "Fotografe cada recibo de médico, dentista, escola e previdência assim que pagar. No fim do ano está tudo pronto.": "ডাক্তার, দন্তচিকিৎসক, স্কুল ও পেনশনের প্রতিটি রসিদ পরিশোধের সঙ্গে সঙ্গে ছবি তুলে রাখুন। বছর শেষে সব প্রস্তুত থাকবে।",
 "Fotos": "ছবি",
 "Fotos JPG, PNG e outras viram um PDF.": "JPG, PNG ও অন্যান্য ছবি একটি PDF হয়ে যায়।",
 "Fotos de {d}": "{d}-এর ছবি",
 "Fotos do espaço pronto": "প্রস্তুত জায়গার ছবি",
 "Fotos e arquivos desta ficha também vão para a pasta do grupo, para quem participa abrir.": "এই রেকর্ডের ছবি ও ফাইলও গ্রুপের ফোল্ডারে যায়, যাতে সদস্যরা খুলতে পারেন।",
 "Fotos e arquivos ficam guardados só neste dispositivo. Os dados do documento vão para a sua conta, protegidos.": "ছবি ও ফাইল শুধু এই ডিভাইসেই সংরক্ষিত থাকে। নথির তথ্য আপনার অ্যাকাউন্টে সুরক্ষিতভাবে থাকে।",
 "Fotos e arquivos ficam neste dispositivo (e no seu Drive ou OneDrive, se estiver ligado em Ajustes).": "ছবি ও ফাইল এই ডিভাইসে থাকে (এবং সেটিংসে চালু থাকলে আপনার Drive বা OneDrive-এও)।",
 "Fotos e notas": "ছবি ও নোট",
 "Fotos e vídeos": "ছবি ও ভিডিও",
 "Fotos, arquivos e links": "ছবি, ফাইল ও লিংক",
 "Fraldas e lenços": "ডায়াপার ও ওয়াইপস",
 "Francês": "ফরাসি",
 "Frango com osso": "হাড়সহ মুরগি",
 "Frango sem osso": "হাড় ছাড়া মুরগি",
 "Frase (opcional, ex.: Bom dia!)": "বাক্য (ঐচ্ছিক, যেমন: সুপ্রভাত!)",
 "Freelancer & Projetos": "ফ্রিল্যান্সার ও প্রকল্প",
 "Freezer": "ফ্রিজার",
 "Freios": "ব্রেক",
 "Frente": "সামনে",
 "Frente do documento": "নথির সামনের দিক",
 "Frente e verso na mesma folha": "সামনে ও পেছনে একই পাতায়",
 "Frente pronta": "সামনের দিক তৈরি",
 "Frequência": "পুনরাবৃত্তি",
 "Frio": "ঠান্ডা",
 "Fruta": "ফল",
 "Frágil": "ভঙ্গুর",
 "Fundação e estrutura": "ভিত ও কাঠামো",
 "Fundo": "পটভূমি",
 "Fundos e renda fixa": "ফান্ড ও স্থির আয়",
 "Fuso": "টাইম জোন",
 "Fuso horário": "টাইম জোন",
 "Fuso horário do destino": "গন্তব্যের টাইম জোন",
 "Futebol": "ফুটবল",
 "Física": "পদার্থবিজ্ঞান",
 "Físico (obra pronta): {p}%": "ভৌত (কাজ সম্পন্ন): {p}%",
 "GASTOS POR CATEGORIA": "বিভাগ অনুযায়ী খরচ",
 "GIF guardado nos seus GIFs.": "GIF আপনার GIF-এ সংরক্ষিত হয়েছে।",
 "Garagem": "গ্যারেজ",
 "Garantia": "ওয়ারেন্টি",
 "Garantia até {data}.": "{data} পর্যন্ত ওয়ারেন্টি।",
 "Garantia legal": "আইনি ওয়ারেন্টি",
 "Garantia vencendo": "ওয়ারেন্টি শেষ হচ্ছে",
 "Garantias": "ওয়ারেন্টি",
 "Garrafa de água": "পানির বোতল",
 "Gasolina": "পেট্রোল",
 "Gasto": "খরচ",
 "Gasto até agora": "এ পর্যন্ত খরচ",
 "Gasto de {v} lançado. {n} preço(s) guardado(s) para a sua lista de compras.": "{v} খরচ যোগ হয়েছে। আপনার বাজারের তালিকার জন্য {n}টি দাম সংরক্ষিত হয়েছে।",
 "Gasto neste mês: {v}": "এই মাসে খরচ: {v}",
 "Gasto: {v}": "খরচ: {v}",
 "Gastos": "খরচ",
 "Gastos por categoria": "বিভাগ অনুযায়ী খরচ",
 "Gato": "বিড়াল",
 "Geladeira": "ফ্রিজ",
 "Geografia": "ভূগোল",
 "Gerado por": "যা দিয়ে উৎপন্ন",
 "Gerando QR Code...": "QR Code তৈরি হচ্ছে...",
 "Gerar PDF": "PDF তৈরি করুন",
 "Gerar as cobranças do mês": "এই মাসের চার্জ তৈরি করুন",
 "Gerar as parcelas": "কিস্তি তৈরি করুন",
 "Gerar lista da mala": "লাগেজের তালিকা বানান",
 "Gerar pelo cardápio e pela despensa": "মেনু ও ভাঁড়ার থেকে বানান",
 "Gesso e forro": "জিপসাম ও ফলস সিলিং",
 "Gira todas as páginas ou só as escolhidas.": "সব পৃষ্ঠা বা শুধু বেছে নেওয়াগুলো ঘোরায়।",
 "Girar": "ঘোরান",
 "Google Drive e OneDrive": "Google Drive ও OneDrive",
 "Google Drive, OneDrive e agenda do Google: só se você conectar, e só para guardar os seus arquivos e eventos.": "Google Drive, OneDrive ও Google ক্যালেন্ডার: শুধু আপনি সংযুক্ত করলে, এবং শুধু আপনার ফাইল ও ইভেন্ট রাখার জন্য।",
 "Gorro, cachecol e luvas": "উলের টুপি, মাফলার ও দস্তানা",
 "Gota": "ফোঁটা",
 "Graduação e Pós": "স্নাতক ও স্নাতকোত্তর",
 "Grande": "বড়",
 "Gravando": "রেকর্ড হচ্ছে",
 "Gravar lembretes e anotações por voz quando você pedir. O microfone só liga com o seu toque.": "আপনি চাইলে ভয়েসে রিমাইন্ডার ও নোট রেকর্ড করা। মাইক্রোফোন শুধু আপনার ট্যাপেই চালু হয়।",
 "Gravar reunião": "মিটিং রেকর্ড করুন",
 "Gravação de áudio": "অডিও রেকর্ডিং",
 "Gravações das reuniões": "মিটিংয়ের রেকর্ডিং",
 "Grossa": "মোটা",
 "Grupo": "দল",
 "Grupo com convite (turma, equipe, convidados)": "আমন্ত্রণভিত্তিক গ্রুপ (ক্লাস, টিম, অতিথি)",
 "Grupo criado": "গ্রুপ তৈরি হয়েছে",
 "Grupo da família": "পরিবারের দল",
 "Grupo da mudança (família e ajudantes)": "বাসা বদলের দল (পরিবার ও সহকারী)",
 "Grupo da obra (equipe)": "নির্মাণ দল (টিম)",
 "Grupo da turma (convidar alunos)": "ক্লাসের দল (শিক্ষার্থীদের আমন্ত্রণ)",
 "Grupo da viagem (convidar quem vai)": "ভ্রমণের দল (সঙ্গীদের আমন্ত্রণ)",
 "Grupo de cuidado (família ou profissional)": "যত্নের দল (পরিবার বা পেশাদার)",
 "Grupo de estudos (convidar colegas)": "পড়াশোনার দল (সহপাঠীদের আমন্ত্রণ)",
 "Grupo de leitura (convidar)": "পাঠচক্র (আমন্ত্রণ)",
 "Grupo do cliente": "ক্লায়েন্টের দল",
 "Grupo do evento (convidar)": "ইভেন্টের দল (আমন্ত্রণ)",
 "Grupos": "গ্রুপ",
 "Grupos de estudo": "পড়াশোনার দল",
 "Grupos de {aba}": "{aba}-এর গ্রুপ",
 "Grupos desta aba: {n}": "এই ট্যাবের গ্রুপ: {n}",
 "Grupos e convites": "গ্রুপ ও আমন্ত্রণ",
 "Grátis no lançamento": "লঞ্চে বিনামূল্যে",
 "Guarda-chuva": "ছাতা",
 "Guardada nas suas figurinhas.": "আপনার স্টিকারে সংরক্ষিত হয়েছে।",
 "Guardado": "জমানো",
 "Guardado até agora: {v}": "এখন পর্যন্ত জমানো: {v}",
 "Guardado em outro dispositivo": "অন্য ডিভাইসে সংরক্ষিত",
 "Guardado na pasta \"{pasta}\" do celular.": "মোবাইলের \"{pasta}\" ফোল্ডারে সংরক্ষিত।",
 "Guardado no cofre, com criptografia de ponta a ponta.": "এন্ড-টু-এন্ড এনক্রিপশনসহ ভল্টে সংরক্ষিত।",
 "Guardado no {nome}.": "{nome}-এ সংরক্ষিত।",
 "Guardado {onde} em {quando}": "{quando}-এ {onde} সেভ হয়েছে",
 "Guardando...": "সংরক্ষণ হচ্ছে...",
 "Guardar": "জমান",
 "Guardar como recibo do IR": "IR (আয়কর) রসিদ হিসেবে সংরক্ষণ করুন",
 "Guardar dinheiro": "টাকা জমান",
 "Guardar e enviar": "সেভ করে পাঠান",
 "Guardar na meta": "লক্ষ্যে জমান",
 "Guardar nas minhas figurinhas": "আমার স্টিকারে সংরক্ষণ করুন",
 "Guardar nos meus GIFs": "আমার GIF-এ সংরক্ষণ করুন",
 "Guardar o PDF {onde}": "PDF {onde} সেভ করুন",
 "Guardar os PDFs em": "PDF সেভ করার জায়গা",
 "Guardar os arquivos prontos em": "তৈরি ফাইল এখানে সংরক্ষণ করুন",
 "Guardar sozinho cada arquivo pronto": "প্রতিটি তৈরি ফাইল স্বয়ংক্রিয়ভাবে সংরক্ষণ করুন",
 "Guarde as prescrições e orientações que você usa sempre. No atendimento, toque em ⋮ › Usar modelo.": "যে প্রেসক্রিপশন ও নির্দেশনা প্রায়ই দেন, সেগুলো সংরক্ষণ করুন। অ্যাপয়েন্টমেন্টে ⋮ › টেমপ্লেট ব্যবহার করুন-এ ট্যাপ করুন।",
 "Guarde seus documentos num lugar só": "আপনার নথিগুলো এক জায়গায় রাখুন",
 "Guarde {v} por mês até {d}": "{d} পর্যন্ত প্রতি মাসে {v} জমান",
 "Guardou": "জমিয়েছেন",
 "Guia de imposto": "কর চালান",
 "Gás": "গ্যাস",
 "Gênero ou categoria": "ধরন বা বিভাগ",
 "HISTÓRICO DOS DADOS": "ডেটার ইতিহাস",
 "HOJE": "আজ",
 "Hall de entrada": "প্রবেশপথ",
 "Halteres": "ডাম্বেল",
 "Hexágono": "ষড়ভুজ",
 "Hidratante": "ময়েশ্চারাইজার",
 "Hidratante labial": "লিপ বাম",
 "Hidráulica": "প্লাম্বিং",
 "Higiene bucal": "মুখের স্বাস্থ্যবিধি",
 "Higienizar": "পরিষ্কার করুন",
 "História": "ইতিহাস",
 "Histórico": "ইতিহাস",
 "Histórico da família, exames protegidos, vacinas, consultas e alarme dos remédios na linha do tempo.": "পরিবারের স্বাস্থ্য ইতিহাস, সুরক্ষিত পরীক্ষা, টিকা, ডাক্তার দেখানো এবং টাইমলাইনে ওষুধের অ্যালার্ম।",
 "Hmm...": "হুম...",
 "Hoje": "আজ",
 "Hoje: {a} de {m} aulas ({p}%)": "আজ: {m}টির মধ্যে {a}টি ক্লাস ({p}%)",
 "Hoje: {n} página(s)": "আজ: {n} পৃষ্ঠা",
 "Hora": "সময়",
 "Hora da pausa": "বিরতির সময়",
 "Hora de voltar": "ফেরার সময়",
 "Hora de voltar!": "ফেরার সময় হয়েছে!",
 "Hora do check-in": "চেক-ইনের সময়",
 "Hora do check-out": "চেক-আউটের সময়",
 "Horas": "ঘণ্টা",
 "Horas de sono": "ঘুমের ঘণ্টা",
 "Horário": "সময়",
 "Horário de check-in": "চেক-ইনের সময়সূচি",
 "Horário de check-out": "চেক-আউটের সময়সূচি",
 "Horário do lembrete": "রিমাইন্ডারের সময়",
 "Horário inválido": "অবৈধ সময়",
 "Horário ocupado": "সময়টি ব্যস্ত",
 "Horários": "সময়",
 "Horários (remédio diário)": "সময় (প্রতিদিনের ওষুধ)",
 "Hospedados agora": "এখন অবস্থানরত",
 "Hospedagem": "থাকার জায়গা",
 "Hospital ou pronto-socorro de referência": "পছন্দের হাসপাতাল বা জরুরি বিভাগ",
 "Hotel": "হোটেল",
 "Há uma versão nova do My Planner Web. Recarregue para usar.": "My Planner Web-এর নতুন সংস্করণ এসেছে। ব্যবহার করতে রিলোড করুন।",
 "Híbrido": "হাইব্রিড",
 "Hóspede": "অতিথি",
 "Hóspede ({c})": "অতিথি ({c})",
 "Hóspedes (máximo)": "সর্বোচ্চ অতিথি",
 "IA ligada": "AI চালু",
 "IA não ligada": "AI বন্ধ",
 "IA não ligada. Ligue em Ajustes › Inteligência artificial.": "AI বন্ধ। সেটিংস › কৃত্রিম বুদ্ধিমত্তা থেকে চালু করুন।",
 "IPVA": "IPVA",
 "ISS": "ISS",
 "ISS %": "ISS %",
 "ISS retido pelo tomador": "সেবা গ্রহীতা ISS কেটে রেখেছেন",
 "Ida": "যাত্রা",
 "Identidade": "পরিচয়পত্র",
 "Idioma": "ভাষা",
 "Idiomas": "ভাষা",
 "Ilimitados": "সীমাহীন",
 "Imagem": "ছবি",
 "Imagem escolhida (trocar)": "ছবি বাছাই হয়েছে (বদলান)",
 "Imagem guardada no {nome}. Toque para abrir.": "ছবি {nome}-এ সংরক্ষিত হয়েছে। খুলতে ট্যাপ করুন।",
 "Imagens para PDF": "ছবি থেকে PDF",
 "Imagens {data}": "ছবি {data}",
 "Imperdíveis": "অবশ্যই দেখুন",
 "Imperdível": "অবশ্যই দেখার",
 "Importar": "ইমপোর্ট",
 "Importar XML de nota": "ইনভয়েসের XML আমদানি করুন",
 "Importar arquivo": "ফাইল ইমপোর্ট করুন",
 "Importar backup?": "ব্যাকআপ ইমপোর্ট করবেন?",
 "Importar extrato": "স্টেটমেন্ট ইমপোর্ট করুন",
 "Importar extrato do banco (OFX ou CSV)": "ব্যাংক স্টেটমেন্ট ইমপোর্ট করুন (OFX বা CSV)",
 "Importar fatura": "কার্ড বিল ইমপোর্ট করুন",
 "Importar fotos": "ছবি ইমপোর্ট করুন",
 "Importar reservas do Airbnb, Booking...": "Airbnb, Booking... থেকে বুকিং ইমপোর্ট করুন",
 "Importar {n} lançamento(s)": "{n}টি এন্ট্রি ইমপোর্ট করুন",
 "Imóveis e espaços": "প্রপার্টি ও জায়গা",
 "Imóvel": "বাড়ি/জমি",
 "Imóvel inteiro": "পুরো প্রপার্টি",
 "Imóvel inteiro ou por cômodo: reservas do Airbnb, Booking ou direto, limpeza no check-out, despesas, ocupação e lucro do mês.": "পুরো প্রপার্টি বা ঘর হিসেবে: Airbnb, Booking বা সরাসরি বুকিং, চেক-আউটে পরিষ্কার, খরচ, অকুপেন্সি ও মাসের লাভ।",
 "Inclui {v} das notas fiscais emitidas na aba Notas Fiscais.": "ইনভয়েস (NF) ট্যাবে ইস্যু করা ইনভয়েসের {v} অন্তর্ভুক্ত।",
 "Independência do Brasil": "ব্রাজিলের স্বাধীনতা দিবস",
 "Indicação": "রেফারেল",
 "Indique e ganhe": "রেফার করুন ও জিতুন",
 "Indique o My Planner para amigos e família. Quem criar a conta com o seu código ganha 10 dias com todas as abas liberadas.": "বন্ধু ও পরিবারকে My Planner সুপারিশ করুন। যিনি আপনার কোড দিয়ে অ্যাকাউন্ট তৈরি করবেন, তিনি সব ট্যাব খোলা অবস্থায় 10 দিন পাবেন।",
 "Infantil": "শিশুসাহিত্য",
 "Informações do PDF": "PDF-এর তথ্য",
 "Informe a descrição e o valor.": "বিবরণ ও পরিমাণ লিখুন।",
 "Informe de quantos em quantos dias regar ou adubar.": "কত দিন পরপর পানি বা সার দিতে হবে তা লিখুন।",
 "Informe o nome do produto.": "পণ্যের নাম দিন।",
 "Informe o rótulo e o nome.": "লেবেল ও নাম দিন।",
 "Informe o total de aulas da matéria em Editar.": "সম্পাদনায় বিষয়ের মোট ক্লাস লিখুন।",
 "Informe o valor.": "পরিমাণ লিখুন।",
 "Informe os horários": "সময় লিখুন",
 "Informe quanto quer juntar.": "কত জমাতে চান লিখুন।",
 "Informe seu nome.": "আপনার নাম দিন।",
 "Informática": "কম্পিউটার",
 "Inglês": "ইংরেজি",
 "Ingredientes (um por linha)": "উপকরণ (প্রতি লাইনে একটি)",
 "Inscrição municipal (se tiver)": "পৌর নিবন্ধন (যদি থাকে)",
 "Inspeção": "যানবাহন পরিদর্শন",
 "Instalar ou atualizar o Health Connect": "Health Connect ইনস্টল বা আপডেট করুন",
 "Instruções, receita, observações...": "নির্দেশনা, রেসিপি, মন্তব্য...",
 "Insumos (papel, sabonete, café)": "প্রয়োজনীয় জিনিস (টিস্যু, সাবান, কফি)",
 "Inteligência artificial": "কৃত্রিম বুদ্ধিমত্তা",
 "Inteligência artificial (Claude, ChatGPT ou Gemini): só se você ligar, com a sua própria chave, que fica apenas no dispositivo. O texto da pergunta vai direto para o serviço escolhido.": "কৃত্রিম বুদ্ধিমত্তা (Claude, ChatGPT বা Gemini): শুধু আপনি চালু করলে, আপনার নিজের কী দিয়ে, যা শুধু ডিভাইসেই থাকে। প্রশ্নের লেখা সরাসরি বেছে নেওয়া সেবায় যায়।",
 "Intensidade": "তীব্রতা",
 "Internação": "হাসপাতালে ভর্তি",
 "Internet": "ইন্টারনেট",
 "Intimação": "নোটিশ",
 "Intimação com prazo": "সময়সীমাসহ নোটিশ",
 "Investimento": "বিনিয়োগ",
 "Investimentos": "বিনিয়োগ",
 "Início": "শুরু",
 "Início {ini} · Fim {fim} · Duração {dur}": "শুরু {ini} · শেষ {fim} · সময়কাল {dur}",
 "Iogurte": "দই",
 "Ir para Ajustes (exportar meus dados)": "সেটিংসে যান (আমার ডেটা এক্সপোর্ট করুন)",
 "Ir para hoje": "আজকে যান",
 "Ir para o My Planner Web": "My Planner Web-এ যান",
 "Italiano": "ইতালীয়",
 "Item": "আইটেম",
 "Item da despensa": "ভাঁড়ারের জিনিস",
 "Item protegido: fotos e arquivos ficam criptografados no cofre, só neste dispositivo (não vão para o Drive ou OneDrive).": "সুরক্ষিত আইটেম: ছবি ও ফাইল ভল্টে এনক্রিপ্ট হয়, শুধু এই ডিভাইসে থাকে (Drive বা OneDrive-এ যায় না)।",
 "Itens": "জিনিস",
 "Itens de higiene (xampu, sabonete)": "পরিচ্ছন্নতার জিনিস (শ্যাম্পু, সাবান)",
 "Jantar": "রাতের খাবার",
 "Japonês": "জাপানি",
 "Jaqueta impermeável": "ওয়াটারপ্রুফ জ্যাকেট",
 "Jogo": "গেম",
 "Jovem e divertido": "তরুণ ও মজাদার",
 "Juntar PDFs": "PDF জোড়া লাগান",
 "Juros": "সুদ",
 "Juros ainda por vir: {v}": "সামনের সুদ: {v}",
 "Juros ao mês": "মাসিক সুদ",
 "JÁ RESPONDIDOS": "উত্তর দেওয়া হয়েছে",
 "Já aberta na casa nova": "নতুন বাড়িতে খোলা হয়েছে",
 "Já enviado para a turma": "ক্লাসে পাঠানো হয়েছে",
 "Já está compacto": "ইতিমধ্যে ছোট",
 "Já está no Planner": "ইতিমধ্যে Planner-এ আছে",
 "Já está pago": "পরিশোধ হয়ে গেছে",
 "Já há horários deste item no My Planner": "এই আইটেমের সময় ইতিমধ্যে My Planner-এ আছে",
 "Já pago: {v}": "পরিশোধিত: {v}",
 "Já tenho o app: abrir nele": "আমার অ্যাপ আছে: সেখানে খুলুন",
 "Já tenho o app: abrir o convite nele": "আমার অ্যাপ আছে: আমন্ত্রণটি সেখানে খুলুন",
 "Já visitei": "ঘুরে এসেছি",
 "Kit de primeiros socorros": "প্রাথমিক চিকিৎসার কিট",
 "Kkkk": "হাহা",
 "Kkkkk": "হাহাহা",
 "Km de hoje no painel": "আজ ড্যাশবোর্ডে কিমি",
 "Km no dia": "সেদিনের কিমি",
 "Km no painel": "ড্যাশবোর্ডে কিমি",
 "LANÇAMENTOS": "এন্ট্রি",
 "LINHA DO TEMPO": "টাইমলাইন",
 "Laboratório": "ল্যাব",
 "Lanche": "নাস্তা",
 "Lanche da manhã": "সকালের হালকা খাবার",
 "Lanche da tarde": "বিকেলের নাশতা",
 "Lanches e água": "নাস্তা ও পানি",
 "Lançamentos": "লেনদেন",
 "Lavanderia": "লন্ড্রি",
 "Lavanderia, insumos, manutenção, contas e taxas. Entram no lucro do mês.": "লন্ড্রি, প্রয়োজনীয় জিনিস, রক্ষণাবেক্ষণ, বিল ও ফি। এগুলো মাসের লাভে হিসাব হয়।",
 "Lavar o rosto com sabonete facial": "ফেসওয়াশ দিয়ে মুখ ধুয়ে নিন",
 "Lazer": "অবসর",
 "Leg press": "লেগ প্রেস",
 "Legenda": "ক্যাপশন",
 "Legislação Específica": "নির্দিষ্ট আইন",
 "Legumes": "সবজি",
 "Leia hoje para começar uma sequência": "ধারাবাহিকতা শুরু করতে আজ পড়ুন",
 "Leite": "দুধ",
 "Leitura": "পড়া",
 "Leitura automática do texto": "লেখার স্বয়ংক্রিয় পাঠ",
 "Leitura da IA": "AI-এর পাঠ",
 "Leitura, Cursos & Mídia": "পড়া, কোর্স ও মিডিয়া",
 "Lembrete": "রিমাইন্ডার",
 "Lembrete de hoje": "আজকের রিমাইন্ডার",
 "Lembrete de renovação no Planner": "Planner-এ নবায়নের রিমাইন্ডার",
 "Lembrete no Planner": "Planner-এ রিমাইন্ডার",
 "Lembrete no planner": "প্ল্যানারে রিমাইন্ডার",
 "Lembrete pelo WhatsApp": "WhatsApp-এ রিমাইন্ডার",
 "Lembrete: começa às {hora}": "রিমাইন্ডার: {hora}-এ শুরু",
 "Lemos todas as mensagens. Se precisar, respondemos pelo seu e-mail.": "আমরা সব মেসেজ পড়ি। প্রয়োজনে আপনার ইমেইলে উত্তর দিই।",
 "Lendo": "পড়ছি",
 "Lendo a fatura...": "কার্ড বিল পড়া হচ্ছে...",
 "Lendo a página": "পৃষ্ঠা পড়া হচ্ছে",
 "Lendo o boleto...": "বোলেটো পড়া হচ্ছে...",
 "Lendo o cupom...": "রসিদ পড়া হচ্ছে...",
 "Lendo o documento...": "নথি পড়া হচ্ছে...",
 "Lendo o extrato...": "স্টেটমেন্ট পড়া হচ্ছে...",
 "Lendo o relógio...": "ঘড়ি পড়া হচ্ছে...",
 "Lendo o texto": "লেখা পড়া হচ্ছে",
 "Ler a fatura": "কার্ড বিল পড়ুন",
 "Ler a publicação inteira": "পুরো প্রকাশনাটি পড়ুন",
 "Ler com a minha IA": "আমার AI দিয়ে পড়ুন",
 "Ler de novo": "আবার পড়ুন",
 "Ler de novo agora": "এখনই আবার পড়ুন",
 "Ler o texto": "লেখা পড়ুন",
 "Ler o texto completo": "পুরো লেখা পড়ুন",
 "Ler publicação inteira": "পুরো প্রকাশনা পড়ুন",
 "Ler sozinho as publicações novas": "নতুন প্রকাশনা নিজে থেকে পড়ুন",
 "Leve": "হালকা",
 "Leve (sem perder qualidade)": "হালকা (মান না হারিয়ে)",
 "Li e aceito os termos e a política de privacidade": "আমি শর্তাবলি ও গোপনীয়তা নীতি পড়েছি এবং মেনে নিচ্ছি",
 "Li mais {n} páginas": "আরও {n} পৃষ্ঠা পড়েছি",
 "Liberada pelo suporte": "সাপোর্ট দ্বারা খোলা",
 "Liberar para a equipe": "টিমের জন্য খুলে দিন",
 "Liberar para a turma em": "ক্লাসের জন্য খোলার তারিখ",
 "Liberar para o grupo": "গ্রুপের জন্য খুলুন",
 "Liberações e créditos são vinculados ao seu CPF. Atualiza ao sincronizar.": "অনুমোদন ও ক্রেডিট আপনার CPF-এর সাথে যুক্ত। সিঙ্ক করলে আপডেট হয়।",
 "Libere a câmera para o My Planner nas configurações do celular para ler o QR Code.": "QR Code পড়তে মোবাইলের সেটিংসে My Planner-কে ক্যামেরার অনুমতি দিন।",
 "Libere a câmera para o My Planner nas configurações do celular.": "ফোনের সেটিংসে My Planner-কে ক্যামেরা ব্যবহারের অনুমতি দিন।",
 "Libere outras abas em Ajustes › Compras.": "সেটিংস › কেনাকাটায় অন্য ট্যাব আনলক করুন।",
 "Licenciamento": "লাইসেন্সিং",
 "Lidas hoje": "আজ পড়া",
 "Lido": "পড়া শেষ",
 "Ligando. Toque para atender.": "কল আসছে। ধরতে ট্যাপ করুন।",
 "Ligar": "কল করুন",
 "Ligar certificado": "সার্টিফিকেট যুক্ত করুন",
 "Ligar para a assistência": "সার্ভিস সেন্টারে কল করুন",
 "Ligar para {nome}": "{nome}-কে কল করুন",
 "Ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini) para usar esta ferramenta.": "এই টুল ব্যবহার করতে সেটিংস › কৃত্রিম বুদ্ধিমত্তা (Claude, ChatGPT বা Gemini)-তে আপনার AI চালু করুন।",
 "Ligue a sua IA em Ajustes › Inteligência artificial para ler o texto, resumir e perguntar sobre o documento.": "লেখা পড়া, সারাংশ করা ও নথি নিয়ে প্রশ্ন করতে সেটিংস › কৃত্রিম বুদ্ধিমত্তা-তে আপনার AI চালু করুন।",
 "Ligue a sua IA em Ajustes › Inteligência artificial.": "সেটিংস › কৃত্রিম বুদ্ধিমত্তা থেকে আপনার AI চালু করুন।",
 "Ligue o certificado A1 da empresa primeiro.": "আগে প্রতিষ্ঠানের A1 সার্টিফিকেট যুক্ত করুন।",
 "Ligue o seu Google Drive ou OneDrive para guardar fotos e arquivos (que passam a abrir em qualquer dispositivo) e para ter cópias de segurança completas.": "ছবি ও ফাইল সংরক্ষণ করতে (যা যেকোনো ডিভাইসে খোলা যাবে) এবং সম্পূর্ণ ব্যাকআপ রাখতে আপনার Google Drive বা OneDrive সংযুক্ত করুন।",
 "Ligue para o grupo trabalhar nos mesmos dados (obra, viagem, turma, imóvel, consultório), cada pessoa com o seu papel.": "চালু করুন যাতে গ্রুপ একই ডেটায় কাজ করে (নির্মাণ, ভ্রমণ, ক্লাস, সম্পত্তি, চেম্বার), প্রত্যেকে নিজের ভূমিকায়।",
 "Ligue pelo menos 4 pontos.": "কমপক্ষে ৪টি বিন্দু যুক্ত করুন।",
 "Limite anual editável em Ajustes › Abas › Aba Finanças. Confira sempre com o seu contador.": "বার্ষিক সীমা সেটিংস › ট্যাব › অর্থায়ন ট্যাব থেকে বদলানো যায়। সবসময় আপনার হিসাবরক্ষকের সঙ্গে যাচাই করুন।",
 "Limite de consultas atingido. Tente de novo em 1 minuto.": "অনুসন্ধানের সীমা পূর্ণ। ১ মিনিট পরে আবার চেষ্টা করুন।",
 "Limite de energia por dia": "দৈনিক এনার্জির সীমা",
 "Limite de faturamento anual do MEI (confira o valor vigente com o seu contador).": "MEI-এর বার্ষিক আয়ের সীমা (বর্তমান পরিমাণ আপনার হিসাবরক্ষকের সঙ্গে যাচাই করুন)।",
 "Limite de mensagens por hoje atingido. Tente amanhã.": "আজকের মেসেজের সীমা পূর্ণ হয়েছে। আগামীকাল চেষ্টা করুন।",
 "Limite diário": "দৈনিক সীমা",
 "Limite livre: {v} de {l}": "খালি লিমিট: {l}-এর মধ্যে {v}",
 "Limite total (opcional)": "মোট লিমিট (ঐচ্ছিক)",
 "Limpar": "মুছে ফেলুন",
 "Limpar a agenda": "এজেন্ডা পরিষ্কার করুন",
 "Limpar banheiro": "বাথরুম পরিষ্কার",
 "Limpar cozinha e louça": "রান্নাঘর ও বাসন পরিষ্কার",
 "Limpar feitos": "সম্পন্নগুলো মুছুন",
 "Limpeza": "পরিষ্কার",
 "Limpeza após {h}": "{h}-এর পরে পরিষ্কার",
 "Limpeza final": "শেষ পরিষ্কার",
 "Limpeza · {e}": "পরিষ্কার · {e}",
 "Limpeza: {e}": "পরিষ্কার: {e}",
 "Limpezas": "পরিষ্কার",
 "Linha do tempo, tarefas, energia e alertas.": "টাইমলাইন, কাজ, এনার্জি ও অ্যালার্ট।",
 "Link": "লিংক",
 "Link (Drive, OneDrive, Dropbox)": "লিংক (Drive, OneDrive, Dropbox)",
 "Link copiado. Cole onde quiser enviar.": "লিংক কপি হয়েছে। যেখানে পাঠাতে চান সেখানে পেস্ট করুন।",
 "Link da aula ou reunião online (opcional)": "ক্লাস বা অনলাইন মিটিংয়ের লিংক (ঐচ্ছিক)",
 "Link da nota fiscal (Drive ou OneDrive)": "চালানের লিংক (Drive বা OneDrive)",
 "Link da pasta no Drive ou OneDrive (opcional)": "Drive বা OneDrive ফোল্ডারের লিংক (ঐচ্ছিক)",
 "Link da reserva": "বুকিং লিংক",
 "Link da sala online (Meet, Zoom...)": "অনলাইন রুমের লিংক (Meet, Zoom...)",
 "Link de outro calendário (iCal)": "অন্য ক্যালেন্ডারের লিংক (iCal)",
 "Link do calendário do Airbnb (iCal)": "Airbnb ক্যালেন্ডারের লিংক (iCal)",
 "Link do calendário do Booking (iCal)": "Booking ক্যালেন্ডারের লিংক (iCal)",
 "Link inválido": "লিংক সঠিক নয়",
 "Links de materiais (Drive, vídeos, PDFs), um por linha": "উপকরণের লিংক (Drive, ভিডিও, PDF), প্রতি লাইনে একটি",
 "Links: {n}": "লিংক: {n}",
 "Lista": "তালিকা",
 "Lista da mala": "লাগেজের তালিকা",
 "Lista de compras": "বাজারের তালিকা",
 "Lista de exercícios": "অনুশীলনী",
 "Lista rápida": "দ্রুত তালিকা",
 "Listas rápidas e caixas que viram tarefa ou vão para outra aba.": "দ্রুত তালিকা ও বাক্স, যা কাজে পরিণত হয় বা অন্য ট্যাবে যায়।",
 "Literatura": "সাহিত্য",
 "Litros": "লিটার",
 "Livre": "খালি",
 "Livro": "বই",
 "Livros": "বই",
 "Local": "স্থান",
 "Local ou endereço": "স্থান বা ঠিকানা",
 "Local: {l}": "স্থান: {l}",
 "Localização (país e fuso horário)": "লোকেশন (দেশ ও টাইম জোন)",
 "Logo, foto ou rubrica nas páginas.": "পৃষ্ঠায় লোগো, ছবি বা সংক্ষিপ্ত স্বাক্ষর।",
 "Loja (opcional)": "দোকান (ঐচ্ছিক)",
 "Lote": "ব্যাচ",
 "Lua": "চাঁদ",
 "Lugar": "জায়গা",
 "Lugar para visitar": "দেখার জায়গা",
 "Lugares": "জায়গা",
 "Luz": "বিদ্যুৎ",
 "Luz indireta": "পরোক্ষ আলো",
 "Luz, água, gás e internet": "বিদ্যুৎ, পানি, গ্যাস ও ইন্টারনেট",
 "Lápis": "পেনসিল",
 "Língua Portuguesa": "পর্তুগিজ ভাষা",
 "MAIS ADIANTE": "পরে",
 "MAIS USADOS": "সবচেয়ে বেশি ব্যবহৃত",
 "ME ou EPP do Simples": "Simples-এর ME বা EPP",
 "MEI": "MEI",
 "MEI: faturamento em {ano} de {v} (limite {l}).": "MEI: {ano} সালে আয় {v} (সীমা {l})।",
 "MEMBROS ({n})": "সদস্য ({n})",
 "METAS": "লক্ষ্য",
 "MS": "MS",
 "Mais": "আরও",
 "Mais abas": "আরও ট্যাব",
 "Mais cidades entram nas próximas versões.": "পরবর্তী সংস্করণে আরও শহর যোগ হবে।",
 "Mais emojis": "আরও ইমোজি",
 "Mais ferramentas": "আরও টুল",
 "Mais figurinhas animadas (KLIPY)": "আরও অ্যানিমেটেড স্টিকার (KLIPY)",
 "Mais opções desta aba chegam nas próximas versões.": "এই ট্যাবের আরও বিকল্প পরবর্তী সংস্করণে আসবে।",
 "Mais uma": "আরও একটি",
 "Mala": "লাগেজ",
 "Mala ({clima}, {n} dias)": "লাগেজ ({clima}, {n} দিন)",
 "Mamadeiras e leite": "ফিডার ও দুধ",
 "Mandamos um código de 6 números no WhatsApp do número {tel}.": "আমরা {tel} নম্বরের WhatsApp-এ ৬ সংখ্যার একটি কোড পাঠিয়েছি।",
 "Mandar as orientações pelo WhatsApp": "নির্দেশনা WhatsApp-এ পাঠান",
 "Mandar de novo": "আবার পাঠান",
 "Mandar e-mail": "ই-মেইল পাঠান",
 "Mandar lembrete": "রিমাইন্ডার পাঠান",
 "Mandar meu código": "আমার কোড পাঠান",
 "Mandar o acerto para o grupo": "হিসাব গ্রুপে পাঠান",
 "Mandar para quem limpa (WhatsApp)": "পরিষ্কারকর্মীকে পাঠান (WhatsApp)",
 "Mandarim": "ম্যান্ডারিন",
 "Mande um e-mail pedindo a exclusão, com o CPF da conta. Respondemos em até 15 dias.": "অ্যাকাউন্টের পরিচয় নম্বরসহ মুছে ফেলার অনুরোধ ইমেইল করুন। আমরা ১৫ দিনের মধ্যে উত্তর দিই।",
 "Manter": "রাখুন",
 "Manter ambas": "দুটোই রাখুন",
 "Manter ambos": "দুটোই রাখুন",
 "Manter aqui também": "এখানেও রাখুন",
 "Manter tarefas": "কাজগুলো রাখুন",
 "Manutenção": "রক্ষণাবেক্ষণ",
 "Manutenções": "রক্ষণাবেক্ষণ",
 "Mapas (Apple)": "Apple Maps",
 "Marca d'água": "ওয়াটারমার্ক",
 "Marca-texto": "হাইলাইটার",
 "Marcado": "চিহ্নিত",
 "Marcado como feito hoje.": "আজ সম্পন্ন হিসেবে চিহ্নিত।",
 "Marcar como concluída ({dia})": "সম্পন্ন হিসেবে চিহ্নিত করুন ({dia})",
 "Marcar como devolvido": "ফেরত দেওয়া হিসেবে চিহ্নিত করুন",
 "Marcar como feita hoje": "আজ সম্পন্ন হিসেবে চিহ্নিত করুন",
 "Marcar como lido": "পড়া হয়েছে চিহ্নিত করুন",
 "Marcar como paga": "পরিশোধিত চিহ্নিত করুন",
 "Marcar como pago": "পরিশোধিত হিসেবে চিহ্নিত করুন",
 "Marcar como quitado": "পরিশোধ সম্পন্ন হিসেবে চিহ্নিত করুন",
 "Marcar como recebida": "প্রাপ্ত চিহ্নিত করুন",
 "Marcar como recebida?": "প্রাপ্ত হিসেবে চিহ্নিত করবেন?",
 "Marcar como recebido": "প্রাপ্ত হিসেবে চিহ্নিত করুন",
 "Marcar como visto": "দেখা হয়েছে চিহ্নিত করুন",
 "Marcar e avisar a equipe": "ঠিক করুন ও টিমকে জানান",
 "Marcar esta conta como paga?": "এই বিলটি পরিশোধিত হিসেবে চিহ্নিত করবেন?",
 "Marcar fatura como paga": "কার্ড বিল পরিশোধিত চিহ্নিত করুন",
 "Marcar grupo": "গ্রুপ নির্বাচন করুন",
 "Marcar reunião": "মিটিং ঠিক করুন",
 "Marcenaria": "কাঠের কাজ",
 "Margem": "মার্জিন",
 "Marketing": "মার্কেটিং",
 "Marque as fotos do diário como Antes ou Depois para montar a galeria.": "গ্যালারি বানাতে ডায়েরির ছবিগুলোকে আগে বা পরে হিসেবে চিহ্নিত করুন।",
 "Marque os dias em que você estuda e o horário de cada dia. Cada dia vira uma tarefa que se repete toda semana, ligada a este item.": "যেসব দিনে আপনি পড়েন সেগুলো এবং প্রতিদিনের সময় চিহ্নিত করুন। প্রতিটি দিন এই আইটেমের সাথে যুক্ত একটি কাজ হয়ে যায়, যা প্রতি সপ্তাহে পুনরাবৃত্তি হয়।",
 "Marque um ou mais estados.": "এক বা একাধিক রাজ্য বেছে নিন।",
 "Martelo": "হাতুড়ি",
 "Masculino": "পুরুষ",
 "Masculino e minimalista": "পুরুষালি ও মিনিমালিস্ট",
 "Matemática": "গণিত",
 "Materiais": "উপকরণ",
 "Material": "মালামাল",
 "Matrícula, placa, código ou CNPJ": "নিবন্ধন, নম্বর প্লেট, কোড বা CNPJ",
 "Matéria ou material": "বিষয় বা উপকরণ",
 "Matéria ou módulo": "বিষয় বা মডিউল",
 "Matérias": "বিষয়সমূহ",
 "Meia-sombra": "আধা-ছায়া",
 "Melhorando a imagem...": "ছবি উন্নত করা হচ্ছে...",
 "Melhorias novas já foram baixadas. Leva só alguns segundos e seus dados continuam.": "নতুন উন্নতিগুলো ডাউনলোড হয়ে গেছে। মাত্র কয়েক সেকেন্ড লাগবে এবং আপনার ডেটা থেকে যাবে।",
 "Membros": "সদস্য",
 "Menos de 1 minuto": "১ মিনিটের কম",
 "Mensagem": "বার্তা",
 "Mensagem apagada": "বার্তা মুছে ফেলা হয়েছে",
 "Mensagem enviada. Obrigado!": "মেসেজ পাঠানো হয়েছে। ধন্যবাদ!",
 "Mensagem ou observações": "বার্তা বা মন্তব্য",
 "Mensagens": "বার্তা",
 "Mensagens que você envia em Fale conosco.": "যোগাযোগ করুন অংশে আপনার পাঠানো মেসেজ।",
 "Mensagens: a sua lista de amigos, as conversas, as fotos e os arquivos enviados ficam guardados no servidor para chegar aos outros dispositivos. As chamadas de áudio e vídeo não são gravadas.": "বার্তা: আপনার বন্ধু তালিকা, চ্যাট, পাঠানো ছবি ও ফাইল সার্ভারে সংরক্ষিত থাকে যাতে অন্য ডিভাইসে পৌঁছাতে পারে। অডিও ও ভিডিও কল রেকর্ড করা হয় না।",
 "Mensalidade de {m}": "{m}-এর মাসিক ফি",
 "Mensalidade ou valor por aluno": "মাসিক ফি বা শিক্ষার্থীপ্রতি পরিমাণ",
 "Mensalidades, aulas avulsas e materiais. Em ⋮ da turma, \"Gerar as cobranças do mês\" cria uma para cada aluno.": "মাসিক ফি, একক ক্লাস ও উপকরণ। ক্লাসের ⋮-তে \"এই মাসের চার্জ তৈরি করুন\" প্রত্যেক শিক্ষার্থীর জন্য একটি করে তৈরি করে।",
 "Mercado": "বাজার",
 "Mesa flexora": "লেগ কার্ল",
 "Mestre Achado": "Mestre Achado",
 "Mestre de obras": "সাইট সুপারভাইজার",
 "Meta": "লক্ষ্য",
 "Meta 100% batida": "লক্ষ্য ১০০% পূরণ",
 "Meta atingida": "লক্ষ্য পূরণ",
 "Meta atingida!": "লক্ষ্য পূরণ হয়েছে!",
 "Meta da semana: {dur}": "সপ্তাহের লক্ষ্য: {dur}",
 "Meta de aulas": "ক্লাসের লক্ষ্য",
 "Meta de aulas batida": "ক্লাসের লক্ষ্য পূরণ",
 "Meta de copos por dia": "দৈনিক গ্লাসের লক্ষ্য",
 "Meta de páginas por dia": "দৈনিক পৃষ্ঠার লক্ষ্য",
 "Meta de páginas, progresso e resumos dos livros, filmes e séries para ver e aulas dos cursos.": "পৃষ্ঠার লক্ষ্য, অগ্রগতি, বই আর দেখতে চাওয়া সিনেমা ও সিরিজের সারাংশ, এবং কোর্সের ক্লাস।",
 "Meta diária": "দৈনিক লক্ষ্য",
 "Meta por dia": "দৈনিক লক্ষ্য",
 "Meta por semana:": "সাপ্তাহিক লক্ষ্য:",
 "Meta {meta} · copo de {copo} · {n} copos": "লক্ষ্য {meta} · {copo}-এর গ্লাস · {n} গ্লাস",
 "Metas": "লক্ষ্যসমূহ",
 "Metodologia Científica": "গবেষণা পদ্ধতি",
 "Meu caderno": "আমার খাতা",
 "Meu cartão de contato": "আমার কন্টাক্ট কার্ড",
 "Meu plano": "আমার প্ল্যান",
 "Meus GIFs ({n})": "আমার GIF ({n})",
 "Meus PDFs": "আমার PDF",
 "Meus dados": "আমার তথ্য",
 "Meus dados profissionais": "আমার পেশাগত তথ্য",
 "Microchip": "মাইক্রোচিপ",
 "Microfone": "মাইক্রোফোন",
 "Microscópio": "মাইক্রোস্কোপ",
 "Militares estaduais": "রাজ্য সামরিক",
 "Minha Casa": "আমার বাড়ি",
 "Minha conta": "আমার অ্যাকাউন্ট",
 "Minhas anotações do livro": "আমার বইয়ের নোট",
 "Minhas figurinhas": "আমার স্টিকার",
 "Minutos": "মিনিট",
 "Minutos de exercício": "ব্যায়ামের মিনিট",
 "Mirante": "ভিউপয়েন্ট",
 "Mirantes": "ভিউপয়েন্ট",
 "Modelo": "মডেল",
 "Modelo de prescrição": "প্রেসক্রিপশনের টেমপ্লেট",
 "Modelos": "টেমপ্লেট",
 "Modificado em": "পরিবর্তনের তারিখ",
 "Modo": "মোড",
 "Modo de preparo": "প্রস্তুত প্রণালী",
 "Modo seguro: tarefas automáticas desligadas até abrir o app de novo": "নিরাপদ মোড: অ্যাপ আবার খোলা পর্যন্ত স্বয়ংক্রিয় কাজ বন্ধ",
 "Moeda": "মুদ্রা",
 "Moeda: {m}": "মুদ্রা: {m}",
 "Moedas": "কয়েন",
 "Momento do evento": "ইভেন্টের মুহূর্ত",
 "Monitor do Diário de Justiça Eletrônico (DJEN) por nome e OAB.": "নাম ও OAB অনুযায়ী ইলেকট্রনিক বিচার গেজেট (DJEN) মনিটর।",
 "Monitor ou co-professor": "মনিটর বা সহ-শিক্ষক",
 "Montando o PDF: página {n} de {total}...": "PDF তৈরি হচ্ছে: পৃষ্ঠা {n} / {total}...",
 "Montar a mala pelo clima ({n} dias)": "আবহাওয়া অনুযায়ী লাগেজ গোছান ({n} দিন)",
 "Monte o cronograma alimentar para ver o relatório.": "রিপোর্ট দেখতে খাদ্য সময়সূচি তৈরি করুন।",
 "Monte o roteiro dia a dia. No período da viagem, ele aparece na linha do tempo do My Planner.": "দিনে দিনে ভ্রমণসূচি বানান। ভ্রমণের সময় এটি My Planner-এর টাইমলাইনে দেখা যায়।",
 "Monte seu cronograma alimentar e seus cuidados abaixo. O que for de hoje aparece aqui para marcar.": "নিচে আপনার খাদ্য সময়সূচি ও যত্ন সাজান। আজকের যা আছে তা চিহ্নিত করার জন্য এখানে দেখাবে।",
 "Monte seu cronograma alimentar, cuidados, treinos e suplementos abaixo. O que for de hoje aparece aqui para marcar.": "নিচে আপনার খাদ্য সময়সূচি, যত্ন, ওয়ার্কআউট ও সাপ্লিমেন্ট তৈরি করুন। আজকের সবকিছু চিহ্নিত করার জন্য এখানে দেখাবে।",
 "Monte seus treinos com atividades prontas: aparelhos da academia, exercícios em casa, caminhada, corrida, yoga, pilates...": "তৈরি কার্যকলাপ দিয়ে ওয়ার্কআউট সাজান: জিমের মেশিন, বাড়িতে ব্যায়াম, হাঁটা, দৌড়, যোগব্যায়াম, পিলাটিস...",
 "Mostrando as 120 mais recentes.": "সাম্প্রতিকতম ১২০টি দেখানো হচ্ছে।",
 "Mostrando só o roteiro. {n} tarefa(s) do dia escondida(s).": "শুধু ভ্রমণসূচি দেখানো হচ্ছে। দিনের {n}টি কাজ লুকানো।",
 "Mostrar datas, horários, moeda e feriados certos para onde você está. Não usamos o GPS.": "আপনি যেখানে আছেন সেই অনুযায়ী সঠিক তারিখ, সময়, মুদ্রা ও ছুটির দিন দেখানো। আমরা GPS ব্যবহার করি না।",
 "Mostrar menos": "কম দেখান",
 "Mostrar só o roteiro durante a viagem": "ভ্রমণের সময় শুধু ভ্রমণসূচি দেখান",
 "Motivo do cancelamento": "বাতিলের কারণ",
 "Moto": "মোটরসাইকেল",
 "Mover": "সরান",
 "Mover para hoje": "আজকে সরান",
 "Mudança": "স্থানান্তর",
 "Mudança: {para}": "স্থানান্তর: {para}",
 "Mudanças": "স্থানান্তর",
 "Mudar e-mail": "ইমেল পরিবর্তন",
 "Mudar o nome": "নাম বদলান",
 "Mudar senha": "পাসওয়ার্ড পরিবর্তন",
 "Mudo": "মিউট",
 "Muitas tentativas": "অনেকবার চেষ্টা করা হয়েছে",
 "Muitas tentativas erradas. Tente de novo em {s} segundos.": "অনেকবার ভুল চেষ্টা হয়েছে। {s} সেকেন্ড পরে আবার চেষ্টা করুন।",
 "Muitas tentativas. Aguarde alguns minutos.": "অনেকবার চেষ্টা করা হয়েছে। কয়েক মিনিট অপেক্ষা করুন।",
 "Muito bem: já guardou {v} este mês. Constância vale mais que valor alto.": "দারুণ: এই মাসে ইতিমধ্যে {v} জমিয়েছেন। বড় অঙ্কের চেয়ে নিয়মিত থাকা বেশি মূল্যবান।",
 "Multa": "জরিমানা",
 "Multa e juros": "বিলম্ব জরিমানা ও সুদ",
 "Multa e juros de {v}": "{v} বিলম্ব জরিমানা ও সুদ",
 "Multa e juros estimados: {v}": "আনুমানিক জরিমানা ও সুদ: {v}",
 "Multas e juros pagos": "পরিশোধিত বিলম্ব জরিমানা ও সুদ",
 "Mundo": "বিশ্ব",
 "Municipal": "পৌর",
 "Município da prestação (IBGE), se for outro": "সেবা প্রদানের পৌরসভা (IBGE), যদি ভিন্ন হয়",
 "Município da prestação (código IBGE, 7 números)": "সেবা প্রদানের পৌরসভা (IBGE কোড, ৭ সংখ্যা)",
 "Mural": "নোটিশ বোর্ড",
 "Museu": "জাদুঘর",
 "Museus": "জাদুঘর",
 "My Planner (vira tarefa)": "My Planner (কাজে পরিণত হয়)",
 "My Planner bloqueado": "My Planner লক করা",
 "Máxima": "সর্বোচ্চ",
 "Média": "মাঝারি",
 "Média para aprovação": "পাসের গড় নম্বর",
 "Média · repouso {n}": "গড় · বিশ্রাম {n}",
 "Médico": "ডাক্তার",
 "Médico ou clínica": "ডাক্তার বা ক্লিনিক",
 "Médio": "মাঝারি",
 "Mês": "মাস",
 "Mês a mês": "মাসে মাসে",
 "Mês atual": "চলতি মাস",
 "Mês passado": "গত মাস",
 "Móveis e enxoval": "আসবাব ও বিছানাপত্র",
 "Móvel": "আসবাব",
 "Música": "সংগীত",
 "NAS ABAS": "ট্যাবগুলোতে",
 "NF-e: a SEFAZ pede 1 hora entre as buscas. Próxima a partir das {h}.": "NF-e: SEFAZ দুই খোঁজের মধ্যে ১ ঘণ্টা বিরতি চায়। পরেরটি {h}-এর পর।",
 "NF-e: informe a UF da empresa para buscar as notas de produtos.": "NF-e: পণ্যের ইনভয়েস খুঁজতে প্রতিষ্ঠানের রাজ্য (UF) দিন।",
 "NFS-e emitida": "NFS-e ইস্যু হয়েছে",
 "NFS-e: {m}": "NFS-e: {m}",
 "Na (opcional):": "বার (ঐচ্ছিক):",
 "Na agenda": "সময়সূচিতে",
 "Na agenda em {data}": "{data}-এ সময়সূচিতে",
 "Na barra": "বারে আছে",
 "Na demonstração não há servidor de notas. Use o app com a sua conta.": "ডেমোতে ইনভয়েস সার্ভার নেই। নিজের অ্যাকাউন্ট দিয়ে অ্যাপ ব্যবহার করুন।",
 "Na hora": "সঙ্গে সঙ্গে",
 "Na hora da pausa aparece um aviso grande na tela, com contagem regressiva.": "বিরতির সময় স্ক্রিনে কাউন্টডাউনসহ একটি বড় নোটিশ দেখা যায়।",
 "Na linha do tempo, tocar no temporizador também abre esta página.": "টাইমলাইনে টাইমারে ট্যাপ করলেও এই পৃষ্ঠা খোলে।",
 "Na pasta \"{pasta}\" do celular. Cada arquivo pronto vai para lá.": "মোবাইলের \"{pasta}\" ফোল্ডারে। প্রতিটি তৈরি ফাইল সেখানে যায়।",
 "Na pasta \"{pasta}\" do celular. Cada documento novo vai para lá quando você sai dele.": "ফোনের \"{pasta}\" ফোল্ডারে। প্রতিটি নতুন নথি আপনি বের হলে সেখানে চলে যায়।",
 "Na prévia de demonstração não há chamadas de verdade.": "ডেমো প্রিভিউতে আসল কল হয় না।",
 "Na prévia de demonstração não há gravação de verdade.": "ডেমো প্রিভিউতে আসল রেকর্ডিং নেই।",
 "Na prévia de demonstração os arquivos não abrem.": "ডেমো প্রিভিউতে ফাইল খোলে না।",
 "Na versão das lojas, a compra será pela Google Play ou pela App Store. Por enquanto a chave simula a assinatura para testes.": "স্টোর সংস্করণে কেনাকাটা হবে Google Play বা App Store-এর মাধ্যমে। আপাতত এই সুইচটি পরীক্ষার জন্য সাবস্ক্রিপশনের সিমুলেশন করে।",
 "Na versão das lojas, este botão abre a compra da Google Play ou da App Store.": "স্টোর সংস্করণে এই বোতামটি Google Play বা App Store-এর ক্রয় পৃষ্ঠা খোলে।",
 "Nacional": "জাতীয়",
 "Nada a gerar": "তৈরি করার কিছু নেই",
 "Nada encontrado.": "কিছু পাওয়া যায়নি।",
 "Nada entra na agenda de ninguém sem autorização: cada pessoa aceita, edita ou recusa.": "অনুমতি ছাড়া কারও এজেন্ডায় কিছু যোগ হয় না: প্রত্যেকে গ্রহণ, সম্পাদনা বা প্রত্যাখ্যান করেন।",
 "Nada foi registrado.": "কিছুই রেকর্ড হয়নি।",
 "Nada lançado neste mês.": "এই মাসে কোনো এন্ট্রি নেই।",
 "Nada no mês": "এই মাসে কিছু নেই",
 "Nada no roteiro deste dia.": "এই দিনের ভ্রমণসূচিতে কিছু নেই।",
 "Nada para apagar com esse filtro.": "এই ফিল্টারে মোছার মতো কিছু নেই।",
 "Nada para comprar": "কেনার কিছু নেই",
 "Nada para enviar.": "পাঠানোর কিছু নেই।",
 "Nada planejado para este dia": "এই দিনের জন্য কিছু পরিকল্পনা নেই",
 "Nada planejado para hoje. Bom dia!": "আজকের জন্য কিছু পরিকল্পনা নেই। সুপ্রভাত!",
 "Nada por aqui.": "এখানে কিছু নেই।",
 "Nada recebido ainda.": "এখনও কিছু পাওয়া যায়নি।",
 "Nas conversas, cada pessoa vê o seu nome e o que você manda ali. Você pode apagar uma mensagem para todos, sair de um grupo ou bloquear alguém.": "চ্যাটে প্রত্যেকে আপনার নাম ও আপনি সেখানে যা পাঠান তা দেখতে পায়। আপনি কোনো বার্তা সবার জন্য মুছতে, গ্রুপ ছাড়তে বা কাউকে ব্লক করতে পারেন।",
 "Nascimento": "জন্ম",
 "Natal": "বড়দিন",
 "Natação": "সাঁতার",
 "Navegador conectado": "ব্রাউজার সংযুক্ত",
 "Negrito": "বোল্ড",
 "Negócios": "ব্যবসা",
 "Nenhum": "কোনোটি নয়",
 "Nenhum XML neste período (ou foram guardados em outro dispositivo).": "এই সময়ে কোনো XML নেই (বা অন্য ডিভাইসে সংরক্ষিত হয়েছে)।",
 "Nenhum amigo para adicionar. Convide pelo WhatsApp ou adicione amigos no Mensagens (código do amigo).": "যোগ করার মতো কোনো বন্ধু নেই। WhatsApp-এ আমন্ত্রণ পাঠান বা বার্তা-তে বন্ধু যোগ করুন (বন্ধুর কোড)।",
 "Nenhum arquivo, imagem ou link nas páginas desta matéria.": "এই বিষয়ের পৃষ্ঠাগুলোতে কোনো ফাইল, ছবি বা লিংক নেই।",
 "Nenhum arquivo.": "কোনো ফাইল নেই।",
 "Nenhum atendimento pago neste mês.": "এই মাসে কোনো পরিশোধিত অ্যাপয়েন্টমেন্ট নেই।",
 "Nenhum cartão": "কোনো কার্ড নেই",
 "Nenhum comprovante guardado ainda. Ao pagar uma conta, toque nela e anexe a foto, o PDF ou o print do comprovante.": "এখনো কোনো রসিদ সংরক্ষিত নেই। বিল পরিশোধের পর সেটিতে ট্যাপ করুন এবং রসিদের ছবি, PDF বা স্ক্রিনশট যুক্ত করুন।",
 "Nenhum cômodo ainda": "এখনো কোনো ঘর নেই",
 "Nenhum dia": "কোনো দিন নয়",
 "Nenhum documento ainda.": "এখনও কোনো নথি নেই।",
 "Nenhum documento neste filtro.": "এই ফিল্টারে কোনো নথি নেই।",
 "Nenhum e-mail cadastrado": "কোনো ইমেল নিবন্ধিত নেই",
 "Nenhum erro registrado. Se o app fechar sozinho ou uma tela der problema, o erro aparece aqui para você mandar para a equipe.": "কোনো ত্রুটি নেই। অ্যাপ নিজে বন্ধ হলে বা কোনো স্ক্রিনে সমস্যা হলে ত্রুটিটি এখানে দেখাবে, যাতে দলের কাছে পাঠাতে পারেন।",
 "Nenhum feriado neste ano.": "এই বছরে কোনো ছুটি নেই।",
 "Nenhum fichário ainda": "এখনো কোনো বাইন্ডার নেই",
 "Nenhum grupo ainda.": "এখনও কোনো গ্রুপ নেই।",
 "Nenhum item em {nome}": "{nome}-এ কোনো জিনিস নেই",
 "Nenhum lançamento encontrado": "কোনো এন্ট্রি পাওয়া যায়নি",
 "Nenhum país encontrado.": "কোনো দেশ পাওয়া যায়নি।",
 "Nenhum selecionado": "কিছু নির্বাচিত নয়",
 "Nenhuma (plano gratuito)": "কোনোটি নয় (ফ্রি প্ল্যান)",
 "Nenhuma aba encontrada.": "কোনো ট্যাব পাওয়া যায়নি।",
 "Nenhuma aba fixada além do My Planner.": "My Planner ছাড়া কোনো ট্যাব পিন করা নেই।",
 "Nenhuma aba liberada para receber": "কোনো আনলক করা ট্যাব এটি নিতে পারে না",
 "Nenhuma agenda encontrada": "কোনো ক্যালেন্ডার পাওয়া যায়নি",
 "Nenhuma agenda para trazer": "আনার মতো কোনো ক্যালেন্ডার নেই",
 "Nenhuma audiência ou prazo encontrado nesta publicação.": "এই প্রকাশনায় কোনো শুনানি বা সময়সীমা পাওয়া যায়নি।",
 "Nenhuma caixa arquivada. Arraste uma caixa para a esquerda para arquivar.": "কোনো আর্কাইভ করা বাক্স নেই। আর্কাইভ করতে বাক্সটি বাঁদিকে সোয়াইপ করুন।",
 "Nenhuma compra encontrada": "কোনো কেনাকাটা পাওয়া যায়নি",
 "Nenhuma compra nesta fatura.": "এই কার্ড বিলে কোনো কেনাকাটা নেই।",
 "Nenhuma conta a pagar cadastrada.": "কোনো দেনা বিল যোগ করা হয়নি।",
 "Nenhuma conta a receber cadastrada.": "কোনো পাওনা অর্থ যোগ করা হয়নি।",
 "Nenhuma conta neste mês. Toque em + para cadastrar (aluguel, luz, cartão...).": "এই মাসে কোনো বিল নেই। যোগ করতে + চাপুন (ভাড়া, বিদ্যুৎ, কার্ড...)।",
 "Nenhuma cópia de segurança ainda.": "এখনও কোনো ব্যাকআপ নেই।",
 "Nenhuma cópia encontrada.": "কোনো ব্যাকআপ পাওয়া যায়নি।",
 "Nenhuma garantia ativa. Cadastre com o +.": "কোনো সক্রিয় ওয়ারেন্টি নেই। + দিয়ে যোগ করুন।",
 "Nenhuma garantia vencida.": "কোনো মেয়াদোত্তীর্ণ ওয়ারেন্টি নেই।",
 "Nenhuma mensagem ainda. Diga oi! 👋": "এখনও কোনো বার্তা নেই। হাই বলুন! 👋",
 "Nenhuma nota neste período.": "এই সময়ে কোনো ইনভয়েস নেই।",
 "Nenhuma opção ainda.": "এখনো কোনো বিকল্প নেই।",
 "Nenhuma publicação nova.": "কোনো নতুন প্রকাশনা নেই।",
 "Nenhuma refeição neste dia.": "এই দিনে কোনো খাবার নেই।",
 "Nenhuma reunião marcada.": "কোনো মিটিং ঠিক করা নেই।",
 "Nesse ritmo, termina em {d}": "এই গতিতে {d} তারিখে শেষ হবে",
 "Nesta fase de lançamento, todas as abas estão liberadas e grátis.": "লঞ্চের এই পর্যায়ে সব ট্যাব খোলা ও বিনামূল্যে।",
 "Nesta fase de testes, a senha é redefinida pelo suporte. Escreva para {email} informando seu CPF ou e-mail.": "পরীক্ষার এই পর্যায়ে পাসওয়ার্ড সাপোর্ট টিম রিসেট করে। আপনার CPF বা ই-মেইল জানিয়ে {email}-এ লিখুন।",
 "Nesta fase de testes, a senha é redefinida pelo suporte. Escreva para {email} informando seu CPF.": "এই পরীক্ষামূলক পর্যায়ে পাসওয়ার্ড সাপোর্ট রিসেট করে। আপনার CPF উল্লেখ করে {email}-এ লিখুন।",
 "Neve": "বরফ",
 "Ninguém deve nada a ninguém.": "কারও কাছে কারও কিছু পাওনা নেই।",
 "Ninguém entrou ainda. Envie o convite.": "এখনও কেউ যোগ দেয়নি। আমন্ত্রণ পাঠান।",
 "Ninguém usou o seu código ainda.": "এখনও কেউ আপনার কোড ব্যবহার করেননি।",
 "No Android, o app guarda só o atalho do arquivo escolhido: ele continua onde está (Drive, OneDrive, Downloads) e abre no app do celular. Nada é copiado. Esta opção vale para as fotos tiradas pela câmera.": "Android-এ অ্যাপ শুধু বেছে নেওয়া ফাইলের শর্টকাট রাখে: ফাইলটি যেখানে আছে সেখানেই থাকে (Drive, OneDrive, Downloads) এবং ফোনের অ্যাপে খোলে। কিছুই কপি হয় না। এই বিকল্প ক্যামেরায় তোলা ছবির জন্য প্রযোজ্য।",
 "No Google Drive ou OneDrive: {n}": "Google Drive বা OneDrive-এ: {n}",
 "No Google Drive, o app só enxerga os arquivos que ele mesmo criou na pasta My Planner. O uso das informações recebidas das APIs do Google segue a Política de Dados do Usuário dos Serviços de API do Google, inclusive as regras de Uso Limitado: nada é vendido, usado para publicidade ou lido por pessoas, salvo com a sua autorização ou por obrigação legal.": "Google Drive-এ অ্যাপটি শুধু সেই ফাইলগুলোই দেখতে পায় যেগুলো সে নিজে My Planner ফোল্ডারে তৈরি করেছে। Google API থেকে পাওয়া তথ্যের ব্যবহার Google API পরিষেবার ব্যবহারকারীর ডেটা সংক্রান্ত নীতি মেনে চলে, যার মধ্যে সীমিত ব্যবহারের শর্তাবলিও রয়েছে: আপনার অনুমতি বা আইনগত বাধ্যবাধকতা ছাড়া কিছুই বিক্রি করা হয় না, বিজ্ঞাপনে ব্যবহার করা হয় না বা কোনো ব্যক্তি পড়েন না।",
 "No app do seu relógio (Samsung Health, Garmin Connect, Mi Fitness, Zepp, Fitbit, Amazfit, Google Fit...), ligue a opção \"Health Connect\" ou \"Sincronizar com o Health Connect\".": "আপনার ঘড়ির অ্যাপে (Samsung Health, Garmin Connect, Mi Fitness, Zepp, Fitbit, Amazfit, Google Fit...) \"Health Connect\" বা \"Health Connect-এর সাথে সিঙ্ক করুন\" অপশনটি চালু করুন।",
 "No app novo (versão 0.49), o celular acha as bordas da folha sozinho. Nesta versão, ajuste os 4 cantos com o dedo.": "নতুন অ্যাপে (সংস্করণ 0.49) ফোন নিজেই পাতার প্রান্ত খুঁজে নেয়। এই সংস্করণে আঙুল দিয়ে 4টি কোণ ঠিক করুন।",
 "No centro": "মাঝখানে",
 "No computador, abra {url}, toque no botão acima e aponte a câmera para o QR Code da tela.": "কম্পিউটারে {url} খুলুন, উপরের বোতামে ট্যাপ করুন এবং স্ক্রিনের QR Code-এর দিকে ক্যামেরা ধরুন।",
 "No dia (opcional):": "তারিখ (ঐচ্ছিক):",
 "No iPhone, o app abre \"Salvar em Arquivos\" para você escolher a pasta (pode ser o iCloud Drive).": "iPhone-এ অ্যাপ \"Files-এ সেভ\" খোলে যাতে আপনি ফোল্ডার বেছে নিতে পারেন (iCloud Drive-ও হতে পারে)।",
 "No início": "শুরুতে",
 "No modo seguro o app abre sem as tarefas automáticas (avisos, agenda do Google, publicações, mensagens e relógio). Os seus dados não mudam e tudo volta ao normal na próxima vez que abrir.": "নিরাপদ মোডে অ্যাপ স্বয়ংক্রিয় কাজ (সতর্কবার্তা, Google ক্যালেন্ডার, প্রকাশনা, বার্তা ও ঘড়ি) ছাড়াই খোলে। আপনার ডেটা বদলায় না, পরের বার খুললে সব স্বাভাবিক হয়ে যায়।",
 "No navegador, as páginas ficam só enquanto esta página estiver aberta.": "ব্রাউজারে পৃষ্ঠাগুলো শুধু এই পেজ খোলা থাকা পর্যন্ত থাকে।",
 "No navegador, cole o link do arquivo do Drive, OneDrive ou Dropbox (em Estudos ou Documentos, opção Link). No celular, o botão de arquivo já mostra o Drive e o OneDrive.": "ব্রাউজারে, Drive, OneDrive বা Dropbox-এর ফাইলের লিংক পেস্ট করুন (পড়াশোনা বা নথি-তে, লিংক বিকল্প)। ফোনে, ফাইল বোতামেই Drive ও OneDrive দেখা যায়।",
 "No navegador, o PDF é baixado para o computador.": "ব্রাউজারে PDF কম্পিউটারে ডাউনলোড হয়।",
 "No navegador, só dá para guardar imagens pequenas (até 200 KB). Para outros arquivos, adicione um link do Drive, OneDrive ou Dropbox, ou use o app no celular.": "ব্রাউজারে শুধু ছোট ছবি (200 KB পর্যন্ত) সংরক্ষণ করা যায়। অন্য ফাইলের জন্য Drive, OneDrive বা Dropbox-এর লিংক যোগ করুন, অথবা ফোনে অ্যাপটি ব্যবহার করুন।",
 "No outro app, copie o link do arquivo (Compartilhar › Copiar link) e cole no bloco de link que ficou nesta página.": "অন্য অ্যাপে ফাইলের লিংক কপি করুন (শেয়ার › লিংক কপি করুন) এবং এই পৃষ্ঠায় তৈরি হওয়া লিংক ব্লকে পেস্ট করুন।",
 "No ritmo atual, o ano fecha em {v}.": "বর্তমান হারে বছর শেষে হবে {v}।",
 "No seu fuso: {hora}{dia}": "আপনার টাইম জোনে: {hora}{dia}",
 "Nome": "নাম",
 "Nome (cliente ou fornecedor)": "নাম (ক্লায়েন্ট বা সরবরাহকারী)",
 "Nome (ex.: 8º ano B, Pacientes da clínica, Aniversário da Ana)": "নাম (যেমন: ৮ম শ্রেণি B, ক্লিনিকের রোগী, আনার জন্মদিন)",
 "Nome (ex.: Almoço)": "নাম (যেমন: দুপুরের খাবার)",
 "Nome (ex.: Aluguel recebido, Cliente X)": "নাম (যেমন: প্রাপ্ত ভাড়া, গ্রাহক X)",
 "Nome (ex.: Aluguel, Luz, Internet)": "নাম (যেমন: ভাড়া, বিদ্যুৎ, ইন্টারনেট)",
 "Nome (ex.: Doutorado UFPR)": "নাম (যেমন: UFPR ডক্টরেট)",
 "Nome (ex.: Nubank, Itaú Visa)": "নাম (যেমন: Nubank, Itaú Visa)",
 "Nome (ex.: Skincare da noite)": "নাম (যেমন: রাতের স্কিনকেয়ার)",
 "Nome (ex.: Treino A)": "নাম (যেমন: ওয়ার্কআউট A)",
 "Nome (ex.: Viagem de férias, Reserva de emergência)": "নাম (যেমন: ছুটির ভ্রমণ, জরুরি তহবিল)",
 "Nome (ex.: Vitamina C)": "নাম (যেমন: ভিটামিন সি)",
 "Nome (opcional)": "নাম (ঐচ্ছিক)",
 "Nome (opcional, ex.: CNH do Walter)": "নাম (ঐচ্ছিক, যেমন: Walter-এর CNH)",
 "Nome (pode editar, ex.: \"Suco de uva\")": "নাম (বদলাতে পারেন, যেমন: \"আঙুরের জুস\")",
 "Nome completo": "পুরো নাম",
 "Nome curto": "সংক্ষিপ্ত নাম",
 "Nome da lista": "তালিকার নাম",
 "Nome da matéria": "বিষয়ের নাম",
 "Nome da obra": "নির্মাণকাজের নাম",
 "Nome da pasta (ex.: Recibos, Contratos)": "ফোল্ডারের নাম (যেমন: রসিদ, চুক্তি)",
 "Nome da tarefa": "কাজের নাম",
 "Nome da tarefa (ex.: Academia)": "কাজের নাম (যেমন: জিম)",
 "Nome da tarefa (ex.: Limpar o banheiro)": "কাজের নাম (যেমন: বাথরুম পরিষ্কার)",
 "Nome do PDF (opcional)": "PDF-এর নাম (ঐচ্ছিক)",
 "Nome do conselho": "কাউন্সিলের নাম",
 "Nome do cômodo": "ঘরের নাম",
 "Nome do documento": "নথির নাম",
 "Nome do escritório (ex.: Ravasco Contabilidade)": "অফিসের নাম (যেমন: Ravasco Contabilidade)",
 "Nome do evento": "ইভেন্টের নাম",
 "Nome do grupo (ex.: Família)": "গ্রুপের নাম (যেমন: পরিবার)",
 "Nome do modelo": "টেমপ্লেটের নাম",
 "Nome ou modelo": "নাম বা মডেল",
 "Nome ou razão social": "নাম বা প্রতিষ্ঠানের নাম",
 "Nome, subtarefa ou anotação": "নাম, উপকাজ বা নোট",
 "Nos grupos, cada pessoa responde pelo que inclui. Quem administra o grupo decide quem participa.": "গ্রুপে প্রত্যেকে নিজের যোগ করা বিষয়ের জন্য দায়ী। গ্রুপের অ্যাডমিন ঠিক করেন কে অংশ নেবেন।",
 "Nossa Senhora Aparecida": "Nossa Senhora Aparecida",
 "Nossa Senhora da Luz dos Pinhais": "Nossa Senhora da Luz dos Pinhais",
 "Nota cancelada": "ইনভয়েস বাতিল হয়েছে",
 "Nota fiscal": "ইনভয়েস",
 "Nota fiscal emitida": "ইনভয়েস ইস্যু হয়েছে",
 "Nota fiscal, certificado de garantia e fotos": "চালান, ওয়ারেন্টি সনদ ও ছবি",
 "Nota importada": "আমদানি করা ইনভয়েস",
 "Notas": "ইনভয়েস",
 "Notas Fiscais": "ইনভয়েস (NF)",
 "Notebook e carregador": "ল্যাপটপ ও চার্জার",
 "Nova avaliação": "নতুন মূল্যায়ন",
 "Nova caixa (ex.: Compras, Ideias)": "নতুন বাক্স (যেমন: কেনাকাটা, আইডিয়া)",
 "Nova conversa": "নতুন চ্যাট",
 "Nova garantia": "নতুন ওয়ারেন্টি",
 "Nova matéria": "নতুন বিষয়",
 "Nova meta": "নতুন লক্ষ্য",
 "Nova pasta": "নতুন ফোল্ডার",
 "Nova página": "নতুন পৃষ্ঠা",
 "Nova página com esta caixa": "এই বাক্স দিয়ে নতুন পৃষ্ঠা",
 "Nova refeição": "নতুন খাবার",
 "Nova tarefa": "নতুন কাজ",
 "Nova tarefa da casa": "নতুন ঘরের কাজ",
 "Nova tarefa neste cômodo": "এই ঘরে নতুন কাজ",
 "Novas": "নতুন",
 "Novo": "নতুন",
 "Novo alerta:": "নতুন সতর্কতা:",
 "Novo cartão": "নতুন কার্ড",
 "Novo cartão de crédito": "নতুন ক্রেডিট কার্ড",
 "Novo cuidado": "নতুন যত্ন",
 "Novo documento": "নতুন নথি",
 "Novo e-mail": "নতুন ইমেল",
 "Novo fichário": "নতুন বাইন্ডার",
 "Novo grupo": "নতুন গ্রুপ",
 "Novo item": "নতুন জিনিস",
 "Novo perfil": "নতুন প্রোফাইল",
 "Novo suplemento": "নতুন সাপ্লিমেন্ট",
 "Novo treino": "নতুন ওয়ার্কআউট",
 "Novo: {nome}": "নতুন: {nome}",
 "Novos": "নতুন",
 "Num período": "একটি সময়কালে",
 "Numere cada caixa e diga o cômodo e o conteúdo. Use a busca para achar onde está cada coisa.": "প্রতিটি বাক্সে নম্বর দিন এবং ঘর ও ভেতরের জিনিস লিখুন। কোন জিনিস কোথায় তা খুঁজতে সার্চ ব্যবহার করুন।",
 "Nº": "নং",
 "Não": "না",
 "Não achei o total no cupom. Tente uma foto mais nítida.": "রসিদে মোট অঙ্ক পাওয়া যায়নি। আরও পরিষ্কার ছবি দিয়ে চেষ্টা করুন।",
 "Não consegue entrar?": "প্রবেশ করতে পারছেন না?",
 "Não consegui abrir \"{nome}\". Tente a ferramenta Reparar PDF.": "\"{nome}\" খোলা গেল না। PDF মেরামত টুলটি চেষ্টা করুন।",
 "Não consegui conectar a chamada. Confira a internet e tente de novo.": "কল সংযোগ করা যায়নি। ইন্টারনেট দেখে আবার চেষ্টা করুন।",
 "Não deu certo: {msg}": "সফল হয়নি: {msg}",
 "Não deu para diminuir mais este PDF ({tam}).": "এই PDF আর ছোট করা গেল না ({tam})।",
 "Não dá para tirar todas as páginas.": "সব পৃষ্ঠা সরানো যায় না।",
 "Não encontrei texto neste PDF.": "এই PDF-এ কোনো লেখা পাওয়া যায়নি।",
 "Não encontrei texto neste documento.": "এই নথিতে কোনো লেখা পাইনি।",
 "Não foi possível": "করা সম্ভব হয়নি",
 "Não foi possível abrir": "খোলা সম্ভব হয়নি",
 "Não foi possível abrir o certificado guardado. Ligue o certificado de novo.": "সংরক্ষিত সার্টিফিকেট খোলা গেল না। আবার সার্টিফিকেট যুক্ত করুন।",
 "Não foi possível abrir.": "খোলা যায়নি।",
 "Não foi possível baixar os feriados deste país. Confira a internet.": "এই দেশের ছুটির দিন ডাউনলোড করা যায়নি। ইন্টারনেট সংযোগ পরীক্ষা করুন।",
 "Não foi possível conectar": "সংযোগ করা সম্ভব হয়নি",
 "Não foi possível conectar o {nome}": "{nome} সংযুক্ত করা যায়নি",
 "Não foi possível consultar o DJEN agora.": "এই মুহূর্তে DJEN-এ অনুসন্ধান করা সম্ভব হয়নি।",
 "Não foi possível continuar": "চালিয়ে যাওয়া সম্ভব হয়নি",
 "Não foi possível criar um evento na agenda: {msg}": "ক্যালেন্ডারে ইভেন্ট তৈরি করা যায়নি: {msg}",
 "Não foi possível entrar.": "প্রবেশ করা সম্ভব হয়নি।",
 "Não foi possível enviar": "পাঠানো যায়নি",
 "Não foi possível enviar.": "পাঠানো যায়নি।",
 "Não foi possível guardar: {erro}": "সংরক্ষণ করা গেল না: {erro}",
 "Não foi possível ler o arquivo.": "ফাইলটি পড়া যায়নি।",
 "Não foi possível ler o calendário. Confira o link em Editar.": "ক্যালেন্ডার পড়া যায়নি। সম্পাদনায় লিংকটি দেখে নিন।",
 "Não foi possível procurar agora. Tenta de novo sozinho mais tarde.": "এই মুহূর্তে খোঁজা সম্ভব হয়নি। পরে নিজে থেকে আবার চেষ্টা করা হবে।",
 "Não foi possível reiniciar sozinho.": "নিজে থেকে আবার চালু করা যায়নি।",
 "Não foi possível sincronizar com a agenda: {msg}": "ক্যালেন্ডারের সাথে সিঙ্ক করা যায়নি: {msg}",
 "Não foi possível trocar a foto": "ছবি বদলানো যায়নি",
 "Não há garantia de aviso com o app fechado. A verificação ocorre ao abrir o app (a cada 6 horas) ou em \"Verificar agora\".": "অ্যাপ বন্ধ থাকলে নোটিফিকেশনের নিশ্চয়তা নেই। যাচাই হয় অ্যাপ খুললে (প্রতি ৬ ঘণ্টায়) অথবা \"এখনই যাচাই করুন\"-এ।",
 "Não identificado": "শনাক্ত হয়নি",
 "Não marcada como feita": "সম্পন্ন চিহ্নিত নয়",
 "Não optante pelo Simples": "Simples-এ অন্তর্ভুক্ত নয়",
 "Não se repete": "পুনরাবৃত্তি হয় না",
 "Não use o app para atividades ilegais, para guardar conteúdo de terceiros sem autorização ou para tentar acessar dados de outras pessoas.": "অবৈধ কাজে, অনুমতি ছাড়া অন্যের কনটেন্ট রাখতে বা অন্য মানুষের ডেটায় প্রবেশের চেষ্টায় অ্যাপটি ব্যবহার করবেন না।",
 "Não vai": "আসবেন না",
 "Não vence": "মেয়াদ নেই",
 "Não vendemos seus dados e não usamos o seu conteúdo para publicidade.": "আমরা আপনার ডেটা বিক্রি করি না এবং আপনার কনটেন্ট বিজ্ঞাপনে ব্যবহার করি না।",
 "Não é possível adicionar esta pessoa.": "এই ব্যক্তিকে যোগ করা যাবে না।",
 "Não é um XML de nota fiscal": "এটি ইনভয়েসের XML নয়",
 "Número": "নম্বর",
 "Número (opcional)": "নম্বর (ঐচ্ছিক)",
 "Número da OAB": "OAB নম্বর",
 "Número da caixa": "বাক্স নম্বর",
 "Número da carteirinha": "কার্ড নম্বর",
 "Número da guia do convênio": "বিমা ফর্ম নম্বর",
 "Número da parcela": "কিস্তি নম্বর",
 "Número de hóspedes": "অতিথির সংখ্যা",
 "Número de parcelas": "কিস্তির সংখ্যা",
 "Número do contrato": "চুক্তি নম্বর",
 "Número do registro": "নিবন্ধন নম্বর",
 "Número na chamada": "হাজিরা নম্বর",
 "Número {n}. O XML ficou guardado na nota. Toque nela para ver o PDF.": "নম্বর {n}। XML ইনভয়েসে সংরক্ষিত হয়েছে। PDF দেখতে এতে ট্যাপ করুন।",
 "Número, órgão emissor e observações ficam criptografados (AES-256) no aparelho antes de ir para a nuvem.": "নম্বর, ইস্যুকারী সংস্থা ও মন্তব্য ক্লাউডে যাওয়ার আগে ডিভাইসে এনক্রিপ্ট হয় (AES-256)।",
 "Número, órgão emissor, observações, fotos e PDFs ficam criptografados (AES-256) no dispositivo. Os arquivos protegidos ficam só neste dispositivo.": "নম্বর, ইস্যুকারী সংস্থা, নোট, ছবি ও PDF ডিভাইসে এনক্রিপ্ট (AES-256) হয়। সুরক্ষিত ফাইল শুধু এই ডিভাইসে থাকে।",
 "Número: {n}": "নম্বর: {n}",
 "Números de página": "পৃষ্ঠা নম্বর",
 "O ChatGPT não lê PDF por aqui. Tire uma foto ou um print da página, ou use o Claude ou o Gemini em Ajustes › Inteligência artificial.": "এখানে ChatGPT PDF পড়ে না। পৃষ্ঠার ছবি বা স্ক্রিনশট নিন, অথবা সেটিংস › কৃত্রিম বুদ্ধিমত্তা-য় Claude বা Gemini ব্যবহার করুন।",
 "O DAS vence dia {dia}. Marque como pago em Finanças.": "DAS-এর শেষ তারিখ {dia}। অর্থায়নে পরিশোধিত চিহ্নিত করুন।",
 "O Escritório ainda não foi ligado no servidor. No computador, rode o 29-SERVIDOR-0.45.bat (uma vez só).": "সার্ভারে অফিস এখনও চালু করা হয়নি। কম্পিউটারে 29-SERVIDOR-0.45.bat চালান (শুধু একবার)।",
 "O Mestre Achado cuida do seu dinheiro: contas, cartões e faturas, orçamento por categoria, metas, extrato e cupom pela foto, relatório e MEI.": "Mestre Achado আপনার টাকার দেখাশোনা করে: বিল, কার্ড ও কার্ড বিল, বিভাগ অনুযায়ী বাজেট, লক্ষ্য, ছবি থেকে স্টেটমেন্ট ও রসিদ, রিপোর্ট এবং MEI।",
 "O Mestre está pensando...": "মাস্টার ভাবছেন...",
 "O My Planner cria a pasta \"My Planner\" no seu Drive e só enxerga o que ele mesmo guardou lá.": "My Planner আপনার Drive-এ \"My Planner\" ফোল্ডার তৈরি করে এবং শুধু নিজে যা সেখানে রেখেছে তা-ই দেখে।",
 "O My Planner já abriu no computador, com os seus dados.": "My Planner আপনার তথ্যসহ কম্পিউটারে খুলে গেছে।",
 "O My Planner lê os dados do relógio pelo {fonte}, onde o relógio e os apps de saúde e de exercício guardam tudo.": "My Planner {fonte}-এর মাধ্যমে ঘড়ির ডেটা পড়ে, যেখানে ঘড়ি এবং স্বাস্থ্য ও ব্যায়ামের অ্যাপ সবকিছু সেভ করে।",
 "O My Planner organiza a sua agenda, tarefas, finanças, documentos e outras áreas da vida. É oferecido por Walter Ravasco da Costa, que é o controlador dos dados pessoais tratados no app.": "My Planner আপনার এজেন্ডা, কাজ, ফাইন্যান্স, ডকুমেন্ট ও জীবনের অন্যান্য দিক গুছিয়ে রাখে। এটি দিচ্ছেন Walter Ravasco da Costa, যিনি অ্যাপে প্রক্রিয়াকৃত ব্যক্তিগত ডেটার নিয়ন্ত্রক।",
 "O My Planner usa só a pasta Aplicativos › My Planner do seu OneDrive.": "My Planner আপনার OneDrive-এর শুধু অ্যাপস › My Planner ফোল্ডারটি ব্যবহার করে।",
 "O PDF e as imagens saem deste dispositivo e da nuvem.": "PDF ও ছবিগুলো এই ডিভাইস ও ক্লাউড থেকে মুছে যাবে।",
 "O PDF passou de 15 MB. Se o WhatsApp ou o e-mail recusar, ligue \"Arquivo menor\".": "PDF 15 MB ছাড়িয়ে গেছে। WhatsApp বা ইমেল না নিলে \"ছোট ফাইল\" চালু করুন।",
 "O QUE COMER": "কী খাবেন",
 "O QUE OS MEMBROS PODEM": "সদস্যরা যা করতে পারেন",
 "O QUE VOCÊ MANDA": "আপনি যা পাঠান",
 "O QUE VOCÊ RECEBE": "আপনি যা পান",
 "O acesso continua sendo pelo CPF. O e-mail serve para o suporte falar com você.": "প্রবেশ আগের মতোই CPF দিয়ে হয়। ইমেলটি সাপোর্ট টিম আপনার সাথে যোগাযোগ করতে ব্যবহার করে।",
 "O administrador do grupo poderá enviar compromissos, materiais e avisos. Nada entra na sua agenda sem você aceitar.": "গ্রুপের অ্যাডমিন অ্যাপয়েন্টমেন্ট, উপকরণ ও নোটিশ পাঠাতে পারবেন। আপনি গ্রহণ না করলে আপনার এজেন্ডায় কিছু যোগ হবে না।",
 "O alarme toca de novo a cada 2 minutos (até 4 vezes) enquanto o remédio não for marcado como tomado.": "ওষুধ নেওয়া হয়েছে চিহ্নিত না করা পর্যন্ত অ্যালার্ম প্রতি ২ মিনিটে আবার বাজে (সর্বোচ্চ ৪ বার)।",
 "O app ajuda a organizar, mas não substitui orientação de médicos, advogados, contadores ou outros profissionais. Confira prazos, valores e datas importantes.": "অ্যাপটি গোছাতে সাহায্য করে, কিন্তু ডাক্তার, আইনজীবী, হিসাবরক্ষক বা অন্য পেশাদারদের পরামর্শের বিকল্প নয়। সময়সীমা, অঙ্ক ও গুরুত্বপূর্ণ তারিখ যাচাই করুন।",
 "O app avisa 3 dias antes e no dia do vencimento, às 9h.": "অ্যাপ শেষ তারিখের ৩ দিন আগে ও সেদিন সকাল ৯টায় জানায়।",
 "O app consulta o serviço público do CNJ (DJEN) com os nomes e a OAB que você cadastrar. Esses dados são enviados a esse serviço a cada verificação.": "অ্যাপটি আপনার নিবন্ধিত নাম ও OAB দিয়ে CNJ-এর সরকারি সেবা (DJEN)-তে অনুসন্ধান করে। প্রতিবার যাচাইয়ের সময় এই তথ্য সেই সেবায় পাঠানো হয়।",
 "O app e o servidor do My Planner consultam o serviço público do CNJ (DJEN) com os nomes e as OABs que você cadastrar e, se você marcar, o Querido Diário (diários oficiais municipais). Esses dados são enviados a esses serviços a cada verificação.": "My Planner অ্যাপ ও সার্ভার আপনার নিবন্ধিত নাম ও OAB নম্বর দিয়ে CNJ-এর সরকারি পরিষেবা (DJEN) এবং, আপনি চিহ্নিত করলে, Querido Diário (পৌর সরকারি গেজেট) থেকে তথ্য খোঁজে। প্রতিবার যাচাইয়ের সময় এই তথ্য ওই পরিষেবাগুলোতে পাঠানো হয়।",
 "O app fechou sozinho {n} vezes seguidas": "অ্যাপটি পরপর {n} বার নিজে বন্ধ হয়েছে",
 "O app instalado neste aparelho é a versão {v}. Para fazer chamadas de áudio e vídeo, instale o app 0.35 ou mais novo (APK novo). As mensagens já funcionam.": "এই ডিভাইসে ইনস্টল করা অ্যাপের সংস্করণ {v}। অডিও ও ভিডিও কলের জন্য অ্যাপ 0.35 বা নতুন (নতুন APK) ইনস্টল করুন। বার্তা ইতিমধ্যে কাজ করছে।",
 "O app não fechou e os seus dados continuam salvos. Tente de novo ou mande o relatório para a equipe corrigir.": "অ্যাপ বন্ধ হয়নি এবং আপনার ডেটা সংরক্ষিত আছে। আবার চেষ্টা করুন বা ঠিক করার জন্য দলের কাছে রিপোর্ট পাঠান।",
 "O app pede o desbloqueio ao abrir e ao voltar do segundo plano.": "অ্যাপ খোলার সময় এবং ব্যাকগ্রাউন্ড থেকে ফিরলে অ্যাপ আনলক করতে বলে।",
 "O app pede o desbloqueio ao abrir. Trocar de app ou de tela rapidinho não pede de novo; se o celular ficar travado ou o app ficar fora da tela por mais tempo que o prazo abaixo, pede.": "অ্যাপ খোলার সময় আনলক চায়। দ্রুত অ্যাপ বা স্ক্রিন বদলালে আবার চায় না; ফোন লক হলে বা অ্যাপটি নিচের সময়সীমার চেয়ে বেশি সময় স্ক্রিনের বাইরে থাকলে চাইবে।",
 "O app só lê (passos, distância, calorias, exercício, batimentos e sono) e nunca altera os seus dados de saúde. Os totais de cada dia ficam na sua conta para aparecer também no site e no outro celular.": "অ্যাপটি শুধু পড়ে (ধাপ, দূরত্ব, ক্যালরি, ব্যায়াম, হৃদস্পন্দন ও ঘুম) এবং কখনো আপনার স্বাস্থ্যের ডেটা বদলায় না। প্রতিদিনের মোট হিসাব আপনার অ্যাকাউন্টে থাকে, যাতে ওয়েবসাইট ও অন্য ফোনেও দেখা যায়।",
 "O app volta a pedir a senha para desbloquear.": "অ্যাপ আবার আনলক করতে পাসওয়ার্ড চাইবে।",
 "O app é feito para maiores de 18 anos. Dados de crianças só podem ser registrados pelos pais ou responsáveis.": "অ্যাপটি 18 বছরের বেশি বয়সীদের জন্য। শিশুদের ডেটা শুধু বাবা-মা বা অভিভাবকরাই লিখতে পারেন।",
 "O arquivo ficou só neste dispositivo. Não foi possível guardar no {nome}: {erro}": "ফাইলটি শুধু এই ডিভাইসে রয়ে গেছে। {nome}-এ সংরক্ষণ করা যায়নি: {erro}",
 "O arquivo não está mais nesse lugar (foi apagado ou movido).": "ফাইলটি আর সেখানে নেই (মুছে ফেলা বা সরানো হয়েছে)।",
 "O arquivo não está mais nesse lugar (foi apagado, movido ou o app dele tirou a permissão). Anexe de novo.": "ফাইলটি আর সেখানে নেই (মুছে ফেলা, সরানো হয়েছে বা এর অ্যাপ অনুমতি তুলে নিয়েছে)। আবার সংযুক্ত করুন।",
 "O arquivo passa de 15 MB.": "ফাইলটি 15 MB-এর বেশি।",
 "O arquivo passa de 15 MB. Ligue \"Arquivo menor\" e tente de novo.": "ফাইলটি 15 MB-এর বেশি। \"ছোট ফাইল\" চালু করে আবার চেষ্টা করুন।",
 "O arquivo passa de 25 MB.": "ফাইলটি 25 MB-এর বেশি।",
 "O arquivo passa de 50 MB.": "ফাইলটি ৫০ MB-এর বেশি।",
 "O arquivo sai deste celular. As cópias que você salvou no Drive, OneDrive ou mandou para alguém continuam lá.": "ফাইলটি এই ফোন থেকে মুছে যাবে। Drive, OneDrive-এ রাখা বা কাউকে পাঠানো কপি সেখানেই থাকবে।",
 "O arquivo sai do escritório para todos.": "ফাইলটি সবার জন্য অফিস থেকে সরে যাবে।",
 "O aviso chega às 9h, e de novo no dia do vencimento.": "সকাল ৯টায় বিজ্ঞপ্তি আসে, আর মেয়াদ শেষের দিনে আবার।",
 "O banco ainda não foi preparado. Rode o arquivo supabase/schema.sql no Supabase.": "ডেটাবেস এখনো প্রস্তুত করা হয়নি। Supabase-এ supabase/schema.sql ফাইলটি চালান।",
 "O cartão {c} está com {p}% do limite tomado. Evite parcelar coisa nova nele por enquanto.": "কার্ড {c}-এর লিমিটের {p}% ব্যবহৃত হয়ে গেছে। আপাতত এতে নতুন কিস্তি নেবেন না।",
 "O celular não avisa o app quando a tela é travada, por isso o app conta o tempo fora. Com 1 minuto, travar o celular e voltar depois pede a biometria; responder uma mensagem rápida, não.": "স্ক্রিন লক হলে ফোন অ্যাপকে জানায় না, তাই অ্যাপ বাইরে থাকার সময় গোনে। 1 মিনিট রাখলে ফোন লক করে পরে ফিরলে বায়োমেট্রিক চাইবে; দ্রুত একটি মেসেজের উত্তর দিলে চাইবে না।",
 "O celular serve só para confirmar que a conta é sua (código pelo WhatsApp no cadastro e ao trocar de número). Um número por conta.": "মোবাইল শুধু এটা নিশ্চিত করতে ব্যবহৃত হয় যে অ্যাকাউন্টটি আপনার (নিবন্ধনের সময় ও নম্বর বদলানোর সময় WhatsApp-এ কোড)। প্রতি অ্যাকাউন্টে একটি নম্বর।",
 "O compartilhamento ainda não foi ligado no servidor. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 12-LIGAR-COMPARTILHAMENTO.bat (uma vez só).": "সার্ভারে শেয়ারিং এখনও চালু হয়নি। কম্পিউটারে C:\\MyPlanner ফোল্ডার খুলুন এবং 12-LIGAR-COMPARTILHAMENTO.bat-এ ডাবল-ক্লিক করুন (শুধু একবার)।",
 "O computador vai abrir o My Planner com a sua conta. Faça isso só em computadores de confiança.": "কম্পিউটারটি আপনার অ্যাকাউন্ট দিয়ে My Planner খুলবে। শুধু বিশ্বস্ত কম্পিউটারে এটি করুন।",
 "O convite leva o link do app e do APK mais recente. Quem entra pelo link cai direto no escritório.": "আমন্ত্রণে অ্যাপের লিংক ও সর্বশেষ APK থাকে। লিংক দিয়ে যে ঢোকে, সে সরাসরি অফিসে চলে যায়।",
 "O código de indicação vale só nos primeiros 30 dias da conta.": "রেফারেল কোড শুধু অ্যাকাউন্টের প্রথম 30 দিনে কার্যকর।",
 "O desenho fica guardado só neste dispositivo, protegido. A senha continua valendo se você esquecer o desenho.": "প্যাটার্নটি শুধু এই ডিভাইসে সুরক্ষিতভাবে সংরক্ষিত থাকে। প্যাটার্ন ভুলে গেলেও পাসওয়ার্ড কাজ করবে।",
 "O dinheiro gasto está à frente do andamento da obra.": "খরচ হওয়া টাকা কাজের অগ্রগতির চেয়ে এগিয়ে আছে।",
 "O documento não tem páginas.": "নথিতে কোনো পৃষ্ঠা নেই।",
 "O extrato é lido aqui no aparelho. Contas a pagar com o mesmo valor e data próxima recebem baixa automática.": "স্টেটমেন্টটি এই ডিভাইসেই পড়া হয়। একই পরিমাণ ও কাছাকাছি তারিখের দেয় বিল স্বয়ংক্রিয়ভাবে পরিশোধিত হিসেবে চিহ্নিত হয়।",
 "O extrato é lido aqui no dispositivo. Contas a pagar com o mesmo valor e data próxima recebem baixa automática. O pagamento da fatura do cartão não conta duas vezes.": "স্টেটমেন্ট এই ডিভাইসেই পড়া হয়। একই অঙ্ক ও কাছাকাছি তারিখের দেয় বিল স্বয়ংক্রিয়ভাবে পরিশোধিত হিসেবে মিলিয়ে নেওয়া হয়। কার্ড বিলের পরিশোধ দুবার গোনা হয় না।",
 "O governo recusou a nota": "সরকার ইনভয়েস প্রত্যাখ্যান করেছে",
 "O governo recusou a nota.": "সরকার ইনভয়েস প্রত্যাখ্যান করেছে।",
 "O idioma vale para este dispositivo. Os dados que você digitou não são traduzidos.": "ভাষাটি এই ডিভাইসের জন্য প্রযোজ্য। আপনার লেখা তথ্য অনুবাদ করা হয় না।",
 "O item vinculado foi apagado ou movido.": "লিংক করা আইটেমটি মুছে ফেলা বা সরানো হয়েছে।",
 "O item vinculado foi apagado ou movido. Edite a tarefa para escolher outro.": "লিংক করা আইটেমটি মুছে ফেলা বা সরানো হয়েছে। অন্যটি বেছে নিতে কাজটি সম্পাদনা করুন।",
 "O link antigo deixa de funcionar.": "পুরোনো লিংক আর কাজ করবে না।",
 "O link antigo deixa de funcionar. Quem já está no grupo continua.": "পুরোনো লিংক আর কাজ করবে না। যারা গ্রুপে আছেন তারা থেকে যাবেন।",
 "O link deve começar com https://": "লিংক https:// দিয়ে শুরু হতে হবে",
 "O navegador não deixa ler o calendário das plataformas. Importe pelo app no celular.": "ব্রাউজার প্ল্যাটফর্মের ক্যালেন্ডার পড়তে দেয় না। ফোনের অ্যাপ থেকে ইমপোর্ট করুন।",
 "O plano básico e os períodos de teste das abas seguem as regras mostradas em Ajustes > Compras. Benefícios de indicação valem uma vez por conta.": "বেসিক প্ল্যান ও ট্যাবের ট্রায়াল সময়কাল সেটিংস > কেনাকাটা-এ দেখানো নিয়ম অনুসরণ করে। রেফারেলের সুবিধা প্রতি অ্যাকাউন্টে একবারই।",
 "O que acontece": "কী হবে",
 "O que apagar": "কী মুছবেন",
 "O que comprou": "কী কিনেছেন",
 "O que fazer": "কী করতে হবে",
 "O que foi comido:": "যা খাওয়া হয়েছে:",
 "O que foi feito": "কী কাজ হয়েছে",
 "O que foi visto": "কী পড়ানো হয়েছে",
 "O que funcionou, o que ajustar, metodologias, resumos...": "কী কাজ করেছে, কী বদলাতে হবে, পদ্ধতি, সারসংক্ষেপ...",
 "O que já foi guardado continua nos lançamentos como investimento.": "যা ইতিমধ্যে জমানো হয়েছে তা লেনদেনে বিনিয়োগ হিসেবে থেকে যাবে।",
 "O que levar ou estudar": "কী নিতে হবে বা পড়তে হবে",
 "O que o app pode usar": "অ্যাপ কী ব্যবহার করতে পারে",
 "O que o médico disse": "ডাক্তার কী বলেছেন",
 "O que os seus grupos enviaram. Compromissos aceitos vão para o My Planner; materiais e avisos vão para as Anotações.": "আপনার গ্রুপগুলো যা পাঠিয়েছে। গৃহীত অ্যাপয়েন্টমেন্ট My Planner-এ যায়; উপকরণ ও নোটিশ নোট-এ যায়।",
 "O que precisa": "কী লাগবে",
 "O que tem dentro": "ভেতরে কী আছে",
 "O que você emprestou ou pegou emprestado: foto, com quem está e aviso da devolução.": "আপনি যা ধার দিয়েছেন বা নিয়েছেন: ছবি, কার কাছে আছে এবং ফেরতের সতর্কতা।",
 "O que é apagado": "কী মুছে যায়",
 "O quê": "কী",
 "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando esses apps estão instalados no celular. O app guarda só o atalho: o arquivo continua onde está e abre no app do celular.": "ফোনে Google Drive, OneDrive ও Dropbox থাকলে নির্বাচক সেগুলো দেখায়। অ্যাপ শুধু শর্টকাট রাখে: ফাইল যেখানে আছে সেখানেই থাকে এবং ফোনের অ্যাপে খোলে।",
 "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando esses apps estão instalados no celular. O arquivo escolhido fica guardado neste dispositivo.": "ফোনে Google Drive, OneDrive ও Dropbox ইনস্টল থাকলে সেগুলো নির্বাচকে দেখা যায়। বেছে নেওয়া ফাইলটি এই ডিভাইসে সংরক্ষিত থাকে।",
 "O servidor ainda não buscou para os seus perfis.": "সার্ভার এখনও আপনার প্রোফাইলগুলোর জন্য খোঁজ করেনি।",
 "O servidor ainda não está preparado para as mensagens. Rode o 17-LIGAR-MENSAGENS.bat.": "সার্ভার এখনও বার্তার জন্য প্রস্তুত নয়। 17-LIGAR-MENSAGENS.bat চালান।",
 "O servidor ainda não está preparado para indicações. Tente de novo mais tarde.": "সার্ভার এখনও রেফারেলের জন্য প্রস্তুত নয়। পরে আবার চেষ্টা করুন।",
 "O servidor ainda não está preparado para o cartão de contato. Rode o 19-LIGAR-CONTATO.bat.": "সার্ভার এখনও কন্টাক্ট কার্ডের জন্য প্রস্তুত নয়। 19-LIGAR-CONTATO.bat চালান।",
 "O servidor ainda não foi preparado para dados compartilhados. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (uma vez só).": "সার্ভার এখনো শেয়ার করা ডেটার জন্য প্রস্তুত নয়। কম্পিউটারে C:\\MyPlanner ফোল্ডারটি খুলুন এবং 15-LIGAR-GRUPOS-COLABORATIVOS.bat-এ ডাবল-ক্লিক করুন (শুধু একবার)।",
 "O servidor ainda não foi preparado para o Drive e o OneDrive (veja COMO RODAR, versão 0.14).": "সার্ভার এখনও Drive ও OneDrive-এর জন্য প্রস্তুত হয়নি (COMO RODAR, সংস্করণ 0.14 দেখুন)।",
 "O servidor ainda não foi preparado para o acesso pela web (rode supabase/migracao-0.6.sql).": "সার্ভার এখনো ওয়েব অ্যাক্সেসের জন্য প্রস্তুত নয় (supabase/migracao-0.6.sql চালান)।",
 "O servidor ainda não tem a função \"qr-login\". Veja o passo da versão 0.6 no COMO RODAR.": "সার্ভারে এখনো \"qr-login\" ফাংশন নেই। COMO RODAR-এ সংস্করণ 0.6-এর ধাপটি দেখুন।",
 "O servidor de chamadas recusou a chave do LiveKit. No computador do administrador, rode o 30-CONSERTAR-CHAMADAS.bat.": "কল সার্ভার LiveKit-এর কী গ্রহণ করেনি। অ্যাডমিনের কম্পিউটারে 30-CONSERTAR-CHAMADAS.bat চালান।",
 "O servidor de notas respondeu algo inesperado (HTTP {s}). Confira o endereço.": "ইনভয়েস সার্ভার অপ্রত্যাশিত উত্তর দিয়েছে (HTTP {s})। ঠিকানা যাচাই করুন।",
 "O servidor faz a captura automática de 2 em 2 horas, das 08h às 20h (horário de Brasília), mesmo com o app fechado. As publicações capturadas aparecem quando você abre o app. Também dá para usar \"Verificar agora\".": "অ্যাপ বন্ধ থাকলেও সার্ভার প্রতি ২ ঘণ্টায়, ০৮:০০ থেকে ২০:০০ (ব্রাসিলিয়া সময়) পর্যন্ত স্বয়ংক্রিয়ভাবে সংগ্রহ করে। সংগৃহীত প্রকাশনাগুলো অ্যাপ খুললে দেখা যায়। আপনি \"এখনই যাচাই করুন\"-ও ব্যবহার করতে পারেন।",
 "O servidor faz a captura automática todos os dias às 08h e 12h (horário de Brasília), mesmo com o app fechado. As publicações capturadas aparecem quando você abre o app. Também dá para usar \"Verificar agora\".": "অ্যাপ বন্ধ থাকলেও সার্ভার প্রতিদিন 08:00 ও 12:00-এ (ব্রাসিলিয়া সময়) স্বয়ংক্রিয় সংগ্রহ করে। সংগ্রহ করা প্রকাশনা অ্যাপ খুললে দেখা যায়। আপনি \"এখনই যাচাই করুন\"-ও ব্যবহার করতে পারেন।",
 "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desligue \"Verify JWT\" (o 32-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).": "সার্ভার অ্যাক্সেস প্রত্যাখ্যান করেছে: Supabase-এর \"nuvem\" ফাংশনে \"Verify JWT\" বন্ধ করুন (32-LIGAR-DRIVE-ONEDRIVE.bat এটি আগেই করে)।",
 "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desligue \"Verify JWT\" (o 9-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).": "সার্ভার প্রবেশাধিকার প্রত্যাখ্যান করেছে: Supabase-এর \"nuvem\" ফাংশনে \"Verify JWT\" বন্ধ করুন (9-LIGAR-DRIVE-ONEDRIVE.bat এটি আগেই করে)।",
 "O seu papel no grupo não permite incluir aqui.": "গ্রুপে আপনার ভূমিকা এখানে যোগ করার অনুমতি দেয় না।",
 "O site deve começar com https://": "সাইটটি https:// দিয়ে শুরু হতে হবে",
 "O tamanho padrão do copo ({copo}) muda em Ajustar, no quadro da água.": "গ্লাসের ডিফল্ট মাপ ({copo}) পানির কার্ডে \"সম্পাদনা\"-তে বদলান।",
 "O tema muda as cores das abas (os ícones continuam os mesmos) e vale nos modos claro e escuro. Depois você ainda pode trocar a cor de uma aba em Ajustes > Abas.": "থিম ট্যাবের রং বদলায় (আইকন একই থাকে) এবং লাইট ও ডার্ক দুই মোডেই কাজ করে। পরে সেটিংস > ট্যাব থেকে যেকোনো ট্যাবের রং বদলাতে পারবেন।",
 "O temporizador se enche de cor conforme o tempo da tarefa passa. Tocar nele abre o vínculo da tarefa.": "কাজের সময় যত এগোয়, টাইমার তত রঙে ভরে ওঠে। এতে ট্যাপ করলে কাজের লিংক খোলে।",
 "O teste grátis terminou": "বিনামূল্যের ট্রায়াল শেষ হয়েছে",
 "O texto": "লেখা",
 "O texto do PDF num arquivo .docx para editar.": "PDF-এর লেখা সম্পাদনার জন্য একটি .docx ফাইলে।",
 "O texto também vai escondido dentro do PDF: dá para buscar e copiar no leitor de PDF.": "লেখাটি PDF-এর ভেতরেও লুকানো থাকে: PDF রিডারে খুঁজে কপি করতে পারবেন।",
 "O tom escolhido fica para os próximos emojis.": "বেছে নেওয়া রং পরের ইমোজিগুলোতেও থাকবে।",
 "O total aparece no topo do My Planner. Se passar do limite, o raio fica vermelho. Tarefas \"Relaxar\" valem 0.": "মোট পরিমাণ My Planner-এর উপরে দেখা যায়। সীমা ছাড়ালে বজ্রচিহ্নটি লাল হয়ে যায়। \"বিশ্রাম\" কাজের মান 0।",
 "OAB (opcional, para advogados)": "OAB (ঐচ্ছিক, আইনজীবীদের জন্য)",
 "OBS": "নোট",
 "OCR: texto pesquisável": "OCR: খোঁজার যোগ্য লেখা",
 "OK": "ঠিক আছে",
 "OU ESCOLHER CÔMODO…": "অথবা ঘর বেছে নিন…",
 "Objetivos": "উদ্দেশ্য",
 "Objeto": "বস্তু",
 "Objetos": "বস্তু",
 "Objetos e valores": "জিনিস ও টাকা",
 "Obra": "নির্মাণকাজ",
 "Obras": "নির্মাণকাজ",
 "Obras & Reformas": "নির্মাণ ও সংস্কার",
 "Obrigado": "ধন্যবাদ",
 "Obrigado!": "ধন্যবাদ!",
 "Observações": "মন্তব্য",
 "Observações (alergias, ração...)": "মন্তব্য (অ্যালার্জি, খাবার...)",
 "Observações (chave Pix, conta para depósito...)": "মন্তব্য (Pix কী, জমার অ্যাকাউন্ট...)",
 "Observações (código de barras, chave Pix...)": "মন্তব্য (বারকোড, Pix কী...)",
 "Observações (dados bancários, PIX...)": "মন্তব্য (ব্যাংকের তথ্য, PIX...)",
 "Observações (estado do item...)": "মন্তব্য (জিনিসের অবস্থা...)",
 "Observações (garantia, seguro, CET...)": "মন্তব্য (জামানত, বিমা, মোট খরচ...)",
 "Observações (nº de série, modelo...)": "মন্তব্য (সিরিয়াল নং, মডেল...)",
 "Observações (onde está o original, categoria da CNH...)": "মন্তব্য (মূল কপি কোথায়, CNH-এর শ্রেণি...)",
 "Observações (recibo de entrega, número...)": "মন্তব্য (প্রাপ্তি রসিদ, নম্বর...)",
 "Observações (restrição alimentar...)": "মন্তব্য (খাদ্য বিধিনিষেধ...)",
 "Ocultar texto (tarja)": "লেখা লুকান (কালো দাগ)",
 "Ocupado": "ভরা",
 "Oficina": "ওয়ার্কশপ",
 "Ofício": "লিগ্যাল",
 "Oi!": "হাই!",
 "Oi! Tudo certo para sábado?": "হাই! শনিবারের সব ঠিক আছে তো?",
 "Oi, {pessoa}! Ainda estou com o(a) {coisa} que você me emprestou. Quando fica bom para eu devolver?": "হাই {pessoa}! আপনার ধার দেওয়া {coisa} এখনও আমার কাছে আছে। কখন ফেরত দিলে সুবিধা হবে?",
 "Oi, {pessoa}! Tudo bem? Passando para lembrar do(a) {coisa} que te emprestei em {data}. Consegue devolver {quando}?": "হাই {pessoa}! কেমন আছেন? {data} তারিখে আপনাকে যে {coisa} ধার দিয়েছিলাম, সেটা মনে করিয়ে দিচ্ছি। {quando} ফেরত দিতে পারবেন?",
 "Oi?!": "কী?!",
 "Olá!": "হ্যালো!",
 "Olá! Eu sou o Mestre Achado. Pergunte sobre os seus gastos, contas, cartões e metas: eu respondo com os seus números.": "হ্যালো! আমি Mestre Achado। আপনার খরচ, বিল, কার্ড ও লক্ষ্য নিয়ে জিজ্ঞেস করুন: আমি আপনার নিজের হিসাব দিয়েই উত্তর দেব।",
 "Olá! Passando para lembrar do pagamento de {ref} ({v}), com vencimento em {d}. Obrigado(a)!": "হ্যালো! মনে করিয়ে দিচ্ছি, {ref} ({v})-এর পেমেন্টের শেষ তারিখ {d}। ধন্যবাদ!",
 "Olá! Preciso de assistência técnica para: {item}": "হ্যালো! আমার এর জন্য সার্ভিসিং দরকার: {item}",
 "Olá, {nome}!": "হ্যালো {nome}!",
 "Olá, {nome}! Seja bem-vindo(a).": "হ্যালো, {nome}! স্বাগতম।",
 "Ombros: girar para trás": "কাঁধ: পেছনের দিকে ঘোরান",
 "Omelete": "অমলেট",
 "Onde": "কোথায়",
 "Onde a IA ajuda: Publicações (audiências e prazos), Documentos (preencher a ficha pela foto) e Anotações (transformar uma caixa em tarefas).": "AI যেখানে সাহায্য করে: প্রকাশনা (শুনানি ও সময়সীমা), নথি (ছবি থেকে ফর্ম পূরণ) এবং নোট (বাক্সকে কাজে পরিণত করা)।",
 "Onde assistir": "কোথায় দেখবেন",
 "Onde eu mais gastei este mês?": "এই মাসে আমি সবচেয়ে বেশি কোথায় খরচ করেছি?",
 "Onde fica": "কোথায় আছে",
 "Onde guardar fotos e arquivos novos": "নতুন ছবি ও ফাইল কোথায় সংরক্ষণ করবেন",
 "Onde na página": "পৃষ্ঠার কোথায়",
 "Ontem": "গতকাল",
 "Organizar": "সাজান",
 "Organizar barra": "বার সাজান",
 "Organizar com IA": "AI দিয়ে সাজান",
 "Organizar com IA (vira tarefas)": "AI দিয়ে সাজান (কাজে পরিণত)",
 "Organizar páginas": "পৃষ্ঠা সাজান",
 "Orgulho e vibrante": "গর্বিত ও উজ্জ্বল",
 "Origem": "উৎস",
 "Origem da reserva": "বুকিংয়ের উৎস",
 "Original": "মূল",
 "Orquídeas": "অর্কিড",
 "Orçado": "আনুমানিক",
 "Orçamento": "বাজেট",
 "Orçamento do mês": "মাসের বাজেট",
 "Orçamento por categoria": "বিভাগ অনুযায়ী বাজেট",
 "Orçamento total": "মোট বাজেট",
 "Orçamento: {v}": "বাজেট: {v}",
 "Os alertas precisam de um horário.": "অ্যালার্টের জন্য একটি সময় দরকার।",
 "Os anexos que ficam só no dispositivo não aparecem nos outros dispositivos e se perdem se o celular for trocado. Ligue o Google Drive ou o OneDrive em Ajustes para guardar uma cópia.": "যে সংযুক্তি শুধু এই ডিভাইসে আছে, সেগুলো অন্য ডিভাইসে দেখা যায় না এবং ফোন বদলালে হারিয়ে যায়। কপি রাখতে সেটিংসে Google Drive বা OneDrive সংযুক্ত করুন।",
 "Os arquivos e cópias que já estão lá continuam lá. O My Planner só deixa de guardar coisas novas.": "সেখানে আগে থেকে থাকা ফাইল ও ব্যাকআপ সেখানেই থাকবে। My Planner শুধু নতুন কিছু সংরক্ষণ করা বন্ধ করবে।",
 "Os arquivos guardados neste dispositivo também serão apagados.": "এই ডিভাইসে সংরক্ষিত ফাইলগুলোও মুছে যাবে।",
 "Os arquivos que estão no seu Google Drive, OneDrive ou no celular continuam com você. Registros que a lei obriga a guardar (como os de acesso) podem ficar guardados pelo prazo legal e depois são apagados.": "আপনার Google Drive, OneDrive বা ফোনের ফাইল আপনার কাছেই থাকে। আইন অনুযায়ী রাখতে হয় এমন রেকর্ড (যেমন অ্যাক্সেস লগ) আইনি সময় পর্যন্ত রাখা হতে পারে, পরে মুছে ফেলা হয়।",
 "Os avisos do grupo ainda não foram ligados no servidor. No computador, dê dois cliques em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (uma vez só).": "গ্রুপের নোটিশ এখনো সার্ভারে চালু করা হয়নি। কম্পিউটারে 15-LIGAR-GRUPOS-COLABORATIVOS.bat-এ ডাবল-ক্লিক করুন (শুধু একবার)।",
 "Os avisos estão desligados para o My Planner. Toque em Abrir configurações e ligue as notificações.": "My Planner-এর নোটিফিকেশন বন্ধ আছে। সেটিংস খুলুন-এ ট্যাপ করে নোটিফিকেশন চালু করুন।",
 "Os avisos no celular funcionam no app instalado (Android ou iPhone).": "ফোনে নোটিফিকেশন ইনস্টল করা অ্যাপে (Android বা iPhone) কাজ করে।",
 "Os campos do formulário viram parte da página.": "ফর্মের ঘরগুলো পৃষ্ঠার অংশ হয়ে যায়।",
 "Os dados atuais serão substituídos pelos do arquivo, aqui e na nuvem.": "বর্তমান তথ্য এখানে ও ক্লাউডে ফাইলের তথ্য দিয়ে প্রতিস্থাপিত হবে।",
 "Os dados continuam salvos na nuvem.": "তথ্য ক্লাউডে সংরক্ষিত থাকবে।",
 "Os dados da aba ainda são só seus": "এই ট্যাবের ডেটা এখনও শুধু আপনার",
 "Os dados da aba {aba} passam a ser vistos pela equipe, cada pessoa conforme o papel que você escolher.": "{aba} ট্যাবের ডেটা দলের কাছে দৃশ্যমান হবে, প্রত্যেকে আপনার বেছে নেওয়া ভূমিকা অনুযায়ী।",
 "Os dados deste grupo ainda não foram liberados. Peça para quem criou o grupo abrir o My Planner atualizado: o app libera sozinho.": "এই গ্রুপের তথ্য এখনো উন্মুক্ত করা হয়নি। যিনি গ্রুপ তৈরি করেছেন তাঁকে আপডেট করা My Planner খুলতে বলুন: অ্যাপ নিজেই উন্মুক্ত করবে।",
 "Os dados deste grupo ainda não foram liberados. Peça para quem criou o grupo atualizar o My Planner e abrir o grupo: lá aparece o botão para liberar.": "এই গ্রুপের ডেটা এখনো খোলা হয়নি। যিনি গ্রুপটি তৈরি করেছেন তাঁকে My Planner আপডেট করে গ্রুপটি খুলতে বলুন: সেখানে খোলার বোতাম দেখা যাবে।",
 "Os dados do cofre são criptografados aqui no dispositivo (AES-256) antes de ir para a nuvem. Nem o suporte consegue ler. Se esquecer a senha do cofre, esses dados não podem ser recuperados.": "ভল্টের তথ্য ক্লাউডে যাওয়ার আগে এখানেই ডিভাইসে এনক্রিপ্ট হয় (AES-256)। সাপোর্টও পড়তে পারে না। ভল্টের পাসওয়ার্ড ভুলে গেলে এই তথ্য উদ্ধার করা যায় না।",
 "Os dados ficam guardados enquanto a conta existir. Ao apagar a conta, os dados são apagados, salvo o que a lei obrigar a manter.": "অ্যাকাউন্ট থাকা পর্যন্ত ডেটা রাখা হয়। অ্যাকাউন্ট মুছলে ডেটাও মুছে যায়, আইন যা রাখতে বাধ্য করে তা ছাড়া।",
 "Os desenhos não conferem. Comece de novo.": "প্যাটার্ন দুটি মিলছে না। আবার শুরু করুন।",
 "Os dias estão no app ou na fatura do banco. Compras feitas depois do fechamento caem na fatura seguinte.": "দিনগুলো ব্যাংকের অ্যাপে বা কার্ড বিলে থাকে। বিল বন্ধ হওয়ার পরের কেনাকাটা পরের বিলে যায়।",
 "Os emojis que você usar aparecem aqui.": "আপনি যে ইমোজি ব্যবহার করবেন, সেগুলো এখানে দেখাবে।",
 "Os grupos ainda não foram ligados no servidor. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 11-LIGAR-GRUPOS.bat (uma vez só).": "সার্ভারে গ্রুপ এখনো চালু করা হয়নি। কম্পিউটারে C:\\MyPlanner ফোল্ডারটি খুলুন এবং 11-LIGAR-GRUPOS.bat-এ ডাবল-ক্লিক করুন (শুধু একবার)।",
 "Os grupos ainda não foram ligados no servidor. Rode o supabase\\migracao-0.21.sql no Supabase (veja o COMO RODAR).": "সার্ভারে গ্রুপ এখনও চালু হয়নি। Supabase-এ supabase\\migracao-0.21.sql চালান (COMO RODAR দেখুন)।",
 "Os lugares abrem no Google Maps, no Waze ou no Mapas, como escolhido em Ajustes.": "জায়গাগুলো Google Maps, Waze বা মানচিত্রে খুলবে, সেটিংসে যেমন বেছে নিয়েছেন।",
 "Os membros sempre veem os administradores e só recebem o que foi enviado para eles.": "সদস্যরা সবসময় অ্যাডমিনদের দেখতে পান এবং শুধু তাদের পাঠানো জিনিসই পান।",
 "Os outros membros deixam de ver os dados (a cópia some do dispositivo deles). Tudo continua com você.": "অন্য সদস্যরা আর ডেটা দেখতে পাবেন না (তাদের ডিভাইস থেকে কপি মুছে যাবে)। সবকিছু আপনার কাছে থাকবে।",
 "Os perfis e os resultados ficam na sua conta do My Planner.": "প্রোফাইল ও ফলাফল আপনার My Planner অ্যাকাউন্টে থাকে।",
 "Os perfis, as OABs e os tribunais ficam dentro da aba Publicações. A busca automática roda no servidor às 08h e às 12h (horário de Brasília).": "প্রোফাইল, OAB ও আদালত প্রকাশনা ট্যাবের ভেতরে থাকে। স্বয়ংক্রিয় অনুসন্ধান সার্ভারে ০৮:০০ ও ১২:০০ টায় (ব্রাসিলিয়া সময়) চলে।",
 "Os preços ficam guardados e aparecem na lista de Compras da aba Alimentação & Despensa como o preço da última compra.": "দামগুলো সংরক্ষিত থাকে এবং খাবার ও ভাঁড়ার ট্যাবের বাজারের তালিকায় শেষ কেনার দাম হিসেবে দেখা যায়।",
 "Os resultados deste perfil também serão apagados.": "এই প্রোফাইলের ফলাফলও মুছে যাবে।",
 "Os termos foram atualizados": "শর্তাবলি হালনাগাদ হয়েছে",
 "Ou digite (ex.: 2 ovos mexidos)": "অথবা লিখুন (যেমন: 2টি ডিম ভাজি)",
 "Ou escreva o prato": "অথবা খাবারের নাম লিখুন",
 "Ou escreva o seu": "অথবা নিজের লেখা লিখুন",
 "Outra": "অন্য",
 "Outra aba…": "অন্য ট্যাব…",
 "Outra atividade (digite e dê Enter)": "অন্য কার্যকলাপ (লিখে Enter চাপুন)",
 "Outro": "অন্যান্য",
 "Outro (ml)": "অন্য (ml)",
 "Outro valor": "অন্য পরিমাণ",
 "Outros": "অন্যান্য",
 "Outros países": "অন্যান্য দেশ",
 "Outros relógios (Garmin, Samsung, Xiaomi, Amazfit...): no app do relógio, ligue a opção de enviar os dados para o app Saúde (Apple Health).": "অন্যান্য ঘড়ি (Garmin, Samsung, Xiaomi, Amazfit...): ঘড়ির অ্যাপে Health অ্যাপে (Apple Health) ডেটা পাঠানোর অপশন চালু করুন।",
 "Ovo": "ডিম",
 "PAGO, RECEBIDO, CONFIDENCIAL, APROVADO ou o seu texto, com a data.": "পরিশোধিত, প্রাপ্ত, গোপনীয়, অনুমোদিত বা আপনার লেখা, তারিখসহ।",
 "PARA ACERTAR": "হিসাব মেটাতে হবে",
 "PARA QUEM": "কাকে",
 "PARA {refeicao}": "{refeicao}-এর জন্য",
 "PASSO A PASSO": "ধাপে ধাপে",
 "PASSO {n}": "ধাপ {n}",
 "PDF": "PDF",
 "PDF Edit": "PDF Edit",
 "PDF com texto digital: sai na hora no navegador. PDF escaneado (foto): a sua IA lê cada página.": "ডিজিটাল লেখার PDF: ব্রাউজারে সঙ্গে সঙ্গে হয়। স্ক্যান করা PDF (ছবি): আপনার AI প্রতিটি পৃষ্ঠা পড়ে।",
 "PDF grande": "বড় PDF",
 "PDF guardado na pasta \"{pasta}\" do celular.": "PDF ফোনের \"{pasta}\" ফোল্ডারে সেভ হয়েছে।",
 "PDF guardado no {nome}.": "PDF {nome}-এ সেভ হয়েছে।",
 "PDF numa página só": "এক পৃষ্ঠায় PDF",
 "PDF para Word": "PDF থেকে Word",
 "PDF para imagens": "PDF থেকে ছবি",
 "PDF para texto": "PDF থেকে লেখা",
 "PDFs arquivados ({n})": "আর্কাইভ করা PDF ({n})",
 "PDFs juntados {data}": "জোড়া লাগানো PDF {data}",
 "PEDIDOS RECEBIDOS": "প্রাপ্ত অনুরোধ",
 "PIX": "PIX",
 "PIX COPIA E COLA": "PIX কপি-পেস্ট",
 "PRÓXIMAS FATURAS (JÁ COMPROMETIDO)": "আগামী কার্ড বিল (ইতিমধ্যে নির্ধারিত)",
 "Paciente": "রোগী",
 "Paciente ou aluno": "রোগী বা শিক্ষার্থী",
 "Pacientes": "রোগী",
 "Padrão": "ডিফল্ট",
 "Padrão da aba": "ট্যাবের ডিফল্ট",
 "Paga": "পরিশোধিত",
 "Paga (toque para desfazer)": "পরিশোধিত (বাতিল করতে ট্যাপ করুন)",
 "Pagador": "পরিশোধকারী",
 "Pagamento já contado": "আগেই গোনা পরিশোধ",
 "Pagar": "পরিশোধ",
 "Pagar parcela {n}/{t} · {c}": "কিস্তি {n}/{t} পরিশোধ · {c}",
 "Pagas": "পরিশোধিত",
 "Pago": "পরিশোধিত",
 "Pago com": "যেভাবে পরিশোধ",
 "Pago: {p} · Falta pagar: {f}": "পরিশোধিত: {p} · বাকি: {f}",
 "Pagos": "পরিশোধিত",
 "Pagou {v}? Se teve desconto, multa ou juros, informe o valor pago. Quer guardar o comprovante agora?": "{v} পরিশোধ করেছেন? ছাড়, জরিমানা বা সুদ থাকলে পরিশোধিত অর্থ লিখুন। এখনই রসিদ সংরক্ষণ করবেন?",
 "Paguei outro valor (desconto, multa ou juros)": "আমি অন্য পরিমাণ পরিশোধ করেছি (ছাড়, জরিমানা বা সুদ)",
 "Paixão de Cristo": "গুড ফ্রাইডে",
 "Palavras-chave (separe com vírgula)": "কীওয়ার্ড (কমা দিয়ে আলাদা করুন)",
 "Para a meta \"{m}\" chegar no prazo, seriam {v} por mês. Vale esticar o prazo ou começar com um valor menor.": "লক্ষ্য \"{m}\" সময়মতো পূরণ করতে প্রতি মাসে {v} লাগবে। সময়সীমা বাড়ানো বা কম অঙ্ক দিয়ে শুরু করা ভালো হবে।",
 "Para clareza, firmo o presente.": "স্পষ্টতার জন্য আমি এতে স্বাক্ষর করছি।",
 "Para comprar": "কেনার জন্য",
 "Para continuar, digite a senha do app.": "চালিয়ে যেতে অ্যাপের পাসওয়ার্ড লিখুন।",
 "Para conversar, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini).": "কথা বলতে, সেটিংস › কৃত্রিম বুদ্ধিমত্তা-য় আপনার AI (Claude, ChatGPT বা Gemini) চালু করুন।",
 "Para dividir as despesas, escreva em \"Quem vai\" os nomes separados por vírgula (edite a viagem).": "খরচ ভাগ করতে \"কে যাচ্ছেন\"-এ নামগুলো কমা দিয়ে আলাদা করে লিখুন (ভ্রমণ সম্পাদনা করুন)।",
 "Para emitir e buscar notas, ligue uma vez o servidor de notas: no computador, dê dois cliques em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar (termina em .netlify.app).": "ইনভয়েস ইস্যু ও খুঁজতে একবার ইনভয়েস সার্ভার চালু করুন: কম্পিউটারে 13-LIGAR-NOTAS.bat-এ ডাবল-ক্লিক করুন এবং যে ঠিকানা দেখায় (.netlify.app দিয়ে শেষ) তা এখানে পেস্ট করুন।",
 "Para exercer seus direitos, use Fale conosco no app ou escreva para o e-mail abaixo. Respondemos em até 15 dias.": "আপনার অধিকার প্রয়োগ করতে অ্যাপে যোগাযোগ করুন ব্যবহার করুন বা নিচের ইমেইলে লিখুন। আমরা 15 দিনের মধ্যে উত্তর দিই।",
 "Para fazer chamadas de áudio e vídeo, instale a versão nova do app (0.35). As mensagens já funcionam.": "অডিও ও ভিডিও কল করতে অ্যাপের নতুন সংস্করণ (0.35) ইনস্টল করুন। বার্তা ইতিমধ্যে কাজ করছে।",
 "Para fazer o app funcionar: guardar e sincronizar seus dados entre dispositivos, mandar alertas, compartilhar com os grupos que você escolheu e dar suporte.": "অ্যাপ চালানোর জন্য: ডিভাইসগুলোর মধ্যে আপনার ডেটা রাখা ও সিঙ্ক করা, অ্যালার্ট পাঠানো, আপনার বেছে নেওয়া গ্রুপের সঙ্গে শেয়ার করা এবং সাপোর্ট দেওয়া।",
 "Para guardar os PDFs no {nome}, conecte a sua conta em Ajustes › Google Drive e OneDrive.": "{nome}-এ PDF সেভ করতে সেটিংস › Google Drive ও OneDrive-এ আপনার অ্যাকাউন্ট সংযুক্ত করুন।",
 "Para hoje": "আজকের জন্য",
 "Para ler foto ou PDF, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini). O extrato em OFX ou CSV funciona sem IA.": "ছবি বা PDF পড়তে, সেটিংস › কৃত্রিম বুদ্ধিমত্তা-য় আপনার AI (Claude, ChatGPT বা Gemini) চালু করুন। OFX বা CSV স্টেটমেন্ট AI ছাড়াই চলে।",
 "Para ler o relógio automaticamente, instale a versão nova do app (0.33). Enquanto isso, dá para digitar à mão.": "ঘড়ি স্বয়ংক্রিয়ভাবে পড়তে অ্যাপের নতুন ভার্সন (0.33) ইনস্টল করুন। ততক্ষণ হাতে লিখতে পারেন।",
 "Para ler o relógio, conecte pelo app no celular. Os números aparecem aqui também.": "ঘড়ি পড়তে ফোনের অ্যাপ থেকে সংযুক্ত করুন। সংখ্যাগুলো এখানেও দেখা যাবে।",
 "Para ler o relógio, libere os dados de atividade para o My Planner.": "ঘড়ি পড়তে My Planner-কে অ্যাক্টিভিটি ডেটার অনুমতি দিন।",
 "Para ler o texto, resumir e perguntar, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini).": "লেখা পড়া, সারাংশ করা ও প্রশ্ন করতে সেটিংস › কৃত্রিম বুদ্ধিমত্তা-তে আপনার AI চালু করুন (Claude, ChatGPT বা Gemini)।",
 "Para ligar, use o app no celular (Ajustes > Agenda do Google). Depois, tudo aparece aqui também.": "চালু করতে ফোনে অ্যাপটি ব্যবহার করুন (সেটিংস > Google ক্যালেন্ডার)। এরপর সবকিছু এখানেও দেখা যাবে।",
 "Para ligar, use o app no celular (Ajustes › Configuração geral › Agenda do Google). Depois, tudo aparece aqui também.": "চালু করতে ফোনে অ্যাপটি ব্যবহার করুন (সেটিংস › সাধারণ সেটিংস › Google ক্যালেন্ডার)। এরপর সবকিছু এখানেও দেখা যাবে।",
 "Para monitorar a OAB, informe o número e a UF.": "OAB মনিটর করতে নম্বর ও রাজ্য (UF) দিন।",
 "Para não perguntar mais, escolha o app em Ajustes › Configuração geral.": "আর জিজ্ঞেস না করতে, সেটিংস › সাধারণ সেটিংস থেকে অ্যাপ বেছে নিন।",
 "Para profissionais de saúde: pacientes, evolução no cofre, prescrições com modelos, financeiro, recibo e declaração para reembolso em PDF.": "স্বাস্থ্য পেশাদারদের জন্য: রোগী, ভল্টে অগ্রগতি নোট, টেমপ্লেটসহ প্রেসক্রিপশন, আর্থিক হিসাব, রসিদ ও রিইমবার্সমেন্টের PDF ঘোষণাপত্র।",
 "Para profissionais de saúde: pacientes, evolução, prescrições com modelos, financeiro com convênio, recibo e declaração para reembolso.": "স্বাস্থ্য পেশাদারদের জন্য: রোগী, অগ্রগতি নোট, টেমপ্লেটসহ প্রেসক্রিপশন, বিমাসহ আর্থিক হিসাব, রসিদ ও রিইমবার্সমেন্টের ঘোষণাপত্র।",
 "Para proteger a sua conta, confirmamos o seu celular uma vez, com um código pelo WhatsApp. Ele só é pedido de novo se você trocar de número.": "আপনার অ্যাকাউন্ট সুরক্ষিত রাখতে, আমরা WhatsApp-এ একটি কোড দিয়ে একবার আপনার মোবাইল নিশ্চিত করি। নম্বর বদলালেই কেবল আবার চাওয়া হয়।",
 "Para quem aluga o imóvel ou um cômodo por temporada (Airbnb, Booking ou direto): reservas, limpeza, despesas e o lucro de cada mês.": "যাঁরা প্রপার্টি বা একটি ঘর স্বল্পমেয়াদে ভাড়া দেন (Airbnb, Booking বা সরাসরি): বুকিং, পরিষ্কার, খরচ ও প্রতি মাসের লাভ।",
 "Para receber a agenda, o local e os avisos do evento no celular, entre no grupo: {link}": "ইভেন্টের সময়সূচি, স্থান ও নোটিশ ফোনে পেতে গ্রুপে যোগ দিন: {link}",
 "Para sincronizar, libere o acesso à agenda para o My Planner nas configurações do celular.": "সিঙ্ক করতে ফোনের সেটিংসে My Planner-কে ক্যালেন্ডারের অনুমতি দিন।",
 "Para tirar uma permissão que você já deu ao sistema (câmera, fotos, microfone), use também os ajustes do celular.": "সিস্টেমকে আগে দেওয়া কোনো অনুমতি (ক্যামেরা, ছবি, মাইক্রোফোন) তুলে নিতে ফোনের সেটিংসও ব্যবহার করুন।",
 "Para uma leitura mais completa, ligue a sua IA em Ajustes › Inteligência artificial.": "আরও পূর্ণ পাঠের জন্য সেটিংস › কৃত্রিম বুদ্ধিমত্তা থেকে আপনার AI চালু করুন।",
 "Parabéns": "অভিনন্দন",
 "Parabéns!": "অভিনন্দন!",
 "Parada": "স্থির",
 "Parar": "থামান",
 "Parar de compartilhar?": "শেয়ার করা বন্ধ করবেন?",
 "Parar e salvar": "থামান ও সংরক্ষণ করুন",
 "Parar gravação": "রেকর্ডিং থামান",
 "Parcela": "কিস্তি",
 "Parcela de financiamento": "ফাইন্যান্সিং-এর কিস্তি",
 "Parcela {n}/{t}": "কিস্তি {n}/{t}",
 "Parcela {n}/{t} · {c}": "কিস্তি {n}/{t} · {c}",
 "Parcelas": "কিস্তি",
 "Parcelas a pagar nos próximos meses": "আগামী মাসগুলোতে দেয় কিস্তি",
 "Parcelas recalculadas": "কিস্তি আবার হিসাব করা হয়েছে",
 "Parece que foi impresso e escaneado.": "দেখে মনে হয় প্রিন্ট করে স্ক্যান করা।",
 "Parei": "থেমে গেছি",
 "Parei na aula": "থেমেছি যে ক্লাসে",
 "Parei na aula...": "থেমেছি এই ক্লাসে...",
 "Pares de meia": "মোজার জোড়া",
 "Parque ou natureza": "পার্ক বা প্রকৃতি",
 "Parques": "পার্ক",
 "Parte": "পক্ষ",
 "Partes": "পক্ষসমূহ",
 "Participa": "অংশগ্রহণকারী",
 "Participantes": "অংশগ্রহণকারী",
 "Participação em empresa": "কোম্পানিতে অংশীদারত্ব",
 "Passa do limite do MEI: fale com seu contador.": "MEI-এর সীমা ছাড়িয়ে যাচ্ছে: আপনার হিসাবরক্ষকের সঙ্গে কথা বলুন।",
 "Passaporte": "পাসপোর্ট",
 "Passe o dedo sobre o desenho para apagar só aquele pedaço.": "শুধু ওই অংশ মুছতে আঁকার উপর আঙুল বোলান।",
 "Passeio": "ভ্রমণ",
 "Passeios": "ঘোরাঘুরি",
 "Passo a passo": "ধাপে ধাপে",
 "Passos": "ধাপ",
 "Passos, exercício, calorias, batimentos e sono": "ধাপ, ব্যায়াম, ক্যালরি, হৃদস্পন্দন ও ঘুম",
 "Passou do orçamento": "বাজেট ছাড়িয়ে গেছে",
 "Passou do orçamento em {v}": "বাজেট ছাড়িয়েছে {v}",
 "Pasta": "ফোল্ডার",
 "Patrimônio": "সম্পদ",
 "Patrimônio & Imposto de Renda": "সম্পদ ও আয়কর",
 "Patrimônio pelo valor de compra: {v}": "ক্রয়মূল্যে সম্পদ: {v}",
 "Pausa (s)": "বিশ্রাম (সেকেন্ড)",
 "Pausa de {m} min": "{m} মিনিটের বিরতি",
 "Pausado": "বিরতিতে",
 "Pausar": "বিরতি দিন",
 "Pausas": "বিরতি",
 "Pausas de estudo": "পড়ার বিরতি",
 "Pauta (opcional)": "আলোচ্যসূচি (ঐচ্ছিক)",
 "Paz": "শান্তি",
 "Pediatra": "শিশুরোগ বিশেষজ্ঞ",
 "Pedido": "অনুরোধ",
 "Pedido enviado para {nome}. Quando aceitar, vocês já podem conversar.": "{nome}-কে অনুরোধ পাঠানো হয়েছে। গ্রহণ করলেই আপনারা চ্যাট করতে পারবেন।",
 "Pedido enviado. Quando a pessoa aceitar, vocês já podem conversar.": "অনুরোধ পাঠানো হয়েছে। অপরজন গ্রহণ করলেই আপনারা চ্যাট করতে পারবেন।",
 "Pedidos de documentos": "নথির অনুরোধ",
 "Pedir de novo depois de": "আবার চাইবে এর পরে",
 "Peguei emprestado": "ধার নিয়েছি",
 "Peito de frango": "মুরগির বুকের মাংস",
 "Peixe": "মাছ",
 "Pela última compra: cerca de {v}": "শেষ কেনা অনুযায়ী: প্রায় {v}",
 "Pelas contas que ainda vencem este mês, vão faltar {v}. Veja o que dá para adiar ou cortar antes de assumir gasto novo.": "এই মাসে যে বিলগুলো এখনো দেয়, সেগুলো ধরলে {v} কম পড়বে। নতুন খরচের আগে দেখুন কী পিছিয়ে দেওয়া বা কমানো যায়।",
 "Pendente": "অপেক্ষমাণ",
 "Pensão alimentícia": "খোরপোশ",
 "Pequena": "ছোট",
 "Pequeno": "ছোট",
 "Percentual de tributos do Simples (para sair na nota)": "Simples-এর করের শতাংশ (ইনভয়েসে থাকবে)",
 "Perguntar ao Mestre": "মাস্টারকে জিজ্ঞেস করুন",
 "Perguntar sempre": "সবসময় জিজ্ঞেস করুন",
 "Pergunte ao Mestre...": "মাস্টারকে জিজ্ঞেস করুন...",
 "Pergunte sobre o documento (ex.: qual o prazo?)": "নথি নিয়ে প্রশ্ন করুন (যেমন: সময়সীমা কবে?)",
 "Permissões": "অনুমতি",
 "Personalizado": "কাস্টম",
 "Perto do limite do orçamento": "বাজেটের সীমার কাছাকাছি",
 "Período": "সময়কাল",
 "Período da meta": "লক্ষ্যের সময়কাল",
 "Pescoço: inclinar para os lados": "ঘাড়: দুই পাশে কাত করুন",
 "Peso": "ওজন",
 "Peso na média": "গড়ে ওজন (গুরুত্ব)",
 "Pesquisar no mapa": "মানচিত্রে খুঁজুন",
 "Pessoa": "ব্যক্তি",
 "Pessoa de contato": "যোগাযোগের ব্যক্তি",
 "Pessoas dos seus grupos veem só o que for compartilhado no grupo.": "আপনার গ্রুপের সদস্যরা শুধু গ্রুপে শেয়ার করা বিষয়ই দেখেন।",
 "Pet": "পোষা প্রাণী",
 "Pet & Família": "পোষা প্রাণী ও পরিবার",
 "Pet shop": "পেট শপ",
 "Pet shop ou clínica": "পেট শপ বা ক্লিনিক",
 "Pets": "পোষা প্রাণী",
 "Peça documentos ao cliente com prazo. Ele recebe, anexa e marca como entregue.": "সময়সীমা দিয়ে ক্লায়েন্টের কাছে নথি চান। তিনি অনুরোধ পান, ফাইল যোগ করেন এবং জমা দেওয়া হয়েছে চিহ্নিত করেন।",
 "Pijamas": "পাজামা",
 "Pilates": "পিলাটিস",
 "Pintura": "রং",
 "Pix copia e cola": "Pix কপি-পেস্ট",
 "Placa": "নম্বর প্লেট",
 "Planejado": "পরিকল্পিত",
 "Planejado e comido": "পরিকল্পিত ও খাওয়া",
 "Planilha": "স্প্রেডশিট",
 "Planilha (Excel)": "স্প্রেডশিট (Excel)",
 "Planilha do mês para o Receita Saúde": "Receita Saúde-এর জন্য মাসের শিট",
 "Planner": "Planner",
 "Plano básico: My Planner + Anotações": "বেসিক প্ল্যান: My Planner + নোট",
 "Plano de aula": "পাঠ পরিকল্পনা",
 "Plano de saúde": "স্বাস্থ্য বিমা",
 "Planos de aula": "পাঠ পরিকল্পনা",
 "Planta": "গাছ",
 "Plantas": "গাছপালা",
 "Plantas & Jardim": "গাছপালা ও বাগান",
 "Plataforma ou escola": "প্ল্যাটফর্ম বা প্রতিষ্ঠান",
 "Pneus novos": "নতুন টায়ার",
 "Podcast": "পডকাস্ট",
 "Pode confirmar sua presença respondendo esta mensagem?": "এই বার্তার উত্তর দিয়ে আপনার উপস্থিতি নিশ্চিত করবেন?",
 "Polichinelo": "জাম্পিং জ্যাক",
 "Polo ativo": "বাদী পক্ষ",
 "Polo passivo": "বিবাদী পক্ষ",
 "Política de privacidade (LGPD)": "গোপনীয়তা নীতি (LGPD)",
 "Política de privacidade, LGPD e permissões": "গোপনীয়তা নীতি, LGPD ও অনুমতি",
 "Política de privacidade, LGPD e termos": "গোপনীয়তা নীতি, LGPD ও শর্তাবলি",
 "Ponha aqui as fotos e os vídeos da viagem. No grupo, todos veem e todos podem pôr as suas.": "ভ্রমণের ছবি ও ভিডিও এখানে দিন। গ্রুপে সবাই দেখতে পায় এবং সবাই নিজের ছবি দিতে পারে।",
 "Ponte de glúteos": "গ্লুট ব্রিজ",
 "Ponto facultativo": "ঐচ্ছিক ছুটি",
 "Ponto facultativo: {nome}": "ঐচ্ছিক ছুটি: {nome}",
 "Ponto turístico": "দর্শনীয় স্থান",
 "Pontos turísticos": "দর্শনীয় স্থান",
 "Por dia": "প্রতি দিন",
 "Por faixas": "সীমা অনুযায়ী",
 "Por mês": "প্রতি মাস",
 "Por nome": "নাম অনুযায়ী",
 "Por semana": "প্রতি সপ্তাহ",
 "Portal": "পোর্টাল",
 "Portal do Cliente": "ক্লায়েন্ট পোর্টাল",
 "Portal do cliente (convidar o cliente)": "ক্লায়েন্ট পোর্টাল (ক্লায়েন্টকে আমন্ত্রণ)",
 "Português": "Português",
 "Porão": "বেসমেন্ট",
 "Porções": "পরিবেশন",
 "Pouco espaço livre: fotos e anexos novos podem não ser salvos. Libere espaço ou guarde os anexos no Google Drive ou OneDrive.": "খালি জায়গা কম: নতুন ছবি ও সংযুক্তি হয়তো সংরক্ষিত হবে না। জায়গা খালি করুন বা সংযুক্তি Google Drive বা OneDrive-এ রাখুন।",
 "Praia": "সৈকত",
 "Prancha": "প্ল্যাঙ্ক",
 "Prato do cardápio": "মেনুর খাবার",
 "Prato principal": "প্রধান খাবার",
 "Prazo": "সময়সীমা",
 "Prazo (pagamento ou entrega)": "সময়সীমা (পরিশোধ বা সরবরাহ)",
 "Prazo até {fim} · fazer em {dia}": "সময়সীমা {fim} পর্যন্ত · {dia}-এ করুন",
 "Prazo final: {fim}": "শেষ তারিখ: {fim}",
 "Prazo: {d}": "সময়সীমা: {d}",
 "Prazo: {t}": "সময়সীমা: {t}",
 "Prazos criados": "সময়সীমা তৈরি হয়েছে",
 "Precisa da sua IA": "আপনার AI লাগবে",
 "Preencha a descrição, o código de tributação nacional (6 números) e o valor.": "বিবরণ, জাতীয় কর কোড (৬ সংখ্যা) ও মূল্য পূরণ করুন।",
 "Preenche os campos do PDF e, se quiser, trava.": "PDF-এর ঘর পূরণ করে এবং চাইলে লক করে।",
 "Preencher formulário": "ফর্ম পূরণ করুন",
 "Preencher pela foto com a minha IA": "আমার AI দিয়ে ছবি থেকে পূরণ করুন",
 "Preencher pela nota fiscal com a minha IA": "আমার AI দিয়ে রসিদ থেকে পূরণ করুন",
 "Preparando a conversa da equipe...": "টিমের কথোপকথন তৈরি হচ্ছে...",
 "Preparando a página {n} de {total}...": "পৃষ্ঠা {n} / {total} প্রস্তুত হচ্ছে...",
 "Preparando o arquivo": "ফাইল তৈরি হচ্ছে",
 "Prescrição, conduta e orientações": "প্রেসক্রিপশন, চিকিৎসা পরিকল্পনা ও নির্দেশনা",
 "Presente": "উপস্থিত",
 "Presença": "উপস্থিতি",
 "Pressione e segure o código para copiar, ou toque em Enviar e escolha \"Copiar\".": "কপি করতে কোডটি চেপে ধরে রাখুন, অথবা পাঠান-এ ট্যাপ করে \"কপি করুন\" বেছে নিন।",
 "Pressione e segure o código para copiar.": "কপি করতে কোডটি চেপে ধরে রাখুন।",
 "Pressione e segure um lançamento para apagar.": "মুছতে কোনো এন্ট্রি চেপে ধরে রাখুন।",
 "Pressione e segure um perfil para removê-lo.": "কোনো প্রোফাইল সরাতে চেপে ধরে রাখুন।",
 "Preto e branco": "সাদা-কালো",
 "Previdência privada": "বেসরকারি পেনশন",
 "Preço ou ingresso": "দাম বা টিকিট",
 "Price": "Price (সমান কিস্তি)",
 "Primeira": "প্রথম",
 "Primeira cota ou cota única do IR": "আয়করের প্রথম কিস্তি বা এককালীন",
 "Primeira parcela na fatura de {mes}, que vence {data}.": "প্রথম কিস্তি {mes}-এর কার্ড বিলে, যার শেষ তারিখ {data}।",
 "Prioridade": "অগ্রাধিকার",
 "Privacidade": "গোপনীয়তা",
 "Privacidade e termos": "গোপনীয়তা ও শর্তাবলি",
 "Privacidade: o texto ou a imagem analisada vai direto deste dispositivo para a empresa da IA escolhida, com a sua chave. O My Planner não guarda cópia.": "গোপনীয়তা: বিশ্লেষণ করা লেখা বা ছবি আপনার কী দিয়ে সরাসরি এই ডিভাইস থেকে নির্বাচিত AI কোম্পানির কাছে যায়। My Planner কোনো কপি রাখে না।",
 "Problema": "সমস্যা",
 "Problemas, erros e sugestões": "সমস্যা, এরর ও পরামর্শ",
 "Procedimento": "প্রক্রিয়া",
 "Procedimento: {c}": "প্রক্রিয়া: {c}",
 "Processo": "মামলা",
 "Processo Civil": "দেওয়ানি কার্যবিধি",
 "Processo Penal": "ফৌজদারি কার্যবিধি",
 "Processo do Trabalho": "শ্রম কার্যবিধি",
 "Processo não informado": "মামলা নম্বর দেওয়া নেই",
 "Proclamação da República": "প্রজাতন্ত্র ঘোষণা দিবস",
 "Procurando a folha...": "পাতা খোঁজা হচ্ছে...",
 "Procurando atualização...": "আপডেট খোঁজা হচ্ছে...",
 "Procurar aba": "ট্যাব খুঁজুন",
 "Procurar atualização agora": "এখনই আপডেট খুঁজুন",
 "Procurar documento": "নথি খুঁজুন",
 "Procurar ferramenta (ex.: juntar, assinar, comprimir)": "টুল খুঁজুন (যেমন: জোড়া, স্বাক্ষর, কম্প্রেস)",
 "Produto": "পণ্য",
 "Produto (ex.: Geladeira)": "পণ্য (যেমন: ফ্রিজ)",
 "Produtos, notas fiscais, assistência técnica e aviso antes de vencer.": "পণ্য, চালান, সার্ভিস সেন্টার এবং মেয়াদ শেষের আগে নোটিফিকেশন।",
 "Produção (vale de verdade)": "প্রোডাকশন (আসল, বৈধ)",
 "Produção restrita (teste)": "সীমিত প্রোডাকশন (পরীক্ষা)",
 "Produção restrita (teste, não vale)": "সীমিত প্রোডাকশন (পরীক্ষা, বৈধ নয়)",
 "Produção restrita: ambiente de teste do governo. As notas não valem. Teste tudo aqui antes de mudar para Produção (em Editar).": "সীমিত প্রোডাকশন: সরকারের পরীক্ষা পরিবেশ। ইনভয়েস বৈধ নয়। প্রোডাকশনে যাওয়ার আগে (সম্পাদনা-য়) এখানে সব পরীক্ষা করুন।",
 "Produção: as notas emitidas valem de verdade e vão para a prefeitura e a Receita.": "প্রোডাকশন: ইস্যু করা ইনভয়েস আসল ও বৈধ, এবং পৌরসভা ও Receita-তে যায়।",
 "Produção: vale de verdade": "প্রোডাকশন: আসল, বৈধ",
 "Professor": "শিক্ষক",
 "Professor & Mentoria": "শিক্ষক ও মেন্টরিং",
 "Professor(a)": "শিক্ষক",
 "Profissionais": "কারিগর",
 "Profissional": "কারিগর",
 "Profissional assistente": "সহকারী পেশাজীবী",
 "Profissional ou fornecedor": "কারিগর বা সরবরাহকারী",
 "Profissional ou local": "বিশেষজ্ঞ বা স্থান",
 "Profissão ou especialidade": "পেশা বা বিশেষজ্ঞতা",
 "Profissões": "পেশা",
 "Programação": "প্রোগ্রামিং",
 "Progresso geral": "মোট অগ্রগতি",
 "Projeto e licenças": "নকশা ও অনুমতি",
 "Projetos": "প্রকল্প",
 "Prontas": "তৈরি",
 "Pronto": "হয়ে গেছে",
 "Pronto! Todas as abas estão liberadas até {data}.": "হয়ে গেছে! {data} পর্যন্ত সব ট্যাব খোলা।",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer com som.": "হয়ে গেছে। স্ক্রিন লক করুন এবং ১ মিনিট অপেক্ষা করুন: সতর্কবার্তাটি শব্দসহ আসা উচিত।",
 "Prontuário, evolução e prescrições, sem o financeiro.": "মেডিকেল রেকর্ড, অগ্রগতি ও প্রেসক্রিপশন, আর্থিক অংশ ছাড়া।",
 "Protegendo a chave...": "কী সুরক্ষিত করা হচ্ছে...",
 "Proteger no cofre": "ভল্টে সুরক্ষিত করুন",
 "Protegido": "সুরক্ষিত",
 "Protegido no cofre": "ভল্টে সুরক্ষিত",
 "Protegidos pelo cofre: {n}": "ভল্টে সুরক্ষিত: {n}",
 "Protetor solar": "সানস্ক্রিন",
 "Protocolo": "প্রোটোকল নম্বর",
 "Prova": "পরীক্ষা",
 "Próxima": "পরবর্তী",
 "Próxima até a data": "পরবর্তী, এই তারিখের মধ্যে",
 "Próxima com quantos km": "পরবর্তী, কত কিমিতে",
 "Próxima dose": "পরবর্তী ডোজ",
 "Próxima: {data}": "পরবর্তী: {data}",
 "Próxima: {d} · {v}": "পরবর্তী: {d} · {v}",
 "Próximas": "আসন্ন",
 "Próximo": "পরবর্তী",
 "Próximo ano": "পরের বছর",
 "Próximo número da DPS": "পরের DPS নম্বর",
 "Próximos 7 dias": "আগামী ৭ দিন",
 "Próximos vencimentos ({n})": "আসন্ন নির্ধারিত তারিখ ({n})",
 "Publicação": "প্রকাশনা",
 "Publicações": "প্রকাশনা",
 "Pula": "লাফানো",
 "Pulsa": "স্পন্দন",
 "Punho": "মুষ্টি",
 "Puxada frontal": "ল্যাট পুলডাউন",
 "PÁGINAS": "পৃষ্ঠাসমূহ",
 "PÔR NA BARRA": "বারে রাখুন",
 "Pág. {n}": "পৃ. {n}",
 "Página": "পৃষ্ঠা",
 "Página 1": "পৃষ্ঠা 1",
 "Página 1 de 10": "পৃষ্ঠা 1 / 10",
 "Página em branco no fim": "শেষে ফাঁকা পৃষ্ঠা",
 "Página em que estou": "যে পৃষ্ঠায় আছি",
 "Página escaneada": "পৃষ্ঠা স্ক্যান হয়েছে",
 "Página inteira": "পুরো পৃষ্ঠা",
 "Página {a} de {n}": "পৃষ্ঠা {a} / {n}",
 "Página {n}": "পৃষ্ঠা {n}",
 "Página {n} de {total}": "পৃষ্ঠা {n} / {total}",
 "Página: {titulo}": "পৃষ্ঠা: {titulo}",
 "Páginas": "পৃষ্ঠা",
 "Páginas, tamanho, autor, datas e campos.": "পৃষ্ঠা, আকার, লেখক, তারিখ ও ঘর।",
 "Pássaro": "পাখি",
 "Pão francês": "ব্রেড রোল",
 "Pão integral": "হোল হুইট ব্রেড",
 "Pôr a data de hoje": "আজকের তারিখ দিন",
 "Pôr as parcelas no My Planner": "কিস্তি My Planner-এ যোগ করুন",
 "Pôr na barra": "বারে রাখুন",
 "Pôr no roteiro da viagem": "ভ্রমণসূচিতে যোগ করুন",
 "Pôr uma foto": "ছবি দিন",
 "Quadro": "বোর্ড",
 "Quadro Kanban, cronômetro de horas por cliente e prazos no My Planner.": "Kanban বোর্ড, ক্লায়েন্ট অনুযায়ী ঘণ্টার টাইমার এবং My Planner-এ সময়সীমা।",
 "Quais contas vencem nos próximos dias?": "সামনের কয়েক দিনে কোন বিলগুলোর শেষ তারিখ?",
 "Quais páginas ficam no PDF novo": "নতুন PDF-এ কোন পৃষ্ঠাগুলো থাকবে",
 "Quais páginas sair": "কোন পৃষ্ঠাগুলো সরাবেন",
 "Qual IA": "কোন AI",
 "Qualidade alta": "উচ্চ মান",
 "Qualidade boa (menor)": "ভালো মান (ছোট)",
 "Quantidade": "পরিমাণ",
 "Quanto cortar de cada lado (% da página)": "প্রতিটি পাশ থেকে কতটা কাটবেন (পৃষ্ঠার %)",
 "Quanto já tem guardado (opcional)": "ইতিমধ্যে কত জমানো আছে (ঐচ্ছিক)",
 "Quanto paga por limpeza": "প্রতিবার পরিষ্কারে কত দেন",
 "Quanto preciso guardar por mês para as minhas metas?": "আমার লক্ষ্যগুলোর জন্য প্রতি মাসে কত জমাতে হবে?",
 "Quanto quer juntar": "কত জমাতে চান",
 "Quanto você quer gastar, no máximo, em cada categoria por mês. Deixe em branco para não controlar.": "প্রতিটি বিভাগে প্রতি মাসে সর্বোচ্চ কত খরচ করতে চান। নিয়ন্ত্রণ না করতে চাইলে ফাঁকা রাখুন।",
 "Quarta": "বুধবার",
 "Quarta-feira de Cinzas (até 14h)": "অ্যাশ ওয়েনসডে (দুপুর ২টা পর্যন্ত)",
 "Quarto": "শোবার ঘর",
 "Quarto das crianças": "শিশুদের ঘর",
 "Quarto de casal": "মাস্টার বেডরুম",
 "Quarto de hóspedes": "অতিথি কক্ষ",
 "Quarto infantil": "শিশুদের ঘর",
 "Queijo": "চিজ",
 "Queixa principal": "প্রধান সমস্যা",
 "Quem abrir o link baixa o My Planner (ou usa no navegador), entra na conta e passa a fazer parte do grupo.": "যে লিংক খুলবেন তিনি My Planner ডাউনলোড করবেন (বা ব্রাউজারে ব্যবহার করবেন), সাইন ইন করবেন এবং গ্রুপের সদস্য হবেন।",
 "Quem criar a conta com o seu código já vira seu amigo aqui, sem precisar pedir.": "যে আপনার কোড দিয়ে অ্যাকাউন্ট খুলবে, সে অনুরোধ ছাড়াই এখানে সরাসরি আপনার বন্ধু হয়ে যাবে।",
 "Quem enviou": "কে পাঠিয়েছে",
 "Quem está num grupo do app com você (turma, família, viagem...) já pode conversar sem ser amigo. Segure um amigo para desfazer a amizade ou bloquear.": "অ্যাপে যারা আপনার সাথে কোনো গ্রুপে আছে (ক্লাস, পরিবার, ভ্রমণ...), তারা বন্ধু না হয়েও চ্যাট করতে পারে। বন্ধুত্ব বাতিল বা ব্লক করতে কোনো বন্ধুকে চেপে ধরে রাখুন।",
 "Quem faz a limpeza": "কে পরিষ্কার করেন",
 "Quem paga, se não for o paciente (mãe, pai, responsável)": "কে পরিশোধ করেন, রোগী না হলে (মা, বাবা, অভিভাবক)",
 "Quem pagou": "কে পরিশোধ করেছেন",
 "Quem recebeu (médico, escola...)": "কে পেয়েছেন (ডাক্তার, স্কুল...)",
 "Quem vai": "কে যাচ্ছেন",
 "Quem vai limpar": "কে পরিষ্কার করবেন",
 "Quem vê: só quem conversa com você, os seus amigos e quem está num grupo do app com você. Deixe em branco o que não quiser mostrar.": "কে দেখতে পান: শুধু যারা আপনার সঙ্গে চ্যাট করেন, আপনার বন্ধুরা এবং যারা অ্যাপের কোনো গ্রুপে আপনার সঙ্গে আছেন। যা দেখাতে চান না, তা ফাঁকা রাখুন।",
 "Quente": "গরম",
 "Quer escanear mais uma página?": "আরও একটি পৃষ্ঠা স্ক্যান করবেন?",
 "Quer guardar o comprovante agora? Foto, PDF ou print do Pix.": "এখনই রসিদ সংরক্ষণ করবেন? ছবি, PDF বা Pix-এর স্ক্রিনশট।",
 "Quer mandar um print da tela? Envie por e-mail e anexe a imagem.": "স্ক্রিনশট পাঠাতে চান? ইমেইলে পাঠান এবং ছবিটি সংযুক্ত করুন।",
 "Quer trocar pelos novos ou manter os dois?": "নতুনগুলো দিয়ে বদলাবেন, নাকি দুটোই রাখবেন?",
 "Quero assistir": "দেখতে চাই",
 "Quero ir": "যেতে চাই",
 "Quero ler": "পড়তে চাই",
 "Quero ver": "দেখতে চাই",
 "Quilometragem atual": "বর্তমান কিমি",
 "Quilometragem: {km}": "কিমি: {km}",
 "Quinta": "বৃহস্পতিবার",
 "Quintal": "উঠোন",
 "Quitado": "পরিশোধ সম্পন্ন",
 "Quitados": "পরিশোধ সম্পন্ন",
 "Química": "রসায়ন",
 "RECIBO": "রসিদ",
 "RG / Carteira de identidade": "RG / পরিচয়পত্র",
 "RG, CNH, passaporte, contratos e certidões, com aviso antes de vencer e envio com um toque.": "RG, CNH, পাসপোর্ট, চুক্তি ও সনদ, মেয়াদ শেষের আগে সতর্কতা ও এক ট্যাপে পাঠানোর সুবিধাসহ।",
 "Raciocínio Lógico": "যৌক্তিক বিচার",
 "Razão social ou nome": "প্রতিষ্ঠানের নাম বা নাম",
 "Razão social ou nome do consultório": "কোম্পানি বা ক্লিনিকের নাম",
 "Razão social ou nome fantasia": "প্রতিষ্ঠানের আইনি নাম বা ব্র্যান্ড নাম",
 "Raça": "জাত",
 "Realizado": "সম্পন্ন",
 "Recado": "বার্তা",
 "Recalcular": "আবার হিসাব করুন",
 "Recalcular as parcelas em aberto": "বাকি কিস্তি আবার হিসাব করুন",
 "Recalcular as parcelas?": "কিস্তি আবার হিসাব করবেন?",
 "Receber": "গ্রহণ",
 "Receber de volta: {i} ({p})": "ফেরত নিতে হবে: {i} ({p})",
 "Receber o código no WhatsApp": "WhatsApp-এ কোড পান",
 "Receber parcela {n}/{t} · {c}": "কিস্তি {n}/{t} গ্রহণ · {c}",
 "Recebeu um convite?": "আমন্ত্রণ পেয়েছেন?",
 "Recebeu um código?": "কোড পেয়েছেন?",
 "Recebi de {pagador}{doc}, a quantia de {valor}{extenso}, referente a {tipo} realizado(a) em {data}{paciente}.": "আমি {pagador}{doc}-এর কাছ থেকে {valor}{extenso} পরিমাণ অর্থ পেয়েছি, যা {data} তারিখে হওয়া {tipo}{paciente}-এর জন্য।",
 "Recebi outro valor": "আমি অন্য পরিমাণ পেয়েছি",
 "Recebida": "প্রাপ্ত",
 "Recebida (toque para desfazer)": "প্রাপ্ত (বাতিল করতে ট্যাপ করুন)",
 "Recebidas": "পাওয়া গেছে",
 "Recebido": "পাওয়া গেছে",
 "Recebido: {v}": "প্রাপ্ত: {v}",
 "Recebidos": "প্রাপ্ত",
 "Recebidos dos grupos": "গ্রুপ থেকে প্রাপ্ত",
 "Recebimento": "প্রাপ্তি",
 "Receita": "রেসিপি",
 "Receitas": "রেসিপি",
 "Recibo": "রসিদ",
 "Recibo em PDF": "PDF রসিদ",
 "Recibo emitido": "রসিদ দেওয়া হয়েছে",
 "Recibo guardado": "রসিদ সংরক্ষিত হয়েছে",
 "Recibos dedutíveis": "কর-ছাড়যোগ্য রসিদ",
 "Recomendada": "প্রস্তাবিত",
 "Recomeçar": "আবার শুরু",
 "Recortar": "কাটুন",
 "Recortar margens": "মার্জিন কাটুন",
 "Recortar, girar e os filtros chegam com o app novo (versão 0.49).": "কাটা, ঘোরানো ও ফিল্টার নতুন অ্যাপে (সংস্করণ 0.49) আসবে।",
 "Recusada": "প্রত্যাখ্যাত",
 "Recusado": "প্রত্যাখ্যাত",
 "Recusar": "প্রত্যাখ্যান",
 "Redação": "রচনা",
 "Refazer": "আবার করুন",
 "Refeição": "খাবার",
 "Refeições, exercícios, cuidados e suplementos marcados para hoje": "আজকের জন্য নির্ধারিত খাবার, ব্যায়াম, যত্ন ও সাপ্লিমেন্ট",
 "Referente a": "যার জন্য",
 "Referência": "রেফারেন্স",
 "Reforço": "বুস্টার",
 "Regar a cada quantos dias": "কত দিন পরপর পানি দেবেন",
 "Regar hoje": "আজ পানি দিন",
 "Regar: {p}": "পানি দিন: {p}",
 "Regional": "আঞ্চলিক",
 "Registra o diário, as etapas e as entregas, sem ver os valores.": "ডায়েরি, ধাপ ও ডেলিভারি লেখেন, টাকার পরিমাণ না দেখে।",
 "Registrar venda/serviço do MEI": "MEI-এর বিক্রি/সেবা নথিভুক্ত করুন",
 "Registre cada atendimento: a evolução fica no cofre, com criptografia. A prescrição pode vir de um modelo.": "প্রতিটি অ্যাপয়েন্টমেন্ট লিখে রাখুন: অগ্রগতি নোট এনক্রিপ্ট হয়ে ভল্টে থাকে। প্রেসক্রিপশন টেমপ্লেট থেকে নেওয়া যায়।",
 "Registre compras e vendas de imóveis, veículos e investimentos com os comprovantes. Ajuda muito na hora do imposto.": "প্রমাণপত্রসহ বাড়ি, যানবাহন ও বিনিয়োগের কেনাবেচা লিখে রাখুন। কর দেওয়ার সময় খুব কাজে লাগে।",
 "Registre o que foi diferente do cronograma (trocou um alimento, mudou a refeição). Entra no relatório da semana.": "সময়সূচি থেকে যা আলাদা হয়েছে তা লিখুন (খাবার বদলেছেন, বেলার খাবার বদলেছেন)। এটি সাপ্তাহিক রিপোর্টে যাবে।",
 "Registro": "রেকর্ড",
 "Registro clínico": "চিকিৎসা রেকর্ড",
 "Registro de horas": "ঘণ্টার রেকর্ড",
 "Registro do diário": "ডায়েরির রেকর্ড",
 "Regiões com feriado próprio (marque as suas):": "নিজস্ব ছুটির দিন আছে এমন অঞ্চল (আপনারগুলো বেছে নিন):",
 "Regras da casa": "বাড়ির নিয়ম",
 "Regras da casa:": "বাড়ির নিয়ম:",
 "Reguei": "পানি দিয়েছি",
 "Reguei hoje": "আজ পানি দিয়েছি",
 "Reiniciar": "আবার চালু করুন",
 "Reiniciar o app": "অ্যাপ আবার চালু করুন",
 "Relatório": "রিপোর্ট",
 "Relatório da semana": "সাপ্তাহিক রিপোর্ট",
 "Relatório em PDF ou Excel": "PDF বা Excel-এ রিপোর্ট",
 "Relatório enviado. Obrigado!": "রিপোর্ট পাঠানো হয়েছে। ধন্যবাদ!",
 "Relatórios": "রিপোর্ট",
 "Relatórios do Bem-Estar": "সুস্থতার রিপোর্ট",
 "Relatórios gerados ({n})": "তৈরি রিপোর্ট ({n})",
 "Relaxar": "বিশ্রাম",
 "Religião": "ধর্ম",
 "Relógio": "ঘড়ি",
 "Relógio e apps de saúde": "ঘড়ি ও হেলথ অ্যাপ",
 "Remada baixa": "সিটেড রো",
 "Remover": "সরান",
 "Remover \"{nome}\"?": "\"{nome}\" সরাবেন?",
 "Remover anotações": "টীকা সরান",
 "Remover este bloco?": "এই ব্লকটি সরাবেন?",
 "Remover páginas": "পৃষ্ঠা সরান",
 "Remover vínculo": "লিংক সরান",
 "Remover {nome}?": "{nome}-কে সরাবেন?",
 "Remédio": "ওষুধ",
 "Remédio contínuo": "নিয়মিত ওষুধ",
 "Remédio na linha do tempo": "টাইমলাইনে ওষুধ",
 "Remédios": "ওষুধ",
 "Remédios de uso contínuo": "নিয়মিত সেবনের ওষুধ",
 "Renavam ou chassi": "Renavam বা চেসিস নম্বর",
 "Renegociado": "পুনরায় আলোচনা করা",
 "Renomear": "নাম বদলান",
 "Renomear com IA": "AI দিয়ে নাম বদলান",
 "Renomear ou trocar ícone": "নাম বদলান বা আইকন পরিবর্তন করুন",
 "Renomear pasta": "ফোল্ডারের নাম বদলান",
 "Renomear, ícone ou cor": "নাম, আইকন বা রং",
 "Renovar: {nome}": "নবায়ন: {nome}",
 "Reorganiza o arquivo por dentro. Ajuda pouco em PDFs com fotos.": "ফাইলকে ভেতর থেকে আবার সাজায়। ছবিওয়ালা PDF-এ কম কাজে দেয়।",
 "Reparar PDF": "PDF মেরামত",
 "Repelente": "মশা তাড়ানোর ক্রিম",
 "Repete": "পুনরাবৃত্তি",
 "Repetir a cada quantos dias": "কত দিন পরপর পুনরাবৃত্তি",
 "Repetições": "পুনরাবৃত্তি",
 "Repita a senha": "পাসওয়ার্ড আবার লিখুন",
 "Repita a senha do cofre": "ভল্টের পাসওয়ার্ড আবার দিন",
 "Repita a senha nova": "নতুন পাসওয়ার্ড আবার লিখুন",
 "Replantio": "টব বদল",
 "Replantios": "টব বদল",
 "Repor papel higiênico, sabonete e café": "টয়লেট পেপার, সাবান ও কফি পূরণ করুন",
 "Representatividade": "প্রতিনিধিত্ব",
 "Reserva": "বুকিং",
 "Reservas": "বুকিং",
 "Reservas, limpeza, receitas e despesas na aba Aluguel & Hospedagem": "বুকিং, পরিষ্কার, আয় ও খরচ \"ভাড়া ও হোমস্টে\" ট্যাবে",
 "Respirar fundo 5 vezes": "৫ বার গভীর শ্বাস নিন",
 "Respondendo a {nome}": "{nome}-কে উত্তর দিচ্ছেন",
 "Responder": "উত্তর দিন",
 "Responsável": "দায়িত্বপ্রাপ্ত ব্যক্তি",
 "Responsável (imobiliária, vistoriador)": "দায়িত্বপ্রাপ্ত (এজেন্সি, পরিদর্শক)",
 "Resposta da SEFAZ": "SEFAZ-এর উত্তর",
 "Resta {tempo}": "বাকি {tempo}",
 "Restam {ml} = {n} copo(s) de {copo}": "বাকি {ml} = {copo}-এর {n}টি গ্লাস",
 "Restaurante": "রেস্তোরাঁ",
 "Restaurantes": "রেস্তোরাঁ",
 "Restaurar": "পুনরুদ্ধার",
 "Restaurar esta cópia?": "এই ব্যাকআপ পুনরুদ্ধার করবেন?",
 "Restaurar troca TODOS os dados atuais pelos da cópia, aqui e na sua conta.": "পুনরুদ্ধার করলে এখানে ও আপনার অ্যাকাউন্টে থাকা বর্তমান সব ডেটা ব্যাকআপের ডেটা দিয়ে বদলে যাবে।",
 "Restaurar uma cópia": "ব্যাকআপ পুনরুদ্ধার করুন",
 "Resultado": "ফলাফল",
 "Resultado nas vendas: {v}": "বিক্রির ফলাফল: {v}",
 "Resumir": "সারাংশ",
 "Resumir e perguntar": "সারাংশ ও প্রশ্ন",
 "Resumo": "সারসংক্ষেপ",
 "Resumo (falta o XML completo)": "সারাংশ (সম্পূর্ণ XML নেই)",
 "Resumo da manhã": "সকালের সারসংক্ষেপ",
 "Resumo da pasta": "ফোল্ডারের সারাংশ",
 "Resumo e opinião": "সারাংশ ও মতামত",
 "Resumo, gastos por categoria, contas, faturas, metas e todos os lançamentos. Bom para mandar ao contador ou guardar para o IR.": "সারসংক্ষেপ, বিভাগ অনুযায়ী খরচ, বিল, কার্ড বিল, লক্ষ্য এবং সব লেনদেন। হিসাবরক্ষককে পাঠাতে বা IR (আয়কর)-এর জন্য রাখতে কাজে লাগে।",
 "Retirar": "তুলুন",
 "Retirar da meta": "লক্ষ্য থেকে তুলুন",
 "Retorno": "ফলো-আপ",
 "Reunião": "মিটিং",
 "Reunião agora": "এখনই মিটিং",
 "Reunião de equipe": "টিম মিটিং",
 "Reuniões": "মিটিং",
 "Revestimento e pisos": "ক্ল্যাডিং ও মেঝে",
 "Revisão": "সার্ভিসিং",
 "Revolução Constitucionalista": "সাংবিধানিক বিপ্লব দিবস",
 "Rico em matéria orgânica": "জৈব পদার্থে সমৃদ্ধ",
 "Rodízio de pneus": "টায়ার রোটেশন",
 "Roedor": "ইঁদুর জাতীয় প্রাণী",
 "Romance": "রোমান্স",
 "Rosca direta": "বাইসেপস কার্ল",
 "Rota": "রুট",
 "Rota passando pelos {n} lugares que faltam": "বাকি {n}টি জায়গা ছুঁয়ে রুট",
 "Rotas e mapas": "রুট ও মানচিত্র",
 "Roteiro": "ভ্রমণসূচি",
 "Roteiro por dia que entra na linha do tempo durante a viagem, mala pelo clima, reservas e fusos.": "প্রতিদিনের ভ্রমণসূচি যা ভ্রমণের সময় টাইমলাইনে আসে, আবহাওয়া অনুযায়ী লাগেজ, বুকিং ও টাইম জোন।",
 "Rotina": "রুটিন",
 "Rotinas com passo a passo: skincare, alongamento, cabelo... Toque em \"+ Cuidado\" para escolher um modelo ou criar o seu.": "ধাপে ধাপে রুটিন: স্কিনকেয়ার, স্ট্রেচিং, চুল... একটি টেমপ্লেট বেছে নিতে বা নিজেরটি তৈরি করতে \"+ যত্ন\" ট্যাপ করুন।",
 "Roupa": "পোশাক",
 "Roupa social": "ফরমাল পোশাক",
 "Roupas de banho": "সাঁতারের পোশাক",
 "Roupas extras das crianças": "শিশুদের অতিরিক্ত জামাকাপড়",
 "Roupas íntimas": "অন্তর্বাস",
 "Rua": "রাস্তা",
 "Rua, número, bairro, cidade (ou o nome do lugar)": "রাস্তা, নম্বর, এলাকা, শহর (বা জায়গার নাম)",
 "Régua": "রুলার",
 "Réptil": "সরীসৃপ",
 "Rótulo (ex.: Meu nome, Empresa do cliente)": "লেবেল (যেমন: আমার নাম, ক্লায়েন্টের প্রতিষ্ঠান)",
 "SAC": "SAC (সমান আসল)",
 "SEM HORÁRIO": "সময় নির্ধারিত নয়",
 "SEU MÊS EM NÚMEROS": "সংখ্যায় আপনার মাস",
 "SEU TREINO": "আপনার ওয়ার্কআউট",
 "SEUS GRUPOS DO APP": "অ্যাপে আপনার গ্রুপ",
 "SP": "SP",
 "SUBTAREFA": "উপকাজ",
 "SUBTAREFAS": "উপ-কাজ",
 "SUPLEMENTAÇÃO": "সাপ্লিমেন্ট",
 "Sabonete facial": "ফেসিয়াল সাবান",
 "Sabão para lavar roupa": "কাপড় কাচার সাবান",
 "Sacada": "বারান্দা",
 "Sai só da lista deste app. A cópia guardada no Drive, no OneDrive ou na pasta do celular continua lá.": "শুধু এই অ্যাপের তালিকা থেকে সরে। Drive, OneDrive বা মোবাইলের ফোল্ডারে সংরক্ষিত কপি থেকে যায়।",
 "Sai só da lista. O arquivo continua onde foi salvo.": "শুধু তালিকা থেকে সরবে। ফাইলটি যেখানে সংরক্ষিত সেখানেই থাকবে।",
 "Sair": "বের হোন",
 "Sair da conta?": "অ্যাকাউন্ট থেকে বের হবেন?",
 "Sair do escritório": "অফিস ছাড়ুন",
 "Sair do escritório?": "অফিস ছাড়বেন?",
 "Sair do grupo": "গ্রুপ ছাড়ুন",
 "Sair do grupo?": "গ্রুপ ছাড়বেন?",
 "Sair sem baixar": "ডাউনলোড না করে বের হন",
 "Saiu": "গেছে",
 "Sala": "শ্রেণিকক্ষ",
 "Sala de estar": "বসার ঘর",
 "Sala de jantar": "খাবার ঘর",
 "Sala virtual": "ভার্চুয়াল কক্ষ",
 "Salada": "সালাদ",
 "Saldo": "ব্যালান্স",
 "Saldo depois desta parcela": "এই কিস্তির পরে বকেয়া",
 "Saldo devedor: {v}": "বকেয়া: {v}",
 "Saldo do mês": "মাসের ব্যালান্স",
 "Salvar": "সংরক্ষণ করুন",
 "Salvar backup do My Planner": "My Planner-এর ব্যাকআপ সংরক্ষণ করুন",
 "Salvar cuidado": "যত্ন সংরক্ষণ করুন",
 "Salvar cômodo": "ঘর সংরক্ষণ করুন",
 "Salvar e colocar no My Planner": "সংরক্ষণ করে My Planner-এ রাখুন",
 "Salvar e sincronizar": "সেভ করুন ও সিঙ্ক করুন",
 "Salvar e testar": "সংরক্ষণ ও পরীক্ষা",
 "Salvar endereço": "ঠিকানা সংরক্ষণ করুন",
 "Salvar no My Planner": "My Planner-এ সংরক্ষণ করুন",
 "Salvar refeição": "খাবার সংরক্ষণ করুন",
 "Salvar suplemento": "সাপ্লিমেন্ট সংরক্ষণ করুন",
 "Salvar tarefa": "কাজ সংরক্ষণ করুন",
 "Salvar treino": "ওয়ার্কআউট সংরক্ষণ করুন",
 "Sanduíche natural": "স্বাস্থ্যকর স্যান্ডউইচ",
 "Santo Antônio": "সেন্ট অ্যান্থনি দিবস",
 "Sapato confortável": "আরামদায়ক জুতা",
 "Saudade": "মিস করছি",
 "Saída (imóvel antigo)": "বের হওয়া (পুরোনো বাড়ি)",
 "Saída de praia": "সৈকতের কভার-আপ",
 "Saúde": "স্বাস্থ্য",
 "Saúde & Prontuário": "স্বাস্থ্য ও মেডিকেল রেকর্ড",
 "Saúde (médicos, dentistas, exames, plano)": "স্বাস্থ্য (ডাক্তার, দন্তচিকিৎসক, পরীক্ষা, স্বাস্থ্য বিমা)",
 "Saúde e bem-estar": "স্বাস্থ্য ও সুস্থতা",
 "Scanner": "স্ক্যানার",
 "Scanner PDF": "PDF স্ক্যানার",
 "Sci-Fi": "সায়েন্স ফিকশন",
 "Se alguma coisa não responder, reinicie o app. Os seus dados estão salvos.": "কিছু সাড়া না দিলে অ্যাপ আবার চালু করুন। আপনার ডেটা সংরক্ষিত আছে।",
 "Se der tempo": "সময় পেলে",
 "Se esta política mudar de forma importante, o app avisa e pede o seu aceite de novo.": "এই নীতিতে গুরুত্বপূর্ণ পরিবর্তন হলে অ্যাপ জানাবে এবং আবার আপনার সম্মতি চাইবে।",
 "Se este aviso apareceu, os alertas dos compromissos estão funcionando.": "এই সতর্কবার্তা দেখা গেলে, অ্যাপয়েন্টমেন্টের সতর্কবার্তা ঠিকমতো কাজ করছে।",
 "Se existir uma conta com {email}, enviamos um link para criar uma senha nova. Confira também o spam.": "{email} দিয়ে কোনো অ্যাকাউন্ট থাকলে, আমরা নতুন পাসওয়ার্ড তৈরির একটি লিংক পাঠিয়েছি। স্প্যাম ফোল্ডারও দেখুন।",
 "Se o alerta atrasar ou não aparecer: nas configurações do app, deixe as notificações ligadas, a bateria \"sem restrição\" e permita \"Alarmes e lembretes\".": "সতর্কবার্তা দেরিতে এলে বা না এলে: অ্যাপের সেটিংসে নোটিফিকেশন চালু রাখুন, ব্যাটারি \"সীমাবদ্ধতাহীন\" রাখুন এবং \"অ্যালার্ম ও রিমাইন্ডার\" অনুমতি দিন।",
 "Se o relógio estiver conectado, os números dele entram por cima dos digitados quando ele tiver o dado.": "ঘড়ি সংযুক্ত থাকলে, ডেটা পেলে ঘড়ির সংখ্যাগুলো হাতে লেখা সংখ্যার জায়গা নেবে।",
 "Se você conectar o relógio: totais de cada dia de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect (Android) ou do app Saúde (iPhone). O app só lê e nunca altera esses dados.": "আপনি ঘড়ি সংযুক্ত করলে: ধাপ, দূরত্ব, ক্যালরি, ব্যায়াম, হৃদস্পন্দন ও ঘুমের দৈনিক মোট হিসাব, যা Health Connect (Android) বা Health অ্যাপ (iPhone) থেকে পড়া হয়। অ্যাপটি শুধু পড়ে এবং কখনো এই ডেটা বদলায় না।",
 "Se você já usou esta aba, nada foi apagado: tudo volta como estava ao assinar.": "আপনি আগে এই ট্যাব ব্যবহার করে থাকলে কিছুই মোছেনি: সাবস্ক্রাইব করলে সব আগের মতো ফিরে আসবে।",
 "Secretária ou recepção": "সচিব বা রিসেপশন",
 "Seg a sex": "সোম-শুক্র",
 "Seguir": "এগিয়ে যান",
 "Segunda": "সোমবার",
 "Segurança": "নিরাপত্তা",
 "Segure e arraste para mudar a ordem. ↻ gira, ⧉ duplica e ✕ tira a página.": "ক্রম বদলাতে ধরে রেখে টানুন। ↻ ঘোরায়, ⧉ ডুপ্লিকেট করে আর ✕ পৃষ্ঠা সরায়।",
 "Segure um GIF numa conversa e toque em \"Guardar\" para ele aparecer aqui.": "কোনো চ্যাটে GIF চেপে ধরে \"সংরক্ষণ করুন\"-এ ট্যাপ করুন, তাহলে এটি এখানে দেখাবে।",
 "Segure um cômodo para mudar de lugar. Com o cômodo aberto, segure uma tarefa e solte em outro cômodo para levá-la.": "জায়গা বদলাতে ঘরটি চেপে ধরে রাখুন। ঘর খোলা থাকলে কোনো কাজ চেপে ধরে অন্য ঘরে ছেড়ে দিন, সেটি সেখানে চলে যাবে।",
 "Segure um fichário, uma matéria ou uma página para mudar a ordem. Solte uma matéria em outro fichário para levá-la para lá.": "ক্রম বদলাতে বাইন্ডার, বিষয় বা পৃষ্ঠা চেপে ধরে রাখুন। কোনো বিষয় অন্য বাইন্ডারে ছেড়ে দিলে সেটি সেখানে চলে যাবে।",
 "Segure uma conversa para silenciar ou arquivar. Arquivada continua recebendo e enviando, mas sem aviso.": "কোনো চ্যাট মিউট বা আর্কাইভ করতে সেটি চেপে ধরে রাখুন। আর্কাইভ করা চ্যাটে বার্তা আসা-যাওয়া চলতে থাকে, তবে নোটিফিকেশন আসে না।",
 "Seguro": "বিমা",
 "Seguro da casa": "গৃহ বিমা",
 "Seguro viagem": "ভ্রমণ বিমা",
 "Selecionar": "নির্বাচন",
 "Sem": "নেই",
 "Sem alerta": "অ্যালার্ট নেই",
 "Sem categoria": "বিভাগ নেই",
 "Sem comprovante": "প্রমাণপত্র নেই",
 "Sem conexão com o servidor de notas. Confira a internet e o endereço do servidor.": "ইনভয়েস সার্ভারের সঙ্গে সংযোগ নেই। ইন্টারনেট ও সার্ভারের ঠিকানা যাচাই করুন।",
 "Sem conexão com o servidor. Confira a internet.": "সার্ভারের সাথে সংযোগ নেই। ইন্টারনেট যাচাই করুন।",
 "Sem conexão com os GIFs agora.": "এখন GIF-এর সাথে সংযোগ নেই।",
 "Sem cômodo": "ঘর নেই",
 "Sem data de fim": "শেষের তারিখ নেই",
 "Sem exercícios": "কোনো ব্যায়াম নেই",
 "Sem fatura em {mes}": "{mes}-এ কোনো কার্ড বিল নেই",
 "Sem fim": "শেষ নেই",
 "Sem horário": "সময় নেই",
 "Sem internet ou servidor ainda não preparado.": "ইন্টারনেট নেই বা সার্ভার এখনও প্রস্তুত নয়।",
 "Sem internet. Envia quando voltar.": "ইন্টারনেট নেই। সংযোগ ফিরলে পাঠানো হবে।",
 "Sem internet. Tente de novo.": "ইন্টারনেট নেই। আবার চেষ্টা করুন।",
 "Sem isso, a tarja só cobre: o texto por baixo continua no arquivo e dá para copiar.": "এটি ছাড়া দাগ শুধু ঢেকে রাখে: নিচের লেখা ফাইলে থেকে যায় এবং কপি করা যায়।",
 "Sem itens": "কোনো আইটেম নেই",
 "Sem juros": "সুদ ছাড়া",
 "Sem limite": "সীমা নেই",
 "Sem link de calendário": "ক্যালেন্ডার লিংক নেই",
 "Sem margem": "মার্জিন ছাড়া",
 "Sem nome": "নামহীন",
 "Sem número na primeira página (capa)": "প্রথম পৃষ্ঠায় (কভার) নম্বর নয়",
 "Sem pasta": "ফোল্ডার নেই",
 "Sem pausas": "বিরতি নেই",
 "Sem permissão": "অনুমতি নেই",
 "Sem prazo": "সময়সীমা নেই",
 "Sem recibo": "রসিদ নেই",
 "Sem tarefas": "কোনো কাজ নেই",
 "Sem texto.": "কোনো লেখা নেই।",
 "Sem tomador identificado": "সেবা গ্রহীতা শনাক্ত হয়নি",
 "Sem título": "শিরোনামহীন",
 "Sem validade": "মেয়াদহীন",
 "Semana": "সপ্তাহ",
 "Semana completa": "পুরো সপ্তাহ",
 "Semana de {de} a {ate}": "{de} থেকে {ate} পর্যন্ত সপ্তাহ",
 "Semanal": "সাপ্তাহিক",
 "Semanal · dias úteis": "সাপ্তাহিক · কর্মদিবস",
 "Semanal · todos os dias": "সাপ্তাহিক · প্রতিদিন",
 "Semanal · {dias}": "সাপ্তাহিক · {dias}",
 "Sempre aparecem, junto com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpus Christi).": "এগুলো সবসময় দেখা যায়, ঐচ্ছিক ছুটির দিনগুলোর (কার্নিভাল, অ্যাশ ওয়েডনেসডে ও কর্পাস ক্রিস্টি) সাথে।",
 "Senha": "পাসওয়ার্ড",
 "Senha (8 caracteres ou mais)": "পাসওয়ার্ড (৮ বা তার বেশি অক্ষর)",
 "Senha alterada.": "পাসওয়ার্ড পরিবর্তিত হয়েছে।",
 "Senha atual": "বর্তমান পাসওয়ার্ড",
 "Senha atual do cofre": "বর্তমান ভল্টের পাসওয়ার্ড",
 "Senha da conta": "অ্যাকাউন্টের পাসওয়ার্ড",
 "Senha do certificado": "সার্টিফিকেটের পাসওয়ার্ড",
 "Senha do cofre": "ভল্টের পাসওয়ার্ড",
 "Senha do cofre alterada.": "ভল্টের পাসওয়ার্ড বদলানো হয়েছে।",
 "Senha do cofre incorreta.": "ভল্টের পাসওয়ার্ড ভুল।",
 "Senha incorreta": "ভুল পাসওয়ার্ড",
 "Senha incorreta.": "ভুল পাসওয়ার্ড।",
 "Senha nova (8 caracteres ou mais)": "নতুন পাসওয়ার্ড (৮ বা তার বেশি অক্ষর)",
 "Senha nova do cofre (6 caracteres ou mais)": "নতুন ভল্টের পাসওয়ার্ড (৬ বা তার বেশি অক্ষর)",
 "Senha, biometria, bloqueio e privacidade": "পাসওয়ার্ড, বায়োমেট্রিক, লক ও গোপনীয়তা",
 "Senha, e-mail e formas de desbloquear": "পাসওয়ার্ড, ইমেল ও আনলক করার উপায়",
 "Separar informes de rendimentos (bancos, empregador, corretoras)": "আয়ের বিবরণী গুছিয়ে রাখুন (ব্যাংক, নিয়োগকর্তা, ব্রোকার)",
 "Servidor de notas": "ইনভয়েস সার্ভার",
 "Servidor não configurado (lib/config.ts).": "সার্ভার কনফিগার করা নেই (lib/config.ts)।",
 "Servidor não configurado.": "সার্ভার কনফিগার করা নেই।",
 "Servidor não configurado: faltam os dados do Supabase em lib/config.ts.": "সার্ভার কনফিগার করা নেই: lib/config.ts-এ Supabase-এর তথ্য নেই।",
 "Serviço": "সেবা",
 "Serviço não prestado": "সেবা দেওয়া হয়নি",
 "Serviços": "সেবা",
 "Será excluída em 1 dia": "1 দিনের মধ্যে মুছে ফেলা হবে",
 "Será excluída em {n} dias": "{n} দিনের মধ্যে মুছে ফেলা হবে",
 "Será excluída hoje": "আজ মুছে ফেলা হবে",
 "Sessão": "সেশন",
 "Seu acesso ainda precisa ser liberado. Tente entrar em alguns instantes.": "আপনার অ্যাক্সেস এখনো অনুমোদন হওয়া বাকি। কিছুক্ষণ পরে প্রবেশের চেষ্টা করুন।",
 "Seu código": "আপনার কোড",
 "Seu código de amigo": "আপনার বন্ধু কোড",
 "Seu código para amigos ganharem 10 dias com todas as abas": "বন্ধুদের সব ট্যাবসহ 10 দিন পাওয়ার জন্য আপনার কোড",
 "Seu nome": "আপনার নাম",
 "Seu papel: {p}": "আপনার ভূমিকা: {p}",
 "Seu papel: {p}. {d}": "আপনার ভূমিকা: {p}। {d}",
 "Seu scanner de bolso": "আপনার পকেট স্ক্যানার",
 "Seus dados continuam salvos na nuvem.": "আপনার তথ্য ক্লাউডে সংরক্ষিত থাকবে।",
 "Seus dados na nuvem do My Planner": "My Planner ক্লাউডে আপনার ডেটা",
 "Seus dados são seus: não vendemos e não usamos para publicidade. Você pode exportar ou apagar tudo quando quiser.": "আপনার ডেটা আপনারই: আমরা বিক্রি করি না এবং বিজ্ঞাপনে ব্যবহার করি না। যখন খুশি সব এক্সপোর্ট বা মুছে ফেলতে পারেন।",
 "Seus {n} meses grátis terminaram": "আপনার {n} মাসের বিনামূল্যের সময় শেষ",
 "Sexta": "শুক্রবার",
 "Sextou": "শুক্রবার",
 "Sextou!": "অবশেষে শুক্রবার!",
 "Shampoo": "শ্যাম্পু",
 "Show ou passeio": "শো বা ভ্রমণ",
 "Silenciar avisos": "বিজ্ঞপ্তি মিউট করুন",
 "Sim": "হ্যাঁ",
 "Simples Nacional": "Simples Nacional",
 "Sincronizado em {data}": "{data}-এ সিঙ্ক হয়েছে",
 "Sincronizando pelo dispositivo {nome}": "{nome} ডিভাইস থেকে সিঙ্ক হচ্ছে",
 "Sincronizando...": "সিঙ্ক হচ্ছে...",
 "Sincronizar agora": "এখনই সিঙ্ক করুন",
 "Sincronização parada: confirme sua senha. Nada se perde.": "সিঙ্ক থেমে আছে: আপনার পাসওয়ার্ড নিশ্চিত করুন। কিছুই হারাবে না।",
 "Site da assistência": "সার্ভিস সেন্টারের ওয়েবসাইট",
 "Site da assistência (https://...)": "সার্ভিস সেন্টারের ওয়েবসাইট (https://...)",
 "Site ou ingresso online": "ওয়েবসাইট বা অনলাইন টিকিট",
 "Situação": "অবস্থা",
 "Situação agora": "এখনকার অবস্থা",
 "Skincare da manhã": "সকালের স্কিনকেয়ার",
 "Skincare da noite": "রাতের স্কিনকেয়ার",
 "Slides": "স্লাইড",
 "Smileys e pessoas": "স্মাইলি ও মানুষ",
 "Sobremesa": "ডেজার্ট",
 "Sobrou no mês": "মাসে বেঁচেছে",
 "Sociologia": "সমাজবিজ্ঞান",
 "Sofá": "সোফা",
 "Sol": "সূর্য",
 "Sol pleno": "পূর্ণ রোদ",
 "Solo ou substrato": "মাটি বা মিশ্রণ",
 "Solte numa matéria para mover a página para lá:": "পৃষ্ঠাটি সেখানে সরাতে কোনো বিষয়ের ওপর ছেড়ে দিন:",
 "Soma a garantia legal e a do fabricante. Confira no termo de garantia. Avisa 15 e 3 dias antes.": "আইনি ওয়ারেন্টি ও প্রস্তুতকারকের ওয়ারেন্টি যোগ করে। ওয়ারেন্টি কার্ডে যাচাই করুন। ১৫ ও ৩ দিন আগে জানায়।",
 "Sombra": "ছায়া",
 "Somente esta tarefa": "শুধু এই কাজটি",
 "Sono": "ঘুম",
 "Sono da noite": "রাতের ঘুম",
 "Sopa": "স্যুপ",
 "Sou MEI": "আমি MEI",
 "Status": "অবস্থা",
 "Sua conexão com a nuvem venceu (acontece quando o app fica muito tempo sem abrir ou a senha foi trocada em outro dispositivo). Nada se perde: o que está aqui é enviado assim que você confirmar.": "ক্লাউডের সাথে আপনার সংযোগের মেয়াদ শেষ হয়েছে (অ্যাপটি অনেকদিন খোলা না হলে বা অন্য ডিভাইসে পাসওয়ার্ড বদলালে এমন হয়)। কিছুই হারাবে না: নিশ্চিত করার সাথে সাথেই এখানকার সবকিছু পাঠানো হবে।",
 "Sua equipe num lugar só: conversa, documentos, reuniões de vídeo com gravação e convite pelo link.": "আপনার টিম এক জায়গায়: কথোপকথন, নথি, রেকর্ডিংসহ ভিডিও মিটিং এবং লিংকে আমন্ত্রণ।",
 "Sua rotina em um só lugar": "আপনার রুটিন এক জায়গায়",
 "Sua senha": "আপনার পাসওয়ার্ড",
 "Suas abas": "আপনার ট্যাব",
 "Substituir": "প্রতিস্থাপন",
 "Substrato usado": "ব্যবহৃত মিশ্রণ",
 "Subtarefa {n}": "উপকাজ {n}",
 "Suco": "জুস",
 "Sugerir nome": "নাম প্রস্তাব করুন",
 "Sugestão": "পরামর্শ",
 "Sugestões de {categoria}": "{categoria}-এর পরামর্শ",
 "Supabase: guarda a conta e os dados sincronizados, como operador. Os servidores podem ficar fora do Brasil, com as garantias do art. 33 da LGPD.": "Supabase: প্রসেসর হিসেবে অ্যাকাউন্ট ও সিঙ্ক করা ডেটা রাখে। সার্ভার ব্রাজিলের বাইরে থাকতে পারে, LGPD-এর art. 33-এর নিশ্চয়তাসহ।",
 "Superiores": "উচ্চতর",
 "Supino reto": "বেঞ্চ প্রেস",
 "Suplemento": "সাপ্লিমেন্ট",
 "Suspense": "সাসপেন্স",
 "Suíte": "সংযুক্ত বাথরুমসহ শোবার ঘর",
 "Sábado": "শনিবার",
 "São Paulo": "São Paulo",
 "São Paulo (SP)": "São Paulo (SP)",
 "São mais de 60 arquivos. Use \"A cada N páginas\".": "60টির বেশি ফাইল হবে। \"প্রতি N পৃষ্ঠায়\" ব্যবহার করুন।",
 "Série": "সিরিজ",
 "Série da DPS": "DPS সিরিজ",
 "Série e turma": "শ্রেণি ও শাখা",
 "Séries": "সেট",
 "Sérum": "সেরাম",
 "Símbolos": "প্রতীক",
 "Só a equipe do escritório vê. Até 50 MB por arquivo.": "শুধু অফিসের টিম দেখতে পায়। প্রতি ফাইল সর্বোচ্চ ৫০ MB।",
 "Só acompanha": "শুধু দেখেন",
 "Só acompanha, sem valores": "শুধু দেখেন, টাকার পরিমাণ ছাড়া",
 "Só administradores": "শুধু অ্যাডমিন",
 "Só em {data}": "শুধু {data}",
 "Só leitura": "শুধু পড়ার জন্য",
 "Só mandar para a aba Estudos (sem escolher página)": "শুধু পড়াশোনা ট্যাবে পাঠান (পৃষ্ঠা না বেছে)",
 "Só neste dispositivo": "শুধু এই ডিভাইসে",
 "Só neste dispositivo: {n}": "শুধু এই ডিভাইসে: {n}",
 "Só o código": "শুধু কোড",
 "Só o dia {data}": "শুধু {data} তারিখে",
 "Só os dados (texto)": "শুধু তথ্য (টেক্সট)",
 "Só os totais das Finanças vão para a sua IA. Não é recomendação de investimento.": "শুধু অর্থায়নের মোট হিসাব আপনার AI-তে যায়। এটি বিনিয়োগের পরামর্শ নয়।",
 "Só seu: estudos, estratégias pedagógicas e o que funcionou ou não em cada aula. Os alunos não veem.": "শুধু আপনার জন্য: অধ্যয়ন, পাঠদানের কৌশল এবং প্রতিটি ক্লাসে কী কাজ করেছে বা করেনি। শিক্ষার্থীরা দেখতে পায় না।",
 "Só um celular sincroniza com a agenda. Para passar para este, toque abaixo.": "শুধু একটি ফোনই ক্যালেন্ডারের সাথে সিঙ্ক হয়। এই ফোনে বদলাতে নিচে ট্যাপ করুন।",
 "Só uma vez": "শুধু একবার",
 "Só uma vez (abrir a ficha da tarefa)": "শুধু একবার (কাজের কার্ড খুলুন)",
 "Só áudio": "শুধু অডিও",
 "Sótão": "চিলেকোঠা",
 "TAREFAS DA CASA": "ঘরের কাজ",
 "TELEFONE (OPCIONAL)": "ফোন (ঐচ্ছিক)",
 "TRAZER PARA O MY PLANNER": "MY PLANNER-এ আনুন",
 "TV por assinatura": "পে টিভি",
 "Tabela": "টেবিল",
 "Talvez": "হয়তো",
 "Tamanho": "আকার",
 "Tamanho da foto": "ছবির মাপ",
 "Tamanho da página": "পৃষ্ঠার আকার",
 "Tamanho das páginas": "পৃষ্ঠাগুলোর আকার",
 "Tamanho do arquivo": "ফাইলের আকার",
 "Tamanho do copo": "গ্লাসের মাপ",
 "Também procurar nos Diários Oficiais dos municípios": "পৌরসভার সরকারি গেজেটেও খুঁজুন",
 "Também serão excluídos {n} item(ns) dentro dele.": "এর ভেতরের {n}টি জিনিসও মুছে যাবে।",
 "Tapioca": "ট্যাপিওকা ক্রেপ",
 "Tarefa": "কাজ",
 "Tarefa da casa": "ঘরের কাজ",
 "Tarefa de casa": "বাড়ির কাজ",
 "Tarefa duplicada": "কাজের কপি তৈরি হয়েছে",
 "Tarefa ou entrega": "কাজ বা সরবরাহ",
 "Tarefa para {nome}": "{nome}-এর জন্য কাজ",
 "Tarefas da casa": "ঘরের কাজগুলো",
 "Tarefas e itens de todas as abas": "সব ট্যাবের কাজ ও আইটেম",
 "Tarefas novas do My Planner vão para: {agenda}": "My Planner-এর নতুন কাজ যাবে: {agenda}",
 "Tarefas que se repetem e passam do período continuam nos outros dias; só os dias escolhidos saem.": "পুনরাবৃত্ত যেসব কাজ সময়কালের বাইরে যায় সেগুলো অন্য দিনগুলোতে থেকে যায়; শুধু বেছে নেওয়া দিনগুলো মোছে।",
 "Tarjas pretas sobre CPF, valores e nomes. Apaga de verdade.": "CPF, টাকার অঙ্ক ও নামের ওপর কালো দাগ। সত্যিই মুছে দেয়।",
 "Tartaruga": "কচ্ছপ",
 "Taxa de limpeza": "পরিষ্কারের ফি",
 "Taxa de limpeza cobrada do hóspede": "অতিথির কাছ থেকে নেওয়া পরিষ্কারের ফি",
 "Taxas e anúncios": "ফি ও বিজ্ঞাপন",
 "Te amo": "ভালোবাসি",
 "Tecnologia": "প্রযুক্তি",
 "Tela cheia": "পূর্ণ স্ক্রিন",
 "Teleconsulta": "টেলি-পরামর্শ",
 "Telefone": "ফোন",
 "Telefone da assistência": "সার্ভিস সেন্টারের ফোন",
 "Telefone da empresa": "প্রতিষ্ঠানের ফোন",
 "Telefone da escola": "স্কুলের ফোন",
 "Telefone da limpeza": "পরিষ্কারকর্মীর ফোন",
 "Telefone de emergência": "জরুরি ফোন",
 "Telefone do veterinário": "পশুচিকিৎসকের ফোন",
 "Telhado": "ছাদ",
 "Tem anexos": "সংযুক্তি আছে",
 "Tem certeza?": "আপনি কি নিশ্চিত?",
 "Tem {n} conta(s) em atraso somando {v}. Pague primeiro as que cobram juros mais altos, como o cartão e o cheque especial.": "আপনার {n}টি বিলের শেষ তারিখ পেরিয়ে গেছে, মোট {v}। আগে বেশি সুদের বিলগুলো দিন, যেমন কার্ড ও ওভারড্রাফ্ট।",
 "Tema": "বিষয়",
 "Tempo de preparo": "প্রস্তুতির সময়",
 "Temporada": "সিজন",
 "Temporizador (direita)": "টাইমার (ডানে)",
 "Tenta consertar um PDF que não abre direito.": "ঠিকমতো না খোলা PDF মেরামতের চেষ্টা করে।",
 "Tentar de novo": "আবার চেষ্টা করুন",
 "Tente uma foto mais nítida, com a página inteira.": "পুরো পৃষ্ঠাসহ আরও পরিষ্কার ছবি দিয়ে চেষ্টা করুন।",
 "Termina às {hora}": "{hora}-এ শেষ",
 "Terminar até": "শেষ করার সময়সীমা",
 "Terminei em": "শেষ করেছি",
 "Terminou": "শেষ হয়েছে",
 "Terminou em {data}. Nada foi apagado: tudo volta como estava ao assinar.": "{data}-এ শেষ হয়েছে। কিছুই মোছা হয়নি: সাবস্ক্রাইব করলে সব আগের মতো ফিরে আসবে।",
 "Termos de uso": "ব্যবহারের শর্তাবলি",
 "Termos de uso e privacidade": "ব্যবহারের শর্তাবলি ও গোপনীয়তা",
 "Terror": "হরর",
 "Terça": "মঙ্গলবার",
 "Testando...": "পরীক্ষা হচ্ছে...",
 "Testar alerta (1 minuto)": "সতর্কবার্তা পরীক্ষা (১ মিনিট)",
 "Testar aviso": "নোটিফিকেশন পরীক্ষা",
 "Teste de alerta do Planner": "Planner সতর্কবার্তা পরীক্ষা",
 "Teste grátis até {data} ({n} dia(s))": "{data} পর্যন্ত বিনামূল্যে ট্রায়াল ({n} দিন)",
 "Teste grátis: {n} dia(s)": "বিনামূল্যে ট্রায়াল: {n} দিন",
 "Teste terminado": "ট্রায়াল শেষ",
 "Teste terminou em {data}": "ট্রায়াল {data}-এ শেষ হয়েছে",
 "Teste: aviso feito pelo próprio celular.": "পরীক্ষা: ফোন নিজেই তৈরি করা নোটিফিকেশন।",
 "Texto": "লেখা",
 "Texto completo": "পুরো লেখা",
 "Texto copiado. Cole onde quiser enviar.": "টেক্সট কপি হয়েছে। যেখানে পাঠাতে চান সেখানে পেস্ট করুন।",
 "Texto do documento": "নথির লেখা",
 "Texto extra do convite (traje, presentes...)": "আমন্ত্রণের অতিরিক্ত লেখা (পোশাক, উপহার...)",
 "Texto livre": "মুক্ত লেখা",
 "Texto ou recado": "টেক্সট বা বার্তা",
 "Texto para PDF": "লেখা থেকে PDF",
 "Texto {data}": "লেখা {data}",
 "Tipo": "ধরন",
 "Tipo sanguíneo": "রক্তের গ্রুপ",
 "Tira as páginas que você não quer.": "যে পৃষ্ঠাগুলো চান না সেগুলো সরায়।",
 "Tira autor, programas, comandos escondidos e anexos.": "লেখক, প্রোগ্রাম, লুকানো কমান্ড ও সংযুক্তি সরায়।",
 "Tira comentários, destaques e desenhos de outros programas.": "অন্য প্রোগ্রামের মন্তব্য, হাইলাইট ও আঁকা সরায়।",
 "Tira o texto do PDF (arquivo .txt).": "PDF থেকে লেখা বের করে (.txt ফাইল)।",
 "Tiradentes": "Tiradentes",
 "Tirar": "সরান",
 "Tirar a assinatura": "স্বাক্ষর সরান",
 "Tirar a foto": "ছবি সরান",
 "Tirar a foto agora": "এখনই ছবি তুলুন",
 "Tirar admin": "অ্যাডমিন সরান",
 "Tirar alarmes do My Planner": "My Planner থেকে অ্যালার্ম সরান",
 "Tirar arquivos anexados": "সংযুক্ত ফাইল সরান",
 "Tirar comentários, destaques e links": "মন্তব্য, হাইলাইট ও লিংক সরান",
 "Tirar da agenda": "সময়সূচি থেকে সরান",
 "Tirar da barra": "বার থেকে সরান",
 "Tirar daqui": "এখান থেকে সরান",
 "Tirar das minhas figurinhas?": "আমার স্টিকার থেকে সরাবেন?",
 "Tirar de administrador": "অ্যাডমিন থেকে সরান",
 "Tirar do escritório": "অফিস থেকে সরান",
 "Tirar dos meus GIFs?": "আমার GIF থেকে সরাবেন?",
 "Tirar este copo": "এই গ্লাসটি সরান",
 "Tirar foto": "ছবি তুলুন",
 "Tirar fotos de boletos, cupons e documentos e escolher fotos e vídeos da galeria.": "বিল, রসিদ ও ডকুমেন্টের ছবি তোলা এবং গ্যালারি থেকে ছবি ও ভিডিও বেছে নেওয়া।",
 "Tirar o desenho padrão?": "প্যাটার্ন সরাবেন?",
 "Tirar o lixo": "ময়লা ফেলুন",
 "Tire a foto e a sua IA preenche a ficha": "ছবি তুলুন, আপনার AI ফর্ম পূরণ করবে",
 "Titular (de quem é o documento)": "ধারক (নথিটি কার)",
 "Titular: {nome}": "ধারক: {nome}",
 "Toalha de praia": "সৈকতের তোয়ালে",
 "Tocar os pés": "পায়ের আঙুল ছুঁয়ে দেখুন",
 "Toda a agenda": "পুরো এজেন্ডা",
 "Toda semana": "প্রতি সপ্তাহে",
 "Todas": "সব",
 "Todas (passadas, esta e futuras)": "সবগুলো (অতীত, এটি ও ভবিষ্যৎ)",
 "Todas ({n})": "সব ({n})",
 "Todas as abas liberadas até {data}.": "{data} পর্যন্ত সব ট্যাব খোলা।",
 "Todas as capitais. Marque uma ou mais cidades.": "সব রাজধানী। এক বা একাধিক শহর চিহ্নিত করুন।",
 "Todas as ferramentas de PDF: juntar, dividir, organizar, assinar, carimbo, tarja, números de página, formulários, comprimir, converter, OCR e IA. Guarda no celular, no Google Drive ou no OneDrive.": "PDF-এর সব টুল: জোড়া, ভাগ, সাজানো, স্বাক্ষর, সিল, কালো দাগ, পৃষ্ঠা নম্বর, ফর্ম, কম্প্রেস, রূপান্তর, OCR ও AI। মোবাইল, Google Drive বা OneDrive-এ সংরক্ষণ করে।",
 "Todas as ferramentas ficam na tela da aba.": "সব টুল এই ট্যাবের স্ক্রিনে আছে।",
 "Todas as fotos da viagem ficam aqui: as que você puser no álbum e as do roteiro, dos lugares e das reservas.": "ভ্রমণের সব ছবি এখানে থাকে: আপনি অ্যালবামে যা দেন এবং ভ্রমণসূচি, জায়গা ও বুকিংয়ের ছবি।",
 "Todas as plantas estão regadas.": "সব গাছে পানি দেওয়া হয়েছে।",
 "Todas as páginas, uma embaixo da outra.": "সব পৃষ্ঠা, একটির নিচে আরেকটি।",
 "Todo ano": "প্রতি বছর",
 "Todo dia": "প্রতিদিন",
 "Todo dia no horário escolhido: quantas tarefas o dia tem, a primeira e a energia total.": "প্রতিদিন বেছে নেওয়া সময়ে: দিনে কতগুলো কাজ, প্রথমটি কী এবং মোট এনার্জি।",
 "Todo mês": "প্রতি মাসে",
 "Todo mês · dia {d}": "প্রতি মাসে · {d} তারিখে",
 "Todo o histórico": "পুরো ইতিহাস",
 "Todos": "সব",
 "Todos ({n})": "সব ({n})",
 "Todos do grupo": "গ্রুপের সবাই",
 "Todos do grupo veem": "গ্রুপের সবাই দেখে",
 "Todos na reunião veem o aviso \"Gravando\". O arquivo vai para os Documentos do escritório, visível só para você até você liberar para a equipe.": "মিটিংয়ের সবাই \"রেকর্ড হচ্ছে\" বার্তা দেখবেন। ফাইলটি অফিসের নথি-তে যাবে, টিমের জন্য খুলে না দেওয়া পর্যন্ত শুধু আপনি দেখতে পাবেন।",
 "Todos os cuidados": "সব যত্ন",
 "Todos os dias": "প্রতিদিন",
 "Todos os suplementos": "সব সাপ্লিমেন্ট",
 "Todos os treinos": "সব ওয়ার্কআউট",
 "Todos os tribunais": "সব আদালত",
 "Todos presentes": "সবাই উপস্থিত",
 "Todos saem do grupo. O que cada pessoa já aceitou continua na agenda dela.": "সবাই গ্রুপ ছেড়ে যাবেন। প্রত্যেকে যা গ্রহণ করেছেন তা তাদের এজেন্ডায় থেকে যাবে।",
 "Todos trabalham nos mesmos dados, cada um conforme o papel. Toque no papel de cada pessoa em Membros para trocar.": "সবাই একই ডেটায় কাজ করেন, প্রত্যেকে নিজের ভূমিকা অনুযায়ী। পরিবর্তন করতে সদস্য-এ প্রত্যেকের ভূমিকায় ট্যাপ করুন।",
 "Tomador": "সেবা গ্রহীতা",
 "Tomador (quem contratou)": "সেবা গ্রহীতা (যিনি সেবা নিয়েছেন)",
 "Tomadores": "সেবা গ্রহীতা",
 "Tomei": "আমি নিয়েছি",
 "Toque aqui ou no + para criar uma tarefa": "কাজ তৈরি করতে এখানে বা + এ ট্যাপ করুন",
 "Toque em \"Apagar minha conta e todos os dados\" e confirme.": "\"আমার অ্যাকাউন্ট ও সব ডেটা মুছুন\" ট্যাপ করে নিশ্চিত করুন।",
 "Toque em + › Novo cartão de crédito e informe os dias de fechamento e de vencimento.": "+ › নতুন ক্রেডিট কার্ড-এ ট্যাপ করুন এবং বিল বন্ধ হওয়ার ও শেষ তারিখের দিন লিখুন।",
 "Toque em Ajustes e depois em Segurança.": "সেটিংসে ট্যাপ করুন, তারপর নিরাপত্তায়।",
 "Toque em Conectar e, na tela da Apple, ligue os itens que o My Planner pode ler.": "সংযুক্ত করুন-এ ট্যাপ করুন এবং Apple-এর স্ক্রিনে My Planner যেগুলো পড়তে পারবে সেগুলো চালু করুন।",
 "Toque em Conectar e, na tela do Health Connect, permita que o My Planner leia os dados.": "সংযুক্ত করুন-এ ট্যাপ করুন এবং Health Connect-এর স্ক্রিনে My Planner-কে ডেটা পড়ার অনুমতি দিন।",
 "Toque em quem NÃO deve ver esta ficha (e o que está dentro dela). Ex.: o presente surpresa.": "যাদের এই কার্ড (এবং এর ভেতরের জিনিস) দেখা উচিত নয়, তাদের ওপর ট্যাপ করুন। যেমন: সারপ্রাইজ উপহার।",
 "Toque em uma aba para abrir. As bloqueadas mostram como assinar.": "খুলতে একটি ট্যাবে ট্যাপ করুন। লক করা ট্যাবে সাবস্ক্রাইব করার উপায় দেখায়।",
 "Toque em uma aba para abrir. Cada aba extra pode ser testada de graça por 10 dias.": "খুলতে কোনো ট্যাবে চাপুন। প্রতিটি অতিরিক্ত ট্যাব ১০ দিন বিনামূল্যে ব্যবহার করে দেখা যায়।",
 "Toque em uma aba para abrir. Toque em 📌 para pôr ou tirar a aba da barra de baixo. Cada aba extra pode ser testada de graça por 10 dias.": "খুলতে একটি ট্যাবে ট্যাপ করুন। ট্যাবটি নিচের বারে রাখতে বা সরাতে 📌 ট্যাপ করুন। প্রতিটি অতিরিক্ত ট্যাব ১০ দিন বিনামূল্যে ব্যবহার করে দেখা যায়।",
 "Toque em uma área para abrir. As bloqueadas mostram como assinar.": "খুলতে একটি এলাকায় ট্যাপ করুন। লক করা এলাকায় সাবস্ক্রাইব করার উপায় দেখানো হয়।",
 "Toque no desenho para continuar desenhando.": "আঁকা চালিয়ে যেতে ছবিতে ট্যাপ করুন।",
 "Toque no que este grupo vai compartilhar. Tudo o que está dentro (roteiro, fotos, reservas...) vai junto e todos participam.": "এই গ্রুপ যা শেয়ার করবে তাতে ট্যাপ করুন। এর ভেতরের সবকিছু (ভ্রমণসূচি, ছবি, বুকিং...) একসাথে যাবে এবং সবাই অংশ নেবে।",
 "Toque nos PDFs na ordem em que devem ficar.": "যে ক্রমে থাকা উচিত সেই ক্রমে PDF-গুলোতে ট্যাপ করুন।",
 "Toque num copo para mudar o volume; segure o + para um copo de outro tamanho.": "পরিমাণ বদলাতে গ্লাসে ট্যাপ করুন; অন্য মাপের গ্লাসের জন্য + চেপে ধরে রাখুন।",
 "Toque num feriado para adicioná-lo ao Planner.": "Planner-এ যোগ করতে একটি ছুটির দিনে ট্যাপ করুন।",
 "Toque num lançamento para trocar a categoria, guardar o recibo no IR ou apagar.": "বিভাগ বদলাতে, IR রসিদ সংরক্ষণ করতে বা মুছতে কোনো লেনদেনে ট্যাপ করুন।",
 "Toque num lançamento para trocar a categoria. Pressione e segure para apagar.": "বিভাগ বদলাতে কোনো এন্ট্রিতে ট্যাপ করুন। মুছতে চেপে ধরে রাখুন।",
 "Toque num perfil para editar. Pressione e segure para removê-lo.": "সম্পাদনা করতে একটি প্রোফাইলে ট্যাপ করুন। সরাতে চেপে ধরে রাখুন।",
 "Toque num texto, desenho ou checklist e arraste para qualquer lugar da folha.": "কোনো লেখা, আঁকা বা চেকলিস্ট ট্যাপ করে পাতার যেকোনো জায়গায় টেনে নিন।",
 "Toque numa página para recortar, girar ou mudar o filtro. Segure e arraste para mudar a ordem.": "কাটতে, ঘোরাতে বা ফিল্টার বদলাতে একটি পৃষ্ঠায় ট্যাপ করুন। ক্রম বদলাতে চেপে ধরে টানুন।",
 "Toque numa tarefa para copiar ou mover para hoje.": "কোনো কাজে ট্যাপ করে আজকে কপি করুন বা সরান।",
 "Toque onde quer a checklist.": "যেখানে চেকলিস্ট চান সেখানে ট্যাপ করুন।",
 "Toque onde quer escrever.": "যেখানে লিখতে চান সেখানে ট্যাপ করুন।",
 "Toque para abrir": "খুলতে ট্যাপ করুন",
 "Toque para abrir no app do celular. Arraste para a direita para tirar da lista.": "ফোনের অ্যাপে খুলতে ট্যাপ করুন। তালিকা থেকে সরাতে ডানে সোয়াইপ করুন।",
 "Toque para abrir, segure para mudar o nome. Arraste para a esquerda para arquivar ou para a direita para excluir.": "খুলতে ট্যাপ করুন, নাম বদলাতে চেপে ধরুন। আর্কাইভ করতে বাঁয়ে বা মুছতে ডানে সোয়াইপ করুন।",
 "Toque para abrir. Arraste para a direita para tirar da lista.": "খুলতে ট্যাপ করুন। তালিকা থেকে সরাতে ডানে সোয়াইপ করুন।",
 "Toque para aceitar ou recusar.": "গ্রহণ বা প্রত্যাখ্যান করতে ট্যাপ করুন।",
 "Toque para aceitar, editar ou recusar.": "গ্রহণ, সম্পাদনা বা প্রত্যাখ্যান করতে ট্যাপ করুন।",
 "Toque para aplicar agora. Ou ela entra sozinha ao reabrir o app.": "এখনই প্রয়োগ করতে ট্যাপ করুন। অথবা অ্যাপ আবার খুললে এটি নিজে থেকে চালু হবে।",
 "Toque para baixar e instalar por cima. Seus dados continuam.": "ডাউনলোড করে উপরে ইনস্টল করতে ট্যাপ করুন। আপনার তথ্য থেকে যাবে।",
 "Toque para conversar": "চ্যাট করতে ট্যাপ করুন",
 "Toque para enviar o emoji animado": "অ্যানিমেটেড ইমোজি পাঠাতে ট্যাপ করুন",
 "Toque para enviar. Segure para guardar ou tirar das suas.": "পাঠাতে ট্যাপ করুন। সংরক্ষণ বা সরাতে চেপে ধরুন।",
 "Toque para escolher": "বেছে নিতে ট্যাপ করুন",
 "Toque para fechar": "বন্ধ করতে ট্যাপ করুন",
 "Toque para gerar um novo QR Code": "নতুন QR Code তৈরি করতে ট্যাপ করুন",
 "Tornar admin": "অ্যাডমিন বানান",
 "Tornar administrador": "অ্যাডমিন বানান",
 "Tosa": "লোম ছাঁটা",
 "Totais por alimento": "খাবার অনুযায়ী মোট",
 "Total": "মোট",
 "Total bruto": "মোট পরিমাণ",
 "Total das reservas: {v}": "বুকিংয়ের মোট: {v}",
 "Total de aulas": "মোট ক্লাস",
 "Total de capítulos": "মোট অধ্যায়",
 "Total de módulos": "মোট মডিউল",
 "Total de páginas": "মোট পৃষ্ঠা",
 "Total de recibos: {v}": "রসিদের মোট: {v}",
 "Total: {n}. Cada aba pode ter até {lim} de texto (fotos e arquivos não contam: ficam no dispositivo ou no seu Drive).": "মোট: {n}। প্রতিটি ট্যাবে {lim} পর্যন্ত টেক্সট রাখা যায় (ছবি ও ফাইল গোনা হয় না: সেগুলো ডিভাইসে বা আপনার Drive-এ থাকে)।",
 "Total: {v}": "মোট: {v}",
 "Trabalhando...": "কাজ চলছে...",
 "Trabalho": "শ্রম",
 "Traga os compromissos da sua agenda do Google para o My Planner e edite por aqui: as mudanças voltam para a agenda.": "আপনার Google ক্যালেন্ডারের ইভেন্ট My Planner-এ এনে এখান থেকেই এডিট করুন: পরিবর্তনগুলো ক্যালেন্ডারেও ফিরে যাবে।",
 "Trans": "ট্রান্স",
 "Transferir: {s}": "স্থানান্তর: {s}",
 "Transferência": "স্থানান্তর",
 "Transferências": "স্থানান্তর",
 "Transporte": "যাতায়াত",
 "Tratamento": "চিকিৎসা",
 "Travar depois de preencher": "পূরণের পর লক করুন",
 "Trazer todas para hoje": "সব আজকে আনুন",
 "Trazer tudo para hoje?": "সব আজকে আনবেন?",
 "Trecho ou ideia": "উদ্ধৃতি বা ভাবনা",
 "Treino": "ওয়ার্কআউট",
 "Trem ou ônibus": "ট্রেন বা বাস",
 "Treme": "কাঁপা",
 "Tribunais": "আদালত",
 "Trilha": "ট্রেকিং",
 "Triste": "মন খারাপ",
 "Triângulo": "ত্রিভুজ",
 "Troca de óleo": "তেল বদল",
 "Troca de óleo, rodízio de pneus, revisões por km, IPVA, licenciamento e seguro.": "তেল বদল, টায়ার রোটেশন, কিমি অনুযায়ী সার্ভিসিং, IPVA, লাইসেন্সিং ও বিমা।",
 "Trocador portátil": "পোর্টেবল চেঞ্জিং ম্যাট",
 "Trocar": "বদলান",
 "Trocar a categoria": "বিভাগ বদলান",
 "Trocar a foto": "ছবি বদলান",
 "Trocar a pasta": "ফোল্ডার বদলান",
 "Trocar a senha do cofre": "ভল্টের পাসওয়ার্ড বদলান",
 "Trocar número": "নম্বর বদলান",
 "Trocar o certificado": "সার্টিফিকেট বদলান",
 "Trocar o código": "কোড বদলান",
 "Trocar o código?": "কোড বদলাবেন?",
 "Trocar o desenho": "প্যাটার্ন বদলান",
 "Trocar o emoji": "ইমোজি বদলান",
 "Trocar o modelo": "মডেল বদলান",
 "Trocar o número": "নম্বরটি বদলান",
 "Trocar o número do celular": "মোবাইল নম্বর বদলান",
 "Trocar por:": "এর বদলে:",
 "Trocar roupa de cama e toalhas": "বিছানার চাদর ও তোয়ালে বদলান",
 "Tríceps na polia": "ট্রাইসেপস পুশডাউন",
 "Tubo de ensaio": "টেস্ট টিউব",
 "Tudo": "সব",
 "Tudo certo": "সব ঠিক আছে",
 "Tudo em dia por aqui. Lance os gastos do dia a dia para eu enxergar para onde o dinheiro vai.": "এখানে সব ঠিক আছে। প্রতিদিনের খরচ যোগ করুন, যাতে আমি দেখতে পারি টাকা কোথায় যাচ্ছে।",
 "Tudo já fica salvo na sua conta. O arquivo é uma cópia extra que você guarda onde quiser.": "সবকিছু আপনার অ্যাকাউন্টে আগে থেকেই সংরক্ষিত থাকে। ফাইলটি একটি অতিরিক্ত কপি, যা আপনি যেখানে খুশি রাখতে পারেন।",
 "Tudo o que está dentro de \"{nome}\" passa a ser visto pelo grupo, cada pessoa conforme o papel que você escolher (quem entra começa com o papel mais limitado).": "\"{nome}\"-এর ভেতরের সবকিছু গ্রুপের কাছে দৃশ্যমান হবে, প্রত্যেকে আপনার বেছে নেওয়া ভূমিকা অনুযায়ী (নতুনরা সবচেয়ে সীমিত ভূমিকা দিয়ে শুরু করেন)।",
 "Tudo! Já comprei os ingressos.": "সব ঠিক! টিকিটও কিনে ফেলেছি।",
 "Turma": "ক্লাস",
 "Turma (opcional)": "ক্লাস (ঐচ্ছিক)",
 "Turmas": "ক্লাস",
 "Turmas e grupos (aulas, mentoria, treino): alunos, chamada, notas, planos, materiais, cobranças e o seu caderno.": "ক্লাস ও গ্রুপ (পাঠ, মেন্টরিং, ট্রেনিং): শিক্ষার্থী, হাজিরা, নম্বর, পরিকল্পনা, উপকরণ, চার্জ ও আপনার খাতা।",
 "Turmas, alunos, chamada, notas e planos de aula.": "ক্লাস, শিক্ষার্থী, হাজিরা, নম্বর ও পাঠ পরিকল্পনা।",
 "Turmas, pacientes, equipes e convidados": "ক্লাস, রোগী, টিম ও অতিথি",
 "Técnico": "কারিগরি",
 "Título": "শিরোনাম",
 "Título (ex.: Capítulo 3)": "শিরোনাম (যেমন: অধ্যায় ৩)",
 "Título (opcional)": "শিরোনাম (ঐচ্ছিক)",
 "Título da caixa": "বাক্সের শিরোনাম",
 "Título de eleitor": "ভোটার আইডি",
 "Título, autor, assunto e palavras-chave.": "শিরোনাম, লেখক, বিষয় ও কীওয়ার্ড।",
 "Tô chegando": "আসছি",
 "Tônico": "টোনার",
 "UF": "UF",
 "Uau": "বাহ",
 "Uhuul!": "হুররে!",
 "Um PDF novo só com as páginas escolhidas.": "শুধু বেছে নেওয়া পৃষ্ঠা নিয়ে নতুন PDF।",
 "Um texto clarinho na diagonal de todas as páginas.": "সব পৃষ্ঠায় তির্যকভাবে হালকা লেখা।",
 "Uma pasta para cada cliente: vocês trocam documentos nos dois sentidos e cada cliente só vê a pasta dele.": "প্রতিটি ক্লায়েন্টের জন্য একটি ফোল্ডার: দুই দিক থেকেই নথি আদান-প্রদান হয় এবং প্রত্যেক ক্লায়েন্ট শুধু নিজের ফোল্ডার দেখেন।",
 "Uma página por arquivo": "প্রতি ফাইলে এক পৃষ্ঠা",
 "Uma página por arquivo, a cada N páginas ou por faixas.": "প্রতি ফাইলে এক পৃষ্ঠা, প্রতি N পৃষ্ঠায় বা সীমা অনুযায়ী।",
 "Unicórnio": "ইউনিকর্ন",
 "Unidade": "একক",
 "Universal": "সাধারণ",
 "União": "ঐক্য",
 "Usa a conta Google que já está no celular. Nenhuma senha do Google é pedida pelo My Planner.": "ফোনে আগে থেকে থাকা Google অ্যাকাউন্টই ব্যবহার করা হয়। My Planner কখনো আপনার Google পাসওয়ার্ড চায় না।",
 "Usado: {u} · livre: {v} · limite {l}": "ব্যবহৃত: {u} · খালি: {v} · লিমিট {l}",
 "Usar": "ব্যবহার করুন",
 "Usar \"{nome}\"": "\"{nome}\" ব্যবহার করুন",
 "Usar biometria": "বায়োমেট্রিক ব্যবহার করুন",
 "Usar desenho padrão": "প্যাটার্ন ব্যবহার করুন",
 "Usar este celular": "এই ফোন ব্যবহার করুন",
 "Usar este nome": "এই নাম ব্যবহার করুন",
 "Usar modelo: {m}": "টেমপ্লেট ব্যবহার করুন: {m}",
 "Usar no navegador (My Planner Web)": "ব্রাউজারে ব্যবহার করুন (My Planner Web)",
 "Usar o arquivo já anexado ({nome})": "আগে যুক্ত করা ফাইল ব্যবহার করুন ({nome})",
 "Usar o código": "কোড ব্যবহার করুন",
 "Usar senha": "পাসওয়ার্ড ব্যবহার করুন",
 "Usar {ia}": "{ia} ব্যবহার করুন",
 "Use a senha nova da próxima vez que entrar, aqui e no My Planner Web.": "পরের বার প্রবেশের সময়, এখানে ও My Planner Web-এ, নতুন পাসওয়ার্ড ব্যবহার করুন।",
 "Use a senha para desbloquear.": "আনলক করতে পাসওয়ার্ড ব্যবহার করুন।",
 "Use a sua própria IA para ler publicações, documentos e anotações e sugerir agendamentos. Você sempre confirma antes de qualquer coisa entrar no Planner.": "প্রকাশনা, নথি ও নোট পড়তে এবং সময়সূচি প্রস্তাব করতে নিজের AI ব্যবহার করুন। Planner-এ কিছু যোগ হওয়ার আগে আপনি সবসময় নিশ্চিত করবেন।",
 "Use este código ao criar a sua conta e ganhe 10 dias com todas as abas liberadas.": "অ্যাকাউন্ট তৈরির সময় এই কোড ব্যবহার করুন এবং ১০ দিন সব ট্যাব আনলক পান।",
 "Use o extrato em OFX (o mais indicado) ou CSV, baixado no app ou site do seu banco.": "আপনার ব্যাংকের অ্যাপ বা ওয়েবসাইট থেকে ডাউনলোড করা OFX (সবচেয়ে ভালো) বা CSV স্টেটমেন্ট ব্যবহার করুন।",
 "Use o seu planner no computador, sincronizado com o celular.": "কম্পিউটারে আপনার প্ল্যানার ব্যবহার করুন, মোবাইলের সাথে সিঙ্ক করা।",
 "Use um link https do Google Drive, Google Docs, OneDrive ou SharePoint.": "Google Drive, Google Docs, OneDrive বা SharePoint-এর একটি https লিংক ব্যবহার করুন।",
 "Uso": "ব্যবহার",
 "Uso próprio": "নিজের ব্যবহার",
 "VRBO": "VRBO",
 "Vacina": "টিকা",
 "Vacina {nome}: {pet}": "{nome} টিকা: {pet}",
 "Vacina: {nome}": "টিকা: {nome}",
 "Vacinas": "টিকা",
 "Vacinas e remédios dos pets, pet shop e a rotina da escola e da saúde das crianças.": "পোষা প্রাণীর টিকা ও ওষুধ, পেট শপ এবং শিশুদের স্কুল ও স্বাস্থ্যের রুটিন।",
 "Vai na viagem": "ভ্রমণে যাচ্ছেন",
 "Vale até {d}": "{d} পর্যন্ত বৈধ",
 "Vale para Estudos e Documentos. Na nuvem, o arquivo abre em qualquer dispositivo e no My Planner Web (até 15 MB por arquivo).": "পড়াশোনা ও নথি-র জন্য প্রযোজ্য। ক্লাউডে থাকলে ফাইলটি যেকোনো ডিভাইসে এবং My Planner Web-এ খোলা যায় (প্রতি ফাইল 15 MB পর্যন্ত)।",
 "Vale quantos pontos": "কত নম্বরের",
 "Vale só para você. No máximo um aviso a cada 3 minutos por pessoa, mesmo que ela inclua várias coisas.": "শুধু আপনার জন্য প্রযোজ্য। প্রতি ব্যক্তির জন্য প্রতি ৩ মিনিটে সর্বোচ্চ একটি নোটিশ, এমনকি সে একাধিক জিনিস যোগ করলেও।",
 "Vale uma vez, nos primeiros 30 dias da sua conta.": "একবারই কার্যকর, আপনার অ্যাকাউন্টের প্রথম 30 দিনে।",
 "Validade": "মেয়াদ",
 "Validade do certificado A1": "A1 সার্টিফিকেটের মেয়াদ",
 "Validade: {data}": "মেয়াদ: {data}",
 "Valor": "মূল্য",
 "Valor ({m})": "পরিমাণ ({m})",
 "Valor a pagar": "দেয় পরিমাণ",
 "Valor combinado": "নির্ধারিত মূল্য",
 "Valor combinado por atendimento": "প্রতি অ্যাপয়েন্টমেন্টে নির্ধারিত পরিমাণ",
 "Valor da hora": "ঘণ্টাপ্রতি মূল্য",
 "Valor da parcela (1ª)": "কিস্তির পরিমাণ (প্রথম)",
 "Valor da venda": "বিক্রয়মূল্য",
 "Valor de costume": "সাধারণ মূল্য",
 "Valor do atendimento: {v}{pago}.": "চিকিৎসার ফি: {v}{pago}।",
 "Valor emprestado ou financiado": "ধার বা ফাইন্যান্স করা পরিমাণ",
 "Valor final definido pela Google Play ou pela App Store, já na moeda do seu país.": "চূড়ান্ত মূল্য Google Play বা App Store নির্ধারণ করে, আপনার দেশের মুদ্রায়।",
 "Valor maior que o guardado nesta meta.": "অঙ্কটি এই লক্ষ্যে জমানো টাকার চেয়ে বেশি।",
 "Valor padrão da consulta ou sessão": "পরামর্শ বা সেশনের সাধারণ ফি",
 "Valor pago": "পরিশোধিত অর্থ",
 "Valor pago (com multa ou desconto)": "পরিশোধিত পরিমাণ (জরিমানা বা ছাড়সহ)",
 "Valor pago (opcional)": "পরিশোধিত অর্থ (ঐচ্ছিক)",
 "Valor pago: {v}": "পরিশোধিত অর্থ: {v}",
 "Valor que este aluno paga (se for diferente)": "এই শিক্ষার্থী কত দেয় (ভিন্ন হলে)",
 "Valor recebido": "প্রাপ্ত অর্থ",
 "Valor recebido: {v}": "প্রাপ্ত অর্থ: {v}",
 "Valor total da compra": "কেনাকাটার মোট মূল্য",
 "Valores e dados clínicos só aparecem para quem o papel permitir. Você pode desligar quando quiser: os dados continuam com você.": "টাকার পরিমাণ ও ক্লিনিক্যাল ডেটা শুধু তাদেরই দেখায় যাদের ভূমিকা অনুমতি দেয়। যখন খুশি বন্ধ করতে পারেন: ডেটা আপনার কাছেই থাকবে।",
 "Valores para conferir com o seu contador. As regras de dedução mudam a cada ano.": "এই অঙ্কগুলো আপনার হিসাবরক্ষকের সঙ্গে মিলিয়ে নিন। কর-ছাড়ের নিয়ম প্রতি বছর বদলায়।",
 "Vamos conversar pelo My Planner? Me adicione como amigo com o código {codigo} (aba Mensagens > Amigos).": "চলুন My Planner-এ কথা বলি? কোড {codigo} দিয়ে আমাকে বন্ধু হিসেবে যোগ করুন (বার্তা ট্যাব > বন্ধুরা)।",
 "Vaso": "টব",
 "Veja os planos em Ajustes › Compras.": "প্ল্যানগুলো সেটিংস › কেনাকাটা-তে দেখুন।",
 "Vem da aba Empréstimos & Financiamentos": "ঋণ ও ফাইন্যান্সিং ট্যাব থেকে আসে",
 "Vence em {data}.": "{data} তারিখে মেয়াদ শেষ।",
 "Vence em {fim} (data informada na publicação).": "{fim}-এ শেষ (প্রকাশনায় উল্লিখিত তারিখ)।",
 "Vence em {n} dia(s)": "{n} দিনে মেয়াদ শেষ",
 "Vence hoje": "আজ মেয়াদ শেষ",
 "Vence {data}": "শেষ তারিখ {data}",
 "Vencendo": "মেয়াদ শেষ হচ্ছে",
 "Venceu há {n} dia(s)": "{n} দিন আগে মেয়াদ শেষ হয়েছে",
 "Vencidas": "মেয়াদোত্তীর্ণ",
 "Vencidos": "মেয়াদোত্তীর্ণ",
 "Vencimento": "শেষ তারিখ",
 "Vencimento (guias e boletos)": "নির্ধারিত তারিখ (চালান ও boleto)",
 "Vencimento da 1ª parcela": "প্রথম কিস্তির শেষ তারিখ",
 "Vencimentos": "মেয়াদ",
 "Venda": "বিক্রি",
 "Venda/serviço do MEI": "MEI-এর বিক্রি/সেবা",
 "Vendidos": "বিক্রি হয়েছে",
 "Ver": "দেখুন",
 "Ver a lista de membros": "সদস্য তালিকা দেখা",
 "Ver a rota": "রুট দেখুন",
 "Ver arquivos": "ফাইল দেখুন",
 "Ver detalhes do erro": "ত্রুটির বিস্তারিত দেখুন",
 "Ver e editar": "দেখুন ও সম্পাদনা করুন",
 "Ver em Compras": "কেনাকাটায় দেখুন",
 "Ver mais": "আরও দেখুন",
 "Ver mais páginas": "আরও পৃষ্ঠা দেখুন",
 "Ver no My Planner": "My Planner-এ দেখুন",
 "Ver o dia": "দিনটি দেখুন",
 "Ver os feriados do ano": "সারা বছরের ছুটির দিন দেখুন",
 "Ver participantes": "অংশগ্রহণকারী দেখুন",
 "Ver páginas": "পৃষ্ঠা দেখুন",
 "Ver todos": "সব দেখুন",
 "Ver todos ({n})": "সব দেখুন ({n})",
 "Ver {nome}": "{nome} দেখুন",
 "Verificar agora": "এখনই যাচাই করুন",
 "Vermífugo": "কৃমিনাশক",
 "Vermífugo ou remédio": "কৃমিনাশক বা ওষুধ",
 "Vermífugos e remédios": "কৃমিনাশক ও ওষুধ",
 "Verso": "পেছনে",
 "Verso do documento": "নথির পেছনের দিক",
 "Versão do PDF": "PDF ভার্সন",
 "Versão instalada": "ইনস্টল করা সংস্করণ",
 "Versão {versao} disponível": "সংস্করণ {versao} পাওয়া যাচ্ছে",
 "Versão {v}": "সংস্করণ {v}",
 "Veterinário": "পশুচিকিৎসক",
 "Veterinário ou clínica": "পশুচিকিৎসক বা ক্লিনিক",
 "Veículo": "যানবাহন",
 "Veículo e acessórios": "যানবাহন ও আনুষঙ্গিক",
 "Veículos": "যানবাহন",
 "Veículos & Manutenção": "যানবাহন ও রক্ষণাবেক্ষণ",
 "Vi mais um episódio": "আরও একটি পর্ব দেখেছি",
 "Viagem": "ভ্রমণ",
 "Viagens": "ভ্রমণ",
 "Viagens & Lazer": "ভ্রমণ ও অবসর",
 "Viagens e lugares": "ভ্রমণ ও স্থান",
 "Vida noturna": "নাইটলাইফ",
 "Vidros e esquadrias": "কাচ ও দরজা-জানালা",
 "Vigente": "চলমান",
 "Vigentes": "চলমান",
 "Virar": "ঘোরান",
 "Virar a câmera": "ক্যামেরা ঘোরান",
 "Virar tarefa (levar à assistência)": "কাজে পরিণত করুন (সার্ভিস সেন্টারে নিয়ে যান)",
 "Visita domiciliar": "বাড়িতে ভিজিট",
 "Visitados": "ঘোরা হয়েছে",
 "Visto": "দেখা শেষ",
 "Vistoria": "পরিদর্শন",
 "Vistoria: {i}": "পরিদর্শন: {i}",
 "Vistorias": "পরিদর্শন",
 "Visualizar feriados": "ছুটির দিন দেখুন",
 "Vitamina": "ভিটামিন",
 "Vitamina D": "ভিটামিন ডি",
 "Vitaminas, whey, creatina... com a frequência de cada um. O que for de hoje aparece em \"Hoje\" para marcar.": "ভিটামিন, হুয়ে, ক্রিয়েটিন... প্রতিটির পুনরাবৃত্তিসহ। আজকেরগুলো চিহ্নিত করার জন্য \"আজ\"-এ দেখাবে।",
 "Você": "আপনি",
 "Você aceitou os termos em {data}.": "আপনি {data}-এ শর্তাবলি মেনে নিয়েছেন।",
 "Você ainda não tem amigos no app. Adicione pelo código.": "অ্যাপে এখনও আপনার কোনো বন্ধু নেই। কোড দিয়ে যোগ করুন।",
 "Você ainda não tem fichários. Crie um na aba Estudos.": "আপনার এখনো কোনো বাইন্ডার নেই। পড়াশোনা ট্যাবে একটি তৈরি করুন।",
 "Você deixa de ver a conversa, os documentos e as reuniões.": "আপনি আর কথোপকথন, নথি ও মিটিং দেখতে পাবেন না।",
 "Você deve: {v}": "আপনার দেনা: {v}",
 "Você entrou no grupo": "আপনি গ্রুপে যোগ দিয়েছেন",
 "Você entrou no grupo \"{nome}\".": "আপনি \"{nome}\" গ্রুপে যোগ দিয়েছেন।",
 "Você está convidado(a) para: {evento}": "আপনাকে আমন্ত্রণ জানানো হচ্ছে: {evento}",
 "Você foi convidado para o My Planner": "আপনাকে My Planner-এ আমন্ত্রণ জানানো হয়েছে",
 "Você foi convidado para o grupo": "আপনাকে গ্রুপে আমন্ত্রণ জানানো হয়েছে",
 "Você juntou {v} para \"{m}\".": "আপনি \"{m}\"-এর জন্য {v} জমিয়েছেন।",
 "Você já tem todas as abas.": "আপনার কাছে সব ট্যাব আছে।",
 "Você já usou um código de indicação nesta conta.": "এই অ্যাকাউন্টে আপনি ইতিমধ্যে একটি রেফারেল কোড ব্যবহার করেছেন।",
 "Você ligou": "আপনি কল করেছেন",
 "Você mesmo pode apagar a conta a qualquer momento, pelo app no celular ou pelo site:": "আপনি যেকোনো সময় ফোনের অ্যাপ বা ওয়েবসাইট থেকে অ্যাকাউন্ট মুছতে পারেন:",
 "Você não tem permissão para isso neste grupo.": "এই গ্রুপে আপনার এটি করার অনুমতি নেই।",
 "Você não vê os outros membros deste grupo.": "আপনি এই গ্রুপের অন্য সদস্যদের দেখতে পারবেন না।",
 "Você pode apagar a conta a qualquer momento em Ajustes > Segurança. Isso apaga para sempre os dados na nuvem e no dispositivo.": "সেটিংস > নিরাপত্তা থেকে যেকোনো সময় অ্যাকাউন্ট মুছে ফেলতে পারেন। এতে ক্লাউড ও ডিভাইসের ডেটা চিরতরে মুছে যায়।",
 "Você pode: confirmar se tratamos seus dados, acessar, corrigir, pedir a portabilidade (exportar o arquivo em Ajustes > Configuração geral), pedir a exclusão, saber com quem compartilhamos, revogar o consentimento e reclamar na ANPD.": "আপনি পারেন: আমরা আপনার ডেটা প্রক্রিয়া করি কি না নিশ্চিত হতে, তা দেখতে, সংশোধন করতে, পোর্টেবিলিটি চাইতে (সেটিংস > সাধারণ সেটিংস থেকে ফাইল এক্সপোর্ট করে), মুছে ফেলার অনুরোধ করতে, আমরা কার সঙ্গে শেয়ার করি জানতে, সম্মতি প্রত্যাহার করতে এবং ANPD-তে অভিযোগ করতে।",
 "Você recebe (líquido)": "আপনি পান (নিট)",
 "Você é responsável pela sua senha e pelo que é feito na sua conta. Use dados verdadeiros no cadastro.": "আপনার পাসওয়ার্ড এবং আপনার অ্যাকাউন্টে যা করা হয় তার দায় আপনার। নিবন্ধনে সত্য তথ্য দিন।",
 "Volta": "ফেরা",
 "Volta ou check-out": "ফেরা বা চেক-আউট",
 "Volta às {hora}": "{hora}-এ ফিরবেন",
 "Voltar": "ফিরে যান",
 "Voltar ao cardápio da semana neste dia": "এই দিনে সপ্তাহের মেনুতে ফিরুন",
 "Voltar ao cálculo": "হিসাবে ফিরে যান",
 "Voltar ao foco": "মনোযোগে ফিরে যান",
 "Voltar ao padrão": "ডিফল্টে ফিরুন",
 "Voltar ao planejado": "পরিকল্পনায় ফিরুন",
 "Voltar para Anotações": "নোটে ফিরে যান",
 "Voltar para as cores do My Planner": "My Planner-এর রঙে ফিরে যান",
 "Voltar para novas": "নতুনগুলোতে ফিরে যান",
 "Voltar para o QR Code": "QR Code-এ ফিরে যান",
 "Volte para o app My Planner no celular. A tela de Ajustes atualiza sozinha.": "ফোনে My Planner অ্যাপে ফিরে যান। সেটিংস স্ক্রিন নিজে থেকেই আপডেট হবে।",
 "Voo": "ফ্লাইট",
 "Voos, hotéis, carro e passeios num lugar só, com o código e o comprovante.": "ফ্লাইট, হোটেল, গাড়ি ও ঘোরাঘুরি এক জায়গায়, কোড ও রসিদসহ।",
 "Vá em Ajustes e toque em \"Conectar navegador\".": "সেটিংসে গিয়ে \"ব্রাউজার সংযুক্ত করুন\" ট্যাপ করুন।",
 "Vá em Ajustes › Configuração geral e toque em \"Conectar navegador\".": "সেটিংস › সাধারণ সেটিংস-এ গিয়ে \"ব্রাউজার সংযুক্ত করুন\" ট্যাপ করুন।",
 "Várias páginas por folha": "প্রতি শিটে একাধিক পৃষ্ঠা",
 "Vários PDFs num só, na ordem que você escolher.": "একাধিক PDF একটিতে, আপনার বাছাই করা ক্রমে।",
 "Vê as aulas e os materiais liberados.": "প্রকাশিত ক্লাস ও উপকরণ দেখেন।",
 "Vê as etapas e registra o diário.": "ধাপগুলো দেখেন এবং ডায়েরিতে লেখেন।",
 "Vê e altera tudo, inclusive os valores.": "টাকার পরিমাণসহ সবকিছু দেখেন ও পরিবর্তন করেন।",
 "Vê e envia os documentos da própria pasta e responde aos pedidos.": "নিজের ফোল্ডারের নথি দেখেন ও পাঠান, এবং অনুরোধের উত্তর দেন।",
 "Vê o andamento, sem os valores e sem alterar.": "অগ্রগতি দেখেন, টাকার পরিমাণ ছাড়া ও পরিবর্তন ছাড়া।",
 "Vê os check-ins e check-outs e marca a limpeza feita, sem valores.": "চেক-ইন ও চেক-আউট দেখেন এবং পরিষ্কার শেষ হলে চিহ্নিত করেন, টাকার পরিমাণ ছাড়া।",
 "Vê tudo e lança gastos, lugares, roteiro e mala.": "সবকিছু দেখেন এবং খরচ, জায়গা, ভ্রমণসূচি ও লাগেজ যোগ করেন।",
 "Vê tudo, inclui, edita, comenta e põe fotos. Só não coloca nem tira pessoas do grupo.": "সবকিছু দেখে, যোগ করে, সম্পাদনা করে, মন্তব্য করে ও ছবি দেয়। শুধু গ্রুপে লোক যোগ বা সরাতে পারে না।",
 "Vê tudo, inclusive os valores, sem alterar.": "টাকার পরিমাণসহ সবকিছু দেখেন, পরিবর্তন ছাড়া।",
 "Vídeo": "ভিডিও",
 "Vínculo": "লিংক",
 "Vínculo perdido": "লিংক হারিয়ে গেছে",
 "WhatsApp da assistência": "সার্ভিস সেন্টারের WhatsApp",
 "Whey": "হুয়ে প্রোটিন",
 "Wi-Fi (rede e senha)": "Wi-Fi (নেটওয়ার্ক ও পাসওয়ার্ড)",
 "Yoga": "যোগব্যায়াম",
 "Zumbi e Consciência Negra": "Zumbi ও কৃষ্ণাঙ্গ চেতনা দিবস",
 "Zzz": "Zzz",
 "a cada {n} dias": "প্রতি {n} দিনে",
 "a pagar": "দেয়",
 "a receber": "পাওনা",
 "a receber {v}": "পাওনা {v}",
 "a reserva": "বুকিং",
 "a última execução falhou; avise o suporte": "শেষ রানটি ব্যর্থ হয়েছে; সাপোর্টকে জানান",
 "abr": "এপ্রি",
 "abril": "এপ্রিল",
 "acabou": "শেষ",
 "achatado": "ফ্ল্যাট",
 "administra": "অ্যাডমিন",
 "ago": "আগ",
 "agosto": "আগস্ট",
 "ajustado": "সমন্বিত",
 "algo novo": "নতুন কিছু",
 "alterou": "পরিবর্তন করেছেন",
 "amanhã": "আগামীকাল",
 "anual": "বার্ষিক",
 "apagou": "মুছেছেন",
 "aplicada em {d}": "{d} তারিখে দেওয়া",
 "app {v} · atualização {p} de {data}": "অ্যাপ {v} · আপডেট {p}, {data}",
 "assinado": "স্বাক্ষরিত",
 "atrasada": "বিলম্বিত",
 "atrasada há {n} dia(s)": "{n} দিন বিলম্বিত",
 "até": "পর্যন্ত",
 "até {data}": "{data} পর্যন্ত",
 "até {d}": "{d} পর্যন্ত",
 "aula {a} de {n}": "ক্লাস {a} / {n}",
 "avisos silenciados": "বিজ্ঞপ্তি মিউট",
 "caixa": "বাক্স",
 "colher(es)": "চামচ",
 "coluna": "কলাম",
 "com anexos": "সংযুক্তিসহ",
 "com imagem": "ছবিসহ",
 "com tarjas": "দাগসহ",
 "com texto": "লেখাসহ",
 "com {p}": "{p}-এর কাছে",
 "como planejado": "পরিকল্পনা অনুযায়ী",
 "comprado em {data}": "{data}-এ কেনা",
 "comprado em {d} por {v}": "{d} তারিখে {v}-এ কেনা",
 "comprimido": "কম্প্রেসড",
 "comprovante": "প্রমাণপত্র",
 "concha(s)": "হাতা",
 "confirmados": "নিশ্চিত",
 "consulta recusada": "অনুসন্ধান প্রত্যাখ্যাত",
 "contratado": "চুক্তিবদ্ধ",
 "contínuo": "নিয়মিত",
 "copo(s)": "গ্লাস",
 "corridos": "ক্যালেন্ডার দিবস",
 "criou o grupo": "গ্রুপ তৈরি করেছেন",
 "de": "/",
 "de Anotações": "নোট থেকে",
 "de {meta} passos": "{meta} ধাপের মধ্যে",
 "de {n}": "/ {n}",
 "de {p}": "{p}-এর কাছ থেকে",
 "dentro / fora do planejado": "পরিকল্পনা অনুযায়ী / পরিকল্পনার বাইরে",
 "desconto {v}": "ছাড় {v}",
 "desfazer": "ফিরিয়ে নিন",
 "destino": "গন্তব্য",
 "deve {v}": "দেনা {v}",
 "devolvido em {d}": "{d} তারিখে ফেরত",
 "dez": "ডিসে",
 "dezembro": "ডিসেম্বর",
 "dia": "দিন",
 "dias": "দিন",
 "dias com a meta batida": "লক্ষ্য পূরণের দিন",
 "dias com a meta de passos": "ধাপের লক্ষ্য পূরণের দিন",
 "digital": "আঙুলের ছাপ",
 "diária média": "গড় প্রতি রাতের ভাড়া",
 "do cliente": "ক্লায়েন্টের",
 "do escritório": "অফিসের",
 "dom": "রবি",
 "domingo": "রবিবার",
 "e mais {n}": "এবং আরও {n}টি",
 "em aberto": "বাকি",
 "em atraso": "মেয়াদোত্তীর্ণ",
 "em {n} dias": "{n} দিনের মধ্যে",
 "emitida": "ইস্যু করা",
 "entregue": "জমা দেওয়া",
 "entrou no escritório": "অফিসে যোগ দিয়েছেন",
 "enviado": "পাঠানো হয়েছে",
 "escaneado": "স্ক্যান",
 "escolha": "বেছে নিন",
 "este": "এটি",
 "este dispositivo": "এই ডিভাইস",
 "este item": "এই আইটেম",
 "exercícios concluídos": "সম্পন্ন ব্যায়াম",
 "falta {v}": "বাকি {v}",
 "faltam {km}": "আর {km} বাকি",
 "fatia(s)": "স্লাইস",
 "faturamento": "মোট আয়",
 "feita em {d}": "{d} তারিখে সম্পন্ন",
 "feito {dur}": "সম্পন্ন {dur}",
 "fev": "ফেব্রু",
 "fevereiro": "ফেব্রুয়ারি",
 "frequência {p}%": "উপস্থিতি {p}%",
 "gasto {v}": "খরচ {v}",
 "girado": "ঘোরানো",
 "guardado": "সংরক্ষিত",
 "higienizado": "পরিষ্কৃত",
 "hoje": "আজ",
 "hora fixa no dia": "দিনের নির্দিষ্ট সময়",
 "há {n} dias": "{n} দিন আগে",
 "iPhone ou computador: {link}": "iPhone বা কম্পিউটার: {link}",
 "incluiu": "যোগ করেছেন",
 "jan": "জানু",
 "janeiro": "জানুয়ারি",
 "jul": "জুলাই",
 "julho": "জুলাই",
 "jun": "জুন",
 "junho": "জুন",
 "já importado": "আগেই ইমপোর্ট করা",
 "liberar em {d}": "{d}-এ খুলবে",
 "ligou o compartilhamento": "শেয়ারিং চালু করেছেন",
 "linha": "সারি",
 "lucro líquido": "নিট লাভ",
 "mai": "মে",
 "maio": "মে",
 "mar": "মার্চ",
 "marca d'água": "ওয়াটারমার্ক",
 "marcada por {nome}": "{nome} ঠিক করেছেন",
 "março": "মার্চ",
 "menos de 1 ano": "১ বছরের কম",
 "mensalidade": "মাসিক ফি",
 "meta batida!": "লক্ষ্য পূরণ!",
 "metadados": "মেটাডেটা",
 "min": "মিনিট",
 "min antes": "মিনিট আগে",
 "min antes do início": "মিনিট শুরুর আগে",
 "min · {de} às {ate}": "মিনিট · {de} থেকে {ate}",
 "multa e juros {v}": "জরিমানা ও সুদ {v}",
 "média {m}": "গড় {m}",
 "mês(es)": "মাস",
 "na nuvem": "ক্লাউডে",
 "na pasta \"{pasta}\"": "\"{pasta}\" ফোল্ডারে",
 "na pasta escolhida": "বেছে নেওয়া ফোল্ডারে",
 "neste dispositivo": "এই ডিভাইসে",
 "neste celular": "এই ফোনে",
 "no Planner": "Planner-এ আছে",
 "no {nome}": "{nome}-এ",
 "nos próximos dias": "আগামী কয়েক দিনে",
 "nov": "নভে",
 "novembro": "নভেম্বর",
 "numerado": "নম্বরযুক্ত",
 "nunca verificado": "কখনো যাচাই হয়নি",
 "não vão": "আসবেন না",
 "o documento mudou depois disso: guarde de novo": "এরপর নথি বদলেছে: আবার সেভ করুন",
 "ocupação": "অকুপেন্সি",
 "ontem": "গতকাল",
 "organizado": "সাজানো",
 "orçando": "দরদাম চলছে",
 "out": "অক্টো",
 "outubro": "অক্টোবর",
 "paga": "পরিশোধিত",
 "paga em {d}": "{d}-এ পরিশোধিত",
 "pago": "পরিশোধিত",
 "pago em {d}": "{d}-এ পরিশোধিত",
 "pago por {p}": "{p} পরিশোধ করেছেন",
 "pagou {v}": "{v} দিয়েছেন",
 "parcela {a} de {n}": "{n}টির মধ্যে কিস্তি {a}",
 "parece já lançado": "মনে হয় আগেই যোগ করা",
 "parte {n}": "অংশ {n}",
 "passos por dia (média)": "দৈনিক ধাপ (গড়)",
 "passou {km}": "{km} পেরিয়ে গেছে",
 "pausa {p}": "বিশ্রাম {p}",
 "pausado": "বিরতিতে",
 "peso {n}": "ওজন {n}",
 "pesquisável": "খোঁজার যোগ্য",
 "por dia": "প্রতিদিন",
 "por dia (média)": "দৈনিক (গড়)",
 "por dia disponível": "প্রতি উপলব্ধ দিনে",
 "por semana": "প্রতি সপ্তাহে",
 "por {p}": "{p}-এর দেওয়া",
 "porção(ões)": "ভাগ",
 "preenchido": "পূরণকৃত",
 "primeira às {hora}: {tarefa}": "প্রথমটি {hora}-এ: {tarefa}",
 "produção": "প্রোডাকশন",
 "próxima em {data}": "পরবর্তী {data}",
 "próxima rega {d}": "পরের পানি {d}",
 "publicação": "প্রকাশনা",
 "página de estudo": "পড়ার পাতা",
 "página única": "একক পৃষ্ঠা",
 "páginas": "পৃষ্ঠা",
 "páginas {p}": "পৃষ্ঠা {p}",
 "qua": "বুধ",
 "quarta": "বুধবার",
 "quarta-feira": "বুধবার",
 "qui": "বৃহঃ",
 "quinta": "বৃহস্পতিবার",
 "quinta-feira": "বৃহস্পতিবার",
 "quitada": "পরিশোধ সম্পন্ন",
 "recebe {v}": "পাবেন {v}",
 "recebida": "প্রাপ্ত",
 "reconhecimento facial": "মুখ শনাক্তকরণ",
 "recortado": "কাটা",
 "refeições feitas": "খাওয়া হয়েছে এমন খাবার",
 "rega a cada {n} dias": "প্রতি {n} দিনে পানি",
 "regar hoje": "আজ পানি দিন",
 "reparado": "মেরামত করা",
 "retorno {d}": "ফলো-আপ {d}",
 "saldo {v}": "অবশিষ্ট {v}",
 "seg": "সোম",
 "segunda": "সোমবার",
 "segunda-feira": "সোমবার",
 "sem anotações": "টীকা ছাড়া",
 "sem as páginas {p}": "পৃষ্ঠা {p} ছাড়া",
 "sem cliente": "ক্লায়েন্ট নেই",
 "sem dias previstos": "কোনো নির্ধারিত দিন নেই",
 "sem horário": "সময় নেই",
 "sem meta": "লক্ষ্য নেই",
 "sem resposta": "উত্তর নেই",
 "sem tempo": "সময় নেই",
 "semana(s)": "সপ্তাহ",
 "set": "সেপ্টে",
 "setembro": "সেপ্টেম্বর",
 "seu@email.com": "apni@email.com",
 "sex": "শুক্র",
 "sexta": "শুক্রবার",
 "sexta-feira": "শুক্রবার",
 "sáb": "শনি",
 "sábado": "শনিবার",
 "talvez": "হয়তো",
 "tarefa da casa": "ঘরের কাজ",
 "tarefa: {t}": "কাজ: {t}",
 "taxas e despesas": "ফি ও খরচ",
 "ter": "মঙ্গল",
 "termina em {d}": "{d} তারিখে শেষ",
 "terça": "মঙ্গলবার",
 "terça-feira": "মঙ্গলবার",
 "teste": "পরীক্ষা",
 "todas": "সব",
 "todo ano em {d}": "প্রতি বছর {d}",
 "todo dia {d}": "প্রতি মাসের {d} তারিখ",
 "todos": "সবাই",
 "toque para abrir": "খুলতে ট্যাপ করুন",
 "toque para pausar": "বিরতি দিতে ট্যাপ করুন",
 "toque para ver o contato": "কন্টাক্ট দেখতে ট্যাপ করুন",
 "toque para voltar a hoje": "আজে ফিরতে ট্যাপ করুন",
 "treinos concluídos": "সম্পন্ন ওয়ার্কআউট",
 "uma vez em {d}": "একবার, {d}",
 "unidade(s)": "পিস",
 "vale {n}": "{n} নম্বরের",
 "vence em {n} dias": "{n} দিনে মেয়াদ শেষ",
 "vence {d}": "মেয়াদ {d}",
 "venceu em {data}": "{data}-এ মেয়াদ শেষ হয়েছে",
 "vencido": "মেয়াদোত্তীর্ণ",
 "vendido com ganho de {v}": "{v} লাভে বিক্রি",
 "vendido com perda de {v}": "{v} লোকসানে বিক্রি",
 "verificado {quando}": "যাচাই করা হয়েছে {quando}",
 "você": "আপনি",
 "você administra": "আপনি অ্যাডমিন",
 "xícara(s)": "কাপ",
 "{aba} bloqueada": "{aba} লক করা",
 "{aba} está bloqueada": "{aba} লক করা আছে",
 "{aba}, em \"Anotações recebidas\"": "{aba}, \"প্রাপ্ত নোট\"-এ",
 "{a} aula(s) feita(s)": "{a}টি ক্লাস সম্পন্ন",
 "{a} de {n} aulas": "{n}টির মধ্যে {a}টি ক্লাস",
 "{c} chegou a {p}% do orçamento ({g} de {l}).": "{c} বাজেটের {p}%-এ পৌঁছেছে ({l}-এর মধ্যে {g})।",
 "{c} confirmados de {n} convidados": "{n} অতিথির মধ্যে {c} জন নিশ্চিত",
 "{c} está em {p}% do orçamento do mês. Ainda faltam {dias} dia(s) para o mês acabar.": "{c} এই মাসের বাজেটের {p}%-এ আছে। মাস শেষ হতে এখনো {dias} দিন বাকি।",
 "{c} já está {v} acima do mês passado inteiro. Confira se foi algo fora do comum.": "{c} ইতিমধ্যে গত পুরো মাসের চেয়ে {v} বেশি। অস্বাভাবিক কিছু হয়েছে কিনা দেখে নিন।",
 "{c} já passou do orçamento: {g} de {l}. Segure esse gasto até o mês virar.": "{c} ইতিমধ্যে বাজেট ছাড়িয়েছে: {l}-এর মধ্যে {g}। মাস বদলানো পর্যন্ত এই খরচ থামিয়ে রাখুন।",
 "{c} passou do orçamento: {g} de {l}.": "{c} বাজেট ছাড়িয়েছে: {l}-এর মধ্যে {g}।",
 "{de} paga {v} para {para}": "{de} {para}-কে {v} দেবেন",
 "{de} às {ate}": "{de} থেকে {ate}",
 "{dia}, {d} de {mes} de {a}": "{dia}, {d} {mes} {a}",
 "{dia}, {d} {mes}": "{dia}, {d} {mes}",
 "{dia}, {d}/{m}": "{dia}, {d}/{m}",
 "{dur} na semana": "সপ্তাহে {dur}",
 "{dur} registrados": "{dur} রেকর্ড হয়েছে",
 "{d}/{n} notas": "{d}/{n} নম্বর",
 "{feito} de {meta}": "{meta}-এর মধ্যে {feito}",
 "{fonte} · {data}": "{fonte} · {data}",
 "{f} de {n} feitas": "{n}টির মধ্যে {f}টি সম্পন্ন",
 "{f}/{n} transferências feitas": "{f}/{n} স্থানান্তর সম্পন্ন",
 "{hora} em {fuso}": "{fuso}-এ {hora}",
 "{h} este mês": "এই মাসে {h}",
 "{h} h": "{h} ঘ.",
 "{h} h {m} min": "{h} ঘ. {m} মি.",
 "{h} no seu relógio": "আপনার ঘড়িতে {h}",
 "{ia} conectado. {n} modelo(s) disponível(is) na sua conta.": "{ia} সংযুক্ত। আপনার অ্যাকাউন্টে {n}টি মডেল উপলব্ধ।",
 "{ia}: chave de API inválida ou sem permissão.": "{ia}: API কী অবৈধ বা অনুমতি নেই।",
 "{ia}: limite de uso atingido. Confira o saldo ou o limite da sua conta de API.": "{ia}: ব্যবহারের সীমা পূর্ণ হয়েছে। আপনার API অ্যাকাউন্টের ব্যালান্স বা সীমা দেখুন।",
 "{item}: em {n} dias ({data}).": "{item}: {n} দিনের মধ্যে ({data})।",
 "{item}: hoje ({data}).": "{item}: আজ ({data})।",
 "{item}: termina em {n} dias ({data}).": "{item}: {n} দিনে শেষ হবে ({data})।",
 "{item}: vence em {n} dias ({data}).": "{item}: {n} দিনে মেয়াদ শেষ ({data})।",
 "{item}: vence hoje ({data}).": "{item}: আজ মেয়াদ শেষ ({data})।",
 "{item}: venceu em {data} e ainda não foi marcado como feito.": "{item}: {data}-এ মেয়াদ শেষ হয়েছে, এখনো সম্পন্ন চিহ্নিত হয়নি।",
 "{livre} livres de {total}": "{total}-এর মধ্যে {livre} খালি",
 "{m} min": "{m} মিনিট",
 "{nome} agora é seu amigo. Já podem conversar.": "{nome} এখন আপনার বন্ধু। আপনারা চ্যাট করতে পারেন।",
 "{nome} conectado!": "{nome} সংযুক্ত হয়েছে!",
 "{nome} ligou": "{nome} কল করেছেন",
 "{novas} nova(s), {atualizadas} atualizada(s), {enviadas} enviada(s), {removidas} removida(s)": "{novas}টি নতুন, {atualizadas}টি আপডেট, {enviadas}টি পাঠানো, {removidas}টি সরানো",
 "{n} ITEM(NS)": "{n}টি আইটেম",
 "{n} aba(s) no seu plano · cores e opções de cada uma": "আপনার প্ল্যানে {n}টি ট্যাব · প্রতিটির রং ও বিকল্প",
 "{n} aba(s) para comprar": "কেনার জন্য {n}টি ট্যাব",
 "{n} adicionada(s)": "{n} জন যোগ হয়েছে",
 "{n} alerta(s) agendado(s) neste celular para os próximos dias.": "আগামী দিনগুলোর জন্য এই মোবাইলে {n}টি সতর্কবার্তা নির্ধারিত আছে।",
 "{n} aluno(s)": "{n} জন শিক্ষার্থী",
 "{n} anexo(s)": "{n}টি সংযুক্তি",
 "{n} ano(s)": "{n} বছর",
 "{n} arquivo(s)": "{n}টি ফাইল",
 "{n} atendimento(s)": "{n}টি অ্যাপয়েন্টমেন্ট",
 "{n} atrasada(s)": "{n}টি বিলম্বিত",
 "{n} atrasado(s)": "{n}টি বিলম্বিত",
 "{n} caixa(s)": "{n}টি বাক্স",
 "{n} caixa(s) frágil(eis)": "{n}টি ভঙ্গুর বাক্স",
 "{n} caixa(s) · {a} já aberta(s) na casa nova": "{n}টি বাক্স · {a}টি নতুন বাড়িতে খোলা হয়েছে",
 "{n} cancelada(s).": "{n}টি বাতিল হয়েছে।",
 "{n} cartão(ões) abertos": "{n}টি খোলা কার্ড",
 "{n} cobrança(s) criada(s) com vencimento em {d}.": "{d} শেষ তারিখসহ {n}টি চার্জ তৈরি হয়েছে।",
 "{n} com vencimento": "{n}টি নির্ধারিত তারিখসহ",
 "{n} compra(s) no cartão {c}. As parcelas futuras já aparecem nas próximas faturas.": "কার্ড {c}-এ {n}টি কেনাকাটা। ভবিষ্যতের কিস্তিগুলো পরের কার্ড বিলে দেখা যাচ্ছে।",
 "{n} conta(s) marcada(s) como paga(s) automaticamente.": "{n}টি বিল স্বয়ংক্রিয়ভাবে পরিশোধিত হিসেবে চিহ্নিত হয়েছে।",
 "{n} copo(s), {ml} de {meta}": "{n} গ্লাস, {meta}-এর মধ্যে {ml}",
 "{n} de {meta} copos": "{meta} গ্লাসের মধ্যে {n}",
 "{n} de {total}": "{total}-এর মধ্যে {n}",
 "{n} de {total} dias": "{total} দিনের মধ্যে {n} দিন",
 "{n} de {total} hoje": "আজ {total}-এর মধ্যে {n}",
 "{n} de {t} item(ns) com preço, dos cupons lidos em Finanças.": "অর্থায়নে পড়া রসিদ থেকে {t}টির মধ্যে {n}টি আইটেমের দাম আছে।",
 "{n} dia(s)": "{n} দিন",
 "{n} dia(s) seguido(s) lendo": "টানা {n} দিন পড়ছেন",
 "{n} dia(s) tirado(s) de tarefas que se repetem": "পুনরাবৃত্ত কাজ থেকে {n} দিন সরানো হয়েছে",
 "{n} dias": "{n} দিন",
 "{n} dias grátis": "{n} দিন বিনামূল্যে",
 "{n} dias grátis para testar": "ব্যবহার করে দেখতে {n} দিন বিনামূল্যে",
 "{n} dias {tipo}: publicada em {pub}, contagem a partir de {ini}, vence em {fim}.": "{n} দিন ({tipo}): {pub}-এ প্রকাশিত, গণনা {ini} থেকে, শেষ {fim}-এ।",
 "{n} documento(s)": "{n}টি নথি",
 "{n} em atraso": "{n}টি বকেয়া",
 "{n} etapa(s) atrasada(s)": "{n}টি ধাপ পিছিয়ে",
 "{n} exclusão(ões) esperando o celular sincronizar.": "{n}টি মুছে ফেলা ফোন সিঙ্ক হওয়ার অপেক্ষায় আছে।",
 "{n} falta(s)": "{n}টি অনুপস্থিতি",
 "{n} ficha(s) no grupo. Escolha o papel de cada pessoa em Membros.": "গ্রুপে {n}টি রেকর্ড। সদস্য-এ প্রত্যেকের ভূমিকা বেছে নিন।",
 "{n} foto(s) e vídeo(s) da viagem, de todos do grupo. Fotos do roteiro, dos lugares e das reservas também aparecem aqui.": "গ্রুপের সবার দেওয়া ভ্রমণের {n}টি ছবি ও ভিডিও। ভ্রমণসূচি, জায়গা ও বুকিংয়ের ছবিও এখানে দেখা যায়।",
 "{n} item(ns) adicionado(s).": "{n}টি জিনিস যোগ হয়েছে।",
 "{n} item(ns) com outras pessoas": "{n}টি জিনিস অন্যদের কাছে",
 "{n} item(ns) no Planner.": "Planner-এ {n}টি আইটেম।",
 "{n} lançamento(s) encontrado(s)": "{n}টি এন্ট্রি পাওয়া গেছে",
 "{n} lançamento(s) novo(s).": "{n}টি নতুন এন্ট্রি।",
 "{n} lembrete(s) colocado(s) no My Planner.": "My Planner-এ {n}টি রিমাইন্ডার যোগ হয়েছে।",
 "{n} livro(s) lido(s) este ano": "এই বছর {n}টি বই পড়া হয়েছে",
 "{n} marcado(s)": "{n}টি চিহ্নিত",
 "{n} matéria(s)": "{n}টি বিষয়",
 "{n} membro(s) · abrir a conversa do grupo": "{n} জন সদস্য · গ্রুপ চ্যাট খুলুন",
 "{n} meses grátis a partir da criação da conta; depois {preco} por ano.": "অ্যাকাউন্ট তৈরির পর থেকে {n} মাস বিনামূল্যে; তারপর বছরে {preco}।",
 "{n} min": "{n} মিনিট",
 "{n} min antes": "{n} মিনিট আগে",
 "{n} módulo(s)": "{n}টি মডিউল",
 "{n} noite(s)": "{n} রাত",
 "{n} nota(s) nova(s).": "{n}টি নতুন ইনভয়েস।",
 "{n} nota(s) sem XML neste dispositivo ficaram de fora.": "এই ডিভাইসে XML ছাড়া {n}টি ইনভয়েস বাদ পড়েছে।",
 "{n} nota(s) · emitidas {e} · recebidas {r}": "{n}টি ইনভয়েস · ইস্যু {e} · প্রাপ্ত {r}",
 "{n} nova(s)": "{n}টি নতুন",
 "{n} novo(s) do cliente": "ক্লায়েন্টের {n}টি নতুন",
 "{n} novo(s) para aceitar, editar ou recusar.": "{n}টি নতুন: গ্রহণ, সম্পাদনা বা প্রত্যাখ্যান করুন।",
 "{n} parcela(s) colocada(s) no My Planner.": "{n}টি কিস্তি My Planner-এ যোগ হয়েছে।",
 "{n} parcela(s) em aberto refeitas. As pagas ficaram como estavam.": "{n}টি বাকি কিস্তি আবার তৈরি হয়েছে। পরিশোধিতগুলো আগের মতোই আছে।",
 "{n} parcela(s) em atraso": "{n}টি কিস্তি বকেয়া",
 "{n} parcela(s) em atraso: {v}": "{n}টি কিস্তি বকেয়া: {v}",
 "{n} participantes · toque para ver": "{n} জন অংশগ্রহণকারী · দেখতে ট্যাপ করুন",
 "{n} passo(s)": "{n}টি ধাপ",
 "{n} pausa(s)": "{n}টি বিরতি",
 "{n} pedido(s) de amizade": "{n}টি বন্ধুত্বের অনুরোধ",
 "{n} pedido(s) em aberto": "{n}টি খোলা অনুরোধ",
 "{n} pessoa(s)": "{n} জন",
 "{n} pessoa(s) já entraram com o seu código.": "{n} জন আপনার কোড দিয়ে যোগ দিয়েছেন।",
 "{n} pessoas": "{n} জন",
 "{n} por folha": "প্রতি শিটে {n}",
 "{n} porções": "{n} জনের পরিবেশন",
 "{n} publicação(ões) nova(s).": "{n}টি নতুন প্রকাশনা।",
 "{n} publicações novas": "{n}টি নতুন প্রকাশনা",
 "{n} página(s)": "{n}টি পৃষ্ঠা",
 "{n} página(s) · {r} revisada(s)": "{n}টি পৃষ্ঠা · {r}টি রিভিশন হয়েছে",
 "{n} páginas": "{n} পৃষ্ঠা",
 "{n} recebido(s) dos seus grupos": "আপনার গ্রুপগুলো থেকে {n}টি প্রাপ্ত",
 "{n} recebido(s) para responder": "উত্তরের অপেক্ষায় {n}টি",
 "{n} refeição(ões), com o cardápio daquele dia": "{n}টি খাবার, সেই দিনের মেনুসহ",
 "{n} reserva(s) nova(s) ou alterada(s).": "{n}টি নতুন বা পরিবর্তিত বুকিং।",
 "{n} resultado(s) em todas as publicações": "সব প্রকাশনায় {n}টি ফলাফল",
 "{n} selecionado(s): {lista}": "{n}টি নির্বাচিত: {lista}",
 "{n} tarefa(s)": "{n}টি কাজ",
 "{n} tarefa(s) apagada(s) por inteiro": "{n}টি কাজ সম্পূর্ণ মুছে ফেলা হয়েছে",
 "{n} tarefa(s) criada(s)": "{n}টি কাজ তৈরি হয়েছে",
 "{n} tarefa(s) da casa saíram do My Planner e agora ficam só em Minha Casa. Para levar uma delas ao Planner, abra a tarefa e toque em \"Enviar para o My Planner\".": "{n}টি ঘরের কাজ My Planner থেকে সরে এখন শুধু আমার বাড়িতে আছে। কোনোটি Planner-এ নিতে কাজটি খুলে \"My Planner-এ পাঠান\" ট্যাপ করুন।",
 "{n} tarefa(s) de ontem sem concluir": "গতকালের {n}টি কাজ অসম্পূর্ণ",
 "{n} tarefa(s) dos últimos dias sem concluir": "গত কয়েক দিনের {n}টি কাজ অসম্পূর্ণ",
 "{n} tarefa(s) hoje": "আজ {n}টি কাজ",
 "{n} tarefa(s) pendente(s) vão para a lista de hoje.": "{n}টি বাকি কাজ আজকের তালিকায় যাবে।",
 "{n} tarjas no documento": "নথিতে {n}টি কালো দাগ",
 "{n} treino(s), cada um nos dias dele": "{n}টি ওয়ার্কআউট, প্রতিটি নিজের দিনগুলোতে",
 "{n} tribunais": "{n}টি আদালত",
 "{n}x de {v}": "{n}x {v}",
 "{n}º alerta": "{n}তম অ্যালার্ট",
 "{n}× {item}": "{n}× {item}",
 "{ok} enviado(s), {falhas} com erro. Tente de novo mais tarde.": "{ok}টি পাঠানো হয়েছে, {falhas}টিতে ত্রুটি। পরে আবার চেষ্টা করুন।",
 "{ok} enviado(s).": "{ok}টি পাঠানো হয়েছে।",
 "{o} de {d} noites ocupadas. Reservas que passam de um mês para outro são divididas pelas noites.": "{d} রাতের মধ্যে {o} রাত ভরা। এক মাস থেকে অন্য মাসে যাওয়া বুকিং রাত অনুযায়ী ভাগ করা হয়।",
 "{preco} por ano": "বছরে {preco}",
 "{p} de {t} parcelas pagas ({pct}%)": "{t}টির মধ্যে {p}টি কিস্তি পরিশোধিত ({pct}%)",
 "{p} presentes · {f} faltas": "{p} উপস্থিত · {f} অনুপস্থিত",
 "{p}% da meta de {m} páginas": "{m} পৃষ্ঠার লক্ষ্যের {p}%",
 "{p}% feito": "{p}% সম্পন্ন",
 "{p}% ocupado no mês": "মাসে {p}% ভরা",
 "{p}% pronta": "{p}% প্রস্তুত",
 "{p}/{t} pagas": "{p}/{t} পরিশোধিত",
 "{quem} convidou você para o grupo \"{grupo}\" no My Planner. Toque no link para entrar (o app é gratuito para começar): {link}\nCódigo do convite: {codigo}": "{quem} আপনাকে My Planner-এ \"{grupo}\" গ্রুপে আমন্ত্রণ জানিয়েছেন। যোগ দিতে লিংকে ট্যাপ করুন (অ্যাপটি শুরু করতে বিনামূল্যে): {link}\nআমন্ত্রণ কোড: {codigo}",
 "{quem} e outros incluíram {n} itens no grupo.": "{quem} ও অন্যরা গ্রুপে {n}টি আইটেম যোগ করেছেন।",
 "{quem} incluiu {item} no grupo.": "{quem} গ্রুপে {item} যোগ করেছেন।",
 "{servico} do veículo": "যানবাহনের {servico}",
 "{s} de {a}": "{a}-এর মধ্যে {s}",
 "{tarefa}: volte às {hora}": "{tarefa}: {hora}-এ ফিরে আসুন",
 "{tipo}: {p}": "{tipo}: {p}",
 "{titulo} (cópia)": "{titulo} (কপি)",
 "{uso} usados de {total} reservados para o site": "সাইটের জন্য সংরক্ষিত {total}-এর মধ্যে {uso} ব্যবহৃত",
 "{v} · atualização de {data}": "{v} · {data}-এর আপডেট",
 "{v}/hora": "{v}/ঘণ্টা",
 "À direita": "ডানদিকে",
 "À vista": "এককালীন",
 "Às": "সময়",
 "Às {hora}": "{hora}-এ",
 "ÁGUA": "পানি",
 "Ácido": "অম্লীয়",
 "Água": "পানি",
 "Água hoje": "আজকের পানি",
 "Área externa": "বাইরের জায়গা",
 "Áreas": "এলাকা",
 "Áudio": "অডিও",
 "É um auxílio e não substitui o acompanhamento das intimações nos canais oficiais. Prazos devem ser conferidos no sistema oficial.": "এটি একটি সহায়ক টুল এবং অফিসিয়াল মাধ্যমে নোটিশ পর্যবেক্ষণের বিকল্প নয়। সময়সীমা অফিসিয়াল সিস্টেমে যাচাই করতে হবে।",
 "Ética Profissional": "পেশাগত নৈতিকতা",
 "Ícone e aba": "আইকন ও ট্যাব",
 "Óculos de sol": "সানগ্লাস",
 "Órgão emissor (ex.: DETRAN-MS, Polícia Federal)": "ইস্যুকারী (যেমন: DETRAN-MS, ফেডারেল পুলিশ)",
 "Órgão emissor: {nome}": "ইস্যুকারী: {nome}",
 "Ômega 3": "ওমেগা ৩",
 "Última": "শেষ",
 "Última adubação": "শেষ সার",
 "Última aplicação": "শেষ প্রয়োগ",
 "Última busca do servidor para você: {quando}": "আপনার জন্য সার্ভারের সর্বশেষ খোঁজ: {quando}",
 "Última cópia de segurança: {data}": "শেষ ব্যাকআপ: {data}",
 "Última rega": "শেষ পানি",
 "Última sincronização: {quando}": "শেষ সিঙ্ক: {quando}",
 "Última: {data}": "সর্বশেষ: {data}",
 "Último dia para entregar a declaração do IR": "আয়কর রিটার্ন জমার শেষ দিন",
 "Último erro: {m}": "শেষ ত্রুটি: {m}",
 "Últimos 30 dias": "শেষ ৩০ দিন",
 "Últimos 7 dias": "শেষ ৭ দিন",
 "íris": "আইরিস",
 "última vez em {data}": "শেষবার {data}",
 "último em {d}": "সর্বশেষ: {d}",
 "úteis": "কর্মদিবস",
 "★ é a cor do My Planner. A escolha vale para todas as conversas deste dispositivo e da sua conta.": "★ হলো My Planner-এর রং। এই পছন্দ এই ডিভাইস ও আপনার অ্যাকাউন্টের সব চ্যাটে প্রযোজ্য।",
 "🎥 {nome} está ligando (vídeo)": "🎥 {nome} কল করছেন (ভিডিও)",
 "📆 Conectar a agenda deste celular": "📆 এই ফোনের ক্যালেন্ডার যুক্ত করুন",
 "📞 {nome} está ligando (áudio)": "📞 {nome} কল করছেন (অডিও)",
 "Link bloqueado por segurança.": "নিরাপত্তার জন্য লিংক আটকানো হয়েছে।",
 "Este arquivo não é uma imagem válida.": "এই ফাইলটি বৈধ ছবি নয়।",
 "A busca automática do servidor acompanha os 5 primeiros perfis. Os outros entram quando você toca em \"Verificar agora\".": "সার্ভারের স্বয়ংক্রিয় খোঁজ প্রথম ৫টি প্রোফাইল দেখে। বাকিগুলো \"এখনই যাচাই করুন\" চাপলে যাচাই হয়।",
 "Esta tela mostra a linha do tempo da viagem, com as atividades e os lugares que têm dia marcado. Para adicionar ou editar as informações completas de um lugar, use a aba Lugares.": "এই স্ক্রিনে ভ্রমণের টাইমলাইন দেখায়, যেসব কাজ ও জায়গার দিন ঠিক করা আছে সেগুলোসহ। কোনো জায়গার পুরো তথ্য যোগ বা সম্পাদনা করতে জায়গা ট্যাব ব্যবহার করুন।",
 "Para a viagem {d}": "ভ্রমণ {d}-এর জন্য",
 "sem nome": "নামহীন",
 "Foi para a viagem {d}.": "ভ্রমণ {d}-এ সরানো হয়েছে।",
 "Orçamento total (se não for detalhar)": "মোট বাজেট (বিস্তারিত না দিলে)",
 "Monte o roteiro dia a dia. Os lugares com dia marcado entram aqui sozinhos. No período da viagem, o roteiro aparece na linha do tempo do My Planner.": "দিন ধরে ধরে ভ্রমণসূচি সাজান। যেসব জায়গার দিন ঠিক করা আছে, সেগুলো নিজে থেকেই এখানে আসে। ভ্রমণের সময় ভ্রমণসূচি My Planner-এর টাইমলাইনে দেখায়।",
 "Marque o dia e o horário no lugar para ele aparecer sozinho no Roteiro.": "জায়গায় দিন ও সময় ঠিক করুন, তাহলে সেটি নিজে থেকেই ভ্রমণসূচিতে দেখাবে।",
 "No roteiro": "ভ্রমণসূচিতে আছে",
 "\"{nome}\" está no roteiro de {data}. Para mudar o dia ou o horário, edite o lugar.": "\"{nome}\" {data}-এর ভ্রমণসূচিতে আছে। দিন বা সময় বদলাতে জায়গাটি সম্পাদনা করুন।",
 "Para o roteiro desta viagem": "এই ভ্রমণের সূচির জন্য",
 "Orçamento e gastos": "বাজেট ও খরচ",
 "Parada (cidade)": "যাত্রাবিরতি (শহর)",
 "Item da categoria": "বিভাগের আইটেম",
 "Orçamento da viagem inteira": "পুরো ভ্রমণের বাজেট",
 "Orçamento geral da viagem": "ভ্রমণের সার্বিক বাজেট",
 "Previsto {p} · gasto {g}": "আনুমানিক {p} · খরচ {g}",
 "Aqui ficam os custos da viagem que não são de uma parada (ex.: passagens, seguro). Cada parada tem o seu orçamento.": "যেসব খরচ কোনো যাত্রাবিরতির নয় (যেমন: টিকিট, বিমা), সেগুলো এখানে থাকে। প্রতিটি যাত্রাবিরতির নিজস্ব বাজেট আছে।",
 "Coloque quanto pretende gastar em cada categoria. Ao lançar os gastos, o app mostra quanto já foi usado.": "প্রতিটি বিভাগে কত খরচ করতে চান তা লিখুন। খরচ যোগ করলে অ্যাপ দেখায় কতটা ব্যবহার হয়েছে।",
 "Orçamento por parada": "যাত্রাবিরতি অনুযায়ী বাজেট",
 "Vai passar por mais de uma cidade? Cadastre as paradas (aba Paradas): cada uma ganha o seu orçamento e os gastos daquelas datas entram nela sozinhos.": "একাধিক শহরে যাবেন? যাত্রাবিরতি যোগ করুন (যাত্রাবিরতি ট্যাব): প্রতিটির নিজস্ব বাজেট থাকে, আর ওই তারিখগুলোর খরচ নিজে থেকেই তাতে যুক্ত হয়।",
 "Coloque o valor do gasto.": "খরচের পরিমাণ লিখুন।",
 "Orçamento de {c}": "{c}-এর বাজেট",
 "Lançar um gasto nesta parada": "এই যাত্রাবিরতিতে একটি খরচ যোগ করুন",
 "Lançar gasto": "খরচ যোগ করুন",
 "Orçamento e gastos da parada": "যাত্রাবিরতির বাজেট ও খরচ",
 "Gastos lançados ({n})": "যোগ করা খরচ ({n})",
 "Para corrigir ou apagar um gasto, use a aba Orçamento e gastos da viagem.": "কোনো খরচ ঠিক বা মুছতে ভ্রমণের বাজেট ও খরচ ট্যাব ব্যবহার করুন।",
 "Paradas": "যাত্রাবিরতি",
 "Cidade ou lugar": "শহর বা জায়গা",
 "Ex.: Porto": "যেমন: পোর্তো",
 "Chegada": "পৌঁছানো",
 "Saída": "রওনা",
 "Onde vai ficar": "কোথায় থাকবেন",
 "gasto {g} de {p}": "{p}-এর মধ্যে {g} খরচ",
 "Vai passar por mais de uma cidade? Cadastre cada parada com as datas. Cada uma ganha o seu orçamento (hospedagem, refeições, transporte...) e os gastos daquelas datas entram nela sozinhos.": "একাধিক শহরে যাবেন? প্রতিটি যাত্রাবিরতি তারিখসহ যোগ করুন। প্রতিটির নিজস্ব বাজেট থাকে (থাকার জায়গা, খাবার, যাতায়াত...) আর ওই তারিখগুলোর খরচ নিজে থেকেই তাতে যুক্ত হয়।",
 "Café da tarde": "বিকেলের চা",
 "Outros / Lanches": "অন্যান্য / নাস্তা",
 "Gasto {v}": "খরচ {v}",
 "Gasto {g} de {p} · {a} acima": "{p}-এর মধ্যে {g} খরচ · {a} বেশি",
 "Gasto {g} de {p}": "{p}-এর মধ্যে {g} খরচ",
 "Tirar \"{nome}\" do orçamento?": "\"{nome}\" বাজেট থেকে সরাবেন?",
 "Os gastos já lançados nela continuam na lista de gastos.": "এতে আগে যোগ করা খরচগুলো খরচের তালিকায় থেকে যাবে।",
 "Previsto para {nome}": "{nome}-এর জন্য আনুমানিক",
 "Tirar {nome}": "{nome} সরান",
 "Nome do item (ex.: Jantar especial)": "আইটেমের নাম (যেমন: বিশেষ ডিনার)",
 "Adicionar item": "আইটেম যোগ করুন",
 "Detalhar em itens": "আইটেমে ভাগ করুন",
 "Nova categoria (ex.: Seguro, Presentes)": "নতুন বিভাগ (যেমন: বিমা, উপহার)",
 "Voltar às categorias sugeridas?": "প্রস্তাবিত বিভাগে ফিরে যাবেন?",
 "Os valores previstos desta lista serão apagados. Os gastos lançados continuam.": "এই তালিকার আনুমানিক পরিমাণগুলো মুছে যাবে। যোগ করা খরচ থেকে যাবে।",
 "Voltar às categorias sugeridas": "প্রস্তাবিত বিভাগে ফিরে যান",
 "Previsto": "আনুমানিক",
 "Ainda pode gastar": "এখনও খরচ করা যাবে",
 "Passou do previsto": "আনুমানিকের বেশি",
 "Não foi possível buscar o câmbio": "বিনিময় হার পাওয়া যায়নি",
 "Sem internet ou a moeda {m} não está na tabela. Edite a viagem e coloque o câmbio à mão.": "ইন্টারনেট নেই বা {m} তালিকায় নেই। ভ্রমণ সম্পাদনা করে হার নিজে লিখুন।",
 "Câmbio de {m} ainda não definido": "{m} এর বিনিময় হার এখনো ঠিক হয়নি",
 "Câmbio de hoje": "আজকের হার",
 "Atualizado em {d}": "{d} তারিখে হালনাগাদ",
 "Valor em {m}": "{m} এ পরিমাণ",
 "Moeda do destino": "গন্তব্যের মুদ্রা",
 "Câmbio: quanto vale 1 da moeda do destino na sua moeda": "বিনিময় হার: গন্তব্যের মুদ্রার ১ একক আপনার মুদ্রায় কত",
 "Sem dia marcado": "কোনো দিন ঠিক নেই",
 "Valor na moeda do destino": "গন্তব্যের মুদ্রায় পরিমাণ",
 "Tirar só desta lista ou excluir de vez?": "শুধু এই তালিকা থেকে সরাবেন নাকি একেবারে মুছবেন?",
 "Excluir de vez": "একেবারে মুছুন",
 "Relatório da viagem (PDF)": "ভ্রমণ প্রতিবেদন (PDF)",
 "Planilha da viagem (Excel)": "ভ্রমণের স্প্রেডশিট (Excel)",
 "Geral da viagem": "পুরো ভ্রমণ",
 "Viagem {d}": "ভ্রমণ {d}",
 "Quem vai: {p}": "কে যাচ্ছে: {p}",
 "Outros gastos": "অন্যান্য খরচ",
 "Orçamento · {n}": "বাজেট · {n}",
 "Código": "কোড",
 "Pagou": "কে দিল",
 "Permissão internacional para dirigir": "আন্তর্জাতিক ড্রাইভিং পারমিট",
 "Vacina (certificado)": "টিকা (সার্টিফিকেট)",
 "Autorização de viagem de menor": "নাবালকের ভ্রমণ অনুমতি",
 "Vence antes da volta": "ফেরার আগেই মেয়াদ শেষ",
 "Vence menos de 6 meses depois da volta (muitos países não aceitam)": "ফেরার পর ৬ মাসের কম মেয়াদ থাকে (অনেক দেশ গ্রহণ করে না)",
 "A lista básica já está aqui.": "মৌলিক তালিকা ইতিমধ্যে এখানে আছে।",
 "{n} documento(s) com validade que pode atrapalhar a viagem": "{n}টি ডকুমেন্টের মেয়াদ ভ্রমণে সমস্যা করতে পারে",
 "Lista básica: passaporte de cada um e seguro viagem": "মৌলিক তালিকা: প্রত্যেকের পাসপোর্ট ও ভ্রমণ বিমা",
 "Lista básica: identidade de cada um": "মৌলিক তালিকা: প্রত্যেকের পরিচয়পত্র",
 "Ponha a validade de cada documento: o app avisa antes de vencer e confere se o passaporte vale por 6 meses depois da volta. As fotos dos documentos ficam protegidas no cofre.": "প্রতিটি ডকুমেন্টের মেয়াদ দিন: মেয়াদ শেষ হওয়ার আগে অ্যাপ জানাবে এবং ফেরার পর ৬ মাস পাসপোর্ট বৈধ কিনা যাচাই করবে। ডকুমেন্টের ছবি ভল্টে সুরক্ষিত থাকে।",
 "De quem": "কার",
 "Número (protegido no cofre)": "নম্বর (ভল্টে সুরক্ষিত)",
 "Está em mãos": "হাতে আছে",
 "Válido até {d}": "{d} পর্যন্ত বৈধ",
 "Passaporte, visto, seguro viagem, vacina, autorização de menor... com a validade e a foto. Marque quando estiver em mãos.": "পাসপোর্ট, ভিসা, ভ্রমণ বিমা, টিকা, নাবালকের অনুমতি... মেয়াদ ও ছবিসহ। হাতে পেলে চিহ্ন দিন।",
 "acerto entre os viajantes (não entra no orçamento)": "ভ্রমণকারীদের মধ্যে হিসাব (বাজেটে নয়)",
 "Só gastos": "শুধু খরচ",
 "Acertos": "হিসাব",
 "Marcar como pago?": "পরিশোধিত চিহ্নিত করবেন?",
 "{de} já pagou {v} para {para}?": "{de} কি {para}-কে {v} দিয়েছে?",
 "Já pagou": "দিয়েছে",
 "Acerto: {de} pagou {para}": "হিসাব: {de} {para}-কে দিয়েছে",
 "Conferir minhas assinaturas": "আমার সাবস্ক্রিপশন দেখুন",
 "Gerenciar ou cancelar assinaturas na loja": "স্টোরে সাবস্ক্রিপশন পরিচালনা বা বাতিল করুন",
 "Restaurar compras": "কেনাকাটা পুনরুদ্ধার করুন",
 "Procurando...": "খোঁজা হচ্ছে...",
 "{n} assinatura(s) encontrada(s) e liberada(s).": "{n}টি সাবস্ক্রিপশন পাওয়া গেছে ও চালু হয়েছে।",
 "Assinatura anual, renova sozinha. Cancele quando quiser nas assinaturas da loja, até 24 horas antes da renovação.": "বার্ষিক সাবস্ক্রিপশন, নিজে থেকে নবায়ন হয়। নবায়নের ২৪ ঘণ্টা আগ পর্যন্ত স্টোরের সাবস্ক্রিপশনে যেকোনো সময় বাতিল করুন।",
 "Assinaturas da loja": "স্টোর সাবস্ক্রিপশন",
 "Gerenciar assinaturas (App Store)": "সাবস্ক্রিপশন পরিচালনা (App Store)",
 "Gerenciar assinaturas (Google Play)": "সাবস্ক্রিপশন পরিচালনা (Google Play)",
 "A assinatura é feita no app do celular (Google Play ou App Store) e vale também aqui no site.": "সাবস্ক্রিপশন ফোনের অ্যাপে নেওয়া হয় (Google Play বা App Store) এবং এই সাইটেও কাজ করে।",
 "Esta assinatura ainda não está disponível na loja. Tente de novo mais tarde.": "এই সাবস্ক্রিপশন এখনও স্টোরে নেই। পরে আবার চেষ্টা করুন।",
 "Assinatura feita": "সাবস্ক্রিপশন হয়েছে",
 "Já assinei no celular: conferir": "ফোনে আগেই সাবস্ক্রাইব করেছি: দেখুন",
 "Nenhuma assinatura encontrada nesta conta da loja.": "এই স্টোর অ্যাকাউন্টে কোনো সাবস্ক্রিপশন পাওয়া যায়নি।",
 "Confira a internet e tente de novo. Nada foi cobrado.": "ইন্টারনেট দেখে আবার চেষ্টা করুন। কিছুই কাটা হয়নি।",
 "{aba} liberada. Vale também nos seus outros dispositivos e no site.": "{aba} চালু হয়েছে। আপনার অন্য ডিভাইস ও সাইটেও কাজ করে।",
 "Para assinar, atualize o My Planner pela Google Play ou pela App Store.": "সাবস্ক্রাইব করতে Google Play বা App Store থেকে My Planner আপডেট করুন।",
 "Assinada, renova em {data}": "সাবস্ক্রাইব করা, {data} তারিখে নবায়ন",
 "Não deu para assinar agora": "এখন সাবস্ক্রাইব করা গেল না",
 "Assinar por {preco} por ano": "বছরে {preco} দিয়ে সাবস্ক্রাইব করুন",
 "\"{nome}\" foi para o Mural, em Conquistas.": "\"{nome}\" নোটিশ বোর্ডে, অর্জন-এ চলে গেছে।",
 "\"{nome}\" já faz parte da sua rotina. Foi para o Mural, em Conquistas.": "\"{nome}\" এখন আপনার রুটিনের অংশ। এটি নোটিশ বোর্ডে, অর্জন-এ চলে গেছে।",
 "\"{nome}\" voltou para o lugar.": "\"{nome}\" আগের জায়গায় ফিরে গেছে।",
 "1 ano": "১ বছর",
 "1 mês": "১ মাস",
 "A IA não achou o valor no comprovante.": "AI রসিদে পরিমাণ খুঁজে পায়নি।",
 "A cada {n} dias": "প্রতি {n} দিনে",
 "A carta está vazia": "চিঠিটি খালি",
 "A carta fica trancada até {d}. Até lá não dá para reler nem editar. Para mudar algo, escreva outra carta.": "চিঠিটি {d} পর্যন্ত লক থাকবে। ততদিন আবার পড়া বা সম্পাদনা করা যাবে না। কিছু বদলাতে চাইলে আরেকটি চিঠি লিখুন।",
 "A lixeira está vazia.": "ট্র্যাশ খালি।",
 "A mesma do app e do celular": "অ্যাপ ও ফোনের মতোই",
 "A mesma forma de desbloqueio do app e do celular": "অ্যাপ ও ফোনের একই আনলক পদ্ধতি",
 "A senha do diário precisa ter 6 caracteres ou mais.": "ডায়েরির পাসওয়ার্ড কমপক্ষে ৬ অক্ষরের হতে হবে।",
 "A senha precisa ter 6 caracteres ou mais.": "পাসওয়ার্ড কমপক্ষে ৬ অক্ষরের হতে হবে।",
 "A turma ainda não tem grupo": "ক্লাসের এখনো কোনো গ্রুপ নেই",
 "AS 4 BOLINHAS DE COR": "৪টি রঙের বিন্দু",
 "Aberta em {d}": "{d} তারিখে খোলা হয়েছে",
 "Abra a aba para poder restaurar": "পুনরুদ্ধার করতে ট্যাবটি খুলুন",
 "Abra o diário primeiro": "আগে ডায়েরি খুলুন",
 "Abre com a biometria, o reconhecimento facial ou a senha do app. A senha do diário só é pedida na primeira vez em cada aparelho.": "বায়োমেট্রিক, ফেস রিকগনিশন বা অ্যাপের পাসওয়ার্ড দিয়ে খোলে। ডায়েরির পাসওয়ার্ড প্রতিটি ডিভাইসে শুধু প্রথমবার চাওয়া হয়।",
 "Abre em {d}": "{d} তারিখে খুলবে",
 "Abrir carta para o futuro": "ভবিষ্যতের চিঠি খুলুন",
 "Abrir em {aba}": "{aba}-এ খুলুন",
 "Abrir o Diário": "ডায়েরি খুলুন",
 "Abrir o diário": "ডায়েরি খুলুন",
 "Abrir {aba}": "{aba} খুলুন",
 "Acompanha o imóvel, as reservas, a ocupação, as despesas e o lucro, sem alterar nada.": "কিছু না বদলে সম্পত্তি, বুকিং, দখলের হার, খরচ ও লাভ দেখেন।",
 "Adicionar foto": "ছবি যোগ করুন",
 "Apaga tudo o que está no quadro desta página.": "এই পৃষ্ঠার বোর্ডে থাকা সবকিছু মুছে ফেলে।",
 "Apagar o desenho?": "আঁকাটি মুছবেন?",
 "Apagar o diário": "ডায়েরি মুছুন",
 "Apagar para todos?": "সবার জন্য মুছবেন?",
 "Aplicar a todas as páginas desta matéria": "এই বিষয়ের সব পৃষ্ঠায় প্রয়োগ করুন",
 "Aplicar a todas as páginas desta pasta": "এই ফোল্ডারের সব পৃষ্ঠায় প্রয়োগ করুন",
 "Apostilas, listas, slides, vídeos, links e recados. Pelo ⋮ › Enviar para a turma, cada aluno recebe no app dele.": "হ্যান্ডআউট, অনুশীলনী, স্লাইড, ভিডিও, লিংক ও নোটিশ। ⋮ › ক্লাসে পাঠান দিয়ে প্রত্যেক শিক্ষার্থী নিজের অ্যাপে পায়।",
 "Aquarela": "জলরং",
 "Aqui aparece, sem custo, o que os grupos compartilharam com você. Para usar a aba com os seus próprios dados, assine a aba.": "গ্রুপগুলো আপনার সাথে যা শেয়ার করেছে তা এখানে বিনামূল্যে দেখা যায়। নিজের তথ্য দিয়ে ট্যাবটি ব্যবহার করতে ট্যাবটি সাবস্ক্রাইব করুন।",
 "Arquivados": "আর্কাইভ",
 "Arraste para a direita para excluir, ou para a esquerda para arquivar.": "মুছতে ডানে সোয়াইপ করুন, আর্কাইভ করতে বাঁয়ে।",
 "As cobranças desta aula extra já existem.": "এই অতিরিক্ত ক্লাসের চার্জ আগেই তৈরি আছে।",
 "As notas vão só para cada aluno. Para isso, o nome da pessoa no grupo precisa ser igual ao nome do aluno ou do responsável no cadastro.": "নম্বর শুধু প্রত্যেক শিক্ষার্থীর কাছে যায়। এজন্য গ্রুপে ব্যক্তির নাম নিবন্ধনে থাকা শিক্ষার্থী বা অভিভাবকের নামের সাথে মিলতে হবে।",
 "Atestado": "মেডিকেল সার্টিফিকেট",
 "Atestados": "মেডিকেল সার্টিফিকেট",
 "Até quando (opcional)": "কবে পর্যন্ত (ঐচ্ছিক)",
 "Até {d}": "{d} পর্যন্ত",
 "Aula extra": "অতিরিক্ত ক্লাস",
 "Aula extra (fora dos dias de aula)": "অতিরিক্ত ক্লাস (ক্লাসের দিনের বাইরে)",
 "Aula extra de {d}": "{d} তারিখের অতিরিক্ত ক্লাস",
 "Avaliação de {d}": "{d} তারিখের মূল্যায়ন",
 "Avaliação salva": "মূল্যায়ন সংরক্ষিত হয়েছে",
 "Avançar": "এগিয়ে যান",
 "Aviso da revisão do mês": "মাসিক পর্যালোচনার রিমাইন্ডার",
 "Aviso no último dia do mês: \"Que tal revisar o seu mês? ✨\"": "মাসের শেষ দিনে রিমাইন্ডার: \"আপনার মাসটা একবার পর্যালোচনা করবেন? ✨\"",
 "Aviso sem nenhum conteúdo do diário: \"Como foi o seu dia? ✍️\"": "ডায়েরির কোনো লেখা ছাড়া রিমাইন্ডার: \"আপনার দিন কেমন কাটল? ✍️\"",
 "Avulsa": "একক",
 "Avulsas": "একক",
 "Azul": "নীল",
 "Baixar na App Store": "App Store থেকে ডাউনলোড করুন",
 "Baixar na Google Play": "Google Play থেকে ডাউনলোড করুন",
 "Baixe o My Planner na loja: Android {android} · iPhone {iphone}": "স্টোর থেকে My Planner ডাউনলোড করুন: Android {android} · iPhone {iphone}",
 "Biometria, reconhecimento facial ou a senha do app. A senha do diário fica guardada para a primeira vez em cada aparelho.": "বায়োমেট্রিক, ফেস রিকগনিশন বা অ্যাপের পাসওয়ার্ড। ডায়েরির পাসওয়ার্ড প্রতিটি ডিভাইসে প্রথমবারের জন্য সংরক্ষিত থাকে।",
 "Branco": "সাদা",
 "Buscando o clima…": "আবহাওয়া খোঁজা হচ্ছে…",
 "Básicas": "মৌলিক",
 "COMO ESTOU": "আমি কেমন আছি",
 "COMO O DIÁRIO ABRE": "ডায়েরি যেভাবে খোলে",
 "COR DA FOLHA": "পাতার রং",
 "Caixinha no My Planner": "My Planner-এ বাক্স",
 "Caixinha {m}": "বাক্স {m}",
 "Carta de {d}": "{d} তারিখের চিঠি",
 "Carta guardada": "চিঠি সংরক্ষিত হয়েছে",
 "Carta para o futuro": "ভবিষ্যতের চিঠি",
 "Carta trancada": "লক করা চিঠি",
 "Cartas abertas podem ser lidas, mas não editadas.": "খোলা চিঠি পড়া যায়, কিন্তু সম্পাদনা করা যায় না।",
 "Cartas para o Futuro": "ভবিষ্যতের চিঠি",
 "Cartões arquivados": "আর্কাইভ করা কার্ড",
 "Chegou uma carta da {nome} de {tempo} atrás 💌": "{tempo} আগের {nome}-এর কাছ থেকে একটি চিঠি এসেছে 💌",
 "Chegou! Toque para abrir 💌": "এসে গেছে! খুলতে ট্যাপ করুন 💌",
 "Cinza-escuro": "গাঢ় ধূসর",
 "Clara (segue o tema)": "হালকা (থিম অনুসারে)",
 "Claras e pastel (boas para folha escura)": "হালকা ও প্যাস্টেল (গাঢ় পাতার জন্য ভালো)",
 "Clima (toque para preencher)": "আবহাওয়া (পূরণ করতে ট্যাপ করুন)",
 "Clima automático": "স্বয়ংক্রিয় আবহাওয়া",
 "Clima do dia": "দিনের আবহাওয়া",
 "Cobrar a aula extra": "অতিরিক্ত ক্লাসের চার্জ নিন",
 "Cobrar a aula extra dos presentes": "উপস্থিতদের কাছ থেকে অতিরিক্ত ক্লাসের চার্জ নিন",
 "Cobrar a turma toda": "পুরো ক্লাসের কাছ থেকে চার্জ নিন",
 "Cole um link que comece com https://": "https:// দিয়ে শুরু হওয়া একটি লিংক পেস্ট করুন",
 "Coloque o valor da aula extra na turma (Editar).": "ক্লাসে (সম্পাদনা) অতিরিক্ত ক্লাসের মূল্য দিন।",
 "Coloque o valor.": "পরিমাণ দিন।",
 "Colunas": "কলাম",
 "Com a sua IA ligada (Ajustes › Inteligência artificial), o app lê o valor, a data e a descrição pela foto.": "আপনার AI চালু থাকলে (সেটিংস › কৃত্রিম বুদ্ধিমত্তা), অ্যাপ ছবি থেকে পরিমাণ, তারিখ ও বিবরণ পড়ে নেয়।",
 "Como cuidei de mim hoje?": "আজ আমি নিজের যত্ন কীভাবে নিলাম?",
 "Como foi o seu dia? ✍️": "আপনার দিন কেমন কাটল? ✍️",
 "Compartilhar este projeto (convidar)": "এই প্রকল্পটি শেয়ার করুন (আমন্ত্রণ)",
 "Compartilhar o texto": "লেখাটি শেয়ার করুন",
 "Completa": "সম্পূর্ণ",
 "Comprovante (foto, PDF ou print)": "রসিদ (ছবি, PDF বা স্ক্রিনশট)",
 "Comprovante anexado": "রসিদ যুক্ত করা হয়েছে",
 "Comprovante de pagamento (foto ou PDF)": "পেমেন্টের রসিদ (ছবি বা PDF)",
 "Concluído: hábito formado": "সম্পন্ন: অভ্যাস গড়ে উঠেছে",
 "Concluídos": "সম্পন্ন",
 "Configurar o Diário": "ডায়েরি সেট আপ করুন",
 "Confirmar pagamento": "পেমেন্ট নিশ্চিত করুন",
 "Confirmar recebimento": "প্রাপ্তি নিশ্চিত করুন",
 "Conquistas": "অর্জন",
 "Contas arquivadas": "আর্কাইভ করা বিল",
 "Continuar escrevendo": "লেখা চালিয়ে যান",
 "Copiado ✓": "কপি হয়েছে ✓",
 "Copiar código": "কোড কপি করুন",
 "Copiar link": "লিংক কপি করুন",
 "Cor atual": "বর্তমান রং",
 "Cor {n}": "রং {n}",
 "Creme": "ক্রিম",
 "Criada em {d}": "{d} তারিখে তৈরি",
 "Criar as cobranças": "চার্জ তৈরি করুন",
 "Criar o grupo da turma": "ক্লাসের গ্রুপ তৈরি করুন",
 "Criar o meu diário": "আমার ডায়েরি তৈরি করুন",
 "Crie a senha do diário (6 ou mais)": "ডায়েরির পাসওয়ার্ড তৈরি করুন (৬ বা তার বেশি)",
 "Crie o grupo da turma e mande o convite aos alunos. Depois, o envio vai direto para eles.": "ক্লাসের গ্রুপ তৈরি করে শিক্ষার্থীদের আমন্ত্রণ পাঠান। এরপর পাঠানো জিনিস সরাসরি তাদের কাছে যাবে।",
 "Crie sua primeira meta, objetivo ou sonho com o botão + abaixo.": "নিচের + বোতাম দিয়ে আপনার প্রথম লক্ষ্য, উদ্দেশ্য বা স্বপ্ন তৈরি করুন।",
 "Crie um projeto, convide quem participa e divida os passos. Cada pessoa marca o que fez.": "একটি প্রকল্প তৈরি করুন, অংশগ্রহণকারীদের আমন্ত্রণ জানান এবং ধাপগুলো ভাগ করে দিন। প্রত্যেকে যা করেছে তা চিহ্নিত করে।",
 "Crie uma senha nova para começar.": "শুরু করতে একটি নতুন পাসওয়ার্ড তৈরি করুন।",
 "Cuidados arquivados": "আর্কাইভ করা যত্ন",
 "Cuidados pessoais do dia feitos (Bem-Estar)": "দিনের ব্যক্তিগত যত্ন সম্পন্ন (সুস্থতা)",
 "Curto prazo": "স্বল্পমেয়াদি",
 "Custos": "খরচ",
 "Céu estrelado": "তারাভরা আকাশ",
 "Círculo": "বৃত্ত",
 "Cômodos arquivados": "আর্কাইভ করা ঘর",
 "DIAS CUMPRIDOS": "সম্পন্ন দিন",
 "Data (opcional)": "তারিখ (ঐচ্ছিক)",
 "De {d}": "{d} থেকে",
 "Desafixar do topo": "ওপর থেকে আনপিন করুন",
 "Desenho mais fraco ou mais forte": "আঁকা হালকা বা গাঢ়",
 "Desfazer \"Concluído\" ({d})": "\"সম্পন্ন\" বাতিল করুন ({d})",
 "Desligado": "বন্ধ",
 "Desmarcar": "চিহ্ন তুলে দিন",
 "Desmarcar como paga?": "পরিশোধিত চিহ্ন তুলে দেবেন?",
 "Desmarcar como recebida?": "প্রাপ্ত চিহ্ন তুলে দেবেন?",
 "Desmarque o que você não usa: some da tela e deixa a aba mais simples. Dá para mudar depois em Ajustes › Abas › {aba} › Partes desta aba.": "যা ব্যবহার করেন না তার চিহ্ন তুলে দিন: সেটি স্ক্রিন থেকে সরে যাবে এবং ট্যাবটি সহজ হবে। পরে সেটিংস › ট্যাব › {aba} › এই ট্যাবের অংশ-এ বদলানো যায়।",
 "Dias da semana": "সপ্তাহের দিন",
 "Dias de aula": "ক্লাসের দিন",
 "Dias de aula: {d}": "ক্লাসের দিন: {d}",
 "Dias escritos": "লেখা দিন",
 "Dica: desenhe a forma à mão e segure o dedo no fim do traço para ela ficar perfeita.": "টিপস: হাতে আকারটি আঁকুন এবং রেখার শেষে আঙুল চেপে ধরে রাখুন, তাহলে এটি নিখুঁত হয়ে যাবে।",
 "Ditado": "ডিক্টেশন",
 "Ditar (falar para escrever)": "ডিক্টেট করুন (বলে লিখুন)",
 "Diário apagado": "ডায়েরি মুছে ফেলা হয়েছে",
 "Diário protegido": "সুরক্ষিত ডায়েরি",
 "Dom": "রবি",
 "Dê um nome a ele na pasta Hábitos.": "অভ্যাস ফোল্ডারে এটির একটি নাম দিন।",
 "EVOLUÇÃO": "অগ্রগতি",
 "Editada em {d}": "{d} তারিখে সম্পাদিত",
 "Ela abre em {d} ({n} dias). Até lá não dá para reler nem editar.": "এটি {d} তারিখে খুলবে ({n} দিন)। ততদিন আবার পড়া বা সম্পাদনা করা যাবে না।",
 "Ela abre em {d}. Você vai receber um aviso nesse dia.": "এটি {d} তারিখে খুলবে। সেদিন আপনি একটি রিমাইন্ডার পাবেন।",
 "Ela fica guardada com a data de hoje para comparar depois.": "পরে তুলনা করার জন্য এটি আজকের তারিখসহ সংরক্ষিত থাকে।",
 "Enorme": "বিশাল",
 "Enviado ao paciente": "রোগীকে পাঠানো হয়েছে",
 "Enviado em": "পাঠানোর তারিখ",
 "Enviar \"{t}\" para todos do grupo {g}?": "\"{t}\" কি গ্রুপ {g}-এর সবাইকে পাঠাবেন?",
 "Enviar a nota para cada aluno": "প্রত্যেক শিক্ষার্থীকে নম্বর পাঠান",
 "Enviar as notas": "নম্বর পাঠান",
 "Enviar o arquivo: {nome}": "ফাইল পাঠান: {nome}",
 "Enviar o recado para a turma": "ক্লাসে নোটিশ পাঠান",
 "Enviar o título para outra aba": "শিরোনামটি অন্য ট্যাবে পাঠান",
 "Enviar para a turma": "ক্লাসে পাঠান",
 "Enviar para outra aba": "অন্য ট্যাবে পাঠান",
 "Escolha a cor desta bolinha": "এই বিন্দুর রং বেছে নিন",
 "Escolha uma data no futuro": "ভবিষ্যতের একটি তারিখ বেছে নিন",
 "Escolher qualquer cor": "যেকোনো রং বেছে নিন",
 "Esconder a barra": "বার লুকান",
 "Escreva a frase": "বাক্যটি লিখুন",
 "Escreva a que se refere a cobrança.": "চার্জটি কিসের জন্য তা লিখুন।",
 "Escreva alguma coisa antes de guardar.": "সংরক্ষণের আগে কিছু লিখুন।",
 "Escreva alguma coisa antes de salvar.": "সংরক্ষণের আগে কিছু লিখুন।",
 "Escreva hoje, abra no futuro": "আজ লিখুন, ভবিষ্যতে খুলুন",
 "Escreva o que você quer mudar a partir de hoje": "আজ থেকে কী বদলাতে চান তা লিখুন",
 "Escreva para você do futuro. A carta fica trancada até o dia de abrir.": "ভবিষ্যতের নিজেকে লিখুন। খোলার দিন পর্যন্ত চিঠিটি লক থাকবে।",
 "Escrever uma carta": "একটি চিঠি লিখুন",
 "Escrita em {e} · abre em {a}": "{e} তারিখে লেখা · {a} তারিখে খুলবে",
 "Escuras (boas para folha clara)": "গাঢ় (হালকা পাতার জন্য ভালো)",
 "Esperado": "প্রত্যাশিত",
 "Esperado: {e} · Feito: {f} · Faltou: {fa}": "প্রত্যাশিত: {e} · করা হয়েছে: {f} · বাকি: {fa}",
 "Esqueceu a senha do diário?": "ডায়েরির পাসওয়ার্ড ভুলে গেছেন?",
 "Esqueci a senha do diário": "আমি ডায়েরির পাসওয়ার্ড ভুলে গেছি",
 "Esta semana": "এই সপ্তাহ",
 "Este lançamento vem de outra parte do app e não se apaga aqui.": "এই এন্ট্রিটি অ্যাপের অন্য অংশ থেকে এসেছে এবং এখান থেকে মোছা যায় না।",
 "Estudo: {h}": "পড়াশোনা: {h}",
 "Esvaziar": "খালি করুন",
 "Esvaziar a lixeira": "ট্র্যাশ খালি করুন",
 "Esvaziar a lixeira?": "ট্র্যাশ খালি করবেন?",
 "Ex.: Comer uma fruta por dia": "যেমন: প্রতিদিন একটি ফল খাওয়া",
 "Ex.: Exercícios para casa, Atestado de 2 dias": "যেমন: বাড়ির ব্যায়াম, ২ দিনের মেডিকেল সার্টিফিকেট",
 "Ex.: Reservar a pousada": "যেমন: গেস্টহাউস বুক করা",
 "Ex.: Viagem em família, juntar para a festa": "যেমন: পারিবারিক ভ্রমণ, পার্টির জন্য টাকা জমানো",
 "Excluir de vez?": "স্থায়ীভাবে মুছবেন?",
 "Excluir esta avaliação?": "এই মূল্যায়নটি মুছবেন?",
 "Excluir este bloco?": "এই ব্লকটি মুছবেন?",
 "Excluir este desenho?": "এই আঁকাটি মুছবেন?",
 "Excluir este item?": "এই আইটেমটি মুছবেন?",
 "Excluir {n} item(ns)?": "{n}টি আইটেম মুছবেন?",
 "Exportar como imagem": "ছবি হিসেবে এক্সপোর্ট করুন",
 "Exportar em PDF": "PDF-এ এক্সপোর্ট করুন",
 "FOTOS": "ছবি",
 "FRASE DO DIA": "দিনের বাণী",
 "FREQUÊNCIA": "পুনরাবৃত্তি",
 "Falta o valor": "পরিমাণ দেওয়া হয়নি",
 "Feriado": "ছুটির দিন",
 "Feriado: {f}": "ছুটির দিন: {f}",
 "Fica 30 dias na lixeira.": "৩০ দিন ট্র্যাশে থাকবে।",
 "Ficam 30 dias na lixeira.": "৩০ দিন ট্র্যাশে থাকবে।",
 "Fichários arquivados": "আর্কাইভ করা বাইন্ডার",
 "Fixar no topo": "ওপরে পিন করুন",
 "Floral": "ফুলেল",
 "Folha": "পাতা",
 "Folha, tema e cores das páginas com escrita": "লেখার পৃষ্ঠাগুলোর পাতা, থিম ও রং",
 "Folhas e plantas": "পাতা ও গাছপালা",
 "Foto adicionada": "ছবি যোগ করা হয়েছে",
 "Foto do sonho": "স্বপ্নের ছবি",
 "Fotos do dia": "দিনের ছবি",
 "Frase": "বাণী",
 "Frase do dia (aparece no topo do Meu Dia)": "দিনের বাণী (আমার দিন-এর ওপরে দেখা যায়)",
 "Frases, textos, vídeos e fotos que motivam": "অনুপ্রেরণা দেয় এমন বাণী, লেখা, ভিডিও ও ছবি",
 "Geométrico": "জ্যামিতিক",
 "Gerar": "তৈরি করুন",
 "Gravar lembretes e anotações por voz e ditar textos (🎤) quando você pedir. O microfone só liga com o seu toque, e o áudio do ditado não é guardado.": "আপনি চাইলে ভয়েসে রিমাইন্ডার ও নোট রেকর্ড করা এবং লেখা ডিক্টেট করা (🎤)। মাইক্রোফোন শুধু আপনার ট্যাপে চালু হয়, এবং ডিক্টেশনের অডিও সংরক্ষিত হয় না।",
 "Guardar e trancar": "সংরক্ষণ করে লক করুন",
 "Guardar e trancar?": "সংরক্ষণ করে লক করবেন?",
 "Guarde aqui o que te motiva: frases, textos seus, vídeos e fotos.": "যা আপনাকে অনুপ্রেরণা দেয় তা এখানে রাখুন: বাণী, নিজের লেখা, ভিডিও ও ছবি।",
 "Guarde bem esta senha: sem ela o diário não pode ser recuperado.": "এই পাসওয়ার্ডটি যত্নে রাখুন: এটি ছাড়া ডায়েরি পুনরুদ্ধার করা যাবে না।",
 "Hoje é feriado: {f}. Registrar mesmo assim?": "আজ ছুটির দিন: {f}। তবুও লিখে রাখবেন?",
 "Humor do mês": "মাসের মেজাজ",
 "Humor do período": "সময়কালের মেজাজ",
 "HÁBITOS LIGADOS": "যুক্ত অভ্যাস",
 "Há itens grandes na seleção. Eles só podem ser excluídos um por um, com confirmação e senha.": "নির্বাচনে বড় আইটেম আছে। সেগুলো শুধু একে একে, নিশ্চিতকরণ ও পাসওয়ার্ড দিয়ে মোছা যায়।",
 "Há um ano": "এক বছর আগে",
 "Há um mês": "এক মাস আগে",
 "Hábito": "অভ্যাস",
 "Hábito criado": "অভ্যাস তৈরি হয়েছে",
 "Hábitos": "অভ্যাস",
 "Hábitos cumpridos": "পালিত অভ্যাস",
 "Hábitos cumpridos: {f} de {n}": "পালিত অভ্যাস: {n}টির মধ্যে {f}টি",
 "Hábitos formados": "গড়ে ওঠা অভ্যাস",
 "INSPIRAÇÃO": "অনুপ্রেরণা",
 "Imagem adicionada": "ছবি যোগ করা হয়েছে",
 "Imagem não encontrada": "ছবি পাওয়া যায়নি",
 "Incrível": "দারুণ",
 "Informação nutricional": "পুষ্টি তথ্য",
 "Inserir": "যোগ করুন",
 "Inspiração": "অনুপ্রেরণা",
 "Item para o paciente": "রোগীর জন্য আইটেম",
 "Itens grandes só se excluem um por um.": "বড় আইটেম শুধু একে একে মোছা যায়।",
 "Junte fotos do que você quer viver. Segure e arraste para organizar.": "যা অনুভব করতে চান তার ছবি জড়ো করুন। সাজাতে চেপে ধরে টেনে নিন।",
 "LIGAR A UM SONHO DO PROJETO DE VIDA (OPCIONAL)": "জীবন প্রকল্পের একটি স্বপ্নের সাথে যুক্ত করুন (ঐচ্ছিক)",
 "LIGAR A UMA META (OPCIONAL)": "একটি লক্ষ্যের সাথে যুক্ত করুন (ঐচ্ছিক)",
 "LINKS DE VÍDEO": "ভিডিও লিংক",
 "Lance as notas antes de enviar.": "পাঠানোর আগে নম্বর দিন।",
 "Lançamentos arquivados": "আর্কাইভ করা এন্ট্রি",
 "Legenda (opcional)": "ক্যাপশন (ঐচ্ছিক)",
 "Lembrete diário": "দৈনিক রিমাইন্ডার",
 "Lendo o comprovante...": "রসিদ পড়া হচ্ছে...",
 "Ler o comprovante com a minha IA": "আমার AI দিয়ে রসিদ পড়ুন",
 "Ligado": "চালু",
 "Ligar um texto de motivação (Inspiração)": "একটি অনুপ্রেরণার লেখা যুক্ত করুন (অনুপ্রেরণা)",
 "Lilás": "বেগুনি",
 "Limpar a folha inteira?": "পুরো পাতা পরিষ্কার করবেন?",
 "Linha reta": "সরলরেখা",
 "Linhas": "রেখা",
 "Link do vídeo (YouTube, Instagram...)": "ভিডিওর লিংক (YouTube, Instagram...)",
 "Lisa": "ফাঁকা",
 "Liste os passos do projeto e diga quem faz cada um.": "প্রকল্পের ধাপগুলো তালিকা করুন এবং প্রতিটি কে করবে তা বলুন।",
 "Lixeira": "ট্র্যাশ",
 "Longo prazo": "দীর্ঘমেয়াদি",
 "MARCAR SOZINHO PELO BEM-ESTAR (OPCIONAL)": "সুস্থতা থেকে স্বয়ংক্রিয়ভাবে চিহ্নিত করুন (ঐচ্ছিক)",
 "META OU SONHO LIGADO (OPCIONAL)": "যুক্ত লক্ষ্য বা স্বপ্ন (ঐচ্ছিক)",
 "Mais opções": "আরও বিকল্প",
 "Mal": "খারাপ",
 "Mandar ao paciente pelo WhatsApp": "WhatsApp-এ রোগীকে পাঠান",
 "Marque o que fez em cada dia": "প্রতিদিন যা করেছেন তা চিহ্নিত করুন",
 "Marque os dias de aula na turma (Editar) para a chamada mostrar só esses dias.": "ক্লাসে (সম্পাদনা) ক্লাসের দিনগুলো চিহ্নিত করুন, যাতে হাজিরায় শুধু সেই দিনগুলো দেখায়।",
 "Matérias arquivadas": "আর্কাইভ করা বিষয়",
 "Mensalidade": "মাসিক ফি",
 "Meta de água do Bem-Estar": "সুস্থতার পানির লক্ষ্য",
 "Metas arquivadas": "আর্কাইভ করা লক্ষ্য",
 "Metas e sonhos concluídos": "সম্পন্ন লক্ষ্য ও স্বপ্ন",
 "Metas em andamento": "চলমান লক্ষ্য",
 "Metas que avançaram": "এগিয়েছে এমন লক্ষ্য",
 "Metas, objetivos e sonhos, com passos e prazos": "ধাপ ও সময়সীমাসহ লক্ষ্য, উদ্দেশ্য ও স্বপ্ন",
 "Meu Dia": "আমার দিন",
 "Meu Dia com página livre, projeto de vida, hábitos, quadro dos sonhos, roda da vida, cartas para o futuro e conquistas. Protegido com senha.": "মুক্ত পৃষ্ঠাসহ আমার দিন, জীবন প্রকল্প, অভ্যাস, স্বপ্নের বোর্ড, জীবনের চাকা, ভবিষ্যতের চিঠি ও অর্জন। পাসওয়ার্ড দিয়ে সুরক্ষিত।",
 "Minimalista": "মিনিমালিস্ট",
 "Mostrar as contas antes do vencimento": "শেষ তারিখের আগে বিলগুলো দেখান",
 "Mostrar datas, horários, moeda e feriados certos para onde você está. A localização aproximada do celular só é usada quando você pede o clima do dia no Diário, e não fica guardada.": "আপনি যেখানে আছেন সেই অনুযায়ী সঠিক তারিখ, সময়, মুদ্রা ও ছুটির দিন দেখানো। ফোনের আনুমানিক অবস্থান শুধু তখনই ব্যবহৃত হয় যখন আপনি ডায়েরিতে দিনের আবহাওয়া চান, এবং তা সংরক্ষিত হয় না।",
 "Muito bem": "খুব ভালো",
 "Muito mal": "খুব খারাপ",
 "Mural de fotos dos seus sonhos": "আপনার স্বপ্নের ছবির বোর্ড",
 "Mural, relatório e revisão do mês": "নোটিশ বোর্ড, রিপোর্ট ও মাসিক পর্যালোচনা",
 "Médio prazo": "মধ্যমেয়াদি",
 "N dias cumpridos no mês": "মাসে N দিন পালিত",
 "N dias seguidos": "টানা N দিন",
 "NESTE DIA": "এই দিনে",
 "Nada a enviar": "পাঠানোর কিছু নেই",
 "Nenhum estudo registrado nesta semana.": "এই সপ্তাহে কোনো পড়াশোনা লেখা হয়নি।",
 "Nenhum hábito ainda. Ex.: \"Comer uma fruta por dia\", \"Beber 2 L de água\", \"Não pular o café da manhã\".": "এখনো কোনো অভ্যাস নেই। যেমন: \"প্রতিদিন একটি ফল খাওয়া\", \"২ লিটার পানি পান করা\", \"সকালের নাশতা বাদ না দেওয়া\"।",
 "Nenhum no período.": "এই সময়কালে কিছু নেই।",
 "Nenhuma": "কোনোটিই নয়",
 "Nenhuma carta ainda.": "এখনো কোনো চিঠি নেই।",
 "Nenhuma foto ainda.": "এখনো কোনো ছবি নেই।",
 "Neutras e opacas": "নিরপেক্ষ ও ম্যাট",
 "Ninguém encontrado no grupo": "গ্রুপে কাউকে পাওয়া যায়নি",
 "No computador: {link}": "কম্পিউটারে: {link}",
 "No navegador, a senha do diário é pedida sempre.": "ব্রাউজারে ডায়েরির পাসওয়ার্ড সবসময় চাওয়া হয়।",
 "No último dia do mês: \"Que tal revisar o seu mês? ✨\"": "মাসের শেষ দিনে: \"আপনার মাসটা একবার পর্যালোচনা করবেন? ✨\"",
 "Nome da página (opcional)": "পৃষ্ঠার নাম (ঐচ্ছিক)",
 "Nome de quem faz este passo": "এই ধাপটি যিনি করবেন তার নাম",
 "Nome do vídeo (opcional)": "ভিডিওর নাম (ঐচ্ছিক)",
 "Normal": "স্বাভাবিক",
 "Nota de 0 a 10 para cada área da vida": "জীবনের প্রতিটি ক্ষেত্রের জন্য ০ থেকে ১০ নম্বর",
 "Nota: {a}": "নম্বর: {a}",
 "Nova caixa": "নতুন বাক্স",
 "Nova carta": "নতুন চিঠি",
 "Nova meta, objetivo ou sonho": "নতুন লক্ষ্য, উদ্দেশ্য বা স্বপ্ন",
 "Nova senha (6 caracteres ou mais)": "নতুন পাসওয়ার্ড (৬ বা তার বেশি অক্ষর)",
 "Nova área (ex.: Espiritualidade)": "নতুন ক্ষেত্র (যেমন: আধ্যাত্মিকতা)",
 "Novo cômodo": "নতুন ঘর",
 "Novo hábito": "নতুন অভ্যাস",
 "Não dá para excluir em grupo": "একসাথে মোছা যায় না",
 "Não enviados": "পাঠানো হয়নি",
 "Não estão no grupo (ou com outro nome): {l}": "গ্রুপে নেই (বা অন্য নামে আছে): {l}",
 "Não foi possível exportar": "এক্সপোর্ট করা যায়নি",
 "Não foi possível ouvir agora ({erro}).": "এখন শোনা যাচ্ছে না ({erro})।",
 "Não pede a senha do diário. É a única parte que pode ser compartilhada.": "ডায়েরির পাসওয়ার্ড চায় না। এটিই একমাত্র অংশ যা শেয়ার করা যায়।",
 "Não é dia de aula desta turma. A chamada fica como reposição ou aula extra.": "আজ এই ক্লাসের ক্লাসের দিন নয়। হাজিরাটি মেকআপ বা অতিরিক্ত ক্লাস হিসেবে থাকবে।",
 "O app avisa {n} dia(s) antes e no dia do vencimento, às 9h. Dá para mudar em Ajustes › Abas › Finanças.": "অ্যাপ শেষ তারিখের {n} দিন আগে এবং শেষ দিনে সকাল ৯টায় মনে করিয়ে দেয়। সেটিংস › ট্যাব › অর্থায়ন-এ বদলানো যায়।",
 "O clima automático usa a localização do celular. Sem permissão, ele fica para preencher aqui.": "স্বয়ংক্রিয় আবহাওয়া ফোনের অবস্থান ব্যবহার করে। অনুমতি না থাকলে এখানে নিজে পূরণ করতে হবে।",
 "O conteúdo desta carta não foi encontrado.": "এই চিঠির বিষয়বস্তু পাওয়া যায়নি।",
 "O ditado chega com a versão nova do app. Atualize o My Planner pela loja (ou instale o APK novo) para usar o microfone.": "ডিক্টেশন অ্যাপের নতুন সংস্করণে আসবে। মাইক্রোফোন ব্যবহার করতে স্টোর থেকে My Planner হালনাগাদ করুন (বা নতুন APK ইনস্টল করুন)।",
 "O diário pede a senha sempre que você entra nele, mesmo com o app desbloqueado.": "অ্যাপ আনলক থাকলেও আপনি প্রতিবার ঢুকলে ডায়েরি পাসওয়ার্ড চায়।",
 "O diário só abre com essa senha, sempre.": "ডায়েরি সবসময় শুধু এই পাসওয়ার্ড দিয়েই খোলে।",
 "O diário é criptografado: sem a senha, ninguém consegue abrir, nem o suporte. Se quiser, dá para apagar o diário e começar um novo (os Projetos em Grupo continuam).": "ডায়েরিটি এনক্রিপ্ট করা: পাসওয়ার্ড ছাড়া কেউ খুলতে পারে না, সাপোর্টও না। চাইলে ডায়েরি মুছে নতুন করে শুরু করতে পারেন (গ্রুপ প্রকল্প থেকে যাবে)।",
 "O que aprendi hoje?": "আজ আমি কী শিখলাম?",
 "O que este mês te ensinou? O que quer levar para o próximo?": "এই মাস আপনাকে কী শেখাল? পরের মাসে কী নিয়ে যেতে চান?",
 "O que fica desmarcado some da tela. Os dados continuam guardados.": "যার চিহ্ন তোলা থাকে তা স্ক্রিন থেকে সরে যায়। তথ্য সংরক্ষিতই থাকে।",
 "O que foi bom hoje?": "আজ কী ভালো হলো?",
 "O que foi excluído nos últimos 30 dias": "গত ৩০ দিনে যা মোছা হয়েছে",
 "O que quero melhorar amanhã?": "কাল আমি কী ভালো করতে চাই?",
 "O que quero mudar agora": "এখন আমি কী বদলাতে চাই",
 "O que você escreveu nesta carta vai se perder.": "এই চিঠিতে যা লিখেছেন তা হারিয়ে যাবে।",
 "O que você quer fazer com o arquivo?": "ফাইলটি দিয়ে কী করতে চান?",
 "Objetivo": "উদ্দেশ্য",
 "Oculta": "লুকানো",
 "Orientação": "নির্দেশনা",
 "Orientações, receitas, atestados e materiais para entregar ao paciente, com arquivos. Só o que está aqui é enviado: o prontuário nunca sai por esta pasta.": "রোগীকে দেওয়ার জন্য নির্দেশনা, প্রেসক্রিপশন, মেডিকেল সার্টিফিকেট ও উপকরণ, ফাইলসহ। শুধু এখানে যা আছে তা-ই পাঠানো হয়: মেডিকেল রেকর্ড কখনো এই ফোল্ডার দিয়ে বের হয় না।",
 "Os dias com página escrita ficam marcados. Toque num dia para abrir.": "লেখা পৃষ্ঠা আছে এমন দিনগুলো চিহ্নিত থাকে। খুলতে একটি দিনে ট্যাপ করুন।",
 "Os itens saem de vez e não podem mais ser restaurados.": "আইটেমগুলো স্থায়ীভাবে মুছে যাবে এবং আর পুনরুদ্ধার করা যাবে না।",
 "Outra data": "অন্য তারিখ",
 "Outras moedas": "অন্যান্য মুদ্রা",
 "Ouvindo…": "শুনছি…",
 "PASSOS": "ধাপ",
 "PDF com seus dados e assinatura": "আপনার তথ্য ও স্বাক্ষরসহ PDF",
 "POR DIA": "প্রতিদিন",
 "POR MATÉRIA": "বিষয় অনুযায়ী",
 "PROGRESSO": "অগ্রগতি",
 "Paciente: {nome}": "রোগী: {nome}",
 "Para o paciente": "রোগীর জন্য",
 "Para trocar a forma de abrir, entre no Diário com a senha dele e volte aqui.": "খোলার পদ্ধতি বদলাতে ডায়েরির পাসওয়ার্ড দিয়ে ডায়েরিতে ঢুকে আবার এখানে ফিরে আসুন।",
 "Para {nome} de {tempo} depois": "{tempo} পরের {nome}-এর জন্য",
 "Parar o ditado": "ডিক্টেশন থামান",
 "Parcelado": "কিস্তিতে",
 "Partes desta aba": "এই ট্যাবের অংশ",
 "Passo": "ধাপ",
 "Pastas arquivadas": "আর্কাইভ করা ফোল্ডার",
 "Pastas arquivadas ({n})": "আর্কাইভ করা ফোল্ডার ({n})",
 "Pautada": "রুলটানা",
 "Pautada com margem": "মার্জিনসহ রুলটানা",
 "Pedido de exame": "পরীক্ষার অনুরোধ",
 "Pelo que sou grata hoje?": "আজ আমি কিসের জন্য কৃতজ্ঞ?",
 "Permita o microfone e o reconhecimento de fala para o My Planner nos ajustes do celular.": "ফোনের সেটিংসে My Planner-এর জন্য মাইক্রোফোন ও স্পিচ রিকগনিশনের অনুমতি দিন।",
 "Personalizar: tipo, cor e tema da folha e cores das bolinhas, só para esta aba": "কাস্টমাইজ: পাতার ধরন, রং ও থিম এবং বিন্দুর রং, শুধু এই ট্যাবের জন্য",
 "Pontilhada": "ডটেড",
 "Posto": "পেট্রল পাম্প",
 "Preenche o clima do Meu Dia pela localização do celular.": "ফোনের অবস্থান দিয়ে আমার দিন-এর আবহাওয়া পূরণ করে।",
 "Preencher pela foto do comprovante": "রসিদের ছবি থেকে পূরণ করুন",
 "Primeira vez neste aparelho: digite a senha do diário.": "এই ডিভাইসে প্রথমবার: ডায়েরির পাসওয়ার্ড লিখুন।",
 "Projeto": "প্রকল্প",
 "Projeto de Vida": "জীবন প্রকল্প",
 "Projetos com amigos e família (compartilhados)": "বন্ধু ও পরিবারের সাথে প্রকল্প (শেয়ার করা)",
 "Projetos em Grupo": "গ্রুপ প্রকল্প",
 "Proprietário / Locador": "মালিক / বাড়িওয়ালা",
 "Páginas arquivadas": "আর্কাইভ করা পৃষ্ঠা",
 "Páginas desta aba": "এই ট্যাবের পৃষ্ঠা",
 "QUANDO ELA ABRE": "কবে এটি খুলবে",
 "Qua": "বুধ",
 "Quadriculada": "গ্রিড",
 "Quadro dos Sonhos": "স্বপ্নের বোর্ড",
 "Quais partes você vai usar?": "কোন অংশগুলো ব্যবহার করবেন?",
 "Quando você concluir uma meta ou formar um hábito, ele aparece aqui para celebrar. 🎉": "কোনো লক্ষ্য পূরণ করলে বা অভ্যাস গড়ে তুললে, উদযাপনের জন্য তা এখানে দেখা যাবে। 🎉",
 "Quanto você pagou?": "আপনি কত পরিশোধ করেছেন?",
 "Quanto você recebeu?": "আপনি কত পেয়েছেন?",
 "Que tal revisar o seu mês? ✨": "আপনার মাসটা একবার পর্যালোচনা করবেন? ✨",
 "Quem faz": "কে করবে",
 "Quem fez o meu dia melhor?": "আজ কে আমার দিনটা ভালো করে দিল?",
 "Quer guardar o comprovante agora?": "এখনই রসিদ সংরক্ষণ করবেন?",
 "Qui": "বৃহঃ",
 "REFLEXÃO DO MÊS": "মাসের প্রতিফলন",
 "Recebeu {v} a mais": "{v} বেশি পেয়েছেন",
 "Recebeu {v} a menos": "{v} কম পেয়েছেন",
 "Receita médica": "প্রেসক্রিপশন",
 "Receitas médicas": "প্রেসক্রিপশন",
 "Recolher": "গুটিয়ে নিন",
 "Refeições arquivadas": "আর্কাইভ করা খাবার",
 "Refeições do cronograma feitas (Bem-Estar)": "খাদ্য পরিকল্পনার খাবার সম্পন্ন (সুস্থতা)",
 "Referente a (ex.: material, passeio, inscrição)": "কিসের জন্য (যেমন: উপকরণ, ভ্রমণ, ভর্তি)",
 "Registrar": "লিখে রাখুন",
 "Relacionamentos": "সম্পর্ক",
 "Relatório de estudos": "পড়াশোনার রিপোর্ট",
 "Relatório de realizações": "অর্জনের রিপোর্ট",
 "Relatório em PDF": "PDF রিপোর্ট",
 "Renomear, adicionar ou tirar áreas": "ক্ষেত্রের নাম বদলান, যোগ করুন বা সরান",
 "Reposição": "মেকআপ ক্লাস",
 "Restaurado": "পুনরুদ্ধার হয়েছে",
 "Resumida": "সংক্ষিপ্ত",
 "Resumida: só uma linha com o total. Completa: mostra os itens do dia. Oculta: não aparece. Nada desta aba vira tarefa sozinho.": "সংক্ষিপ্ত: মোটসহ শুধু এক লাইন। সম্পূর্ণ: দিনের আইটেমগুলো দেখায়। লুকানো: দেখা যায় না। এই ট্যাবের কিছুই নিজে থেকে কাজে পরিণত হয় না।",
 "Resumo de {nome}": "{nome}-এর সারসংক্ষেপ",
 "Resumo do dia": "দিনের সারসংক্ষেপ",
 "Retângulo": "আয়তক্ষেত্র",
 "Revisar antes": "আগে পর্যালোচনা করুন",
 "Revisão do mês": "মাসিক পর্যালোচনা",
 "Roda da Vida": "জীবনের চাকা",
 "Rosa": "গোলাপি",
 "Sair sem guardar?": "সংরক্ষণ না করে বের হবেন?",
 "Salvar avaliação de hoje": "আজকের মূল্যায়ন সংরক্ষণ করুন",
 "Salvar ou enviar": "সংরক্ষণ বা পাঠান",
 "Seg": "সোম",
 "Segure e arraste as pastas para mudar a ordem. Arraste para a esquerda para arquivar.": "ক্রম বদলাতে ফোল্ডারগুলো চেপে ধরে টেনে নিন। আর্কাইভ করতে বাঁয়ে সোয়াইপ করুন।",
 "Sem chamada neste dia: cobra todos os alunos.": "এই দিনে হাজিরা নেই: সব শিক্ষার্থীর কাছ থেকে চার্জ নেয়।",
 "Sem ideia do que escrever? Toque numa pergunta:": "কী লিখবেন বুঝতে পারছেন না? একটি প্রশ্নে ট্যাপ করুন:",
 "Sem registros de humor.": "মেজাজের কোনো রেকর্ড নেই।",
 "Sem tema": "থিম নেই",
 "Semana de {d}": "{d} সপ্তাহ",
 "Senha atual do diário": "ডায়েরির বর্তমান পাসওয়ার্ড",
 "Senha do diário": "ডায়েরির পাসওয়ার্ড",
 "Senha do diário incorreta.": "ডায়েরির পাসওয়ার্ড ভুল।",
 "Senha do diário trocada": "ডায়েরির পাসওয়ার্ড বদলানো হয়েছে",
 "Senha própria só do diário": "শুধু ডায়েরির জন্য আলাদা পাসওয়ার্ড",
 "Sequência dos hábitos": "অভ্যাসের ধারাবাহিকতা",
 "Seta": "তীর",
 "Seu diário, só seu": "আপনার ডায়েরি, শুধু আপনার",
 "Seu texto de motivação": "আপনার অনুপ্রেরণার লেখা",
 "Sex": "শুক্র",
 "Sonho": "স্বপ্ন",
 "Suplementos arquivados": "আর্কাইভ করা সাপ্লিমেন্ট",
 "Sáb": "শনি",
 "Só abre com a senha do diário.": "শুধু ডায়েরির পাসওয়ার্ড দিয়ে খোলে।",
 "TEMA DECORATIVO": "সাজসজ্জার থিম",
 "TIPO DE FOLHA": "পাতার ধরন",
 "Tarefas arquivadas": "আর্কাইভ করা কাজ",
 "Ter": "মঙ্গল",
 "Texto para o paciente": "রোগীর জন্য লেখা",
 "Tipo, cor e tema da folha": "পাতার ধরন, রং ও থিম",
 "Tirar a área \"{a}\"?": "\"{a}\" ক্ষেত্রটি সরাবেন?",
 "Tirar da frase do dia": "দিনের বাণী থেকে সরান",
 "Tirar do arquivo": "আর্কাইভ থেকে সরান",
 "Tirar esta foto do quadro?": "এই ছবিটি বোর্ড থেকে সরাবেন?",
 "Tirar esta pergunta?": "এই প্রশ্নটি সরাবেন?",
 "Tirar este vídeo?": "এই ভিডিওটি সরাবেন?",
 "Todo dia às {h}: \"Como foi o seu dia? ✍️\"": "প্রতিদিন {h}টায়: \"আপনার দিন কেমন কাটল? ✍️\"",
 "Todos os alunos já têm uma cobrança com esta referência.": "সব শিক্ষার্থীর এই রেফারেন্সে আগেই একটি চার্জ আছে।",
 "Toque de novo para \"Outros\" (dispensado, atestado...): não conta como falta nem como aula.": "\"অন্যান্য\"-এর জন্য আবার ট্যাপ করুন (ছুটি দেওয়া, মেডিকেল সার্টিফিকেট...): অনুপস্থিতি বা ক্লাস কোনোটিই হিসেবে গণ্য হয় না।",
 "Toque no círculo para marcar o que fez hoje. Os hábitos não vão para o My Planner sozinhos: use Enviar, no menu ⋮.": "আজ যা করেছেন তা চিহ্নিত করতে বৃত্তে ট্যাপ করুন। অভ্যাসগুলো নিজে থেকে My Planner-এ যায় না: ⋮ মেনুতে পাঠান ব্যবহার করুন।",
 "Toque num dia para marcar ou desmarcar.": "চিহ্নিত করতে বা চিহ্ন তুলতে একটি দিনে ট্যাপ করুন।",
 "Toque numa bolinha para trocar a cor. Na página, segurar a bolinha faz o mesmo.": "রং বদলাতে একটি বিন্দুতে ট্যাপ করুন। পৃষ্ঠায় বিন্দুটি চেপে ধরলেও একই হয়।",
 "Toque para abrir. Arraste para a esquerda para arquivar ou duplicar, ou para a direita para excluir.": "খুলতে ট্যাপ করুন। আর্কাইভ বা ডুপ্লিকেট করতে বাঁয়ে, মুছতে ডানে সোয়াইপ করুন।",
 "Treino do dia feito (Bem-Estar)": "দিনের ব্যায়াম সম্পন্ন (সুস্থতা)",
 "Treinos arquivados": "আর্কাইভ করা ব্যায়াম",
 "Trocar a senha do diário": "ডায়েরির পাসওয়ার্ড বদলান",
 "Tudo o que você escrever no diário fica criptografado neste dispositivo antes de ir para a sua conta. Ninguém mais consegue ler, nem o suporte.": "ডায়েরিতে আপনি যা লেখেন সব আপনার অ্যাকাউন্টে যাওয়ার আগে এই ডিভাইসেই এনক্রিপ্ট হয়। আর কেউ পড়তে পারে না, সাপোর্টও না।",
 "Tudo o que você exclui fica aqui por 30 dias. Depois disso sai de vez.": "আপনি যা মোছেন সব ৩০ দিন এখানে থাকে। এরপর স্থায়ীভাবে মুছে যায়।",
 "Título (ex.: Ter uma boa alimentação)": "শিরোনাম (যেমন: স্বাস্থ্যকর খাবার খাওয়া)",
 "Uma cobrança avulsa para cada um dos {n} aluno(s). Para cobrar só um aluno, toque em +.": "{n} জন শিক্ষার্থীর প্রত্যেকের জন্য একটি একক চার্জ। শুধু একজন শিক্ষার্থীর কাছ থেকে চার্জ নিতে + ট্যাপ করুন।",
 "Uma senha própria, só do diário": "শুধু ডায়েরির জন্য একটি আলাদা পাসওয়ার্ড",
 "Usar a senha do diário": "ডায়েরির পাসওয়ার্ড ব্যবহার করুন",
 "Usar como frase do dia": "দিনের বাণী হিসেবে ব্যবহার করুন",
 "Usar este valor": "এই পরিমাণ ব্যবহার করুন",
 "Usar o padrão do app": "অ্যাপের ডিফল্ট ব্যবহার করুন",
 "Vale para os valores de todas as abas (Finanças, aluguel, mensalidades...).": "সব ট্যাবের পরিমাণের জন্য প্রযোজ্য (অর্থায়ন, ভাড়া, মাসিক ফি...)।",
 "Vale para todas as páginas com escrita (Estudos, Anotações, Diário, Documentos...). Cada aba pode ter o próprio padrão em Ajustes › Abas, e cada página pode mudar a folha no ⋮ › Folha.": "লেখার সব পৃষ্ঠার জন্য প্রযোজ্য (পড়াশোনা, নোট, ডায়েরি, নথি...)। প্রতিটি ট্যাবের নিজস্ব ডিফল্ট সেটিংস › ট্যাব-এ দেওয়া যায়, এবং প্রতিটি পৃষ্ঠা ⋮ › পাতা থেকে পাতা বদলাতে পারে।",
 "Valor da aula extra (por aluno)": "অতিরিক্ত ক্লাসের মূল্য (প্রতি শিক্ষার্থী)",
 "Valor por aluno": "প্রতি শিক্ষার্থী মূল্য",
 "Valor previsto: {v}": "প্রত্যাশিত পরিমাণ: {v}",
 "Vencimento: {d}": "শেষ তারিখ: {d}",
 "Ver o comprovante": "রসিদ দেখুন",
 "Verde": "সবুজ",
 "Visualizar": "প্রিভিউ",
 "Você está como convidado": "আপনি অতিথি হিসেবে আছেন",
 "Voltar a acompanhar este hábito": "এই অভ্যাসটি আবার অনুসরণ করুন",
 "Voltar ao início da folha": "পাতার শুরুতে ফিরে যান",
 "Voltar ao padrão inicial (folha pautada; preto, azul, vermelho e verde)": "প্রাথমিক ডিফল্টে ফিরে যান (রুলটানা পাতা; কালো, নীল, লাল ও সবুজ)",
 "Voltar para a nova avaliação": "নতুন মূল্যায়নে ফিরে যান",
 "Vídeos": "ভিডিও",
 "X vezes por semana": "সপ্তাহে X বার",
 "abre em {n} dias": "{n} দিনে খুলবে",
 "agradável": "মনোরম",
 "arquivo": "ফাইল",
 "aula extra": "অতিরিক্ত ক্লাস",
 "calor": "গরম",
 "chuva": "বৃষ্টি",
 "concluído": "সম্পন্ন",
 "céu limpo": "পরিষ্কার আকাশ",
 "de {n} planejados": "পরিকল্পিত {n}-এর মধ্যে",
 "dentro de {p}": "{p}-এর মধ্যে",
 "enviado em {d}": "{d} তারিখে পাঠানো হয়েছে",
 "estudados na semana": "সপ্তাহে পড়া হয়েছে",
 "excluído em {d}": "{d} তারিখে মোছা হয়েছে",
 "falta 1 dia": "১ দিন বাকি",
 "faltam {n} dias": "{n} দিন বাকি",
 "feito {dur} na semana": "সপ্তাহে {dur} করা হয়েছে",
 "fresco": "শীতল",
 "frio": "ঠান্ডা",
 "garoa": "গুঁড়ি গুঁড়ি বৃষ্টি",
 "hoje não está planejado": "আজ পরিকল্পিত নয়",
 "hábito formado ✨": "অভ্যাস গড়ে উঠেছে ✨",
 "incorreta": "ভুল",
 "neblina": "কুয়াশা",
 "neve": "তুষার",
 "nublado": "মেঘলা",
 "não enviado": "পাঠানো হয়নি",
 "parcela {k}/{n}": "কিস্তি {k}/{n}",
 "passou há {n} dias": "{n} দিন আগে পেরিয়ে গেছে",
 "pelo Bem-Estar": "সুস্থতা থেকে",
 "poucas nuvens": "হালকা মেঘ",
 "reposição": "মেকআপ ক্লাস",
 "sai de vez em {n} dia(s)": "{n} দিনের মধ্যে স্থায়ীভাবে মুছে যাবে",
 "sem registros": "কোনো রেকর্ড নেই",
 "tempestade": "ঝড়",
 "tracejado: {d}": "ড্যাশ লাইন: {d}",
 "ver mais": "আরও দেখুন",
 "ver menos": "কম দেখুন",
 "{aluno}: {n} de {max}": "{aluno}: {max}-এর মধ্যে {n}",
 "{d} é feriado: {f}. Registrar mesmo assim?": "{d} ছুটির দিন: {f}। তবুও লিখে রাখবেন?",
 "{f} de {n} passos feitos": "{n}টির মধ্যে {f}টি ধাপ সম্পন্ন",
 "{f}/{n} passos": "{f}/{n} ধাপ",
 "{nome} daqui a 1 ano": "১ বছর পরের {nome}",
 "{nome} daqui a 10 anos": "১০ বছর পরের {nome}",
 "{nome} daqui a 6 meses": "৬ মাস পরের {nome}",
 "{n} aluno(s) recebem só a própria nota de \"{a}\".": "{n} জন শিক্ষার্থী \"{a}\"-এ শুধু নিজের নম্বর পাবে।",
 "{n} aluno(s) receberam a nota.": "{n} জন শিক্ষার্থী নম্বর পেয়েছে।",
 "{n} aluno(s) · {v} cada": "{n} জন শিক্ষার্থী · প্রত্যেকে {v}",
 "{n} anos": "{n} বছর",
 "{n} dia(s) antes": "{n} দিন আগে",
 "{n} dia(s) cumprido(s) no mês": "মাসে {n} দিন পালিত",
 "{n} dia(s) registrado(s) · média {e}": "{n} দিন লেখা হয়েছে · গড় {e}",
 "{n} dia(s) registrado(s), média {m} de 6": "{n} দিন লেখা হয়েছে, গড় ৬-এর মধ্যে {m}",
 "{n} dia(s) seguido(s)": "টানা {n} দিন",
 "{n} dispensada(s) hoje": "আজ {n}টি বাদ দেওয়া হয়েছে",
 "{n} meses": "{n} মাস",
 "{n} outro(s)": "আরও {n}টি",
 "{n} selecionado(s)": "{n}টি নির্বাচিত",
 "{n} tarefa(s) concluída(s) no My Planner": "My Planner-এ {n}টি কাজ সম্পন্ন",
 "{n} vez(es) por semana": "সপ্তাহে {n} বার",
 "{n}x": "{n}x",
 "Água: {a} de {m} ml": "পানি: {m} ml-এর মধ্যে {a}",
 "ÚLTIMAS 8 SEMANAS": "গত ৮ সপ্তাহ",
 "Última parcela em {d}": "শেষ কিস্তি {d} তারিখে",
 "é hoje!": "আজই!",
 "A mesma do app": "অ্যাপেরটাই",
 "Abrir com o código": "কোড দিয়ে খুলুন",
 "Ainda não criado": "এখনো তৈরি হয়নি",
 "Ao criar, o app mostra um código de recuperação para você guardar.": "তৈরি করার সময় অ্যাপ আপনাকে সংরক্ষণের জন্য একটি পুনরুদ্ধার কোড দেখাবে।",
 "Apagar o diário e começar de novo": "ডায়েরি মুছে নতুন করে শুরু করুন",
 "Biometria ou código do dispositivo": "বায়োমেট্রিক বা ডিভাইসের কোড",
 "Biometria, PIN do dispositivo ou a senha do app. Não precisa criar outra senha.": "বায়োমেট্রিক, ডিভাইসের PIN বা অ্যাপের পাসওয়ার্ড। আলাদা পাসওয়ার্ড তৈরি করতে হবে না।",
 "Bloquear o app": "অ্যাপ লক করুন",
 "Cadastre digital, rosto ou um código de bloqueio no dispositivo para usar.": "ব্যবহার করতে ডিভাইসে আঙুলের ছাপ, মুখ বা লক কোড সেট করুন।",
 "Com a biometria ligada, ela aparece primeiro. Se falhar, a mesma janela oferece o código/PIN/padrão do dispositivo; a senha do app continua valendo.": "বায়োমেট্রিক চালু থাকলে এটি প্রথমে আসে। ব্যর্থ হলে একই উইন্ডোতে ডিভাইসের কোড/PIN/প্যাটার্ন পাওয়া যায়; অ্যাপের পাসওয়ার্ডও কাজ করে।",
 "Com ele você recupera o diário se esquecer a senha ou trocar de dispositivo.": "পাসওয়ার্ড ভুলে গেলে বা ডিভাইস বদলালে এটি দিয়ে ডায়েরি পুনরুদ্ধার করতে পারবেন।",
 "Com este código você recupera o diário se esquecer a senha ou trocar de dispositivo. Guarde em lugar seguro e não mostre a ninguém.": "পাসওয়ার্ড ভুলে গেলে বা ডিভাইস বদলালে এই কোড দিয়ে ডায়েরি পুনরুদ্ধার করতে পারবেন। নিরাপদ জায়গায় রাখুন এবং কাউকে দেখাবেন না।",
 "Como funciona a Roda da Vida": "জীবনের চাকা কীভাবে কাজ করে",
 "Como o diário abre": "ডায়েরি কীভাবে খোলে",
 "Crie a senha que vai abrir o diário.": "ডায়েরি খোলার পাসওয়ার্ড তৈরি করুন।",
 "Crie o PIN do diário (4 a 6 números)": "ডায়েরির PIN তৈরি করুন (৪ থেকে ৬টি সংখ্যা)",
 "Crie o diário de novo para começar.": "শুরু করতে আবার ডায়েরি তৈরি করুন।",
 "Código aceito. Crie uma senha nova para o diário.": "কোড গৃহীত হয়েছে। ডায়েরির জন্য নতুন পাসওয়ার্ড তৈরি করুন।",
 "Código de recuperação": "পুনরুদ্ধার কোড",
 "Código de recuperação (ex.: ABCD-EFGH-...)": "পুনরুদ্ধার কোড (যেমন: ABCD-EFGH-...)",
 "Código de recuperação incorreto.": "পুনরুদ্ধার কোড ভুল।",
 "Cômodos": "ঘরসমূহ",
 "Depois de 1 minuto": "১ মিনিট পরে",
 "Depois de {n} minutos": "{n} মিনিট পরে",
 "Desenhe o padrão do diário": "ডায়েরির প্যাটার্ন আঁকুন",
 "Dias no mês": "মাসে দিন",
 "Dias seguidos": "টানা দিন",
 "Digite o seu PIN": "আপনার PIN দিন",
 "Diário ainda não criado": "ডায়েরি এখনো তৈরি হয়নি",
 "Dê uma nota de 0 a 10 para como você se sente hoje em cada área da vida. O desenho mostra onde a sua vida está equilibrada e onde precisa de atenção. Salve a avaliação e repita de tempos em tempos (por exemplo, todo mês) para comparar e ver a sua evolução. Você pode renomear, adicionar ou tirar áreas.": "আজ জীবনের প্রতিটি ক্ষেত্রে আপনি কেমন বোধ করছেন, তাকে ০ থেকে ১০ পর্যন্ত নম্বর দিন। চিত্রটি দেখায় আপনার জীবন কোথায় ভারসাম্যপূর্ণ আর কোথায় মনোযোগ দরকার। মূল্যায়নটি সংরক্ষণ করুন এবং মাঝে মাঝে (যেমন প্রতি মাসে) আবার করুন, যাতে তুলনা করে নিজের অগ্রগতি দেখতে পারেন। আপনি ক্ষেত্রগুলোর নাম বদলাতে, নতুন যোগ করতে বা সরাতে পারেন।",
 "Entre na aba Diário para criar o seu diário.": "আপনার ডায়েরি তৈরি করতে ডায়েরি ট্যাবে যান।",
 "Entre no Diário (com a senha dele ou o desbloqueio do app) e volte aqui.": "ডায়েরিতে প্রবেশ করুন (এর পাসওয়ার্ড বা অ্যাপ আনলক দিয়ে) এবং এখানে ফিরে আসুন।",
 "Esconder a senha": "পাসওয়ার্ড লুকান",
 "Gerar novo código": "নতুন কোড তৈরি করুন",
 "Gerar um código de recuperação novo?": "নতুন পুনরুদ্ধার কোড তৈরি করবেন?",
 "Guarde este código": "এই কোডটি সংরক্ষণ করুন",
 "Já guardei": "সংরক্ষণ করেছি",
 "Ligar um hábito que já existe": "বিদ্যমান একটি অভ্যাসের সাথে যুক্ত করুন",
 "Mostrar a senha": "পাসওয়ার্ড দেখান",
 "Mudar como o diário abre": "ডায়েরি খোলার পদ্ধতি বদলান",
 "My Planner · Código de recuperação do Diário": "My Planner · ডায়েরির পুনরুদ্ধার কোড",
 "Não foi possível abrir com a chave deste dispositivo. Use a senha do diário ou o código de recuperação.": "এই ডিভাইসের কী দিয়ে খোলা যায়নি। ডায়েরির পাসওয়ার্ড বা পুনরুদ্ধার কোড ব্যবহার করুন।",
 "O Caps Lock parece estar ligado.": "মনে হচ্ছে Caps Lock চালু আছে।",
 "O PIN fica guardado só neste dispositivo, protegido. A senha continua valendo se você esquecer o PIN.": "PIN শুধু এই ডিভাইসেই সুরক্ষিতভাবে রাখা হয়। PIN ভুলে গেলেও পাসওয়ার্ড কাজ করবে।",
 "O PIN precisa ter de 4 a 6 números.": "PIN-এ ৪ থেকে ৬টি সংখ্যা থাকতে হবে।",
 "O código anterior deixa de valer. Por segurança, o código não fica guardado no app: só dá para ver na hora em que é gerado.": "আগের কোডটি আর কাজ করবে না। নিরাপত্তার জন্য কোডটি অ্যাপে সংরক্ষিত হয় না: শুধু তৈরির সময়ই দেখা যায়।",
 "O código não fica guardado em lugar nenhum que o suporte possa ver. Sem a senha e sem o código, o diário não pode ser recuperado.": "কোডটি এমন কোথাও সংরক্ষিত হয় না যা সাপোর্ট টিম দেখতে পারে। পাসওয়ার্ড ও কোড ছাড়া ডায়েরি পুনরুদ্ধার করা যায় না।",
 "O diário agora abre só com a senha dele.": "এখন ডায়েরি শুধু নিজের পাসওয়ার্ড দিয়ে খোলে।",
 "O reconhecimento de rosto deste dispositivo não pode ser usado por apps. Use a digital ou o código/PIN do dispositivo.": "এই ডিভাইসের মুখ শনাক্তকরণ অ্যাপ ব্যবহার করতে পারে না। আঙুলের ছাপ বা ডিভাইসের কোড/PIN ব্যবহার করুন।",
 "O tempo conta a partir do momento em que o app sai da tela (outro app, tela inicial ou tela apagada). Puxar as notificações, a janela da biometria, um pedido de permissão ou escolher uma foto ou arquivo não contam.": "অ্যাপ স্ক্রিন থেকে সরে যাওয়ার মুহূর্ত থেকে সময় গণনা শুরু হয় (অন্য অ্যাপ, হোম স্ক্রিন বা স্ক্রিন বন্ধ)। নোটিফিকেশন টেনে নামানো, বায়োমেট্রিক উইন্ডো, অনুমতির অনুরোধ বা ছবি বা ফাইল বেছে নেওয়া গণনায় ধরা হয় না।",
 "Os PINs não conferem.": "PIN মিলছে না।",
 "PIN": "PIN",
 "PIN (4 a 6 números)": "PIN (৪ থেকে ৬টি সংখ্যা)",
 "PIN (só números, 4 a 6)": "PIN (শুধু সংখ্যা, ৪ থেকে ৬)",
 "PIN do diário": "ডায়েরির PIN",
 "PIN incorreto": "ভুল PIN",
 "PIN salvo.": "PIN সংরক্ষিত হয়েছে।",
 "Padrão do app": "অ্যাপের ডিফল্ট",
 "Para apagar, confirme com a senha do app, biometria ou PIN do dispositivo. Isso apaga o Meu Dia, metas, hábitos, cartas e fotos do diário. Projetos em Grupo continuam.": "মুছতে অ্যাপের পাসওয়ার্ড, বায়োমেট্রিক বা ডিভাইসের PIN দিয়ে নিশ্চিত করুন। এতে ডায়েরির আমার দিন, লক্ষ্যসমূহ, অভ্যাস, চিঠি ও ছবি মুছে যাবে। গ্রুপ প্রকল্প থেকে যাবে।",
 "Para continuar, digite a senha do app ou use a biometria/o código do dispositivo.": "চালিয়ে যেতে অ্যাপের পাসওয়ার্ড দিন বা ডিভাইসের বায়োমেট্রিক/কোড ব্যবহার করুন।",
 "Para recuperar o diário se esquecer a senha ou trocar de dispositivo.": "পাসওয়ার্ড ভুলে গেলে বা ডিভাইস বদলালে ডায়েরি পুনরুদ্ধার করতে।",
 "Pastas": "ফোল্ডার",
 "Pedir a senha de novo": "আবার পাসওয়ার্ড চান",
 "Personalizada": "কাস্টম",
 "Primeira vez neste dispositivo: digite a senha do diário ou use o código de recuperação.": "এই ডিভাইসে প্রথমবার: ডায়েরির পাসওয়ার্ড দিন বা পুনরুদ্ধার কোড ব্যবহার করুন।",
 "Primeira vez neste dispositivo: digite o código de recuperação do diário.": "এই ডিভাইসে প্রথমবার: ডায়েরির পুনরুদ্ধার কোড দিন।",
 "Reconhecimento de rosto": "মুখ শনাক্তকরণ",
 "Repita o PIN": "PIN আবার দিন",
 "Salvar a senha nova": "নতুন পাসওয়ার্ড সংরক্ষণ করুন",
 "Salvar em arquivo / no Drive": "ফাইলে / Drive-এ সংরক্ষণ করুন",
 "Salvar o código de recuperação": "পুনরুদ্ধার কোড সংরক্ষণ করুন",
 "Senha (letras e números)": "পাসওয়ার্ড (অক্ষর ও সংখ্যা)",
 "Senha do app": "অ্যাপের পাসওয়ার্ড",
 "Senha nova do diário": "ডায়েরির নতুন পাসওয়ার্ড",
 "Senha própria": "আলাদা পাসওয়ার্ড",
 "Senha própria do diário": "ডায়েরির আলাদা পাসওয়ার্ড",
 "Tarefas": "কাজ",
 "Trocar o PIN": "PIN বদলান",
 "Usar a senha": "পাসওয়ার্ড ব্যবহার করুন",
 "Usar o PIN": "PIN ব্যবহার করুন",
 "Usar o código de recuperação": "পুনরুদ্ধার কোড ব্যবহার করুন",
 "Usar o desbloqueio do app": "অ্যাপ আনলক ব্যবহার করুন",
 "Use a biometria ou o código/PIN/padrão do dispositivo.": "বায়োমেট্রিক বা ডিভাইসের কোড/PIN/প্যাটার্ন ব্যবহার করুন।",
 "Use o código de recuperação que apareceu quando o diário foi criado. Sem a senha e sem o código, ninguém consegue abrir o diário, nem o suporte.": "ডায়েরি তৈরির সময় যে পুনরুদ্ধার কোড দেখানো হয়েছিল তা ব্যবহার করুন। পাসওয়ার্ড ও কোড ছাড়া কেউই ডায়েরি খুলতে পারে না, সাপোর্ট টিমও না।",
 "Voltar a usar só a senha?": "আবার শুধু পাসওয়ার্ড ব্যবহার করবেন?",
 "incorreto": "ভুল",
 "1 h": "১ ঘণ্টা",
 "12 horas (2:30 PM)": "১২ ঘণ্টা (2:30 PM)",
 "15 min": "১৫ মিনিট",
 "24 horas (14:30)": "২৪ ঘণ্টা (14:30)",
 "30 min": "৩০ মিনিট",
 "A lixeira tem itens grandes. Confirme com a senha do app, a biometria ou o código do dispositivo.": "ট্র্যাশে বড় আইটেম আছে। অ্যাপের পাসওয়ার্ড, বায়োমেট্রিক বা ডিভাইসের কোড দিয়ে নিশ্চিত করুন।",
 "A semana começa na": "সপ্তাহ শুরু হয়",
 "Abra o Diário primeiro": "আগে ডায়েরি খুলুন",
 "Abrir configurações do celular": "ফোনের সেটিংস খুলুন",
 "Agenda e mapas": "ক্যালেন্ডার ও মানচিত্র",
 "Agora: {m}": "এখন: {m}",
 "Ajuda e sobre": "সাহায্য ও পরিচিতি",
 "Alarme (som)": "অ্যালার্ম (শব্দ)",
 "Alarme ou vibração das pausas": "বিরতির অ্যালার্ম বা ভাইব্রেশন",
 "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Pede a sua senha antes.": "অ্যাকাউন্ট এবং ক্লাউড ও এই ডিভাইসের সব তথ্য চিরতরে মুছে ফেলে। আগে আপনার পাসওয়ার্ড চায়।",
 "Apagar todas ({n})": "সব মুছুন ({n})",
 "Apagar {n} selecionada(s)": "{n}টি নির্বাচিত মুছুন",
 "Aparência": "চেহারা",
 "App das rotas": "পথনির্দেশের অ্যাপ",
 "Ardósia": "স্লেট",
 "Arrastar para a direita": "ডানে টানুন",
 "Arrastar para a esquerda": "বামে টানুন",
 "As contas de Finanças aparecem no My Planner com essa antecedência.": "অর্থায়নের বিলগুলো My Planner-এ এত দিন আগে দেখা যায়।",
 "Atualizações e sobre": "আপডেট ও পরিচিতি",
 "Avisar antes do vencimento": "নির্ধারিত তারিখের আগে জানান",
 "Aviso marcado": "রিমাইন্ডার সেট হয়েছে",
 "Aviso no começo e no fim de cada pausa": "প্রতিটি বিরতির শুরু ও শেষে বিজ্ঞপ্তি",
 "Avisos desta aba": "এই ট্যাবের বিজ্ঞপ্তি",
 "Avisos e alarmes": "বিজ্ঞপ্তি ও অ্যালার্ম",
 "Avisos silenciosos": "নীরব বিজ্ঞপ্তি",
 "Avisos: som e vibração": "বিজ্ঞপ্তি: শব্দ ও ভাইব্রেশন",
 "Avisos: só som": "বিজ্ঞপ্তি: শুধু শব্দ",
 "Avisos: só vibração": "বিজ্ঞপ্তি: শুধু ভাইব্রেশন",
 "Azul elétrico": "ইলেকট্রিক নীল",
 "Azul-aço": "স্টিল নীল",
 "Azul-bebê": "বেবি ব্লু",
 "Azul-marinho": "নেভি ব্লু",
 "Baixar meus dados": "আমার তথ্য ডাউনলোড করুন",
 "Baixar todos os meus dados": "আমার সব তথ্য ডাউনলোড করুন",
 "Baixar todos os meus dados e excluir a conta (LGPD)": "আমার সব তথ্য ডাউনলোড করুন ও অ্যাকাউন্ট মুছুন (LGPD)",
 "Biometria": "বায়োমেট্রিক",
 "Bissexual": "বাইসেক্সুয়াল",
 "Brilhante": "উজ্জ্বল",
 "Buscar abas": "ট্যাব খুঁজুন",
 "Buscar nos ajustes": "সেটিংসে খুঁজুন",
 "Cancelar aviso": "রিমাইন্ডার বাতিল করুন",
 "Cinza-chumbo": "চারকোল ধূসর",
 "Cofre": "ভল্ট",
 "Coloque pelo menos uma matéria.": "অন্তত একটি বিষয় যোগ করুন।",
 "Como usar": "কীভাবে ব্যবহার করবেন",
 "Conexões": "সংযোগ",
 "Cor da aba": "ট্যাবের রং",
 "Cor de destaque": "হাইলাইট রং",
 "Crie uma matéria primeiro": "আগে একটি বিষয় তৈরি করুন",
 "Cítrico": "সাইট্রাস",
 "Cópia de segurança em arquivo": "ফাইলে ব্যাকআপ",
 "Dados de paciente e prontuário. Confirme com a senha do app, a biometria ou o código do dispositivo.": "রোগীর তথ্য ও মেডিকেল রেকর্ড। অ্যাপের পাসওয়ার্ড, বায়োমেট্রিক বা ডিভাইসের কোড দিয়ে নিশ্চিত করুন।",
 "Desligadas": "বন্ধ",
 "Digite a senha da sua conta para confirmar.": "নিশ্চিত করতে আপনার অ্যাকাউন্টের পাসওয়ার্ড লিখুন।",
 "Duração padrão de uma tarefa nova": "নতুন কাজের ডিফল্ট সময়কাল",
 "Editar sessão": "সেশন সম্পাদনা করুন",
 "Ela se repete sem data de fim: aparecem as vezes até {data}. Com todas marcadas, sai a tarefa inteira.": "এটি শেষ তারিখ ছাড়াই পুনরাবৃত্তি হয়: {data} পর্যন্ত বারগুলো দেখানো হচ্ছে। সব চিহ্নিত করলে পুরো কাজটি সরে যাবে।",
 "Em atividade": "চলমান",
 "Em pausa": "বিরতিতে",
 "Emoji da pausa": "বিরতির ইমোজি",
 "Encerrar": "শেষ করুন",
 "Encerrar a sessão?": "সেশন শেষ করবেন?",
 "Entra no modo seleção, para escolher vários itens de uma vez.": "নির্বাচন মোডে যায়, যাতে একসাথে অনেক আইটেম বাছাই করা যায়।",
 "Escolha um horário no futuro.": "ভবিষ্যতের একটি সময় বেছে নিন।",
 "Escolher a matéria": "বিষয় বেছে নিন",
 "Esconde os valores em dinheiro (R$ •••)": "টাকার অঙ্ক লুকায় (R$ •••)",
 "Esconder o CPF": "CPF লুকান",
 "Esconder os valores": "অঙ্ক লুকান",
 "Esta e as próximas": "এটি ও পরেরগুলো",
 "Esta tarefa se repete. Onde aplicar a mudança?": "এই কাজটি পুনরাবৃত্তি হয়। পরিবর্তন কোথায় প্রয়োগ করবেন?",
 "Este item tem muita coisa dentro. Confirme com a senha do app, a biometria ou o código do dispositivo.": "এই আইটেমের ভেতরে অনেক কিছু আছে। অ্যাপের পাসওয়ার্ড, বায়োমেট্রিক বা ডিভাইসের কোড দিয়ে নিশ্চিত করুন।",
 "Exclui o item (pede confirmação). Depois dá para desfazer ou restaurar pela Lixeira.": "আইটেমটি মুছে ফেলে (নিশ্চিতকরণ চায়)। পরে পূর্বাবস্থায় ফেরানো বা ট্র্যাশ থেকে পুনরুদ্ধার করা যায়।",
 "Excluir minha conta": "আমার অ্যাকাউন্ট মুছুন",
 "Ficha protegida": "সুরক্ষিত রেকর্ড",
 "Formato da hora": "সময়ের ফরম্যাট",
 "Foto do Quadro dos Sonhos": "স্বপ্নের বোর্ডের ছবি",
 "Geral": "সাধারণ",
 "Gestos": "অঙ্গভঙ্গি",
 "Google Drive, OneDrive e arquivo de cópia": "Google Drive, OneDrive ও ব্যাকআপ ফাইল",
 "Grafite": "গ্রাফাইট",
 "Guardar em": "এখানে সংরক্ষণ করুন",
 "Hábito do Diário": "ডায়েরির অভ্যাস",
 "Idioma e moeda": "ভাষা ও মুদ্রা",
 "Inspiração do Diário": "ডায়েরির অনুপ্রেরণা",
 "Intenso": "তীব্র",
 "Item arquivado": "আইটেম আর্কাইভ করা হয়েছে",
 "Item excluído": "আইটেম মুছে ফেলা হয়েছে",
 "Lavanda": "ল্যাভেন্ডার",
 "Ligadas": "চালু",
 "Limite de energia": "শক্তির সীমা",
 "Lésbica": "লেসবিয়ান",
 "Marque as vezes que vão ser apagadas.": "যে বারগুলো মুছে ফেলা হবে সেগুলো চিহ্নিত করুন।",
 "Matéria": "বিষয়",
 "Me avise em…": "আমাকে মনে করিয়ে দিন…",
 "Menta": "মিন্ট",
 "Menu ⋮": "মেনু ⋮",
 "Meta do Diário": "ডায়েরির লক্ষ্য",
 "Modo discreto": "গোপন মোড",
 "Monte a sessão uma vez (matérias, tempo de cada uma e pausas) e repita nos outros dias tocando em Começar. O tempo estudado entra sozinho na meta.": "একবার সেশন সাজান (বিষয়, প্রতিটির সময় ও বিরতি) এবং অন্য দিনগুলোতে শুরু করুন চেপে পুনরাবৃত্তি করুন। পড়ার সময় নিজে থেকেই লক্ষ্যে যোগ হয়।",
 "Mostra Arquivar e Duplicar.": "আর্কাইভ ও ডুপ্লিকেট দেখায়।",
 "Mostrar feriados no topo": "উপরে ছুটির দিন দেখান",
 "Mostrar os valores": "অঙ্ক দেখান",
 "Muda a ordem dos itens.": "আইটেমগুলোর ক্রম বদলায়।",
 "Muda só a cor do My Planner. A cor de destaque do app fica em Ajustes > Aparência. Cada tarefa pode ter uma cor própria na ficha.": "শুধু My Planner-এর রং বদলায়। অ্যাপের হাইলাইট রং সেটিংস > চেহারায় আছে। প্রতিটি কাজের রেকর্ডে নিজস্ব রং থাকতে পারে।",
 "Nada encontrado nos ajustes.": "সেটিংসে কিছু পাওয়া যায়নি।",
 "Nenhuma sessão salva ainda.": "এখনো কোনো সেশন সংরক্ষিত হয়নি।",
 "Neon": "নিয়ন",
 "Nesse horário o app não toca nem vibra. Os avisos continuam chegando, em silêncio.": "এই সময়ে অ্যাপ বাজবে না বা ভাইব্রেট করবে না। বিজ্ঞপ্তি নীরবে আসতে থাকবে।",
 "No menu ⋮ de qualquer item: o celular avisa na hora escolhida, sem criar tarefa no My Planner.": "যেকোনো আইটেমের মেনু ⋮-এ: ফোন বেছে নেওয়া সময়ে জানায়, My Planner-এ কাজ তৈরি না করেই।",
 "Nome (ex.: Sessão do mestrado)": "নাম (যেমন: মাস্টার্সের সেশন)",
 "Nova sessão": "নতুন সেশন",
 "Nuvem e cópias de segurança": "ক্লাউড ও ব্যাকআপ",
 "Não perturbe": "বিরক্ত করবেন না",
 "Não perturbe {de}–{ate}": "বিরক্ত করবেন না {de}–{ate}",
 "Não-binário": "নন-বাইনারি",
 "O botão 🎉 Feriados no topo do My Planner. O país e a lista de feriados ficam em Ajustes > Feriados.": "My Planner-এর উপরে 🎉 ছুটির দিন বোতাম। দেশ ও ছুটির তালিকা সেটিংস > ছুটির দিন-এ আছে।",
 "O celular avisa às {h}.": "ফোন {h}-এ জানাবে।",
 "O que sai do Diário fica cifrado na lixeira. Entre no Diário e depois volte aqui para restaurar.": "ডায়েরি থেকে যা সরানো হয় তা ট্র্যাশে এনক্রিপ্ট করা থাকে। পুনরুদ্ধার করতে ডায়েরিতে ঢুকে তারপর এখানে ফিরে আসুন।",
 "O que sair fica na Lixeira por 30 dias. Digite a senha da sua conta para confirmar.": "যা সরবে তা ৩০ দিন ট্র্যাশে থাকবে। নিশ্চিত করতে আপনার অ্যাকাউন্টের পাসওয়ার্ড লিখুন।",
 "O que saiu fica na Lixeira por 30 dias.": "যা সরানো হয়েছে তা ৩০ দিন ট্র্যাশে থাকবে।",
 "O tema muda as cores das abas, a cor de destaque e um toque leve no fundo, nos modos claro e escuro. Para trocar a cor de uma aba só, vá em Ajustes > Abas.": "থিম লাইট ও ডার্ক মোডে ট্যাবের রং, হাইলাইট রং এবং পটভূমিতে হালকা ছোঁয়া বদলায়। শুধু একটি ট্যাবের রং বদলাতে সেটিংস > ট্যাব-এ যান।",
 "O tempo estudado até agora entra na meta.": "এখন পর্যন্ত পড়ার সময় লক্ষ্যে যোগ হবে।",
 "Oliva": "জলপাই",
 "Orgulho": "প্রাইড",
 "Os avisos funcionam no app instalado, com as notificações ligadas.": "বিজ্ঞপ্তি ইনস্টল করা অ্যাপে, নোটিফিকেশন চালু থাকলে কাজ করে।",
 "Os gestos do app": "অ্যাপের অঙ্গভঙ্গি",
 "Outro (escolher a hora)": "অন্য (সময় বেছে নিন)",
 "Pansexual": "প্যানসেক্সুয়াল",
 "Para ligar, use o app no celular (Ajustes › Agenda e mapas › Agenda do Google). Depois, tudo aparece aqui também.": "চালু করতে ফোনে অ্যাপ ব্যবহার করুন (সেটিংস › ক্যালেন্ডার ও মানচিত্র › Google ক্যালেন্ডার)। তারপর সবকিছু এখানেও দেখা যাবে।",
 "Para não perguntar mais, escolha o app em Ajustes › Agenda e mapas.": "আর জিজ্ঞেস না করতে সেটিংস › ক্যালেন্ডার ও মানচিত্র-এ অ্যাপ বেছে নিন।",
 "Pausa": "বিরতি",
 "Petróleo": "পেট্রোল নীল",
 "Pink elétrico": "ইলেকট্রিক পিংক",
 "Preto total": "পুরো কালো",
 "Progresso": "অগ্রগতি",
 "Pêssego": "পিচ",
 "Quantos dias antes as contas aparecem fica em Ajustes > Avisos e alarmes.": "বিল কত দিন আগে দেখা যাবে তা সেটিংস > বিজ্ঞপ্তি ও অ্যালার্ম-এ আছে।",
 "Rosa-chá": "ডাস্টি রোজ",
 "Roxo-profundo": "গাঢ় বেগুনি",
 "Segurança e dados": "নিরাপত্তা ও তথ্য",
 "Segurar e arrastar": "চেপে ধরে টানুন",
 "Segurar e soltar": "চেপে ধরে ছাড়ুন",
 "Selecionar todas": "সব নির্বাচন করুন",
 "Semana começa na {dia}": "সপ্তাহ শুরু হয় {dia}",
 "Sessão de estudo": "পড়ার সেশন",
 "Sessão encerrada": "সেশন শেষ হয়েছে",
 "Sessão pausada": "সেশন বিরতিতে",
 "Som e vibração": "শব্দ ও ভাইব্রেশন",
 "Suave": "কোমল",
 "Só esta semana": "শুধু এই সপ্তাহ",
 "Só hoje": "শুধু আজ",
 "Só neste dia ({data})": "শুধু এই দিনে ({data})",
 "Tamanho das caixas": "বাক্সের আকার",
 "Tamanho do texto": "লেখার আকার",
 "Tarefa nova": "নতুন কাজ",
 "Tela inicial": "হোম স্ক্রিন",
 "Tema e cor de destaque": "থিম ও হাইলাইট রং",
 "Testar alerta": "অ্যালার্ট পরীক্ষা করুন",
 "Testar alerta, \"Não perturbe\" e as configurações do celular ficam em Ajustes > Avisos e alarmes.": "অ্যালার্ট পরীক্ষা, \"বিরক্ত করবেন না\" ও ফোনের সেটিংস সেটিংস > বিজ্ঞপ্তি ও অ্যালার্ম-এ আছে।",
 "Testar e conferir": "পরীক্ষা ও যাচাই",
 "Todas as opções do item: editar, mover, compartilhar, arquivar, excluir...": "আইটেমের সব বিকল্প: সম্পাদনা, সরানো, শেয়ার, আর্কাইভ, মুছে ফেলা...",
 "Toque numa cor do tema {tema} para usar nos botões, no botão + e no item selecionado.": "বোতাম, + বোতাম ও নির্বাচিত আইটেমে ব্যবহারের জন্য {tema} থিমের একটি রঙে ট্যাপ করুন।",
 "Total: {dur}": "মোট: {dur}",
 "Tropical": "ট্রপিক্যাল",
 "Turquesa": "ফিরোজা",
 "Um arquivo com todos os seus dados do My Planner, para guardar ou levar para outro lugar (portabilidade, LGPD).": "My Planner-এ আপনার সব তথ্যসহ একটি ফাইল, রেখে দিতে বা অন্য কোথাও নিতে (পোর্টেবিলিটি, LGPD)।",
 "Usar no computador, pelo navegador": "কম্পিউটারে ব্রাউজার দিয়ে ব্যবহার করুন",
 "Usar o padrão": "ডিফল্ট ব্যবহার করুন",
 "Usar o padrão ({emoji})": "ডিফল্ট ব্যবহার করুন ({emoji})",
 "Use o app no celular para baixar o arquivo.": "ফাইল ডাউনলোড করতে ফোনে অ্যাপ ব্যবহার করুন।",
 "Vale para todas as abas. Cada aba pode ter o seu em Ajustes > Abas.": "সব ট্যাবে প্রযোজ্য। প্রতিটি ট্যাবের নিজস্ব সেটিং সেটিংস > ট্যাব-এ থাকতে পারে।",
 "Valem para as tarefas com pausas. Cada tarefa pode mudar o alarme e o emoji na própria ficha.": "বিরতিসহ কাজগুলোতে প্রযোজ্য। প্রতিটি কাজ নিজের রেকর্ডে অ্যালার্ম ও ইমোজি বদলাতে পারে।",
 "Ver lista": "তালিকা দেখুন",
 "Ver o CPF inteiro": "পুরো CPF দেখুন",
 "Verde-floresta": "বনসবুজ",
 "Verde-água": "অ্যাকোয়া সবুজ",
 "Vibração": "ভাইব্রেশন",
 "Vinho": "ওয়াইন",
 "Você pediu para ser avisado agora.": "আপনি এখনই জানাতে বলেছিলেন।",
 "Você pode: confirmar se tratamos seus dados, acessar, corrigir, pedir a portabilidade (baixar os seus dados em Ajustes > Meus dados), pedir a exclusão, saber com quem compartilhamos, revogar o consentimento e reclamar na ANPD.": "আপনি পারেন: আমরা আপনার তথ্য প্রক্রিয়া করি কিনা নিশ্চিত হতে, দেখতে, সংশোধন করতে, পোর্টেবিলিটি চাইতে (সেটিংস > আমার তথ্য-এ আপনার তথ্য ডাউনলোড করুন), মুছে ফেলার অনুরোধ করতে, কার সাথে শেয়ার করি তা জানতে, সম্মতি প্রত্যাহার করতে এবং ANPD-তে অভিযোগ করতে।",
 "Voltar ao filtro": "ফিল্টারে ফিরে যান",
 "Voltar à lista": "তালিকায় ফিরে যান",
 "Vá em Ajustes › My Planner Web e toque em \"Conectar navegador\".": "সেটিংস › My Planner Web-এ যান এবং \"ব্রাউজার সংযুক্ত করুন\"-এ ট্যাপ করুন।",
 "atividade {n} de {total}": "কার্যকলাপ {n} / {total}",
 "matéria {n} de {t}": "বিষয় {n} / {t}",
 "padrão": "ডিফল্ট",
 "pausa em {n} min": "{n} মিনিটে বিরতি",
 "pausa {n} de {total}": "বিরতি {n} / {total}",
 "termina em {n} min": "{n} মিনিটে শেষ",
 "todas as vezes": "সব বার",
 "troca em {n} min": "{n} মিনিটে পরিবর্তন",
 "volta em {n} min": "{n} মিনিটে ফিরে আসা",
 "{nome} · {n} dia(s)": "{nome} · {n} দিন",
 "{n} de {total} vezes": "{total}-এর মধ্যে {n} বার",
 "{n} itens arquivados": "{n}টি আইটেম আর্কাইভ করা হয়েছে",
 "{n} itens excluídos": "{n}টি আইটেম মুছে ফেলা হয়েছে",
 "{n} marcada(s)": "{n}টি চিহ্নিত",
 "{n} vezes": "{n} বার",
 "{rotulo}: {feito} min / {total}": "{rotulo}: {feito} মিনিট / {total}",
 "📔 Diário": "📔 ডায়েরি",
 "Agendados": "নির্ধারিত",
 "Atrasado": "বকেয়া",
 "Atrasado: {v}": "বকেয়া: {v}",
 "Atualizar o a receber": "প্রাপ্য হালনাগাদ করুন",
 "Até (fim do contrato, se houver)": "পর্যন্ত (চুক্তি শেষ, যদি থাকে)",
 "Clínica": "ক্লিনিক",
 "Conta cada dia com chamada feita ou com plano de aula marcado como \"Aula dada\".": "যেদিন হাজিরা নেওয়া হয়েছে বা পাঠ পরিকল্পনা \"ক্লাস হয়েছে\" হিসেবে চিহ্নিত, সেদিন গণনা হয়।",
 "Data do recebimento": "প্রাপ্তির তারিখ",
 "Data prevista do pagamento": "প্রত্যাশিত পরিশোধের তারিখ",
 "Desmarcar como recebido": "প্রাপ্ত চিহ্ন সরান",
 "Dia do pagamento": "পরিশোধের দিন",
 "Diferença: {v} (juros/multa)": "পার্থক্য: {v} (সুদ/জরিমানা)",
 "Diferença: {v} (taxas/descontos)": "পার্থক্য: {v} (ফি/ছাড়)",
 "Escolas, universidades e cursos que pagam você. Com salário fixo, o app gera o a receber de todo mês; por hora-aula, soma as aulas dadas nas turmas ligadas à instituição.": "যে স্কুল, বিশ্ববিদ্যালয় ও কোর্স আপনাকে অর্থ দেয়। নির্দিষ্ট বেতনে অ্যাপ প্রতি মাসে প্রাপ্য তৈরি করে; প্রতি ঘণ্টা-ক্লাসে, প্রতিষ্ঠানের সাথে যুক্ত ক্লাসগুলোর নেওয়া ক্লাস যোগ করে।",
 "Escolha o tipo de pagamento (Editar) para o app calcular o que você tem a receber.": "পরিশোধের ধরন বেছে নিন (সম্পাদনা) যাতে অ্যাপ আপনার প্রাপ্য হিসাব করতে পারে।",
 "Este valor vem da parte \"Onde trabalho\" da aba {aba}. Marque aqui como recebido ou abra a aba para ver a instituição.": "এই অর্থ {aba} ট্যাবের \"আমি কোথায় কাজ করি\" অংশ থেকে আসে। এখানে প্রাপ্ত হিসেবে চিহ্নিত করুন বা প্রতিষ্ঠান দেখতে ট্যাবটি খুলুন।",
 "Ex.: Colégio Estadual, Universidade Federal": "যেমন: সরকারি কলেজ, জাতীয় বিশ্ববিদ্যালয়",
 "Ex.: Hospital Santa Casa, Clínica Vida": "যেমন: সান্তা কাসা হাসপাতাল, ভিদা ক্লিনিক",
 "Ex.: Salário de outubro, 13º, férias": "যেমন: অক্টোবরের বেতন, ১৩তম বেতন, ছুটি",
 "Feitos": "সম্পন্ন",
 "Horas-aula de cada aula": "প্রতি ক্লাসের ঘণ্টা-ক্লাস",
 "Hospitais e clínicas que pagam você. Com salário fixo, o app gera o a receber de todo mês; por plantão ou atendimento, marque os feitos e o app calcula.": "যে হাসপাতাল ও ক্লিনিক আপনাকে অর্থ দেয়। নির্দিষ্ট বেতনে অ্যাপ প্রতি মাসে প্রাপ্য তৈরি করে; প্রতি শিফট বা সেবায়, সম্পন্নগুলো চিহ্নিত করুন, অ্যাপ হিসাব করবে।",
 "Hospital": "হাসপাতাল",
 "Instituição": "প্রতিষ্ঠান",
 "Instituição (Onde trabalho)": "প্রতিষ্ঠান (আমি কোথায় কাজ করি)",
 "Ligue as turmas a esta instituição (na turma, Editar › Instituição) para o app somar as aulas dadas.": "ক্লাসগুলো এই প্রতিষ্ঠানের সাথে যুক্ত করুন (ক্লাসে, সম্পাদনা › প্রতিষ্ঠান) যাতে অ্যাপ নেওয়া ক্লাস যোগ করে।",
 "Marque cada plantão ou atendimento como feito: o app soma e calcula o valor do mês.": "প্রতিটি শিফট বা সেবা সম্পন্ন হিসেবে চিহ্নিত করুন: অ্যাপ যোগ করে মাসের অর্থ হিসাব করে।",
 "Marque cada plantão ou atendimento feito nesta instituição. O app soma e calcula o valor a receber do mês.": "এই প্রতিষ্ঠানে করা প্রতিটি শিফট বা সেবা চিহ্নিত করুন। অ্যাপ যোগ করে মাসের প্রাপ্য অর্থ হিসাব করে।",
 "Nome da instituição": "প্রতিষ্ঠানের নাম",
 "O que a instituição tem a pagar a você, mês a mês. Marque como recebido quando o dinheiro entrar: vai junto para a aba Finanças.": "প্রতিষ্ঠান মাসে মাসে আপনাকে যা দেবে। টাকা এলে প্রাপ্ত হিসেবে চিহ্নিত করুন: এটি অর্থ ট্যাবেও যাবে।",
 "Onde trabalho": "আমি কোথায় কাজ করি",
 "Plantão": "শিফট",
 "Plantão ou atendimento": "শিফট বা সেবা",
 "Plantões e atendimentos": "শিফট ও সেবা",
 "Por atendimento ou procedimento": "প্রতি সেবা বা প্রক্রিয়া",
 "Por hora-aula": "প্রতি ঘণ্টা-ক্লাস",
 "Por plantão": "প্রতি শিফট",
 "Previsto: {v}": "প্রত্যাশিত: {v}",
 "Previsão do mês: {v}": "মাসের পূর্বাভাস: {v}",
 "Quantidade (aulas, plantões ou atendimentos)": "পরিমাণ (ক্লাস, শিফট বা সেবা)",
 "Recebe no mês seguinte ao trabalhado": "কাজের পরের মাসে প্রাপ্তি",
 "Receber: {t}": "প্রাপ্য: {t}",
 "Recebimentos": "প্রাপ্তিসমূহ",
 "Salário": "বেতন",
 "Salário (valor do mês)": "বেতন (মাসের অর্থ)",
 "Salário fixo": "নির্দিষ্ট বেতন",
 "Telefone (RH ou financeiro)": "ফোন (HR বা হিসাব বিভাগ)",
 "Tipo de pagamento": "পরিশোধের ধরন",
 "Universidade": "বিশ্ববিদ্যালয়",
 "Valor da hora-aula": "ঘণ্টা-ক্লাসের মূল্য",
 "Valor de cada um (se for diferente)": "প্রতিটির মূল্য (ভিন্ন হলে)",
 "Valor do plantão": "শিফটের মূল্য",
 "Valor por atendimento ou procedimento": "প্রতি সেবা বা প্রক্রিয়ার মূল্য",
 "Valor previsto": "প্রত্যাশিত অর্থ",
 "feito": "সম্পন্ন",
 "recebido em {d}": "{d} তারিখে প্রাপ্ত",
 "{n} aula(s) dada(s)": "{n}টি ক্লাস নেওয়া হয়েছে",
 "{n} hora(s)-aula": "{n} ঘণ্টা-ক্লাস",
 "{n} plantão(ões)": "{n}টি শিফট",
 "Abas do My Planner Anne": "My Planner Anne-এর ট্যাব",
 "Acesso ao Não perturbe": "বিরক্ত করবেন না অ্যাক্সেস",
 "Alarme dos remédios (mesmo no silencioso)": "ওষুধের অ্যালার্ম (সাইলেন্টেও)",
 "Algodão-doce": "হাওয়াই মিঠাই",
 "Aplicar tema": "থিম প্রয়োগ করুন",
 "As cores próprias de cada tema: floral rosado, folhas verdes, céu azul...": "প্রতিটি থিমের নিজস্ব রং: গোলাপি ফুল, সবুজ পাতা, নীল আকাশ...",
 "Assim ficam as letras no app.": "অ্যাপে অক্ষরগুলো এভাবে দেখাবে।",
 "Automática": "স্বয়ংক্রিয়",
 "Baht tailandês": "থাই বাত",
 "Boliviano": "বলিভিয়ান বলিভিয়ানো",
 "Bolívar venezuelano": "ভেনেজুয়েলান বলিভার",
 "Botão": "বোতাম",
 "Buscar moeda": "মুদ্রা খুঁজুন",
 "Cor do desenho": "আঁকার রং",
 "Coroa dinamarquesa": "ডেনিশ ক্রোন",
 "Coroa norueguesa": "নরওয়েজিয়ান ক্রোন",
 "Coroa sueca": "সুইডিশ ক্রোনা",
 "Coroa tcheca": "চেক কোরুনা",
 "Crepúsculo": "গোধূলি",
 "Crescente": "ক্রমবর্ধমান",
 "Curta": "ছোট",
 "Despesas em outra moeda (fora do lucro): {v}": "অন্য মুদ্রায় খরচ (লাভের বাইরে): {v}",
 "Dirham dos Emirados Árabes Unidos": "সংযুক্ত আরব আমিরাত দিরহাম",
 "Dirham marroquino": "মরক্কান দিরহাম",
 "Do seu país": "আপনার দেশের",
 "Dong vietnamita": "ভিয়েতনামি ডং",
 "Dupla": "দ্বৈত",
 "Dólar americano": "মার্কিন ডলার",
 "Dólar australiano": "অস্ট্রেলিয়ান ডলার",
 "Dólar canadense": "কানাডিয়ান ডলার",
 "Dólar de Hong Kong": "হংকং ডলার",
 "Dólar de Singapura": "সিঙ্গাপুর ডলার",
 "Dólar neozelandês": "নিউজিল্যান্ড ডলার",
 "Envia todos os itens desta lista, inclusive os novos que forem criados depois.": "এই তালিকার সব আইটেম পাঠায়, পরে তৈরি হওয়া নতুনগুলোও।",
 "Enviar todos para a equipe": "সব টিমে পাঠান",
 "Escolha se o alarme deste remédio deve tocar mesmo com o celular no silencioso.": "ফোন সাইলেন্টে থাকলেও এই ওষুধের অ্যালার্ম বাজবে কি না তা বেছে নিন।",
 "Euro": "ইউরো",
 "Exemplo": "উদাহরণ",
 "Falta uma resposta": "একটি উত্তর বাকি আছে",
 "Folha, tema e cores da caneta e das letras": "পাতা, থিম এবং কলম ও অক্ষরের রং",
 "Franco suíço": "সুইস ফ্রাঁ",
 "Guarani paraguaio": "প্যারাগুয়ের গুয়ারানি",
 "Hryvnia ucraniana": "ইউক্রেনীয় রিভনিয়া",
 "Iene japonês": "জাপানি ইয়েন",
 "Kwanza angolano": "অ্যাঙ্গোলান কোয়ানজা",
 "Libra egípcia": "মিশরীয় পাউন্ড",
 "Libra esterlina": "ব্রিটিশ পাউন্ড স্টার্লিং",
 "Lira turca": "তুর্কি লিরা",
 "Longa": "লম্বা",
 "Mais usadas": "সর্বাধিক ব্যবহৃত",
 "Metical moçambicano": "মোজাম্বিকান মেটিকাল",
 "Na página, segurar a bolinha faz o mesmo.": "পাতায় বিন্দুটি চেপে ধরলেও একই কাজ হয়।",
 "Naira nigeriana": "নাইজেরিয়ান নাইরা",
 "Nenhuma moeda encontrada": "কোনো মুদ্রা পাওয়া যায়নি",
 "No Android, para o alarme do remédio tocar com o \"Não perturbe\" ligado, o celular precisa permitir o acesso ao \"Não perturbe\" para o My Planner. Toque em \"Abrir configurações\", procure o My Planner na lista e ligue a permissão.": "Android-এ, \"বিরক্ত করবেন না\" চালু থাকা অবস্থায় ওষুধের অ্যালার্ম বাজাতে ফোনকে My Planner-কে \"বিরক্ত করবেন না\" অ্যাক্সেসের অনুমতি দিতে হবে। \"সেটিংস খুলুন\"-এ ট্যাপ করুন, তালিকায় My Planner খুঁজে অনুমতি চালু করুন।",
 "No My Planner": "My Planner-এ",
 "No iPhone, o silencioso do celular pode impedir o alarme. Deixe o celular no modo normal.": "iPhone-এ, ফোনের সাইলেন্ট মোড অ্যালার্ম আটকাতে পারে। ফোনটি সাধারণ মোডে রাখুন।",
 "No iPhone, o ▶ mostra uma ideia de cada tipo. Os avisos de verdade usam a vibração padrão do iPhone.": "iPhone-এ, ▶ প্রতিটি ধরনের একটি ধারণা দেখায়। আসল নোটিফিকেশনগুলো iPhone-এর সাধারণ ভাইব্রেশন ব্যবহার করে।",
 "Novo dólar taiwanês": "নতুন তাইওয়ান ডলার",
 "Novo shekel israelense": "নতুন ইসরায়েলি শেকেল",
 "Ouvir/Sentir": "শুনুন/অনুভব করুন",
 "Peso argentino": "আর্জেন্টাইন পেসো",
 "Peso chileno": "চিলিয়ান পেসো",
 "Peso colombiano": "কলম্বিয়ান পেসো",
 "Peso filipino": "ফিলিপাইন পেসো",
 "Peso mexicano": "মেক্সিকান পেসো",
 "Peso uruguaio": "উরুগুয়েন পেসো",
 "Política de privacidade": "গোপনীয়তা নীতি",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer em silêncio.": "হয়ে গেছে। স্ক্রিন লক করে 1 মিনিট অপেক্ষা করুন: নোটিফিকেশন নিঃশব্দে আসা উচিত।",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer vibrando, sem som.": "হয়ে গেছে। স্ক্রিন লক করে 1 মিনিট অপেক্ষা করুন: নোটিফিকেশন শব্দ ছাড়া ভাইব্রেট করে আসা উচিত।",
 "Páginas e canetas": "পাতা ও কলম",
 "Pôr do sol": "সূর্যাস্ত",
 "Rand sul-africano": "দক্ষিণ আফ্রিকান র‍্যান্ড",
 "Real brasileiro": "ব্রাজিলিয়ান রিয়াল",
 "Ringgit malaio": "মালয়েশিয়ান রিঙ্গিত",
 "Riyal saudita": "সৌদি রিয়াল",
 "Rublo russo": "রাশিয়ান রুবল",
 "Rupia indiana": "ভারতীয় রুপি",
 "Rupia indonésia": "ইন্দোনেশিয়ান রুপিয়া",
 "Rupia paquistanesa": "পাকিস্তানি রুপি",
 "Se o My Planner não aparecer na lista, essa permissão chega na próxima versão do app (atualize pela loja).": "তালিকায় My Planner না দেখালে, এই অনুমতি অ্যাপের পরবর্তী সংস্করণে আসবে (স্টোর থেকে আপডেট করুন)।",
 "Sentir": "অনুভব করুন",
 "Sol peruano": "পেরুভিয়ান সোল",
 "São as cores rápidas da caneta e das letras nas páginas. A primeira é a cor padrão ao abrir uma página. Toque numa bolinha para trocar a cor dela.": "এগুলো পাতায় কলম ও অক্ষরের দ্রুত রং। প্রথমটি পাতা খোলার সময় ডিফল্ট রং। কোনো বিন্দুর রং বদলাতে সেটিতে ট্যাপ করুন।",
 "Taka bengali": "বাংলাদেশি টাকা",
 "Teste grátis por {n} dias": "{n} দিনের ফ্রি ট্রায়াল",
 "Tipo de vibração": "ভাইব্রেশনের ধরন",
 "Tirar do My Planner": "My Planner থেকে সরান",
 "Tocar mesmo no silencioso e no Não perturbe": "সাইলেন্ট ও বিরক্ত করবেন না মোডেও বাজান",
 "Tocar só se o celular estiver no normal": "শুধু ফোন সাধারণ মোডে থাকলে বাজান",
 "Todos os itens desta lista aparecem no My Planner, inclusive os novos.": "এই তালিকার সব আইটেম My Planner-এ দেখায়, নতুনগুলোও।",
 "Vaga-lume": "জোনাকি",
 "Vale para todos os avisos que vibram (Vibração e Som e vibração).": "যেসব নোটিফিকেশন ভাইব্রেট করে সবগুলোর জন্য প্রযোজ্য (ভাইব্রেশন এবং শব্দ ও ভাইব্রেশন)।",
 "Won sul-coreano": "দক্ষিণ কোরিয়ান ওন",
 "Xelim queniano": "কেনিয়ান শিলিং",
 "Yuan chinês": "চীনা ইউয়ান",
 "Zloty polonês": "পোলিশ জ্লোটি",
 "🔕🔇 O alarme deste remédio deve tocar mesmo com o celular no silencioso?": "🔕🔇 ফোন সাইলেন্টে থাকলেও কি এই ওষুধের অ্যালার্ম বাজা উচিত?",
 "A galeria de fotos chega na próxima versão do app. Por enquanto, use Arquivos ou Tirar foto.": "ফটো গ্যালারি অ্যাপের পরবর্তী সংস্করণে আসছে। আপাতত ফাইল বা ছবি তুলুন ব্যবহার করুন।",
 "Abrir o fichário do grupo": "গ্রুপের বাইন্ডার খুলুন",
 "Arrastar a barra": "বারটি টানুন",
 "Assim que o fichário for compartilhado, ele aparece aqui.": "বাইন্ডারটি শেয়ার হলেই এখানে দেখা যাবে।",
 "Buscar ícone pelo nome (ex.: livro, casa, café)": "নাম দিয়ে আইকন খুঁজুন (যেমন: বই, বাড়ি, কফি)",
 "Com a aba Estudos você cria seus fichários, usa o cronômetro, acompanha seu relatório e muito mais. ✨": "পড়াশোনা ট্যাবে আপনি বাইন্ডার তৈরি করতে, টাইমার ব্যবহার করতে, রিপোর্ট দেখতে এবং আরও অনেক কিছু করতে পারেন। ✨",
 "Com a aba {aba} você cria o que é seu e usa todos os recursos. ✨": "{aba} ট্যাবে আপনি নিজের জিনিস তৈরি করেন এবং সব ফিচার ব্যবহার করেন। ✨",
 "Conhecer a aba": "ট্যাবটি দেখুন",
 "Crie um fichário em Estudos e volte aqui.": "পড়াশোনায় একটি বাইন্ডার তৈরি করে এখানে ফিরে আসুন।",
 "Em sessão": "সেশন চলছে",
 "Encerrar e salvar o cronômetro e começar a sessão?": "টাইমার শেষ করে সেভ করবেন এবং সেশন শুরু করবেন?",
 "Encerrar e salvar o cronômetro e continuar a sessão?": "টাইমার শেষ করে সেভ করবেন এবং সেশন চালিয়ে যাবেন?",
 "Enquadre e toque no botão": "ফ্রেমে আনুন এবং বোতামে ট্যাপ করুন",
 "Escolha o fichário que os colegas vão ver na tela (só para ler).": "সহপাঠীরা স্ক্রিনে যে বাইন্ডারটি দেখবে সেটি বেছে নিন (শুধু পড়ার জন্য)।",
 "Esconder": "লুকান",
 "Este arquivo está guardado só no dispositivo ou no Drive de quem compartilhou, por isso não aparece aqui.": "এই ফাইলটি শুধু শেয়ারকারীর ডিভাইসে বা Drive-এ সংরক্ষিত, তাই এখানে দেখা যায় না।",
 "Fichário do grupo": "গ্রুপের বাইন্ডার",
 "Guia passo a passo do app e de cada aba": "অ্যাপ ও প্রতিটি ট্যাবের ধাপে ধাপে গাইড",
 "Há um cronômetro em andamento.": "একটি টাইমার চলছে।",
 "Há uma sessão em andamento.": "একটি সেশন চলছে।",
 "Inserir imagem": "ছবি যোগ করুন",
 "Mais ícones": "আরও আইকন",
 "Nenhum ícone com esse nome. Tente outra palavra ou escolha numa categoria.": "এই নামে কোনো আইকন নেই। অন্য শব্দ চেষ্টা করুন বা কোনো বিভাগ থেকে বেছে নিন।",
 "Nenhuma matéria neste fichário ainda.": "এই বাইন্ডারে এখনো কোনো বিষয় নেই।",
 "Nenhuma página nesta matéria ainda.": "এই বিষয়ে এখনো কোনো পৃষ্ঠা নেই।",
 "No grupo de estudos, imagens e PDFs abrem aqui na tela. Este tipo de arquivo não tem visualização dentro do app.": "স্টাডি গ্রুপে ছবি ও PDF এখানেই স্ক্রিনে খোলে। এই ধরনের ফাইল অ্যাপের ভেতরে প্রিভিউ করা যায় না।",
 "Não deu para mostrar agora. Confira a internet e tente de novo.": "এখন দেখানো গেল না। ইন্টারনেট সংযোগ দেখে আবার চেষ্টা করুন।",
 "O compartilhamento de fichários ainda está sendo preparado. Volte daqui a pouco.": "বাইন্ডার শেয়ার করার সুবিধা এখনো তৈরি হচ্ছে। একটু পরে আবার আসুন।",
 "O fichário deste grupo está em outro dispositivo seu. Ele continua compartilhado a partir de lá.": "এই গ্রুপের বাইন্ডারটি আপনার অন্য একটি ডিভাইসে আছে। সেখান থেকেই এটি শেয়ার হতে থাকবে।",
 "OK = Conhecer a aba · Cancelar = Agora não": "ঠিক আছে = ট্যাবটি দেখুন · বাতিল = এখন নয়",
 "Os colegas deixam de ver o fichário. Tudo continua com você.": "সহপাঠীরা আর বাইন্ডারটি দেখতে পাবে না। সবকিছু আপনার কাছেই থাকবে।",
 "Os colegas veem este fichário na tela, só para ler: não editam, não baixam, não imprimem e não compartilham. As suas metas, o cronômetro e as páginas revisadas continuam só seus.": "সহপাঠীরা এই বাইন্ডারটি স্ক্রিনে শুধু পড়ার জন্য দেখে: তারা সম্পাদনা, ডাউনলোড, প্রিন্ট বা শেয়ার করতে পারে না। আপনার লক্ষ্য, টাইমার ও রিভিশন করা পৃষ্ঠাগুলো শুধু আপনারই থাকে।",
 "Para ver PDFs aqui na tela, instale a versão mais nova do app pela loja.": "এখানে স্ক্রিনে PDF দেখতে স্টোর থেকে অ্যাপের সর্বশেষ সংস্করণ ইনস্টল করুন।",
 "Parar de compartilhar": "শেয়ার করা বন্ধ করুন",
 "Pausar a sessão": "সেশন থামান",
 "Pausar a sessão e estudar só esta?": "সেশন থামিয়ে শুধু এটি পড়বেন?",
 "Página em branco.": "ফাঁকা পৃষ্ঠা।",
 "Quer estudar com tudo isso?": "এই সবকিছু নিয়ে পড়াশোনা করতে চান?",
 "Quer usar tudo isso?": "এই সবকিছু ব্যবহার করতে চান?",
 "Selecionar todos": "সব নির্বাচন করুন",
 "Trocar fichário": "বাইন্ডার বদলান",
 "Você está participando do grupo de {nome}": "আপনি {nome}-এর গ্রুপে অংশ নিচ্ছেন",
 "Você vê na tela o que foi compartilhado neste grupo, para ler e acompanhar.": "এই গ্রুপে যা শেয়ার করা হয়েছে তা আপনি স্ক্রিনে পড়তে ও অনুসরণ করতে পারেন।",
 "abacate, fruta": "অ্যাভোকাডো, ফল",
 "academia, musculação, treino, peso": "জিম, বডিবিল্ডিং, ব্যায়াম, ওজন",
 "acampamento, camping": "ক্যাম্পিং, তাঁবু",
 "alfinete, fixar, importante": "পিন, আটকানো, গুরুত্বপূর্ণ",
 "almoço, arroz, prato": "দুপুরের খাবার, ভাত, থালা",
 "alvo, meta, objetivo, foco": "লক্ষ্যবস্তু, লক্ষ্য, উদ্দেশ্য, মনোযোগ",
 "aniversário, bolo": "জন্মদিন, কেক",
 "anotação, nota, lista, escrever": "নোট, টীকা, তালিকা, লেখা",
 "arco-íris": "রংধনু",
 "avião, viagem, voo": "বিমান, ভ্রমণ, ফ্লাইট",
 "balança, direito, justiça, lei, processo": "দাঁড়িপাল্লা, আইন, ন্যায়বিচার, বিধি, মামলা",
 "balde, limpeza": "বালতি, পরিষ্কার",
 "banana, fruta": "কলা, ফল",
 "banheira, banho, banheiro": "বাথটাব, গোসল, বাথরুম",
 "barbear, barba, lâmina": "শেভ, দাড়ি, ব্লেড",
 "bicicleta, pedalar, bike": "সাইকেল, সাইকেল চালানো, বাইক",
 "bolo, doce, sobremesa": "কেক, মিষ্টি, ডেজার্ট",
 "brilho, mágica": "ঝলক, জাদু",
 "cabelo, cabeleireiro, corte": "চুল, নাপিত, চুল কাটা",
 "cachorro, cão, pet": "কুকুর, কুকুরছানা, পোষা প্রাণী",
 "caderno": "খাতা",
 "caderno, fichário, amarelo": "খাতা, বাইন্ডার, হলুদ",
 "café, xícara, pausa": "কফি, কাপ, বিরতি",
 "caixa, pacote, mudança, entrega": "বাক্স, প্যাকেট, বাসা বদল, ডেলিভারি",
 "calendário, agenda, data": "ক্যালেন্ডার, সময়সূচি, তারিখ",
 "cama, quarto": "বিছানা, শোবার ঘর",
 "caminhada, caminhar, andar": "হাঁটা, হাঁটাহাঁটি, চলা",
 "camisa, gravata, roupa, trabalho": "শার্ট, টাই, পোশাক, কাজ",
 "carne, churrasco": "মাংস, বারবিকিউ",
 "carrinho, mercado, compras, supermercado": "ট্রলি, বাজার, কেনাকাটা, সুপারমার্কেট",
 "carro, dirigir, veículo": "গাড়ি, গাড়ি চালানো, যানবাহন",
 "certo, feito, visto": "ঠিক, সম্পন্ন, টিক",
 "cesto, roupa, lavanderia, lavar roupa": "ঝুড়ি, কাপড়, লন্ড্রি, কাপড় ধোয়া",
 "chave de fenda, ferramenta, conserto": "স্ক্রুড্রাইভার, যন্ত্র, মেরামত",
 "chave, senha": "চাবি, পাসওয়ার্ড",
 "chocolate, doce": "চকলেট, মিষ্টি",
 "chuveiro, banho": "শাওয়ার, গোসল",
 "chá, xícara": "চা, কাপ",
 "compras, sacolas, shopping": "কেনাকাটা, ব্যাগ, শপিং",
 "computador, monitor, tela": "কম্পিউটার, মনিটর, স্ক্রিন",
 "computador, notebook, informática": "কম্পিউটার, ল্যাপটপ, আইটি",
 "coração amarelo": "হলুদ হৃদয়",
 "coração azul": "নীল হৃদয়",
 "coração branco": "সাদা হৃদয়",
 "coração laranja": "কমলা হৃদয়",
 "coração roxo": "বেগুনি হৃদয়",
 "coração verde": "সবুজ হৃদয়",
 "coração, amor, saúde, vermelho": "হৃদয়, ভালোবাসা, স্বাস্থ্য, লাল",
 "corrida, correr": "দৌড়, দৌড়ানো",
 "creme, hidratante, pele, skincare": "ক্রিম, ময়েশ্চারাইজার, ত্বক, স্কিনকেয়ার",
 "croissant, pão, café da manhã": "ক্রোয়াসাঁ, রুটি, নাস্তা",
 "câmera, foto, fotografia": "ক্যামেরা, ছবি, ফটোগ্রাফি",
 "cérebro, mente, memória, pensar": "মস্তিষ্ক, মন, স্মৃতি, চিন্তা",
 "dado, jogo de tabuleiro": "পাশা, বোর্ড গেম",
 "dente, dentista": "দাঁত, দাঁতের ডাক্তার",
 "despertador, relógio, alarme, acordar": "অ্যালার্ম ঘড়ি, ঘড়ি, অ্যালার্ম, জাগা",
 "diamante, joia": "হীরা, গয়না",
 "dinheiro, pagar, conta, pagamento": "টাকা, পরিশোধ, বিল, পেমেন্ট",
 "dormir, sono, descanso": "ঘুমানো, ঘুম, বিশ্রাম",
 "e-mail, mensagem, carta": "ইমেইল, বার্তা, চিঠি",
 "escada": "সিঁড়ি",
 "escova de dentes, dentes": "টুথব্রাশ, দাঁত",
 "escrever, redação, caneta": "লেখা, রচনা, কলম",
 "esponja, lavar louça": "স্পঞ্জ, থালাবাসন ধোয়া",
 "esquadro, régua, geometria, desenho técnico": "সেট স্কয়ার, রুলার, জ্যামিতি, কারিগরি অঙ্কন",
 "estrela brilhante, destaque": "উজ্জ্বল তারা, বিশেষ",
 "estrela, favorito": "তারা, প্রিয়",
 "etiqueta, marcador": "ট্যাগ, মার্কার",
 "extintor, segurança, incêndio": "অগ্নিনির্বাপক, নিরাপত্তা, আগুন",
 "falar, idioma, inglês, conversa": "কথা বলা, ভাষা, ইংরেজি, কথোপকথন",
 "feito, concluído, certo": "সম্পন্ন, শেষ, ঠিক",
 "ferramenta, conserto, manutenção": "যন্ত্র, মেরামত, রক্ষণাবেক্ষণ",
 "festa, comemoração": "পার্টি, উদযাপন",
 "filme, cinema, série": "সিনেমা, চলচ্চিত্র, সিরিজ",
 "fogo, urgente, sequência": "আগুন, জরুরি, স্ট্রিক",
 "folha, natureza, erva, chá": "পাতা, প্রকৃতি, ভেষজ, চা",
 "fone de ouvido, áudio, música, podcast": "হেডফোন, অডিও, গান, পডকাস্ট",
 "formatura, capelo, faculdade, diploma, universidade": "সমাবর্তন, গ্র্যাজুয়েশন টুপি, কলেজ, ডিপ্লোমা, বিশ্ববিদ্যালয়",
 "força, braço, músculo": "শক্তি, বাহু, পেশি",
 "frango, coxa": "মুরগি, রান",
 "frigideira, cozinhar, ovo, cozinha": "ফ্রাইং প্যান, রান্না, ডিম, রান্নাঘর",
 "futebol, bola, esporte": "ফুটবল, বল, খেলা",
 "gato, pet": "বিড়াল, পোষা প্রাণী",
 "gelo, geladeira, congelador": "বরফ, ফ্রিজ, ফ্রিজার",
 "gráfico, planilha, finanças, relatório": "চার্ট, স্প্রেডশিট, অর্থ, রিপোর্ট",
 "ingresso, show, evento": "টিকিট, শো, ইভেন্ট",
 "jogo, videogame, game": "গেম, ভিডিও গেম, খেলা",
 "lancha, barco": "স্পিডবোট, নৌকা",
 "leite, copo": "দুধ, গ্লাস",
 "letras, alfabeto, português": "অক্ষর, বর্ণমালা, ভাষা",
 "link, corrente": "লিংক, শিকল",
 "livro aberto, leitura, ler": "খোলা বই, পাঠ, পড়া",
 "livro azul, caderno": "নীল বই, খাতা",
 "livro laranja, caderno": "কমলা বই, খাতা",
 "livro verde, caderno": "সবুজ বই, খাতা",
 "livro vermelho, caderno": "লাল বই, খাতা",
 "livros, estudo, estudar, biblioteca": "বই, অধ্যয়ন, পড়াশোনা, গ্রন্থাগার",
 "lixo, lixeira": "আবর্জনা, ময়লার ঝুড়ি",
 "lua, noite": "চাঁদ, রাত",
 "lâmpada, ideia, luz": "বাল্ব, ধারণা, আলো",
 "macarrão, massa": "পাস্তা, নুডলস",
 "maleta, trabalho, escritório, negócios": "ব্রিফকেস, কাজ, অফিস, ব্যবসা",
 "massagem, relaxar": "ম্যাসাজ, আরাম",
 "maçã, fruta": "আপেল, ফল",
 "microfone, cantar, karaokê, palestra": "মাইক্রোফোন, গান গাওয়া, কারাওকে, বক্তৃতা",
 "microscópio, ciência, biologia": "অণুবীক্ষণ যন্ত্র, বিজ্ঞান, জীববিজ্ঞান",
 "mochila, escola, filhos": "ব্যাকপ্যাক, স্কুল, সন্তান",
 "montanha, trilha": "পাহাড়, ট্রেইল",
 "mundo, planeta, geografia": "বিশ্ব, গ্রহ, ভূগোল",
 "médico, consulta, exame, saúde": "ডাক্তার, পরামর্শ, পরীক্ষা, স্বাস্থ্য",
 "música, nota musical": "সংগীত, স্বরলিপি",
 "natação, nadar, piscina": "সাঁতার, সাঁতার কাটা, সুইমিং পুল",
 "olho, visão, oftalmologista": "চোখ, দৃষ্টি, চক্ষু বিশেষজ্ঞ",
 "oração, orar, gratidão, igreja": "প্রার্থনা, প্রার্থনা করা, কৃতজ্ঞতা, গির্জা",
 "ovo": "ডিম",
 "pastas, arquivo, fichário, divisórias": "ফোল্ডার, ফাইল, বাইন্ডার, বিভাজক",
 "peixe": "মাছ",
 "pescaria, pescar": "মাছ ধরা, বড়শি",
 "pessoas, reunião, equipe, grupo": "মানুষ, মিটিং, দল, গ্রুপ",
 "piano, teclado musical": "পিয়ানো, কিবোর্ড",
 "pintura, arte, desenho": "চিত্রকলা, শিল্প, আঁকা",
 "pipa": "ঘুড়ি",
 "pipoca, cinema": "পপকর্ন, সিনেমা",
 "pizza": "পিৎজা",
 "planta, vaso, regar": "গাছ, টব, পানি দেওয়া",
 "porta, entrada": "দরজা, প্রবেশপথ",
 "praia, férias": "সমুদ্রসৈকত, ছুটি",
 "prato, refeição, louça, jantar": "থালা, খাবার, বাসনপত্র, রাতের খাবার",
 "prédio, história, governo, tribunal": "ভবন, ইতিহাস, সরকার, আদালত",
 "pão, padaria": "রুটি, বেকারি",
 "pé, podólogo": "পা, পদরোগ বিশেষজ্ঞ",
 "pôr do sol, amanhecer": "সূর্যাস্ত, সূর্যোদয়",
 "quebra-cabeça, peça": "ধাঁধা, টুকরো",
 "queijo": "পনির",
 "raio, energia, rápido": "বজ্র, শক্তি, দ্রুত",
 "refrigerante, suco, bebida": "কোমল পানীয়, জুস, পানীয়",
 "remédio, medicamento, vitamina, farmácia": "ওষুধ, ঔষধ, ভিটামিন, ফার্মেসি",
 "sabão, sabonete, lavar": "সাবান, গায়ে মাখার সাবান, ধোয়া",
 "salada, dieta, verdura": "সালাদ, ডায়েট, সবজি",
 "sanduíche, lanche": "স্যান্ডউইচ, নাস্তা",
 "sino, aviso, lembrete": "ঘণ্টা, বিজ্ঞপ্তি, রিমাইন্ডার",
 "skate": "স্কেটবোর্ড",
 "sofá, sala": "সোফা, বসার ঘর",
 "sol, manhã, dia": "সূর্য, সকাল, দিন",
 "spa, sauna, autocuidado": "স্পা, সনা, নিজের যত্ন",
 "teatro, máscaras": "নাটক, মুখোশ",
 "telefone, ligação, ligar": "ফোন, কল, ফোন করা",
 "tigela, cereal, sopa, mingau": "বাটি, সিরিয়াল, স্যুপ, জাউ",
 "trevo, sorte": "ক্লোভার, ভাগ্য",
 "troféu, conquista, prêmio": "ট্রফি, অর্জন, পুরস্কার",
 "tubo de ensaio, química, laboratório": "টেস্ট টিউব, রসায়ন, পরীক্ষাগার",
 "tênis, esporte": "টেনিস, খেলা",
 "unha, manicure": "নখ, ম্যানিকিউর",
 "vassoura, limpeza, faxina, varrer": "ঝাড়ু, পরিষ্কার, সাফাই, ঝাড়ু দেওয়া",
 "violão, guitarra": "গিটার, ইলেকট্রিক গিটার",
 "yoga, meditação, alongamento": "যোগ, ধ্যান, স্ট্রেচিং",
 "{n} selecionada": "{n}টি নির্বাচিত",
 "{n} selecionadas": "{n}টি নির্বাচিত",
 "{n} selecionado": "{n}টি নির্বাচিত",
 "{n} selecionados": "{n}টি নির্বাচিত",
 "ábaco, matemática, contas, cálculo, contabilidade": "অ্যাবাকাস, গণিত, হিসাব, গণনা, হিসাবরক্ষণ",
 "água, gota, hidratar": "পানি, ফোঁটা, হাইড্রেট",
 "árvore, jardim, quintal": "গাছ, বাগান, উঠান",
 "ônibus, transporte": "বাস, পরিবহন",
 "1 dia antes": "1 দিন আগে",
 "1 dia depois": "1 দিন পরে",
 "A assinatura é feita no app do celular, pela loja de apps, e vale também aqui no site.": "সাবস্ক্রিপশন ফোনের অ্যাপে অ্যাপ স্টোর থেকে নেওয়া হয়, এবং এখানে সাইটেও কার্যকর থাকে।",
 "A chave está incompleta (curta demais). Copie de novo pelo botão de copiar da página da chave.": "কী অসম্পূর্ণ (খুব ছোট)। কী-এর পৃষ্ঠার কপি বোতাম দিয়ে আবার কপি করুন।",
 "A chave tem caracteres que não fazem parte de uma chave. Copie de novo, só a chave, sem texto em volta.": "কী-তে এমন অক্ষর আছে যা কী-এর অংশ নয়। আবার কপি করুন, শুধু কী, আশেপাশের লেখা ছাড়া।",
 "A galeria chega na próxima atualização do app.": "গ্যালারি অ্যাপের পরবর্তী আপডেটে আসবে।",
 "ALERTAS": "সতর্কতা",
 "Abra uma aba paga e comece o teste grátis. Depois volte aqui.": "একটি পেইড ট্যাব খুলুন এবং ফ্রি ট্রায়াল শুরু করুন। তারপর এখানে ফিরে আসুন।",
 "Abrir a barra do editor": "এডিটর বার খুলুন",
 "Agora é horário do Não perturbe do app: o aviso chega em até 5 segundos, sem som nem vibração.": "এখন অ্যাপের বিরক্ত করবেন না-এর সময়: বিজ্ঞপ্তি 5 সেকেন্ডের মধ্যে আসবে, শব্দ বা ভাইব্রেশন ছাড়া।",
 "Aguardando confirmação": "নিশ্চিতকরণের অপেক্ষায়",
 "Aguardando envio ao My Planner": "My Planner-এ পাঠানোর অপেক্ষায়",
 "Alertas de cada fatura": "প্রতিটি বিলের সতর্কতা",
 "Alertas do fim da garantia": "ওয়ারেন্টি শেষ হওয়ার সতর্কতা",
 "Alertas do vencimento": "মেয়াদ শেষের সতর্কতা",
 "Alertas: {campo}": "সতর্কতা: {campo}",
 "Alvorada": "ভোর",
 "Ao abrir esta aba, o app pede o mesmo desbloqueio do app (senha, biometria ou PIN). Dá para mudar em Ajustes > Abas.": "এই ট্যাব খুললে অ্যাপ অ্যাপের মতোই আনলক চায় (পাসওয়ার্ড, বায়োমেট্রিক বা PIN)। সেটিংস > ট্যাব-এ বদলানো যায়।",
 "Ao tocar num arquivo anexado, ele abre no app do celular que você escolher (se o celular perguntar, \"Apenas uma vez\" ou \"Sempre\"). O que você editar lá fica salvo no próprio arquivo.": "সংযুক্ত ফাইলে ট্যাপ করলে সেটি আপনার বেছে নেওয়া ফোনের অ্যাপে খোলে (ফোন জিজ্ঞেস করলে \"শুধু একবার\" বা \"সবসময়\")। সেখানে যা সম্পাদনা করবেন তা ফাইলেই সংরক্ষিত থাকে।",
 "App instalado": "ইনস্টল করা অ্যাপ",
 "Apple Watch: já grava tudo no app Saúde do celular. Não precisa fazer nada.": "Apple Watch: এটি ইতিমধ্যে সবকিছু ফোনের Health অ্যাপে রেকর্ড করে। কিছু করার দরকার নেই।",
 "Arquivados e fixados": "আর্কাইভ করা ও পিন করা",
 "Arquivo para ler e guardar, organizado por aba. Gerado em {data}.": "পড়া ও রাখার জন্য ফাইল, ট্যাব অনুযায়ী সাজানো। {data}-এ তৈরি।",
 "As notificações do My Planner estão desligadas no celular.": "ফোনে My Planner-এর বিজ্ঞপ্তি বন্ধ আছে।",
 "Atualização automática disponível no app instalado.": "ইনস্টল করা অ্যাপে স্বয়ংক্রিয় আপডেট উপলব্ধ।",
 "Aurora": "অরোরা",
 "Avisos: alarme (som)": "বিজ্ঞপ্তি: অ্যালার্ম (শব্দ)",
 "Baixar o app": "অ্যাপ ডাউনলোড করুন",
 "Baixar o arquivo técnico": "টেকনিক্যাল ফাইল ডাউনলোড করুন",
 "Baixar para ler (PDF)": "পড়ার জন্য ডাউনলোড করুন (PDF)",
 "Barra do editor (caneta, marca-texto, texto)": "এডিটর বার (কলম, হাইলাইটার, লেখা)",
 "Brisa": "মৃদু হাওয়া",
 "Campainha": "কলিং বেল",
 "Canal": "চ্যানেল",
 "Cole a chave antes de testar.": "পরীক্ষা করার আগে কী পেস্ট করুন।",
 "Começa em": "শুরু",
 "Como avisar": "কীভাবে জানাবে",
 "Confira a chave": "কী যাচাই করুন",
 "Conta de teste de compras": "কেনাকাটা পরীক্ষার অ্যাকাউন্ট",
 "Conta vencida": "বিলের মেয়াদ পেরিয়েছে",
 "Copie a chave na hora (ela só aparece uma vez). Começa com \"sk-\".": "এখনই কী কপি করুন (এটি শুধু একবার দেখায়)। এটি \"sk-\" দিয়ে শুরু হয়।",
 "Copie a chave na hora (ela só aparece uma vez). Começa com \"sk-ant-\".": "এখনই কী কপি করুন (এটি শুধু একবার দেখায়)। এটি \"sk-ant-\" দিয়ে শুরু হয়।",
 "Cristal": "ক্রিস্টাল",
 "Daqui a 1 hora": "1 ঘণ্টা পরে",
 "Daqui a 1 semana": "1 সপ্তাহ পরে",
 "Daqui a 3 dias": "3 দিন পরে",
 "Depois de 5 min fora": "5 মিনিট বাইরে থাকার পরে",
 "Depois de 5 minutos fora": "5 মিনিট বাইরে থাকার পরে",
 "Desligar a senha desta aba": "এই ট্যাবের পাসওয়ার্ড বন্ধ করুন",
 "Detalhes técnicos": "টেকনিক্যাল বিবরণ",
 "Dia {n} de {t}": "দিন {n} / {t}",
 "Dica: a chave é como uma senha. Não mande por mensagem nem publique. Se vazar, apague-a no site e crie outra.": "টিপ: কী পাসওয়ার্ডের মতো। মেসেজে পাঠাবেন না বা প্রকাশ করবেন না। ফাঁস হলে সাইটে মুছে দিয়ে নতুন একটি তৈরি করুন।",
 "Documento vencido": "নথির মেয়াদ শেষ",
 "Ela abre em {d}.": "এটি {d}-এ খুলবে।",
 "Ela abre em {d}. Você vai receber avisos: {quando}.": "এটি {d}-এ খুলবে। আপনি বিজ্ঞপ্তি পাবেন: {quando}।",
 "Ela abre em {d}. Você vai receber um aviso: {quando}.": "এটি {d}-এ খুলবে। আপনি একটি বিজ্ঞপ্তি পাবেন: {quando}।",
 "Em \"API keys\", toque em \"Create key\" (Criar chave) e dê um nome, por exemplo \"My Planner\".": "\"API keys\"-এ \"Create key\" (কী তৈরি করুন)-এ ট্যাপ করুন এবং একটি নাম দিন, যেমন \"My Planner\"।",
 "Em \"Billing\" (Cobrança), adicione um cartão e alguns dólares de crédito. A assinatura ChatGPT Plus não vale aqui.": "\"Billing\" (বিলিং)-এ একটি কার্ড যোগ করুন এবং কয়েক ডলার ক্রেডিট দিন। ChatGPT Plus সাবস্ক্রিপশন এখানে চলে না।",
 "Em \"Billing\" (Cobrança), compre créditos. A assinatura Claude Pro não vale aqui.": "\"Billing\" (বিলিং)-এ ক্রেডিট কিনুন। Claude Pro সাবস্ক্রিপশন এখানে চলে না।",
 "Em breve": "শীঘ্রই আসছে",
 "Entre com a mesma conta do ChatGPT ou crie uma.": "ChatGPT-এর একই অ্যাকাউন্ট দিয়ে লগ ইন করুন বা নতুন তৈরি করুন।",
 "Entre com a sua conta Google (a mesma do Gmail serve).": "আপনার Google অ্যাকাউন্ট দিয়ে লগ ইন করুন (Gmail-এরটাই চলবে)।",
 "Entre ou crie uma conta (pode ser o mesmo e-mail do Claude).": "লগ ইন করুন বা অ্যাকাউন্ট তৈরি করুন (Claude-এর একই ইমেল হতে পারে)।",
 "Enviados para o My Planner": "My Planner-এ পাঠানো",
 "Enviar agora": "এখনই পাঠান",
 "Escolha hoje ou uma data futura.": "আজ বা ভবিষ্যতের একটি তারিখ বেছে নিন।",
 "Escolhas lembradas": "মনে রাখা পছন্দ",
 "Escolher a data": "তারিখ বেছে নিন",
 "Escolher células": "সেল বেছে নিন",
 "Escolher quando": "কখন, বেছে নিন",
 "Espessura": "পুরুত্ব",
 "Esquecer": "ভুলে যান",
 "Esta chave é de outro serviço ({servico}). Aqui funcionam só chaves do Claude, do ChatGPT ou do Gemini.": "এই কী অন্য একটি পরিষেবার ({servico})। এখানে শুধু Claude, ChatGPT বা Gemini-এর কী চলে।",
 "Esta chave é do {ia}, não do {escolhida}.": "এই কী {ia}-এর, {escolhida}-এর নয়।",
 "Esta conta vê o app como uma conta nova, sem nenhuma aba liberada, para conferir os cadeados, o teste grátis e a compra. As outras contas não mudam.": "এই অ্যাকাউন্ট অ্যাপটিকে নতুন অ্যাকাউন্টের মতো দেখে, কোনো খোলা ট্যাব ছাড়া, যাতে লক, ফ্রি ট্রায়াল ও কেনাকাটা যাচাই করা যায়। অন্য অ্যাকাউন্টগুলো বদলায় না।",
 "Esta ferramenta precisa ver as páginas do PDF, o que chega com o app novo (versão 0.50). Use o navegador ou atualize o My Planner pela loja.": "এই টুলকে PDF-এর পৃষ্ঠাগুলো দেখতে হয়, যা অ্যাপের নতুন সংস্করণে (0.50) আসবে। ব্রাউজার ব্যবহার করুন বা স্টোর থেকে My Planner আপডেট করুন।",
 "Esta não parece uma chave do {ia}. As chaves do {ia} começam com {ini}.": "এটি {ia}-এর কী বলে মনে হচ্ছে না। {ia}-এর কী {ini} দিয়ে শুরু হয়।",
 "Este aviso está em \"Desligado\": nada vai tocar.": "এই বিজ্ঞপ্তি \"বন্ধ\"-এ আছে: কিছুই বাজবে না।",
 "Este celular ainda não recebe avisos com o app fechado. Atualize o My Planner pela loja (versão {v} ou mais nova). Com o app aberto, os avisos já funcionam.": "এই ফোন এখনও অ্যাপ বন্ধ থাকলে বিজ্ঞপ্তি পায় না। স্টোর থেকে My Planner আপডেট করুন (সংস্করণ {v} বা নতুন)। অ্যাপ খোলা থাকলে বিজ্ঞপ্তি এখনই কাজ করে।",
 "Este tipo de aviso está desligado nas configurações de notificação do celular.": "এই ধরনের বিজ্ঞপ্তি ফোনের বিজ্ঞপ্তি সেটিংসে বন্ধ আছে।",
 "Estudado": "পড়া হয়েছে",
 "Estudado: {dur}": "পড়া হয়েছে: {dur}",
 "Faltou: {dur}": "বাকি ছিল: {dur}",
 "Fazer os testes terminarem agora": "ট্রায়াল এখনই শেষ করুন",
 "Fechar a barra do editor": "এডিটর বার বন্ধ করুন",
 "Fichário": "বাইন্ডার",
 "Figurinhas e emojis": "স্টিকার ও ইমোজি",
 "Garantia terminou": "ওয়ারেন্টি শেষ হয়েছে",
 "Gerando…": "তৈরি হচ্ছে…",
 "Guarda documentos, exames e histórico de saúde com uma senha só dele. Nem o suporte consegue ler. Se você esquecer a senha, não há como recuperar.": "নথি, পরীক্ষার রিপোর্ট ও স্বাস্থ্যের ইতিহাস এর নিজস্ব পাসওয়ার্ড দিয়ে রাখে। সাপোর্টও পড়তে পারে না। পাসওয়ার্ড ভুলে গেলে উদ্ধারের কোনো উপায় নেই।",
 "Harpa": "হার্প",
 "Horas por dia": "দিনে ঘণ্টা",
 "Identificação": "পরিচয়",
 "Isso parece um link ou um e-mail, não uma chave. Copie a chave inteira na página de chaves de API.": "এটি কী নয়, লিংক বা ইমেল বলে মনে হচ্ছে। API কী-এর পৃষ্ঠা থেকে পুরো কী কপি করুন।",
 "Isto só aparece no My Planner se você enviar. Quer enviar agora?": "আপনি পাঠালেই কেবল এটি My Planner-এ দেখাবে। এখনই পাঠাবেন?",
 "Já dá para confirmar {titulo}?": "{titulo} কি এখন নিশ্চিত করা যায়?",
 "Lembrar minha escolha nesta aba": "এই ট্যাবে আমার পছন্দ মনে রাখুন",
 "Lembrete para confirmar: {data}": "নিশ্চিত করার রিমাইন্ডার: {data}",
 "Marimba": "মারিম্বা",
 "Marque pelo menos um dia da semana no plano.": "প্ল্যানে সপ্তাহের অন্তত একটি দিন বেছে নিন।",
 "Me lembre de confirmar": "নিশ্চিত করতে মনে করিয়ে দিন",
 "Me lembre depois": "পরে মনে করিয়ে দিন",
 "Menos": "কম",
 "Meta somada": "মোট লক্ষ্য",
 "Meta somada: {dur}": "মোট লক্ষ্য: {dur}",
 "Meus dados - My Planner {data}": "আমার ডেটা - My Planner {data}",
 "Meus dados do My Planner": "My Planner-এ আমার ডেটা",
 "Mostrar a barra": "বার দেখান",
 "Mudar senha do diário": "ডায়েরির পাসওয়ার্ড বদলান",
 "Na primeira vez, aceite os termos de uso.": "প্রথমবার ব্যবহারের শর্তাবলি মেনে নিন।",
 "Na versão das lojas, a compra será pela loja de apps do celular. Por enquanto a chave simula a assinatura para testes.": "স্টোরের সংস্করণে কেনাকাটা হবে ফোনের অ্যাপ স্টোর থেকে। আপাতত এই কী পরীক্ষার জন্য সাবস্ক্রিপশনের অনুকরণ করে।",
 "Nada de outras abas vai sozinho para o My Planner. Estes itens têm data e ainda não foram enviados.": "অন্য ট্যাবের কিছুই নিজে থেকে My Planner-এ যায় না। এই আইটেমগুলোর তারিখ আছে এবং এখনও পাঠানো হয়নি।",
 "Nenhum estudo registrado neste mês.": "এই মাসে কোনো পড়াশোনা নথিভুক্ত হয়নি।",
 "Nenhum item aguardando envio.": "পাঠানোর অপেক্ষায় কোনো আইটেম নেই।",
 "Nenhum teste começado": "কোনো ট্রায়াল শুরু হয়নি",
 "Nesta tela não há nada para adicionar.": "এই স্ক্রিনে যোগ করার মতো কিছু নেই।",
 "No dia": "সেই দিনে",
 "Nova nota rápida": "নতুন দ্রুত নোট",
 "Nova página do dia": "দিনের নতুন পৃষ্ঠা",
 "Não deu certo": "হলো না",
 "Não entram: o conteúdo do Diário e os campos do cofre (ficam protegidos pela senha), fotos e arquivos anexados. Para restaurar os dados no app, use o arquivo técnico.": "অন্তর্ভুক্ত নয়: ডায়েরির বিষয়বস্তু ও ভল্টের ঘরগুলো (পাসওয়ার্ড দিয়ে সুরক্ষিত থাকে), ছবি ও সংযুক্ত ফাইল। অ্যাপে ডেটা ফিরিয়ে আনতে টেকনিক্যাল ফাইল ব্যবহার করুন।",
 "Não foi possível gerar o PDF.": "PDF তৈরি করা যায়নি।",
 "Não foi possível testar agora. Tente de novo em alguns segundos.": "এখন পরীক্ষা করা যায়নি। কয়েক সেকেন্ড পরে আবার চেষ্টা করুন।",
 "Não lembrar": "মনে রাখবেন না",
 "Não, obrigada": "না, ধন্যবাদ",
 "O Diário é protegido pela senha dele e não entra neste arquivo.": "ডায়েরি নিজের পাসওয়ার্ড দিয়ে সুরক্ষিত এবং এই ফাইলে থাকে না।",
 "O app abre \"Salvar em Arquivos\" para você escolher a pasta (pode ser o iCloud Drive).": "অ্যাপ \"Files-এ সংরক্ষণ করুন\" খোলে যাতে আপনি ফোল্ডার বেছে নিতে পারেন (iCloud Drive-ও হতে পারে)।",
 "O app guarda só o atalho do arquivo escolhido: ele continua onde está (Drive, OneDrive, Downloads) e abre no app do celular. Nada é copiado. Esta opção vale para as fotos tiradas pela câmera.": "অ্যাপ শুধু বেছে নেওয়া ফাইলের শর্টকাট রাখে: ফাইলটি যেখানে আছে সেখানেই থাকে (Drive, OneDrive, Downloads) এবং ফোনের অ্যাপে খোলে। কিছুই কপি হয় না। এই বিকল্প ক্যামেরা দিয়ে তোলা ছবির ক্ষেত্রেও প্রযোজ্য।",
 "O app instalado neste dispositivo é a versão {v}. Para fazer chamadas de áudio e vídeo, atualize o My Planner pela loja (versão 0.35 ou mais nova). As mensagens já funcionam.": "এই ডিভাইসে ইনস্টল করা অ্যাপের সংস্করণ {v}। অডিও ও ভিডিও কল করতে স্টোর থেকে My Planner আপডেট করুন (সংস্করণ 0.35 বা নতুন)। মেসেজ এখনই কাজ করে।",
 "O aviso vai chegar em silêncio, direto na lista de notificações: ligue os alertas do My Planner nas configurações do celular.": "বিজ্ঞপ্তি নীরবে, সরাসরি বিজ্ঞপ্তি তালিকায় আসবে: ফোনের সেটিংসে My Planner-এর সতর্কতা চালু করুন।",
 "O aviso vai chegar sem som: o som deste tipo de aviso foi desligado nas configurações do celular.": "বিজ্ঞপ্তি শব্দ ছাড়া আসবে: এই ধরনের বিজ্ঞপ্তির শব্দ ফোনের সেটিংসে বন্ধ করা আছে।",
 "O aviso vai chegar, mas o som das notificações do My Planner está desligado no celular.": "বিজ্ঞপ্তি আসবে, কিন্তু ফোনে My Planner-এর বিজ্ঞপ্তির শব্দ বন্ধ আছে।",
 "O convite leva o link para baixar o app. Quem entra pelo link cai direto no escritório.": "আমন্ত্রণে অ্যাপ ডাউনলোডের লিংক থাকে। লিংক দিয়ে যে আসে সে সরাসরি অফিসে পৌঁছে যায়।",
 "O ditado chega com a versão nova do app. Atualize o My Planner pela loja para usar o microfone.": "ডিক্টেশন অ্যাপের নতুন সংস্করণে আসবে। মাইক্রোফোন ব্যবহার করতে স্টোর থেকে My Planner আপডেট করুন।",
 "O mesmo desbloqueio do app: senha, biometria ou PIN. Pede uma vez ao entrar; dentro da aba não pede de novo. Abrir a galeria, a câmera ou os arquivos não conta como sair. Itens grandes continuam pedindo a senha para excluir.": "অ্যাপের একই আনলক: পাসওয়ার্ড, বায়োমেট্রিক বা PIN। ঢোকার সময় একবার চায়; ট্যাবের ভেতরে আর চায় না। গ্যালারি, ক্যামেরা বা ফাইল খোলাকে বের হওয়া ধরা হয় না। বড় আইটেম মুছতে এখনও পাসওয়ার্ড লাগে।",
 "O modo silencioso do celular pode impedir o alarme. Deixe o celular no modo normal.": "ফোনের সাইলেন্ট মোড অ্যালার্ম আটকাতে পারে। ফোনটি সাধারণ মোডে রাখুন।",
 "O plano fica só em Estudos (não vai para o My Planner).": "প্ল্যানটি শুধু পড়াশোনা-তে থাকে (My Planner-এ যায় না)।",
 "Opcional: prazo, horas por dia e dias da semana.": "ঐচ্ছিক: সময়সীমা, দিনে ঘণ্টা ও সপ্তাহের দিন।",
 "Os avisos do celular funcionam no app instalado.": "ফোনের বিজ্ঞপ্তি ইনস্টল করা অ্যাপে কাজ করে।",
 "Os avisos no celular funcionam no app instalado.": "ফোনে বিজ্ঞপ্তি ইনস্টল করা অ্যাপে কাজ করে।",
 "Os testes começados terminaram. Abra a aba para ver \"O teste grátis terminou\".": "শুরু করা ট্রায়ালগুলো শেষ হয়েছে। \"ফ্রি ট্রায়াল শেষ হয়েছে\" দেখতে ট্যাবটি খুলুন।",
 "Outros dados": "অন্যান্য ডেটা",
 "Ouvir": "শুনুন",
 "Pacote em uso": "ব্যবহৃত প্যাক",
 "Para assinar, atualize o My Planner pela loja de apps do celular.": "সাবস্ক্রাইব করতে ফোনের অ্যাপ স্টোর থেকে My Planner আপডেট করুন।",
 "Para ler (PDF): organizado por aba, com títulos e datas. Abre em qualquer dispositivo ou computador.": "পড়ার জন্য (PDF): ট্যাব অনুযায়ী সাজানো, শিরোনাম ও তারিখসহ। যেকোনো ডিভাইস বা কম্পিউটারে খোলে।",
 "Para o alarme do remédio tocar com o \"Não perturbe\" ligado, o celular precisa permitir o acesso ao \"Não perturbe\" para o My Planner. Toque em \"Abrir configurações\", procure o My Planner na lista e ligue a permissão.": "\"বিরক্ত করবেন না\" চালু থাকলেও ওষুধের অ্যালার্ম বাজাতে, ফোনকে My Planner-কে \"বিরক্ত করবেন না\"-এর অ্যাক্সেস দিতে হবে। \"সেটিংস খুলুন\"-এ ট্যাপ করুন, তালিকায় My Planner খুঁজে অনুমতি চালু করুন।",
 "Passo a passo para criar a chave": "কী তৈরির ধাপে ধাপে নির্দেশনা",
 "Pedir de novo": "আবার চাইবে",
 "Pedir senha ao abrir esta aba": "এই ট্যাব খুললে পাসওয়ার্ড চাইবে",
 "Plano com período": "মেয়াদসহ প্ল্যান",
 "Plano começa em {d}": "প্ল্যান শুরু {d}-এ",
 "Por matéria": "বিষয় অনুযায়ী",
 "Prolongar": "বাড়ান",
 "Pronto: o aviso chega em até 5 segundos, com som. Se não tocar, confira se o celular está no silencioso.": "হয়ে গেছে: বিজ্ঞপ্তি 5 সেকেন্ডের মধ্যে শব্দসহ আসবে। না বাজলে দেখুন ফোন সাইলেন্টে আছে কিনা।",
 "Pronto: o aviso chega em até 5 segundos, só vibrando.": "হয়ে গেছে: বিজ্ঞপ্তি 5 সেকেন্ডের মধ্যে শুধু ভাইব্রেট করে আসবে।",
 "Publicado em": "প্রকাশিত",
 "Pulso": "পালস",
 "Quando o app bloquear": "অ্যাপ লক হলে",
 "Quer proteger esta aba com senha?": "এই ট্যাবটি পাসওয়ার্ড দিয়ে সুরক্ষিত করবেন?",
 "Recolher ou arrastar a barra": "বার গুটিয়ে রাখুন বা টেনে সরান",
 "Recomeçar os testes grátis": "ফ্রি ট্রায়াল আবার শুরু করুন",
 "Recomeçar os testes grátis?": "ফ্রি ট্রায়াল আবার শুরু করবেন?",
 "Rolar a folha para os lados": "পাতা পাশাপাশি স্ক্রল করুন",
 "Se você conectar o relógio: totais de cada dia de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect ou do app Saúde do celular. O app só lê e nunca altera esses dados.": "আপনি ঘড়ি সংযুক্ত করলে: প্রতিদিনের ধাপ, দূরত্ব, ক্যালোরি, ব্যায়াম, হৃৎস্পন্দন ও ঘুমের মোট হিসাব, Health Connect বা ফোনের Health অ্যাপ থেকে পড়া হয়। অ্যাপ শুধু পড়ে এবং এই ডেটা কখনও বদলায় না।",
 "Sem internet ou a conexão caiu. Confira o Wi-Fi ou os dados móveis e tente de novo.": "ইন্টারনেট নেই বা সংযোগ বিচ্ছিন্ন হয়েছে। Wi-Fi বা মোবাইল ডেটা যাচাই করে আবার চেষ্টা করুন।",
 "Senha desta aba": "এই ট্যাবের পাসওয়ার্ড",
 "Seu plano terminou": "আপনার প্ল্যান শেষ হয়েছে",
 "Sino": "ঘণ্টা",
 "Som do alarme": "অ্যালার্মের শব্দ",
 "Soma a garantia legal e a do fabricante. Confira no termo de garantia.": "আইনি ওয়ারেন্টি ও প্রস্তুতকারকের ওয়ারেন্টি যোগ করে। ওয়ারেন্টি কার্ডে যাচাই করুন।",
 "São dois arquivos com os seus dados do My Planner (portabilidade, LGPD):": "এগুলো আপনার My Planner ডেটার দুটি ফাইল (ডেটা পোর্টেবিলিটি, LGPD):",
 "Só quando o app bloquear": "শুধু অ্যাপ লক হলে",
 "Tamanho da borracha": "ইরেজারের আকার",
 "Tamanho da letra": "অক্ষরের আকার",
 "Tempo": "সময়",
 "Termina em": "শেষ",
 "Testar": "পরীক্ষা করুন",
 "Texto de exemplo": "নমুনা লেখা",
 "Toca nos avisos em \"Alarme (som)\". \"Som e vibração\" usa o som de notificação do celular.": "\"অ্যালার্ম (শব্দ)\" বিজ্ঞপ্তিতে বাজে। \"শব্দ ও ভাইব্রেশন\" ফোনের বিজ্ঞপ্তির শব্দ ব্যবহার করে।",
 "Toda vez que sair": "প্রতিবার বের হলে",
 "Toda vez que sair da aba": "প্রতিবার ট্যাব থেকে বের হলে",
 "Todas as abas voltam a \"{n} dias grátis para testar\", como numa conta nova. As assinaturas simuladas são desligadas.": "সব ট্যাব নতুন অ্যাকাউন্টের মতো \"{n} দিনের ফ্রি ট্রায়াল\"-এ ফিরে যায়। অনুকরণ করা সাবস্ক্রিপশন বন্ধ করা হয়।",
 "Todos os fichários": "সব বাইন্ডার",
 "Toque em \"Create API key\" (Criar chave de API). Se pedir um projeto, escolha o que aparecer ou crie um novo.": "\"Create API key\" (API কী তৈরি করুন)-এ ট্যাপ করুন। প্রজেক্ট চাইলে যেটি দেখায় সেটি বেছে নিন বা নতুন তৈরি করুন।",
 "Toque em \"Criar minha chave de API\" acima. Abre a plataforma da OpenAI (não é o site do ChatGPT).": "উপরে \"আমার API কী তৈরি করুন\"-এ ট্যাপ করুন। OpenAI প্ল্যাটফর্ম খুলবে (এটি ChatGPT-এর সাইট নয়)।",
 "Toque em \"Criar minha chave de API\" acima. Abre o Console da Anthropic (não é o site do Claude).": "উপরে \"আমার API কী তৈরি করুন\"-এ ট্যাপ করুন। Anthropic Console খুলবে (এটি Claude-এর সাইট নয়)।",
 "Toque em \"Criar minha chave de API\" acima. Abre o Google AI Studio.": "উপরে \"আমার API কী তৈরি করুন\"-এ ট্যাপ করুন। Google AI Studio খুলবে।",
 "Toque em Conectar e, na tela do app Saúde, ligue os itens que o My Planner pode ler.": "সংযুক্ত করুন-এ ট্যাপ করুন এবং Health অ্যাপের স্ক্রিনে My Planner যেগুলো পড়তে পারবে সেগুলো চালু করুন।",
 "Toque no ícone de copiar ao lado da chave. Ela começa com \"AIza\" ou \"AQ.\".": "কী-এর পাশে কপি আইকনে ট্যাপ করুন। এটি \"AIza\" বা \"AQ.\" দিয়ে শুরু হয়।",
 "Toque numa célula da tabela (ou em \"Escolher células\") para mudar o tamanho da letra dela.": "টেবিলের একটি সেলে (বা \"সেল বেছে নিন\"-এ) ট্যাপ করে তার অক্ষরের আকার বদলান।",
 "Transparência": "স্বচ্ছতা",
 "Técnico (para restaurar): cópia completa que só o My Planner lê. Para usar, vá em Ajustes › Nuvem e cópias de segurança › Importar arquivo.": "টেকনিক্যাল (ফিরিয়ে আনার জন্য): সম্পূর্ণ কপি যা শুধু My Planner পড়তে পারে। ব্যবহার করতে সেটিংস › ক্লাউড ও ব্যাকআপ › ফাইল ইমপোর্ট করুন-এ যান।",
 "Uma carta da {nome} abre em {n} dias 💌": "{nome}-এর একটি চিঠি {n} দিনে খুলবে 💌",
 "Usa a senha do app": "অ্যাপের পাসওয়ার্ড ব্যবহার করে",
 "Usar no {ia}": "{ia}-এ ব্যবহার করুন",
 "Use o app no celular para baixar o arquivo técnico.": "টেকনিক্যাল ফাইল ডাউনলোড করতে ফোনে অ্যাপ ব্যবহার করুন।",
 "Valor final definido pela loja de apps, já na moeda do seu país.": "চূড়ান্ত মূল্য অ্যাপ স্টোর নির্ধারণ করে, আপনার দেশের মুদ্রায়।",
 "Você ainda não enviou {titulo} para o My Planner.": "আপনি এখনও {titulo} My Planner-এ পাঠাননি।",
 "Volte aqui, cole no campo abaixo e toque em \"Salvar e testar\".": "এখানে ফিরে আসুন, নিচের ঘরে পেস্ট করুন এবং \"সংরক্ষণ ও পরীক্ষা করুন\"-এ ট্যাপ করুন।",
 "Volte em \"API keys\" e toque em \"Create new secret key\" (Criar chave).": "\"API keys\"-এ ফিরে যান এবং \"Create new secret key\" (কী তৈরি করুন)-এ ট্যাপ করুন।",
 "atualização automática": "স্বয়ংক্রিয় আপডেট",
 "erro desconhecido": "অজানা ত্রুটি",
 "estudados no mês": "মাসে পড়া হয়েছে",
 "faltou {dur}": "{dur} বাকি ছিল",
 "hoje {feito} de {meta}": "আজ {feito} / {meta}",
 "hoje é folga": "আজ ছুটি",
 "login do Google (não é chave de API)": "Google লগইন (API কী নয়)",
 "meta cumprida": "লক্ষ্য পূরণ",
 "o que veio com a instalação": "ইনস্টলেশনের সাথে এসেছে",
 "outro": "অন্য",
 "provisório": "অস্থায়ী",
 "superou {dur}": "{dur} বেশি",
 "token de login (não é chave de API)": "লগইন টোকেন (API কী নয়)",
 "{ia} demorou demais para responder. Tente de novo em instantes.": "{ia} উত্তর দিতে অনেক দেরি করেছে। একটু পরে আবার চেষ্টা করুন।",
 "{ia} está fora do ar ou sobrecarregado agora. Não é problema da sua chave: tente de novo mais tarde.": "{ia} এখন বন্ধ বা অতিরিক্ত ব্যস্ত। এটি আপনার কী-এর সমস্যা নয়: পরে আবার চেষ্টা করুন।",
 "{ia} respondeu ao teste com o modelo {modelo}. Já pode usar nas abas.": "{ia} মডেল {modelo} দিয়ে পরীক্ষার উত্তর দিয়েছে। এখন ট্যাবগুলোতে ব্যবহার করতে পারেন।",
 "{ia} se recusou a ler este conteúdo (filtro de segurança da empresa).": "{ia} এই বিষয়বস্তু পড়তে অস্বীকার করেছে (কোম্পানির নিরাপত্তা ফিল্টার)।",
 "{ia}: a chave existe, mas não tem permissão para usar a IA. Crie uma chave nova na página indicada no passo a passo.": "{ia}: কী আছে, কিন্তু AI ব্যবহারের অনুমতি নেই। ধাপে ধাপে নির্দেশনায় দেখানো পৃষ্ঠায় নতুন কী তৈরি করুন।",
 "{ia}: chave inválida. Confira se copiou a chave inteira ou crie uma nova.": "{ia}: অবৈধ কী। পুরো কী কপি করেছেন কিনা দেখুন বা নতুন একটি তৈরি করুন।",
 "{ia}: esta chave foi bloqueada pela empresa porque apareceu publicada na internet. Apague-a e crie outra.": "{ia}: ইন্টারনেটে প্রকাশিত হওয়ায় কোম্পানি এই কী ব্লক করেছে। এটি মুছে নতুন একটি তৈরি করুন।",
 "{ia}: limite de uso atingido. Espere alguns minutos (ou até amanhã, no plano gratuito) e tente de novo.": "{ia}: ব্যবহারের সীমা পূর্ণ হয়েছে। কয়েক মিনিট (বা ফ্রি প্ল্যানে আগামীকাল পর্যন্ত) অপেক্ষা করে আবার চেষ্টা করুন।",
 "{ia}: o modelo escolhido não está disponível para a sua conta. Escolha outro em \"Modelo\".": "{ia}: বেছে নেওয়া মডেল আপনার অ্যাকাউন্টের জন্য উপলব্ধ নয়। \"মডেল\"-এ অন্য একটি বেছে নিন।",
 "{ia}: o serviço não está disponível na sua região ou para este tipo de conta.": "{ia}: এই পরিষেবা আপনার অঞ্চলে বা এই ধরনের অ্যাকাউন্টের জন্য উপলব্ধ নয়।",
 "{ia}: sua conta de API está sem saldo ou sem forma de pagamento. Adicione créditos no site da empresa.": "{ia}: আপনার API অ্যাকাউন্টে ব্যালেন্স বা পেমেন্ট পদ্ধতি নেই। কোম্পানির সাইটে ক্রেডিট যোগ করুন।",
 "{item}: a garantia termina hoje ({data}).": "{item}: ওয়ারেন্টি আজ ({data}) শেষ হচ্ছে।",
 "{item}: a garantia terminou em {data}.": "{item}: ওয়ারেন্টি {data}-এ শেষ হয়েছে।",
 "{item}: venceu em {data}.": "{item}: {data}-এ মেয়াদ শেষ হয়েছে।",
 "{mes} de {ano}": "{mes} {ano}",
 "{nome} protegida com senha": "{nome} পাসওয়ার্ড দিয়ে সুরক্ষিত",
 "{nome}: encerrar o plano ou prolongar com uma nova data final? Nada é apagado.": "{nome}: প্ল্যান শেষ করবেন, নাকি নতুন শেষ তারিখ দিয়ে বাড়াবেন? কিছুই মোছা হয় না।",
 "{n} dias antes": "{n} দিন আগে",
 "{n} dias de estudo no plano · {dur} por dia": "প্ল্যানে পড়াশোনার {n} দিন · দিনে {dur}",
 "{n} dias de plano": "{n} দিনের প্ল্যান",
 "{n} dias depois": "{n} দিন পরে",
 "{n} item(ns) aguardando envio ao My Planner": "{n}টি আইটেম My Planner-এ পাঠানোর অপেক্ষায়",
 "{n} itens aguardando envio": "{n}টি আইটেম পাঠানোর অপেক্ষায়",
 "{quando} às {hora}": "{quando} {hora}-এ",
 "ÚLTIMOS 6 MESES": "শেষ 6 মাস",
 "Abra o My Planner Anne e entre com o seu CPF ou e-mail e a sua senha.": "My Planner Anne খুলুন এবং আপনার CPF বা ইমেইল ও পাসওয়ার্ড দিয়ে সাইন ইন করুন।",
 "Anexo": "সংযুক্তি",
 "Assédio ou ameaça": "হয়রানি বা হুমকি",
 "Bloquear {nome}": "{nome}-কে ব্লক করুন",
 "Conte mais (opcional)": "আরও বলুন (ঐচ্ছিক)",
 "Conteúdo impróprio": "অনুপযুক্ত কনটেন্ট",
 "Conteúdo ofensivo e usuários abusivos não são tolerados. As denúncias são analisadas pela nossa equipe em até 24 horas.": "আপত্তিকর কনটেন্ট ও অপব্যবহারকারী ব্যবহারকারী সহ্য করা হয় না। আমাদের দল ২৪ ঘণ্টার মধ্যে রিপোর্ট পর্যালোচনা করে।",
 "Denunciar": "রিপোর্ট করুন",
 "Denunciar contato": "পরিচিতি রিপোর্ট করুন",
 "Denunciar grupo": "গ্রুপ রিপোর্ট করুন",
 "Denunciar mensagem": "বার্তা রিপোর্ট করুন",
 "Denúncia enviada": "রিপোর্ট পাঠানো হয়েছে",
 "Denúncias que você faz nas Mensagens: o motivo, quem foi denunciado e o trecho da mensagem denunciada. Só a equipe do My Planner lê, para analisar o caso.": "বার্তায় আপনার করা রিপোর্ট: কারণ, কাকে রিপোর্ট করা হয়েছে এবং রিপোর্ট করা বার্তার অংশ। বিষয়টি পর্যালোচনার জন্য শুধু My Planner-এর দল এগুলো পড়ে।",
 "Enviar denúncia": "রিপোর্ট পাঠান",
 "Mande um e-mail pedindo a exclusão, com o CPF ou o e-mail da conta. Respondemos em até 15 dias.": "অ্যাকাউন্টের CPF বা ইমেইলসহ মুছে ফেলার অনুরোধ জানিয়ে একটি ইমেইল পাঠান। আমরা ১৫ দিনের মধ্যে উত্তর দিই।",
 "Não toleramos conteúdo ofensivo, ilegal ou impróprio nem usuários abusivos nas Mensagens e nos grupos. Qualquer pessoa pode denunciar uma mensagem, um contato ou um grupo (segure a mensagem ou toque em ⋮ > Denunciar) e bloquear quem quiser. As denúncias são analisadas pela nossa equipe em até 24 horas: o conteúdo pode ser removido e quem o enviou pode ter a conta suspensa ou encerrada.": "বার্তা ও গ্রুপে আমরা আপত্তিকর, অবৈধ বা অনুপযুক্ত কনটেন্ট এবং অপব্যবহারকারী ব্যবহারকারী সহ্য করি না। যে কেউ কোনো বার্তা, পরিচিতি বা গ্রুপ রিপোর্ট করতে পারেন (বার্তাটি চেপে ধরুন বা ⋮ > রিপোর্ট করুন-এ ট্যাপ করুন) এবং যাকে খুশি ব্লক করতে পারেন। আমাদের দল ২৪ ঘণ্টার মধ্যে রিপোর্ট পর্যালোচনা করে: কনটেন্ট সরিয়ে ফেলা হতে পারে এবং প্রেরকের অ্যাকাউন্ট স্থগিত বা বন্ধ করা হতে পারে।",
 "Obrigado. Nossa equipe vai analisar em até 24 horas.": "ধন্যবাদ। আমাদের দল ২৪ ঘণ্টার মধ্যে পর্যালোচনা করবে।",
 "Para contas que entram com CPF, a senha nova é criada pelo nosso suporte, depois de confirmar que a conta é sua. Escreva para {email} informando o seu CPF ou o e-mail cadastrado.": "যেসব অ্যাকাউন্ট CPF দিয়ে সাইন ইন করে, সেগুলোর নতুন পাসওয়ার্ড অ্যাকাউন্টটি আপনার কিনা নিশ্চিত করার পর আমাদের সাপোর্ট তৈরি করে। আপনার CPF বা নিবন্ধিত ইমেইল জানিয়ে {email}-এ লিখুন।",
 "Por que você está denunciando? A pessoa denunciada não fica sabendo quem denunciou.": "আপনি কেন রিপোর্ট করছেন? যাকে রিপোর্ট করা হয়েছে তিনি জানবেন না কে রিপোর্ট করেছে।",
 "Spam": "স্প্যাম",
 "{nome} não pode mais conversar com você.": "{nome} আর আপনার সাথে চ্যাট করতে পারবে না।",
 "{nome}\nVale até {d}. Ele fica criptografado no seu cofre, só neste dispositivo e na sua cópia da nuvem.": "{nome}\n{d} পর্যন্ত বৈধ। এটি আপনার ভল্টে এনক্রিপ্ট করে রাখা হয়, শুধু এই ডিভাইসে ও আপনার ক্লাউড কপিতে।",
 "1. No computador, abra {url} e escolha Entrar com QR Code.": "১. কম্পিউটারে {url} খুলুন এবং QR কোড দিয়ে প্রবেশ বেছে নিন।",
 "2. Aqui, toque em Conectar navegador e aponte a câmera para o QR Code do computador.": "২. এখানে ব্রাউজার সংযুক্ত করুন-এ ট্যাপ করুন এবং ক্যামেরা কম্পিউটারের QR কোডের দিকে ধরুন।",
 "Abandonados": "ছেড়ে দেওয়া",
 "Bloquear o computador": "কম্পিউটার লক করুন",
 "Cheguei na página...": "আমি এই পৃষ্ঠায় পৌঁছেছি...",
 "Computador conectado": "সংযুক্ত কম্পিউটার",
 "Computador desconectado": "কম্পিউটার বিচ্ছিন্ন",
 "Conectado em {d}": "{d} এ সংযুক্ত",
 "Crie o grupo e mande o link: quem entrar vê o material do livro e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "গ্রুপ তৈরি করে লিংক পাঠান: যে যোগ দেবে সে বইয়ের উপকরণ দেখবে এবং পড়া অনুসরণ করবে। অ্যাডমিন যোগ, সম্পাদনা ও ছবি দেন, এবং যারা এই ট্যাব ব্যবহার করেন তাদেরও এই অনুমতি দিতে পারেন। শুধু অ্যাডমিন লোক যোগ বা বাদ দিতে পারেন।",
 "Depois de {n} minutos parado": "{n} মিনিট নিষ্ক্রিয় থাকলে",
 "Desconectar o computador?": "কম্পিউটার বিচ্ছিন্ন করবেন?",
 "Difícil demais": "খুব কঠিন",
 "Editar livro": "বই সম্পাদনা",
 "Entrar com o QR Code": "QR কোড দিয়ে প্রবেশ",
 "Escreva (ex.: filosofia)": "লিখুন (যেমন: দর্শন)",
 "Este computador": "এই কম্পিউটার",
 "Este computador foi desconectado (pelo celular ou porque outro computador entrou). Para usar de novo, entre com o QR Code.": "এই কম্পিউটার বিচ্ছিন্ন করা হয়েছে (ফোন থেকে বা অন্য কম্পিউটার প্রবেশ করায়)। আবার ব্যবহার করতে QR কোড দিয়ে প্রবেশ করুন।",
 "Já existe um computador conectado": "ইতিমধ্যে একটি কম্পিউটার সংযুক্ত",
 "Já existe um computador conectado. Trocar para este? O outro será desconectado.": "ইতিমধ্যে একটি কম্পিউটার সংযুক্ত। এটিতে বদলাবেন? অন্যটি বিচ্ছিন্ন হবে।",
 "Navegador": "ব্রাউজার",
 "Nenhum computador conectado": "কোনো কম্পিউটার সংযুক্ত নেই",
 "Novo livro": "নতুন বই",
 "Não gostei": "ভালো লাগেনি",
 "Não, abandonei": "না, ছেড়ে দিয়েছি",
 "O My Planner fecha no computador. Para usar de novo, é só conectar pelo QR Code.": "কম্পিউটারে My Planner বন্ধ হবে। আবার ব্যবহার করতে QR কোড দিয়ে সংযুক্ত করুন।",
 "O QR Code muda a cada 3 minutos e só vale uma vez. Em computador compartilhado, use Ajustes › Sair deste computador ao terminar.": "QR কোড প্রতি ৩ মিনিটে বদলায় এবং একবারই কাজ করে। শেয়ার করা কম্পিউটারে শেষে সেটিংস › এই কম্পিউটার থেকে বের হন ব্যবহার করুন।",
 "Os seus dados continuam salvos na nuvem e no celular. Para entrar de novo, use o QR Code.": "আপনার ডেটা ক্লাউডে ও ফোনে সংরক্ষিত থাকে। আবার প্রবেশ করতে QR কোড ব্যবহার করুন।",
 "Parei em": "থামিয়েছি",
 "Perdi o interesse": "আগ্রহ হারিয়েছি",
 "Por que parei": "কেন থামিয়েছি",
 "Páginas e meta": "পৃষ্ঠা ও লক্ষ্য",
 "Quero voltar a ler?": "আবার পড়তে চাই?",
 "Sair deste computador": "এই কম্পিউটার থেকে বের হন",
 "Sair deste computador?": "এই কম্পিউটার থেকে বের হবেন?",
 "Se quiser, escreva com as suas palavras": "চাইলে নিজের ভাষায় লিখুন",
 "Sem mexer no mouse ou no teclado por esse tempo, o My Planner bloqueia. Para voltar, digite a senha da conta (ou entre com o QR Code de novo).": "এত সময় মাউস বা কীবোর্ড ব্যবহার না হলে My Planner লক হয়। ফিরতে অ্যাকাউন্টের পাসওয়ার্ড লিখুন (বা আবার QR কোড দিয়ে প্রবেশ করুন)।",
 "Sem tempo": "সময় নেই",
 "Sim, depois": "হ্যাঁ, পরে",
 "Só um computador pode ficar conectado por vez.": "একসাথে শুধু একটি কম্পিউটার সংযুক্ত থাকতে পারে।",
 "A foto ou o PDF do certificado vai em \"Fotos, arquivos e links\": marque como Certificado.": "সার্টিফিকেটের ছবি বা PDF \"ছবি, ফাইল ও লিংক\"-এ রাখুন এবং সার্টিফিকেট হিসেবে চিহ্নিত করুন।",
 "ABNT copiada": "ABNT কপি হয়েছে",
 "APA copiada": "APA কপি হয়েছে",
 "Ano inválido": "অবৈধ বছর",
 "Ano ou data de publicação": "প্রকাশের বছর বা তারিখ",
 "Assisti em": "দেখেছি",
 "Buscando os dados...": "তথ্য খোঁজা হচ্ছে...",
 "Calculado pelos módulos": "মডিউল থেকে হিসাব করা",
 "Carga horária (horas)": "মোট ঘণ্টা",
 "Certificado": "সার্টিফিকেট",
 "Certificado emitido em": "সার্টিফিকেট ইস্যুর তারিখ",
 "Cheguei na aula": "আমি এই পাঠে আছি",
 "Cheguei na aula...": "আমি এই পাঠে আছি...",
 "Cheguei na temporada": "আমি এই সিজনে আছি",
 "Cheguei no episódio": "আমি এই পর্বে আছি",
 "Citação copiada": "উদ্ধৃতি কপি হয়েছে",
 "Colocar em pasta": "ফোল্ডারে রাখুন",
 "Coloque livros, filmes ou cursos nesta pasta para montar a lista.": "তালিকা বানাতে এই ফোল্ডারে বই, সিনেমা বা কোর্স রাখুন।",
 "Comentário": "মন্তব্য",
 "Copiar ABNT": "ABNT কপি করুন",
 "Copiar APA": "APA কপি করুন",
 "Copiar citação (ABNT)": "উদ্ধৃতি কপি (ABNT)",
 "Copiar citação (APA)": "উদ্ধৃতি কপি (APA)",
 "Crie cards com checklist, lista, texto livre ou desenho para esta matéria. Arraste para a direita para excluir e para a esquerda para Arquivar ou Duplicar.": "এই বিষয়ের জন্য চেকলিস্ট, তালিকা, মুক্ত লেখা বা আঁকা দিয়ে কার্ড বানান। মুছতে ডানে, আর্কাইভ বা ডুপ্লিকেট করতে বামে টানুন।",
 "Crie o grupo e mande o link: quem entrar vê a lista e acompanha. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "গ্রুপ তৈরি করে লিংক পাঠান: যে যোগ দেবে সে তালিকা দেখবে ও অনুসরণ করবে। অ্যাডমিন যোগ, সম্পাদনা ও ছবি দেন, এবং এই ট্যাব ব্যবহারকারীদেরও অনুমতি দিতে পারেন। শুধু অ্যাডমিন লোক যোগ বা বাদ দিতে পারেন।",
 "Crie o grupo e mande o link: quem entrar vê o material do curso e acompanha. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "গ্রুপ তৈরি করে লিংক পাঠান: যে যোগ দেবে সে কোর্সের উপকরণ দেখবে ও অনুসরণ করবে। অ্যাডমিন যোগ, সম্পাদনা ও ছবি দেন, এবং এই ট্যাব ব্যবহারকারীদেরও অনুমতি দিতে পারেন। শুধু অ্যাডমিন লোক যোগ বা বাদ দিতে পারেন।",
 "Crie uma pasta primeiro, na parte 📁 Pastas desta aba.": "আগে এই ট্যাবের 📁 ফোল্ডার অংশে একটি ফোল্ডার বানান।",
 "DOI (artigos)": "DOI (প্রবন্ধ)",
 "Data de acesso": "অ্যাক্সেসের তারিখ",
 "Deixar avulsas": "আলাদা রাখুন",
 "Descrição (objetivo)": "বিবরণ (উদ্দেশ্য)",
 "Digite o ano com 4 números (ex.: {a}).": "বছর ৪ অঙ্কে লিখুন (যেমন: {a})।",
 "Direção": "পরিচালনা",
 "Editar pasta": "ফোল্ডার সম্পাদনা",
 "Editora": "প্রকাশক",
 "Edição": "সংস্করণ",
 "Em 1 mês": "১ মাসে",
 "Em {n} meses": "{n} মাসে",
 "Episódios por temporada (opcional)": "প্রতি সিজনে পর্ব (ঐচ্ছিক)",
 "Escreva o trecho na anotação para copiar a citação.": "উদ্ধৃতি কপি করতে নোটে অংশটি লিখুন।",
 "Este item já está em todas as pastas.": "এই আইটেম সব ফোল্ডারে আছে।",
 "Ex.: 10.1590/...": "যেমন: 10.1590/...",
 "Ex.: TCC — Ética e Direito": "যেমন: থিসিস — নীতি ও আইন",
 "Ex.: {a}": "যেমন: {a}",
 "Fazendo": "চলছে",
 "Grupo de filmes e séries": "সিনেমা ও সিরিজ গ্রুপ",
 "Grupo de leitura": "পড়ার গ্রুপ",
 "Grupo do curso": "কোর্স গ্রুপ",
 "ISBN": "ISBN",
 "Ideia minha": "আমার ভাবনা",
 "Instrutor": "প্রশিক্ষক",
 "Itens da pasta": "ফোল্ডারের আইটেম",
 "Junte livros, filmes e cursos numa pasta (ex.: \"TCC\", \"Só romances\"). O mesmo item pode estar em várias pastas.": "বই, সিনেমা ও কোর্স একটি ফোল্ডারে রাখুন (যেমন: \"থিসিস\", \"শুধু উপন্যাস\")। একই আইটেম একাধিক ফোল্ডারে থাকতে পারে।",
 "Link (material online)": "লিংক (অনলাইন উপকরণ)",
 "Lista copiada": "তালিকা কপি হয়েছে",
 "Lista de referências": "রেফারেন্স তালিকা",
 "Mais de um autor: separe com ponto e vírgula (;).": "একাধিক লেখক: সেমিকোলন (;) দিয়ে আলাদা করুন।",
 "Módulo": "মডিউল",
 "Nada novo": "নতুন কিছু নেই",
 "No ⋮ de um livro, filme ou curso, toque em \"Colocar em pasta\".": "বই, সিনেমা বা কোর্সের ⋮ থেকে \"ফোল্ডারে রাখুন\" ট্যাপ করুন।",
 "Nome da pasta": "ফোল্ডারের নাম",
 "Não achei dados novos para completar a ficha.": "পূরণ করার মতো নতুন তথ্য পাওয়া যায়নি।",
 "Não foi possível preencher": "পূরণ করা গেল না",
 "O módulo não tem cards de anotações.": "এই মডিউলে নোট কার্ড নেই।",
 "Organizador": "সম্পাদক",
 "Os dados vêm da ficha do livro (Editar › Referência).": "তথ্য আসে বইয়ের রেকর্ড থেকে (সম্পাদনা › রেফারেন্স)।",
 "Os livros, filmes e cursos da pasta NÃO são apagados: continuam na aba.": "ফোল্ডারের বই, সিনেমা ও কোর্স মুছবে না: ট্যাবেই থাকবে।",
 "Os {n} card(s) de anotações deste módulo também vão para a lixeira.": "এই মডিউলের {n}টি নোট কার্ডও ট্র্যাশে যাবে।",
 "Pasta vazia": "খালি ফোল্ডার",
 "Preencha o título (e o que mais tiver) na ficha.": "রেকর্ডে শিরোনাম (এবং আর যা আছে) লিখুন।",
 "Preencher pelo DOI": "DOI থেকে পূরণ",
 "Preencher pelo link": "লিংক থেকে পূরণ",
 "Produtora ou país": "প্রযোজক বা দেশ",
 "Quero fazer": "করতে চাই",
 "Quero voltar?": "আবার শুরু করতে চান?",
 "Referência vazia": "রেফারেন্স খালি",
 "Referências": "রেফারেন্স",
 "Se deixar avulsas, elas continuam somando no total do curso.": "আলাদা রাখলেও কোর্সের মোটে গোনা হবে।",
 "Subtítulo": "উপশিরোনাম",
 "Tirar da pasta": "ফোল্ডার থেকে সরান",
 "Total de episódios (opcional)": "মোট পর্ব (ঐচ্ছিক)",
 "Total de temporadas (opcional)": "মোট সিজন (ঐচ্ছিক)",
 "Tradutor": "অনুবাদক",
 "Trecho (citação)": "অংশ (উদ্ধৃতি)",
 "Trecho vazio": "অংশ খালি",
 "Você já assistiu {n} aula(s). Colocar em qual módulo?": "আপনি ইতিমধ্যে {n}টি পাঠ দেখেছেন। কোন মডিউলে রাখবেন?",
 "Volume": "খণ্ড",
 "{n} item(ns)": "{n}টি আইটেম",
 "{n} referência(s) em ordem alfabética.": "বর্ণানুক্রমে {n}টি রেফারেন্স।",
 "Ícone": "আইকন",
 "ASSISTIDOS POR DIA": "দিনে দেখা",
 "ASSISTIDOS POR MÊS": "মাসে দেখা",
 "AULAS POR DIA": "দিনে পাঠ",
 "AULAS POR MÊS": "মাসে পাঠ",
 "Apagar a meta": "লক্ষ্য মুছুন",
 "Assisti {a} · Estou assistindo {b} · Parei {c} · Quero assistir {d}": "দেখেছি {a} · দেখছি {b} · থেমেছি {c} · দেখতে চাই {d}",
 "Aulas": "পাঠ",
 "CURSOS": "কোর্স",
 "Concluí {a} · Fazendo {b} · Parei {c}": "শেষ {a} · চলছে {b} · থেমেছি {c}",
 "Datas": "তারিখ",
 "Datas escolhidas": "বেছে নেওয়া তারিখ",
 "Datas à escolha": "নিজের তারিখ",
 "Definir meta de {ano}": "{ano} সালের লক্ষ্য ঠিক করুন",
 "Definir meta do ano": "বছরের লক্ষ্য ঠিক করুন",
 "FILMES E SÉRIES": "সিনেমা ও সিরিজ",
 "Faltam {f} curso(s): dá cerca de {m} por mês": "আর {f}টি কোর্স: মাসে প্রায় {m}টি",
 "Faltam {f} livro(s): dá cerca de {m} por mês": "আর {f}টি বই: মাসে প্রায় {m}টি",
 "Faltam {f} título(s): dá cerca de {m} por mês": "আর {f}টি: মাসে প্রায় {m}টি",
 "Gênero": "ধরন",
 "Incluir lista de referências no PDF": "PDF-এ রেফারেন্স তালিকা যোগ করুন",
 "LIVROS": "বই",
 "Li {a} livro(s) · Parei {b} · Estou lendo {c}": "পড়েছি {a} · থেমেছি {b} · পড়ছি {c}",
 "Meta de {ano}": "{ano} সালের লক্ষ্য",
 "Meta de {ano}: usar a de {antes} ({n})?": "{ano} সালের লক্ষ্য: {antes} সালেরটা ({n}) রাখবেন?",
 "Meta do ano cumprida": "বছরের লক্ষ্য পূরণ",
 "Mudar": "বদলান",
 "Nada neste período.": "এই সময়ে কিছু নেই।",
 "Nota": "রেটিং",
 "O PDF não leva as suas anotações, resumos e comentários.": "PDF-এ আপনার নোট, সারাংশ ও মন্তব্য থাকে না।",
 "POR ITEM": "প্রতিটি আইটেম",
 "Plataforma": "প্ল্যাটফর্ম",
 "PÁGINAS POR DIA": "দিনে পৃষ্ঠা",
 "PÁGINAS POR MÊS": "মাসে পৃষ্ঠা",
 "Quantos no ano?": "বছরে কতগুলো?",
 "Quero ler {a} · Abandonei {b}": "পড়তে চাই {a} · ছেড়েছি {b}",
 "Relatório de leitura e mídia": "পড়া ও মিডিয়া রিপোর্ট",
 "concluídos no período": "এই সময়ে শেষ",
 "cursos concluídos no período": "এই সময়ে শেষ কোর্স",
 "livros lidos no período": "এই সময়ে পড়া বই",
 "pág. {a} de {n}": "পৃষ্ঠা {a}/{n}",
 "títulos assistidos no período": "এই সময়ে দেখা",
 "{a} aula(s) assistida(s) no período · {h} hora(s) de cursos concluídos": "এই সময়ে {a}টি পাঠ · শেষ কোর্সের {h} ঘণ্টা",
 "{a} de {n} aulas ({p}%)": "{a}/{n} পাঠ ({p}%)",
 "{a} de {n} curso(s) concluído(s) em {ano}": "{ano} সালে {a}/{n}টি কোর্স শেষ",
 "{a} de {n} livro(s) em {ano}": "{ano} সালে {a}/{n}টি বই",
 "{a} de {n} título(s) assistido(s) em {ano}": "{ano} সালে {a}/{n}টি দেখা",
 "{n} item(ns) sem data de mudança de situação: usei a data de criação.": "{n}টি আইটেমে অবস্থা বদলের তারিখ নেই: তৈরির তারিখ নেওয়া হয়েছে।",
 "{p} página(s) lida(s) em {d} dia(s) · melhor sequência: {s} dia(s)": "{d} দিনে {p} পৃষ্ঠা · সেরা ধারা: {s} দিন",
 "{p}% lido · falta {f}%": "{p}% পড়া · বাকি {f}%",
 "Esta aba pede senha. Desbloqueie a aba primeiro e o guia continua daqui.": "এই ট্যাবে পাসওয়ার্ড লাগে। আগে খুলুন, গাইড এখান থেকে চলবে।",
 "Abrir esta aba": "এই ট্যাব খুলুন",
 "Mostrar na tela": "স্ক্রিনে দেখান",
 "Não achei este ponto na tela agora. Confira se a tela certa está aberta e tente de novo.": "এখন স্ক্রিনে এই জায়গা পাওয়া যায়নি। সঠিক স্ক্রিন খোলা আছে কিনা দেখে আবার চেষ্টা করুন।",
 "Primeiros passos": "প্রথম ধাপ",
 "Buscar no guia": "গাইডে খুঁজুন",
 "Entendi": "বুঝেছি",
 "{n} de {total} passos feitos": "{total}টির মধ্যে {n}টি ধাপ শেষ",
 "Já fiz": "করেছি",
 "Guia em construção": "গাইড তৈরি হচ্ছে",
 "Limpar marcações": "চিহ্ন মুছুন",
 "Este ponto ainda não está marcado no app.": "এই জায়গাটি এখনও অ্যাপে চিহ্নিত নয়।",
 "Dicas e atalhos": "টিপস ও শর্টকাট",
 "Gestos do app": "অ্যাপের অঙ্গভঙ্গি",
 "Procurando na tela…": "স্ক্রিনে খোঁজা হচ্ছে…",
 "Guia das abas": "ট্যাব গাইড",
 "Voltar ao guia": "গাইডে ফিরুন",
 "Para que serve": "কী কাজে লাগে",
 "Disponível no app do celular.": "ফোনের অ্যাপে আছে।",
 "Nada encontrado no guia.": "গাইডে কিছু পাওয়া যায়নি।",
 "Recursos que valem para todas as abas": "সব ট্যাবের সুবিধা",
 "Perguntas comuns": "সাধারণ প্রশ্ন",
 "Ligar e desligar partes": "অংশ চালু ও বন্ধ",
 "Entrada cancelada. Este computador não foi conectado.": "সাইন-ইন বাতিল হয়েছে। এই কম্পিউটারটি সংযুক্ত হয়নি।",
 "Alterações ainda não enviadas": "পরিবর্তনগুলো এখনও পাঠানো হয়নি",
 "Algumas alterações ainda não foram enviadas para o servidor (sem internet?). Se sair agora, elas se perdem. Sair mesmo assim?": "কিছু পরিবর্তন এখনও সার্ভারে পাঠানো হয়নি (ইন্টারনেট নেই?)। এখন বের হলে সেগুলো হারিয়ে যাবে। তবুও বের হবেন?",
 "Sair mesmo assim": "তবুও বের হন",
 "O seu papel no grupo não permite mudar aqui.": "গ্রুপে আপনার ভূমিকা এখানে পরিবর্তনের অনুমতি দেয় না।",
 "Não foi possível consultar o DOI agora (sem internet?). Tente de novo.": "এখন DOI খোঁজা যায়নি (ইন্টারনেট নেই?)। আবার চেষ্টা করুন।",
 "DOI inválido.": "অবৈধ DOI।",
 "DOI não encontrado.": "DOI পাওয়া যায়নি।",
 "O site não deixou ler os dados daqui (no navegador do computador isso é comum). Tente pelo app no celular, use o DOI, ou digite os campos.": "সাইটটি এখান থেকে ডেটা পড়তে দেয়নি (কম্পিউটারের ব্রাউজারে এটি সাধারণ)। ফোনে অ্যাপ দিয়ে চেষ্টা করুন, DOI ব্যবহার করুন, অথবা ঘরগুলো পূরণ করুন।",
 "Atualizando...": "আপডেট হচ্ছে...",
 "Banco de dados (Supabase, plano grátis)": "ডেটাবেস (Supabase, ফ্রি প্ল্যান)",
 "Cadeado (HTTPS) até": "HTTPS তালা যতদিন",
 "Dados das abas: {d}": "ট্যাবের ডেটা: {d}",
 "Disco": "ডিস্ক",
 "Esta conta não tem acesso a estas informações.": "এই অ্যাকাউন্টের এই তথ্য দেখার অনুমতি নেই।",
 "Ligado há": "চালু আছে",
 "Livre: {l} · site: {s}": "খালি: {l} · সাইট: {s}",
 "Maiores tabelas": "সবচেয়ে বড় টেবিল",
 "Memória em uso": "ব্যবহৃত মেমরি",
 "O servidor ainda não mandou o relatório. Ele manda a cada 10 minutos depois do 53-SERVIDOR-0.78.bat.": "সার্ভার এখনও রিপোর্ট পাঠায়নি। 53-SERVIDOR-0.78.bat এর পরে এটি প্রতি 10 মিনিটে পাঠায়।",
 "O servidor ainda não tem esta função. Rode o 53-SERVIDOR-0.78.bat no computador.": "সার্ভারে এখনও এই সুবিধা নেই। কম্পিউটারে 53-SERVIDOR-0.78.bat চালান।",
 "O sistema do servidor pede reinício (atualização de segurança instalada).": "সার্ভার সিস্টেম রিস্টার্ট চাইছে (নিরাপত্তা আপডেট ইনস্টল হয়েছে)।",
 "Processador": "প্রসেসর",
 "Relatório do servidor: {q}": "সার্ভার রিপোর্ট: {q}",
 "Servidor": "সার্ভার",
 "Servidor do site (Locaweb)": "সাইটের সার্ভার (Locaweb)",
 "Sistema": "সিস্টেম",
 "Só você vê este quadro.": "এই অংশটি শুধু আপনি দেখতে পান।",
 "Versão do site no ar": "লাইভ সাইটের সংস্করণ",
 "atrasado: confira se o servidor está ligado": "দেরি হয়েছে: সার্ভার চালু আছে কিনা দেখুন",
 "sem cadeado": "তালা নেই",
 "{a} ({n} guardadas)": "{a} ({n}টি রাখা)",
 "{d} dia(s) e {h} h": "{d} দিন ও {h} ঘণ্টা",
 "{n} núcleo(s) · carga {c}": "{n} কোর · লোড {c}",
 "{n} · {novas} nova(s) e {ativas} ativa(s) em 7 dias": "{n} · 7 দিনে {novas}টি নতুন ও {ativas}টি সক্রিয়",
 "{u} de {t} ({p}%)": "{t} এর মধ্যে {u} ({p}%)",
 "Fechar teclado": "কিবোর্ড বন্ধ করুন",
 "Mostrar as ferramentas": "টুল দেখান",
 "Últimas cores usadas": "সম্প্রতি ব্যবহৃত রং",
 "Voltar ao topo": "উপরে যান",
 "Topo": "উপরে",
 "1 atividade do roteiro por fazer": "ভ্রমণসূচির 1টি কাজ বাকি",
 "1 dia": "1 দিন",
 "1 item por pôr na mala": "1টি জিনিস এখনো ব্যাগে তোলা বাকি",
 "1 lista de Viagens ia inteira para o My Planner e saiu de lá. Agora o envio é item por item, pelo ⋮ de cada item.": "ভ্রমণের 1টি তালিকা পুরোটাই My Planner-এ যেত এবং সেখান থেকে সরানো হয়েছে। এখন প্রতিটি আইটেমের ⋮ থেকে একে একে পাঠানো হয়।",
 "1 lugar não visitado": "1টি জায়গা দেখা হয়নি",
 "1 reserva por confirmar": "1টি বুকিং নিশ্চিত করা বাকি",
 "Abrir o bloco": "অংশ খুলুন",
 "Adicionar pessoa": "ব্যক্তি যোগ করুন",
 "Ainda pode gastar {v}": "এখনো {v} খরচ করতে পারেন",
 "Ao ligar, o valor entra em Gastos como pago.": "চালু করলে পরিমাণটি খরচে পরিশোধিত হিসেবে যোগ হবে।",
 "Até (dd/mm/aaaa)": "পর্যন্ত (দিন/মাস/বছর)",
 "Coloque as pessoas em \"Quem vai\" (edite a viagem).": "\"কে যাচ্ছে\"-তে লোকজন যোগ করুন (ভ্রমণ সম্পাদনা করুন)।",
 "Como foi?": "কেমন ছিল?",
 "Concluído em {d}": "{d} তারিখে সম্পন্ন",
 "Confirmada em {d}": "{d} তারিখে নিশ্চিত",
 "Confirmadas": "নিশ্চিত",
 "Dia anterior": "আগের দিন",
 "Dias": "দিন",
 "Dias × valor por dia": "দিন × প্রতিদিনের পরিমাণ",
 "Documentos (só o tipo e a validade)": "কাগজপত্র (শুধু ধরন ও মেয়াদ)",
 "EXIGÊNCIAS DO DESTINO": "গন্তব্যের শর্তাবলি",
 "Em mãos": "হাতে আছে",
 "Escreva o que o destino pede (ex.: 2 páginas em branco no passaporte, certificado de vacina). Confira no site oficial do país.": "গন্তব্যে কী লাগে লিখুন (যেমন: পাসপোর্টে 2টি ফাঁকা পাতা, টিকার সনদ)। দেশের অফিসিয়াল ওয়েবসাইটে যাচাই করুন।",
 "Ex.: Lisboa (LIS)": "যেমন: লিসবন (LIS)",
 "Ex.: São Paulo (GRU)": "যেমন: সাও পাওলো (GRU)",
 "Falta confirmar": "নিশ্চিত করা বাকি",
 "Falta pôr": "তোলা বাকি",
 "Faltou ({n}): {l}": "বাদ পড়েছে ({n}): {l}",
 "Foi ({n}): {l}": "সঙ্গে গেছে ({n}): {l}",
 "Fotos (lista das legendas)": "ছবি (ক্যাপশনের তালিকা)",
 "Gasto de {nome} em {d}": "{d} তারিখে {nome}-এর খরচ",
 "Gastos do dia": "দিনের খরচ",
 "Gastos em outras moedas (não convertidos): {v}": "অন্য মুদ্রায় খরচ (রূপান্তর হয়নি): {v}",
 "Gastos por dia": "দিনভিত্তিক খরচ",
 "Horário de chegada": "পৌঁছানোর সময়",
 "Lugares (visitados, faltam, imperdíveis e a nota)": "জায়গা (দেখা, বাকি, অবশ্যই দেখার এবং রেটিং)",
 "Mala (o que foi e o que faltou)": "ব্যাগ (কী নেওয়া হয়েছে আর কী বাদ পড়েছে)",
 "Marcar como acertado": "মিটমাট হয়েছে হিসেবে চিহ্নিত করুন",
 "Marcar como acertado?": "মিটমাট হয়েছে হিসেবে চিহ্নিত করবেন?",
 "Na mala": "ব্যাগে আছে",
 "Nenhuma parada ainda": "এখনো কোনো বিরতি নেই",
 "Nova exigência": "নতুন শর্ত",
 "Números de documentos e o que está no cofre nunca vão para o relatório. Valores em moedas diferentes aparecem separados.": "কাগজপত্রের নম্বর ও সিন্দুকে থাকা কিছুই রিপোর্টে যায় না। ভিন্ন মুদ্রার পরিমাণ আলাদাভাবে দেখানো হয়।",
 "O QUE AINDA FALTA": "এখনো যা বাকি",
 "O QUE INCLUIR": "কী অন্তর্ভুক্ত করবেন",
 "Opcional. O app avisa se o passaporte vencer antes disso, contado da volta. Confira a exigência do país.": "ঐচ্ছিক। ফেরার দিন থেকে গুনে এর আগে পাসপোর্টের মেয়াদ শেষ হলে অ্যাপ জানাবে। দেশের শর্ত যাচাই করুন।",
 "Orçamento previsto × gasto por categoria": "পরিকল্পিত বাজেট × বিভাগ অনুযায়ী খরচ",
 "Passou do previsto em {v}": "বাজেটের চেয়ে {v} বেশি",
 "Ponha a validade de cada documento: o app avisa antes de vencer. As fotos dos documentos ficam protegidas no cofre.": "প্রতিটি কাগজের মেয়াদ দিন: মেয়াদ শেষ হওয়ার আগে অ্যাপ জানাবে। কাগজপত্রের ছবি সিন্দুকে সুরক্ষিত থাকে।",
 "Próximo dia": "পরের দিন",
 "Quem está no grupo da viagem entra sozinho. Use \"+ Adicionar pessoa\" para quem não tem o app.": "ভ্রমণ গ্রুপের সদস্যরা নিজে থেকেই যুক্ত হন। যাঁদের অ্যাপ নেই, তাঁদের জন্য \"+ ব্যক্তি যোগ করুন\" ব্যবহার করুন।",
 "Recolher o bloco": "অংশ বন্ধ করুন",
 "Relatório da viagem": "ভ্রমণ রিপোর্ট",
 "Reserva confirmada": "বুকিং নিশ্চিত",
 "Resumo da viagem": "ভ্রমণের সারাংশ",
 "Resumo da viagem (datas, destino, pessoas)": "ভ্রমণের সারাংশ (তারিখ, গন্তব্য, লোকজন)",
 "Roteiro por dia (feito e falta)": "দিনভিত্তিক ভ্রমণসূচি (সম্পন্ন ও বাকি)",
 "Sem data": "তারিখ নেই",
 "Seu passaporte pode não ser aceito. Confira a exigência do país": "আপনার পাসপোর্ট গ্রহণযোগ্য না-ও হতে পারে। দেশের শর্ত যাচাই করুন",
 "Subir": "উপরে সরান",
 "Total do dia: {v}": "দিনের মোট: {v}",
 "Uma frase (opcional)": "একটি বাক্য (ঐচ্ছিক)",
 "Validade mínima exigida (meses)": "পাসপোর্টের ন্যূনতম প্রয়োজনীয় মেয়াদ (মাস)",
 "Validade: {d}": "মেয়াদ: {d}",
 "Valor por dia": "প্রতিদিনের পরিমাণ",
 "Viagens no My Planner": "My Planner-এ ভ্রমণ",
 "Visitado": "দেখা হয়েছে",
 "Visitado em {d}": "{d} তারিখে দেখা হয়েছে",
 "Voltaria: {r}": "আবার যাব: {r}",
 "Voltaria?": "আবার যাবেন?",
 "confirmada": "নিশ্চিত",
 "em mãos": "হাতে আছে",
 "gasto na viagem {d}": "ভ্রমণের খরচ {d}",
 "meses": "মাস",
 "outro gasto": "অন্য খরচ",
 "vence em {d}": "{d} তারিখে মেয়াদ শেষ",
 "{a} de {b} confirmadas": "{b}টির মধ্যে {a}টি নিশ্চিত",
 "{a} de {b} em mãos": "{b}টির মধ্যে {a}টি হাতে আছে",
 "{a} de {b} feitos": "{b}টির মধ্যে {a}টি সম্পন্ন",
 "{a} de {b} na mala": "{b}টির মধ্যে {a}টি ব্যাগে",
 "{a} de {b} pagos": "{b}টির মধ্যে {a}টি পরিশোধিত",
 "{a} de {b} visitados": "{b}টির মধ্যে {a}টি দেখা হয়েছে",
 "{de} deve {v} a {para}": "{de} {para}-কে {v} দেবেন",
 "{g} de {p}": "{p}-এর মধ্যে {g}",
 "{n} atividades do roteiro por fazer": "ভ্রমণসূচির {n}টি কাজ বাকি",
 "{n} item(ns) enviado(s).": "{n}টি আইটেম পাঠানো হয়েছে।",
 "{n} itens por pôr na mala": "{n}টি জিনিস এখনো ব্যাগে তোলা বাকি",
 "{n} já estava(m) no My Planner.": "{n}টি আগে থেকেই My Planner-এ ছিল।",
 "{n} listas de Viagens iam inteiras para o My Planner e saíram de lá. Agora o envio é item por item, pelo ⋮ de cada item.": "ভ্রমণের {n}টি তালিকা পুরোটাই My Planner-এ যেত এবং সেখান থেকে সরানো হয়েছে। এখন প্রতিটি আইটেমের ⋮ থেকে একে একে পাঠানো হয়।",
 "{n} lugares não visitados": "{n}টি জায়গা দেখা হয়নি",
 "{n} reservas por confirmar": "{n}টি বুকিং নিশ্চিত করা বাকি",
 "{n} sem data (não foi).": "{n}টির তারিখ নেই (পাঠানো হয়নি)।",
 "ARTIGOS E SITES": "প্রবন্ধ ও ওয়েবসাইট",
 "Agora o envio é item por item (pelo ⋮ do item ou selecionando vários). Estas listas iam inteiras e saíram do My Planner ({n} item(ns), nada foi apagado):": "এখন পাঠানো হয় একটি একটি করে (আইটেমের ⋮ থেকে বা কয়েকটি বেছে)। এই তালিকাগুলো পুরোটা পাঠানো হতো এবং My Planner থেকে সরানো হয়েছে ({n}টি আইটেম, কিছুই মোছা হয়নি):",
 "Artigo científico": "বৈজ্ঞানিক প্রবন্ধ",
 "Artigo de site ou blog": "ওয়েবসাইট বা ব্লগ প্রবন্ধ",
 "Artigo ou site": "প্রবন্ধ বা ওয়েবসাইট",
 "Artigos e sites": "প্রবন্ধ ও ওয়েবসাইট",
 "Autor(es)": "লেখক",
 "Cadastrar pela foto ou PDF": "ছবি বা PDF থেকে যোগ করুন",
 "Capítulo de livro": "বইয়ের অধ্যায়",
 "Crie o grupo e mande o link: quem entrar vê os artigos e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "গ্রুপ তৈরি করে লিংক পাঠান: যে যোগ দেবে সে প্রবন্ধগুলো দেখবে ও পড়া অনুসরণ করবে। অ্যাডমিন যোগ, সম্পাদনা ও ছবি দিতে পারেন এবং যারা এই ট্যাবও ব্যবহার করেন তাদের অনুমতি দিতে পারেন। শুধু অ্যাডমিন লোক যোগ বা সরাতে পারেন।",
 "DOI": "DOI",
 "Data ou ano de publicação": "প্রকাশের তারিখ বা বছর",
 "Editar artigo ou site": "প্রবন্ধ বা ওয়েবসাইট সম্পাদনা",
 "Enviar para o My Planner (lembrete de renovação)": "My Planner-এ পাঠান (নবায়নের রিমাইন্ডার)",
 "Envio para o My Planner": "My Planner-এ পাঠানো",
 "Ex.: 2024 ou 12/03/2024": "যেমন: 2024 বা 12/03/2024",
 "Ex.: 45-60": "যেমন: 45-60",
 "Grupo de artigos": "প্রবন্ধ গ্রুপ",
 "Guarde artigos, notícias e páginas da internet com a referência pronta (ABNT e APA). Preencha pelo DOI ou pelo link.": "প্রবন্ধ, খবর ও ওয়েব পেজ প্রস্তুত রেফারেন্সসহ (ABNT ও APA) রাখুন। DOI বা লিংক দিয়ে পূরণ করুন।",
 "Li {a} · Lendo {b} · Parei {c} · Quero ler {d}": "পড়েছি {a} · পড়ছি {b} · থেমেছি {c} · পড়তে চাই {d}",
 "Minhas anotações do artigo": "প্রবন্ধে আমার নোট",
 "Notícia": "খবর",
 "Novo artigo ou site": "নতুন প্রবন্ধ বা ওয়েবসাইট",
 "Os dados vêm da ficha do artigo (Editar).": "তথ্য প্রবন্ধের কার্ড থেকে আসে (সম্পাদনা)।",
 "Páginas (opcional)": "পৃষ্ঠা (ঐচ্ছিক)",
 "Revista, site ou veículo": "জার্নাল, ওয়েবসাইট বা মাধ্যম",
 "artigos e sites lidos no período": "এই সময়ে পড়া প্রবন্ধ ও ওয়েবসাইট",
 "1 confirmado": "১ জন নিশ্চিত",
 "1 convidado que estava em \"Pendente\" passou para \"A convidar\". Ao enviar o convite pelo app, ele passa sozinho para \"Convidado, sem resposta\".": "\"অপেক্ষমাণ\"-এ থাকা ১ জন অতিথি \"আমন্ত্রণ করতে হবে\"-তে গেছেন। অ্যাপ থেকে আমন্ত্রণ পাঠালে তিনি নিজে থেকেই \"আমন্ত্রিত, উত্তর নেই\"-তে যাবেন।",
 "1 extra": "১ জন অতিরিক্ত",
 "1 talvez": "১ জন হয়তো",
 "A convidar": "আমন্ত্রণ করতে হবে",
 "Agendar na igreja": "গির্জায় সময় নির্ধারণ",
 "Agora": "এখন",
 "Agradeci": "ধন্যবাদ দিয়েছি",
 "Agradeci em {d}": "{d} তারিখে ধন্যবাদ দিয়েছি",
 "Agradecidos": "ধন্যবাদ দেওয়া হয়েছে",
 "Alianças": "আংটি",
 "Aluguéis (mesas, cadeiras, louças)": "ভাড়া (টেবিল, চেয়ার, বাসনপত্র)",
 "Avisar a data (save the date)": "তারিখ জানান (save the date)",
 "Bebidas": "পানীয়",
 "Beca e cerimônia": "গাউন ও অনুষ্ঠান",
 "Bolo": "কেক",
 "Brincadeiras": "খেলা",
 "Brincadeiras e amigo secreto": "খেলা ও সিক্রেট সান্তা",
 "Brindes": "উপহার",
 "Buffet": "ক্যাটারিং",
 "Calculado sozinho: valor menos o sinal.": "নিজে থেকে হিসাব: মোট থেকে অগ্রিম বাদ দিয়ে।",
 "Calcular quantidades": "পরিমাণ হিসাব করুন",
 "Categoria do orçamento": "বাজেটের বিভাগ",
 "Celebrante": "অনুষ্ঠান পরিচালক",
 "Cerimônia": "অনুষ্ঠান",
 "Cerveja (adultos)": "বিয়ার (প্রাপ্তবয়স্ক)",
 "Checklist de preparação": "প্রস্তুতির চেকলিস্ট",
 "Coloque a data do evento (edite o evento) para ver até quando fazer cada item.": "প্রতিটি কাজের শেষ সময় দেখতে অনুষ্ঠানের তারিখ দিন (অনুষ্ঠান সম্পাদনা করুন)।",
 "Coloque as pessoas em \"Pessoas do evento\" (edite o evento).": "\"অনুষ্ঠানের লোকজন\"-এ লোক যোগ করুন (অনুষ্ঠান সম্পাদনা করুন)।",
 "Coloque quanto pretende gastar em cada categoria. Use o ⊕ para calcular por convidado. Os fornecedores contratados entram sozinhos na categoria escolhida.": "প্রতিটি বিভাগে কত খরচ করতে চান লিখুন। অতিথিপ্রতি হিসাবের জন্য ⊕ ব্যবহার করুন। চুক্তিবদ্ধ সরবরাহকারীরা বেছে নেওয়া বিভাগে নিজে থেকেই যুক্ত হয়।",
 "Combinado: {v}": "নির্ধারিত: {v}",
 "Comprado": "কেনা হয়েছে",
 "Comprados": "কেনা হয়েছে",
 "Comprar a decoração e as lembrancinhas": "সাজসজ্জা ও স্মারক উপহার কিনুন",
 "Comprar as alianças": "আংটি কিনুন",
 "Comprar as lembrancinhas": "স্মারক উপহার কিনুন",
 "Comprar bebidas e gelo": "পানীয় ও বরফ কিনুন",
 "Comprar comida e bebidas": "খাবার ও পানীয় কিনুন",
 "Comprar o que falta": "যা বাকি আছে কিনুন",
 "Comprar ou alugar a roupa": "পোশাক কিনুন বা ভাড়া নিন",
 "Confirmados com os acompanhantes. Muda sozinho quando alguém confirma ou desconfirma.": "সঙ্গীসহ নিশ্চিত। কেউ নিশ্চিত বা বাতিল করলে নিজে থেকেই বদলায়।",
 "Confirmar a presença dos convidados": "অতিথিদের উপস্থিতি নিশ্চিত করুন",
 "Confirmar os fornecedores": "সরবরাহকারীদের নিশ্চিত করুন",
 "Confirmar os fornecedores e os convidados": "সরবরাহকারী ও অতিথিদের নিশ্চিত করুন",
 "Contratar a comida": "খাবারের ব্যবস্থা ঠিক করুন",
 "Contratar a comida e o bolo": "খাবার ও কেক ঠিক করুন",
 "Contratar a decoração": "সাজসজ্জা ঠিক করুন",
 "Contratar comida e bebidas": "খাবার ও পানীয় ঠিক করুন",
 "Contratar foto e vídeo": "ছবি ও ভিডিও ঠিক করুন",
 "Contratar o buffet": "ক্যাটারিং ঠিক করুন",
 "Convidado, sem resposta": "আমন্ত্রিত, উত্তর নেই",
 "Convidados (por situação, com acompanhantes)": "অতিথি (অবস্থা অনুযায়ী, সঙ্গীসহ)",
 "Convidados que contam no ⊕": "⊕-এ গণনা করা অতিথি",
 "Convites": "আমন্ত্রণপত্র",
 "Cronograma do dia (com responsáveis e situação)": "দিনের সময়সূচি (দায়িত্বপ্রাপ্ত ও অবস্থাসহ)",
 "Data do restante": "বাকি টাকার তারিখ",
 "Data do sinal": "অগ্রিমের তারিখ",
 "Decoração": "সাজসজ্জা",
 "Definir a data e o orçamento": "তারিখ ও বাজেট ঠিক করুন",
 "Definir a lista de convidados": "অতিথি তালিকা ঠিক করুন",
 "Doces": "মিষ্টি",
 "Dá para mudar, tirar e incluir itens depois.": "পরে আইটেম বদলানো, সরানো ও যোগ করা যাবে।",
 "Enviar os convites": "আমন্ত্রণপত্র পাঠান",
 "Equipamentos (projetor, som)": "সরঞ্জাম (প্রজেক্টর, সাউন্ড)",
 "Equipe (garçons, limpeza)": "কর্মী (ওয়েটার, পরিচ্ছন্নতা)",
 "Escolha \"Outro\" para escrever o nome.": "নাম লিখতে \"অন্যান্য\" বেছে নিন।",
 "Escolher a roupa": "পোশাক বেছে নিন",
 "Escolher a roupa dos noivos": "বর-কনের পোশাক বেছে নিন",
 "Escolher os padrinhos": "সাক্ষী/গডপ্যারেন্ট বেছে নিন",
 "Estimativa para {n} convidados. Mude o que quiser antes de levar.": "{n} জন অতিথির জন্য আনুমানিক হিসাব। যোগ করার আগে ইচ্ছামতো বদলান।",
 "Eu faço": "আমি করব",
 "Ex.: 200 un.": "যেমন: ২০০ টি",
 "Ex.: Copos descartáveis": "যেমন: ওয়ান-টাইম কাপ",
 "Ex.: Jogo de panelas": "যেমন: হাঁড়ি-পাতিলের সেট",
 "Ex.: Reservar o local": "যেমন: স্থান বুক করুন",
 "Ex.: em negociação": "যেমন: আলোচনা চলছে",
 "Extras de margem (quem aparece sem avisar)": "অতিরিক্ত মার্জিন (না জানিয়ে যাঁরা আসেন)",
 "Falta 1 dia": "আর ১ দিন বাকি",
 "Falta agradecer": "ধন্যবাদ দেওয়া বাকি",
 "Falta comprar": "কেনা বাকি",
 "Falta pagar": "পরিশোধ বাকি",
 "Fazer a lista de presentes": "উপহারের তালিকা তৈরি করুন",
 "Fazer o curso de batismo": "ব্যাপটিজম কোর্স করুন",
 "Fornecedores (contratado, pago, falta)": "সরবরাহকারী (চুক্তি, পরিশোধিত, বাকি)",
 "Foto e vídeo": "ছবি ও ভিডিও",
 "Fraldas": "ডায়াপার",
 "Frase curta (opcional)": "ছোট বাক্য (ঐচ্ছিক)",
 "Hoje é o dia do evento!": "আজ অনুষ্ঠানের দিন!",
 "Igreja e celebrante": "গির্জা ও অনুষ্ঠান পরিচালক",
 "Incluir os Talvez": "\"হয়তো\" যোগ করুন",
 "Incluir telefones": "ফোন নম্বর যোগ করুন",
 "Item da lista de compras": "কেনাকাটার তালিকার আইটেম",
 "Item da preparação": "প্রস্তুতির আইটেম",
 "Já deram: {d} · Falta: {f}": "দেওয়া হয়েছে: {d} · বাকি: {f}",
 "Já deu": "দিয়েছেন",
 "L": "লি.",
 "Lance aqui o que foi gasto. Os pagamentos aos fornecedores e as compras marcadas entram sozinhos.": "যা খরচ হয়েছে এখানে লিখুন। সরবরাহকারীদের পরিশোধ ও চিহ্নিত কেনাকাটা নিজে থেকেই যুক্ত হয়।",
 "Lançar o gasto": "খরচ লিখুন",
 "Lembrancinhas": "স্মারক উপহার",
 "Levar para os itens": "আইটেমে যোগ করুন",
 "Local / espaço": "স্থান / ভেন্যু",
 "Mais um extra": "আরও একজন অতিরিক্ত",
 "Menos um extra": "একজন অতিরিক্ত কম",
 "Música / som / DJ": "সংগীত / সাউন্ড / ডিজে",
 "No dia do evento": "অনুষ্ঠানের দিন",
 "O que comprar": "কী কিনতে হবে",
 "O total muda sozinho quando alguém confirma ou desconfirma.": "কেউ নিশ্চিত বা বাতিল করলে মোট নিজে থেকেই বদলায়।",
 "O valor do contrato entra sozinho como previsto nesta categoria, e o que for pago entra nos gastos.": "চুক্তির অঙ্ক এই বিভাগে পরিকল্পিত হিসেবে নিজে থেকেই যুক্ত হয়, আর যা পরিশোধ হয় তা খরচে যায়।",
 "O valor entra nos gastos do evento, na categoria do item. Se preferir, pule.": "অঙ্কটি অনুষ্ঠানের খরচে, আইটেমের বিভাগে যাবে। চাইলে বাদ দিন।",
 "Onde comprar": "কোথায় কিনবেন",
 "Orçamento do evento": "অনুষ্ঠানের বাজেট",
 "Os itens marcados entram na categoria com o ⊕ por convidado. Depois é só tocar no ⊕ e pôr o valor unitário.": "চিহ্নিত আইটেমগুলো অতিথিপ্রতি ⊕ সহ বিভাগে যায়। তারপর শুধু ⊕-এ ট্যাপ করে একক মূল্য দিন।",
 "Os telefones dos convidados só saem no PDF se você marcar \"Incluir telefones\". Valores em moedas diferentes aparecem separados.": "\"ফোন নম্বর যোগ করুন\" চিহ্নিত করলেই কেবল অতিথিদের ফোন নম্বর PDF-এ আসবে। ভিন্ন মুদ্রার অঙ্ক আলাদাভাবে দেখানো হয়।",
 "Pago em {d}": "{d} তারিখে পরিশোধিত",
 "Parte da vaquinha": "চাঁদার অংশ",
 "Pessoas do evento": "অনুষ্ঠানের লোকজন",
 "Pessoas do evento: {p}": "অনুষ্ঠানের লোকজন: {p}",
 "Preparar as brincadeiras": "খেলার প্রস্তুতি নিন",
 "Preparação": "প্রস্তুতি",
 "Presente recebido": "উপহার পাওয়া গেছে",
 "Presentes": "উপহার",
 "Prova final da roupa": "পোশাকের চূড়ান্ত ট্রায়াল",
 "Pular": "বাদ দিন",
 "Quantidade por convidado": "অতিথিপ্রতি পরিমাণ",
 "Quantidade por convidado × valor unitário": "অতিথিপ্রতি পরিমাণ × একক মূল্য",
 "Quanto custou?": "কত খরচ হলো?",
 "Quanto já deu": "কত দিয়েছেন",
 "Quanto vai contribuir": "কত দেবেন",
 "Quantos dias antes do evento": "অনুষ্ঠানের কত দিন আগে",
 "Quem deu": "কে দিয়েছেন",
 "Quem está no grupo do evento entra sozinho. Use \"+ Adicionar pessoa\" para quem não tem o app. Esta lista é usada no cronograma, nos gastos e na vaquinha.": "অনুষ্ঠানের গ্রুপে যাঁরা আছেন তাঁরা নিজে থেকেই যুক্ত হন। যাঁদের অ্যাপ নেই তাঁদের জন্য \"+ ব্যক্তি যোগ করুন\" ব্যবহার করুন। এই তালিকা সময়সূচি, খরচ ও চাঁদায় ব্যবহৃত হয়।",
 "Recreação e brinquedos": "বিনোদন ও খেলনা",
 "Refrigerante": "কোমল পানীয়",
 "Relatório do evento": "অনুষ্ঠানের প্রতিবেদন",
 "Relatório do evento (PDF)": "অনুষ্ঠানের প্রতিবেদন (PDF)",
 "Reservar o local": "স্থান বুক করুন",
 "Reservar o local da cerimônia e da festa": "অনুষ্ঠান ও পার্টির স্থান বুক করুন",
 "Reservar o local ou a mesa da festa": "পার্টির স্থান বা টেবিল বুক করুন",
 "Restante": "বাকি টাকা",
 "Restante pago": "বাকি টাকা পরিশোধিত",
 "Resumo do evento": "অনুষ্ঠানের সারসংক্ষেপ",
 "Roupa e beleza": "পোশাক ও সাজসজ্জা",
 "Salgados": "নোনতা খাবার",
 "Separar a roupa e o que levar": "পোশাক ও সঙ্গে নেওয়ার জিনিস গুছিয়ে রাখুন",
 "Separar os documentos e as alianças": "কাগজপত্র ও আংটি গুছিয়ে রাখুন",
 "Separar os documentos e os ingressos": "কাগজপত্র ও টিকিট গুছিয়ে রাখুন",
 "Sinal": "অগ্রিম",
 "Sinal pago": "অগ্রিম পরিশোধিত",
 "Sinal {v} pago": "অগ্রিম {v} পরিশোধিত",
 "Usar a lista pronta para {tipo}": "{tipo}-এর জন্য তৈরি তালিকা ব্যবহার করুন",
 "Vai contribuir": "চাঁদা দেবেন",
 "Valor unitário": "একক মূল্য",
 "Vaquinha": "চাঁদা",
 "Você acompanha tudo o que foi compartilhado, sempre atualizado. Para incluir, editar e pegar tarefas, assine a aba.": "শেয়ার করা সবকিছু আপনি সবসময় হালনাগাদ অবস্থায় দেখতে পারবেন। যোগ, সম্পাদনা ও কাজ নিতে এই ট্যাবে সাবস্ক্রাইব করুন।",
 "agradeci": "ধন্যবাদ দিয়েছি",
 "atrasado": "বিলম্বিত",
 "completo": "সম্পূর্ণ",
 "deu {d} de {v}": "{v}-এর মধ্যে {d} দিয়েছেন",
 "em {l}": "{l}-এ",
 "falta o valor": "অঙ্ক দেওয়া হয়নি",
 "falta {v} até {d}": "{d}-এর মধ্যে {v} বাকি",
 "gasto em {e}": "{e}-এ খরচ",
 "kg": "kg",
 "o evento": "অনুষ্ঠান",
 "restante": "বাকি টাকা",
 "sinal": "অগ্রিম",
 "total": "মোট",
 "un.": "টি",
 "{n} confirmados": "{n} জন নিশ্চিত",
 "{n} convidados contam no ⊕ por convidado.": "{n} জন অতিথি অতিথিপ্রতি ⊕-এ গণনা হন।",
 "{n} convidados que estavam em \"Pendente\" passaram para \"A convidar\". Ao enviar o convite pelo app, eles passam sozinhos para \"Convidado, sem resposta\".": "\"অপেক্ষমাণ\"-এ থাকা {n} জন অতিথি \"আমন্ত্রণ করতে হবে\"-তে গেছেন। অ্যাপ থেকে আমন্ত্রণ পাঠালে তাঁরা নিজে থেকেই \"আমন্ত্রিত, উত্তর নেই\"-তে যাবেন।",
 "{n} extras": "{n} জন অতিরিক্ত",
 "{n} talvez": "{n} জন হয়তো",
 "{q} por convidado": "অতিথিপ্রতি {q}",
 "{v} por convidado": "অতিথিপ্রতি {v}",
 "Item completo": "সম্পূর্ণ আইটেম",
 "Nota rápida": "দ্রুত নোট",
 "📝 Nota rápida": "📝 দ্রুত নোট",
 "Conteúdo da nota": "নোটের বিষয়বস্তু",
 "{c} confirmado(s) de {n} convidado(s)": "{n} জন অতিথির মধ্যে {c} জন নিশ্চিত",
 "Serão apagados para todos: os documentos, as reuniões marcadas e as gravações do escritório \"{nome}\". A conversa continua no Mensagens.": "সবার জন্য মুছে যাবে: অফিস \"{nome}\"-এর নথি, নির্ধারিত মিটিং ও রেকর্ডিং। কথোপকথন বার্তায় থাকবে।",
 "Confirme para apagar o escritório": "অফিস মুছতে নিশ্চিত করুন",
 "Escreva o assunto da reunião para poder marcar.": "মিটিং ঠিক করতে বিষয় লিখুন।",
 "{n} min (marcada para {m} min)": "{n} মিনিট ({m} মিনিটের জন্য নির্ধারিত)",
 "Não foi possível baixar o arquivo agora. Confira a internet e tente de novo.": "এখন ফাইলটি ডাউনলোড করা গেল না। ইন্টারনেট দেখে আবার চেষ্টা করুন।",
 "Meus clientes": "আমার ক্লায়েন্ট",
 "Uma lista só de clientes, usada por todas as abas de trabalho: contato, endereço, etiquetas, anotações e arquivos.": "ক্লায়েন্টদের একটিই তালিকা, যা সব কাজের ট্যাবে ব্যবহার হয়: যোগাযোগ, ঠিকানা, ট্যাগ, নোট ও ফাইল।",
 "Copiar para Meus clientes": "আমার ক্লায়েন্টে কপি করুন",
 "Ver ou mudar": "দেখুন বা বদলান",
 "Ver o documento completo": "পুরো নথি দেখুন",
 "CEP incompleto": "CEP অসম্পূর্ণ",
 "O CEP tem 8 números.": "CEP-এ ৮টি সংখ্যা থাকে।",
 "CEP não encontrado": "CEP পাওয়া যায়নি",
 "Confira os números ou preencha o endereço à mão.": "সংখ্যাগুলো যাচাই করুন বা ঠিকানা নিজে লিখুন।",
 "Não foi possível buscar o CEP": "CEP খোঁজা যায়নি",
 "Confira a internet ou preencha o endereço à mão.": "ইন্টারনেট সংযোগ যাচাই করুন বা ঠিকানা নিজে লিখুন।",
 "Parece que falta algo neste e-mail (ex.: nome@site.com).": "এই ইমেইলে কিছু অনুপস্থিত মনে হচ্ছে (যেমন: name@site.com)।",
 "opcional": "ঐচ্ছিক",
 "Os seus clientes agora ficam numa lista só, usada por todas as abas de trabalho.": "আপনার ক্লায়েন্টরা এখন একটিই তালিকায় আছেন, যা সব কাজের ট্যাবে ব্যবহার হয়।",
 "Portal do Cliente: {n} cliente(s).": "ক্লায়েন্ট পোর্টাল: {n} জন ক্লায়েন্ট।",
 "Freelancer & Projetos: {n} cliente(s).": "ফ্রিল্যান্সার ও প্রজেক্ট: {n} জন ক্লায়েন্ট।",
 "{n} eram o mesmo cliente em mais de uma aba e viraram uma ficha só.": "{n}টি একাধিক ট্যাবে একই ক্লায়েন্ট ছিল এবং এখন একটি রেকর্ডে মিলেছে।",
 "Nenhum cliente repetido.": "কোনো পুনরাবৃত্ত ক্লায়েন্ট নেই।",
 "Nada foi apagado: documentos, pedidos, cartões e horas continuam onde estavam.": "কিছুই মোছা হয়নি: নথি, অর্ডার, কার্ড ও ঘণ্টা আগের জায়গাতেই আছে।",
 "Já está em Meus clientes": "আগে থেকেই আমার ক্লায়েন্টে আছে",
 "{nome} já está na lista.": "{nome} আগে থেকেই তালিকায় আছে।",
 "Copiado para Meus clientes": "আমার ক্লায়েন্টে কপি হয়েছে",
 "Só o nome e o contato foram copiados.": "শুধু নাম ও যোগাযোগ কপি হয়েছে।",
 "Aniversário hoje!": "আজ জন্মদিন!",
 "Fechar tudo": "সব বন্ধ করুন",
 "Abrir tudo": "সব খুলুন",
 "Quem é": "কে",
 "Razão social": "আইনি প্রতিষ্ঠান নাম",
 "Nome fantasia": "ব্যবসায়িক নাম",
 "Data de abertura": "প্রতিষ্ঠার তারিখ",
 "Inscrição estadual / municipal": "রাজ্য / পৌর নিবন্ধন",
 "Outras pessoas de contato": "অন্যান্য যোগাযোগ ব্যক্তি",
 "Como chamar": "কী নামে ডাকবেন",
 "Cliente desde": "ক্লায়েন্ট যেদিন থেকে",
 "Outro telefone": "অন্য ফোন",
 "Site": "ওয়েবসাইট",
 "Melhor jeito de falar": "যোগাযোগের সেরা উপায়",
 "Autorizou receber mensagens": "বার্তা পেতে সম্মতি দিয়েছেন",
 "Outros endereços": "অন্যান্য ঠিকানা",
 "Relacionamento": "সম্পর্ক",
 "Como me conheceu": "কীভাবে আমাকে চিনলেন",
 "Etiquetas": "ট্যাগ",
 "Nada anotado ainda.": "এখনও কোনো নোট নেই।",
 "Bloco da aba {aba}": "{aba} ট্যাবের অংশ",
 "Abrir na aba {aba}": "{aba} ট্যাবে খুলুন",
 "Uma lista só, usada por todas as abas de trabalho.": "একটিই তালিকা, যা সব কাজের ট্যাবে ব্যবহার হয়।",
 "Escreva o nome do cliente.": "ক্লায়েন্টের নাম লিখুন।",
 "Telefone / WhatsApp": "ফোন / WhatsApp",
 "Só o nome é obrigatório. Abra as partes que quiser preencher.": "শুধু নাম আবশ্যক। যে অংশগুলো পূরণ করতে চান সেগুলো খুলুন।",
 "Como chamar (apelido)": "কী নামে ডাকবেন (ডাকনাম)",
 "Inscrição estadual / municipal (opcional)": "রাজ্য / পৌর নিবন্ধন (ঐচ্ছিক)",
 "Cargo": "পদ",
 "Telefone da pessoa de contato": "যোগাযোগ ব্যক্তির ফোন",
 "Outras pessoas de contato (uma por linha: nome, cargo, telefone)": "অন্যান্য যোগাযোগ ব্যক্তি (প্রতি লাইনে একজন: নাম, পদ, ফোন)",
 "O telefone principal é WhatsApp": "প্রধান ফোনে WhatsApp আছে",
 "O outro telefone é WhatsApp": "অন্য ফোনে WhatsApp আছে",
 "Instagram": "Instagram",
 "Ex.: @nome": "যেমন: @name",
 "Ex.: WhatsApp, à tarde": "যেমন: WhatsApp, বিকেলে",
 "Estado (UF)": "রাজ্য (UF)",
 "Endereço (como estava escrito)": "ঠিকানা (যেমন লেখা ছিল)",
 "Outros endereços (trabalho, entrega...)": "অন্যান্য ঠিকানা (কাজ, ডেলিভারি...)",
 "Google": "Google",
 "Passou na frente": "দোকানের সামনে দিয়ে যাচ্ছিলেন",
 "Indicado por": "কে সুপারিশ করেছেন",
 "Criar etiqueta": "ট্যাগ তৈরি করুন",
 "Ex.: VIP, Mensal, Atacado": "যেমন: VIP, মাসিক, পাইকারি",
 "Ativo": "সক্রিয়",
 "Inativo": "নিষ্ক্রিয়",
 "Em negociação": "আলোচনা চলছে",
 "O cliente autorizou receber mensagens?": "ক্লায়েন্ট কি বার্তা পেতে সম্মতি দিয়েছেন?",
 "Sem autorização, nada de mensagem de aniversário, cobrança automática ou promoção para este cliente.": "সম্মতি ছাড়া এই ক্লায়েন্টকে জন্মদিনের বার্তা, স্বয়ংক্রিয় পেমেন্ট রিমাইন্ডার বা প্রচার পাঠানো হবে না।",
 "aniversário hoje": "আজ জন্মদিন",
 "contato: {n}": "যোগাযোগ: {n}",
 "com esse telefone": "এই ফোন নম্বরে",
 "com esse e-mail": "এই ইমেইলে",
 "com esse documento": "এই নথি নম্বরে",
 "com esse nome": "এই নামে",
 "Cliente parecido": "একই রকম ক্লায়েন্ট",
 "Já existe {nome} {por}. Abrir?": "{nome} আগে থেকেই আছে ({por})। খুলবেন?",
 "Cadastrar mesmo assim": "তবুও যোগ করুন",
 "Serão apagados: a ficha, as anotações e os arquivos deste cliente.": "এই ক্লায়েন্টের রেকর্ড, নোট ও ফাইল মুছে যাবে।",
 "Também nas abas: {abas} (com os documentos, pedidos, cartões e horas de lá).": "এই ট্যাবগুলোতেও: {abas} (সেখানকার নথি, অর্ডার, কার্ড ও ঘণ্টা সহ)।",
 "Juntar com outra ficha": "অন্য রেকর্ডের সাথে মেলান",
 "Juntar fichas": "রেকর্ড মেলান",
 "Não há outra ficha para juntar.": "মেলানোর মতো অন্য কোনো রেকর্ড নেই।",
 "Juntar \"{nome}\" com:": "\"{nome}\" এর সাথে মেলান:",
 "Juntar as duas fichas?": "দুটি রেকর্ড মেলাবেন?",
 "\"{a}\" fica com tudo de \"{b}\" (dados, anotações, arquivos e as ligações com as abas). A ficha \"{b}\" deixa de existir.": "\"{a}\" পাবে \"{b}\"-এর সবকিছু (তথ্য, নোট, ফাইল ও ট্যাবের সংযোগ)। \"{b}\" রেকর্ডটি আর থাকবে না।",
 "Juntar": "মেলান",
 "Confirme para juntar as fichas": "রেকর্ড মেলাতে নিশ্চিত করুন",
 "Aniversariantes do mês": "এ মাসের জন্মদিন",
 "Ativos": "সক্রিয়",
 "Inativos": "নিষ্ক্রিয়",
 "Cadastre cada cliente uma vez: ele aparece em todas as abas de trabalho que você usa.": "প্রতিটি ক্লায়েন্ট একবার যোগ করুন: আপনি যে সব কাজের ট্যাব ব্যবহার করেন সেখানে দেখা যাবে।",
 "Novo cliente": "নতুন ক্লায়েন্ট",
 "Editar cliente": "ক্লায়েন্ট সম্পাদনা করুন",
 "Linha do tempo": "টাইমলাইন",
 "{n} registro(s)": "{n}টি রেকর্ড",
 "Nada ainda. Vendas, pagamentos, documentos e horas aparecem aqui.": "এখনও কিছু নেই। বিক্রি, পেমেন্ট, নথি ও ঘণ্টা এখানে দেখা যাবে।",
 "Me deve": "আমার পাওনা",
 "Total pago": "মোট পরিশোধ",
 "Última compra ou atendimento": "সর্বশেষ কেনাকাটা বা সেবা",
 "Próximo compromisso": "পরবর্তী অ্যাপয়েন্টমেন্ট",
 "na entrega": "ডেলিভারির সময়",
 "Passou do limite de fiado ({v}).": "বাকির সীমা ({v}) ছাড়িয়ে গেছে।",
 "Recebeu {v} ({p})": "{v} পেয়েছেন ({p})",
 "Hoje é aniversário de {n}.": "আজ {n}-এর জন্মদিন।",
 "Mandar parabéns": "শুভেচ্ছা পাঠান",
 "{n}: parcela de {v} atrasada.": "{n}: {v}-এর কিস্তি বকেয়া।",
 "Cobrar": "টাকা চান",
 "{n} não compra há {d} dias.": "{n} {d} দিন ধরে কিছু কেনেননি।",
 "Chamar de volta": "আবার যোগাযোগ করুন",
 "🟢 em dia · 🟡 sumido": "🟢 নিয়মিত · 🟡 অনেকদিন আসেননি",
 "🟢 em dia · 🟡 algo vencendo ou cliente sumido · 🔴 atrasado": "🟢 নিয়মিত · 🟡 কিছু দেয় হচ্ছে বা ক্লায়েন্ট অনুপস্থিত · 🔴 বকেয়া",
 "Limite de fiado (opcional)": "বাকির সীমা (ঐচ্ছিক)",
 "Avisa quando o que ele deve passar deste valor.": "বাকি এই পরিমাণ ছাড়ালে জানাবে।",
 "A prazo": "কিস্তিতে",
 "parcela atrasada": "বকেয়া কিস্তি",
 "falta na entrega": "ডেলিভারিতে বাকি",
 "Sumidos": "অনেকদিন আসেননি",
 "Sinal pago, falta o resto": "অগ্রিম দেওয়া, বাকি আছে",
 "Pagou {a} de {b}": "{b}-এর মধ্যে {a} পরিশোধ",
 "Esta parcela vem de Meus clientes. Marque aqui como recebida ou abra o cliente para cobrar e gerar o recibo.": "এই কিস্তিটি আমার ক্লায়েন্ট থেকে এসেছে। এখানে প্রাপ্ত হিসেবে চিহ্নিত করুন অথবা টাকা চাইতে ও রসিদ তৈরি করতে ক্লায়েন্ট খুলুন।",
 "Sinal + restante": "অগ্রিম + বাকি",
 "Pix": "Pix",
 "Cartão de crédito à vista": "ক্রেডিট কার্ড, এককালীন",
 "Cartão de crédito parcelado": "ক্রেডিট কার্ড, কিস্তিতে",
 "Fiado / a prazo": "বাকি / কিস্তিতে",
 "Parcela única": "একক কিস্তি",
 "Oi, {nome}! Feliz aniversário! 🎉 Que o seu dia seja lindo. Um abraço!": "হ্যালো {nome}! শুভ জন্মদিন! 🎉 আপনার দিনটি সুন্দর কাটুক। অনেক শুভেচ্ছা!",
 "Oi, {nome}! Faz tempo que a gente não se fala. Posso ajudar em alguma coisa? Vai ser um prazer te atender de novo!": "হ্যালো {nome}! অনেকদিন কথা হয়নি। কোনো কিছুতে সাহায্য করতে পারি? আবার আপনার সেবা করতে পারলে খুশি হব!",
 "Oi, {nome}! Passando para lembrar da parcela de {v} que venceu dia {d}. Qualquer coisa, me chama. Obrigada!": "হ্যালো {nome}! শুধু মনে করিয়ে দিচ্ছি, {v}-এর কিস্তিটি {d} তারিখে দেয় ছিল। কিছু দরকার হলে জানাবেন। ধন্যবাদ!",
 "Oi, {nome}! Passando para lembrar da parcela de {v}{d}. Qualquer coisa, me chama. Obrigada!": "হ্যালো {nome}! শুধু মনে করিয়ে দিচ্ছি: {v}-এর কিস্তি{d}। কিছু দরকার হলে জানাবেন। ধন্যবাদ!",
 "que vence dia {d}": "{d} তারিখে দেয়",
 "Quanto recebeu?": "কত পেয়েছেন?",
 "Falta {v}. Pode ser só uma parte.": "{v} বাকি। শুধু কিছু অংশও হতে পারে।",
 "(seu nome ou sua marca, em Como você recebe?)": "(আপনার নাম বা ব্র্যান্ড, \"কীভাবে টাকা পান?\" অংশে)",
 "Recibo {c}": "রসিদ {c}",
 "Recebi de {c} a quantia de {v}, referente a {o}.": "আমি {c}-এর কাছ থেকে {o} বাবদ {v} গ্রহণ করেছি।",
 "{v} no {f} → recebe {l}": "{f}-এ {v} → আপনি পাবেন {l}",
 "Pagou {a} de {b}, faltam {c}": "{b}-এর মধ্যে {a} পরিশোধ, {c} বাকি",
 "Recebido em {d}": "{d} তারিখে প্রাপ্ত",
 "Cobrar pelo WhatsApp": "WhatsApp-এ টাকা চান",
 "Sem autorização": "অনুমতি নেই",
 "Este cliente não autorizou receber mensagens (ficha do cliente › Relacionamento).": "এই ক্লায়েন্ট বার্তা পাওয়ার অনুমতি দেননি (ক্লায়েন্ট প্রোফাইল › সম্পর্ক)।",
 "Sem telefone": "ফোন নম্বর নেই",
 "Coloque o telefone na ficha do cliente.": "ক্লায়েন্ট প্রোফাইলে ফোন নম্বর যোগ করুন।",
 "Gerar recibo": "রসিদ তৈরি করুন",
 "Como você recebe?": "কীভাবে টাকা পান?",
 "Só \"À vista\": a tela fica limpa, sem a prazo, parcelas nem vermelho.": "শুধু \"এককালীন\": পরিষ্কার স্ক্রিন, কিস্তি বা লাল রং ছাড়া।",
 "Taxa da maquininha (%)": "কার্ড মেশিনের ফি (%)",
 "Taxa {k}": "{k} ফি",
 "Cliente sumido depois de (dias sem comprar)": "ক্লায়েন্টকে অনুপস্থিত ধরা হবে (না কেনার দিন)",
 "Dias para considerar sumido": "অনুপস্থিত ধরার দিন",
 "Lembretes de cobrança por parcela atrasada": "বকেয়া কিস্তির জন্য পেমেন্ট রিমাইন্ডার",
 "Nome ou marca no recibo": "রসিদে নাম বা ব্র্যান্ড",
 "Ex.: Ana Beatriz Doces": "যেমন: Ana Beatriz মিষ্টি",
 "Venda ou serviço": "বিক্রি বা সেবা",
 "O que foi vendido ou feito": "কী বিক্রি বা করা হয়েছে",
 "Ex.: Bolo de aniversário": "যেমন: জন্মদিনের কেক",
 "Como paga": "কীভাবে পরিশোধ",
 "Sinal (%)": "অগ্রিম (%)",
 "Ou escreva o valor do sinal logo abaixo.": "অথবা ঠিক নিচে অগ্রিমের পরিমাণ লিখুন।",
 "Sinal (valor)": "অগ্রিম (পরিমাণ)",
 "Restante na entrega": "বাকি ডেলিভারিতে",
 "Próximo vencimento": "পরবর্তী দেয় তারিখ",
 "Sinal a receber": "প্রাপ্য অগ্রিম",
 "falta {v}{q}": "{v} বাকি{q}",
 "quitado": "পরিশোধিত",
 "Parcelas mantidas": "কিস্তি অপরিবর্তিত",
 "Já há pagamento registrado: as parcelas não foram refeitas. Para mudar, desfaça os pagamentos primeiro.": "ইতিমধ্যে পেমেন্ট রেকর্ড করা আছে: কিস্তিগুলো নতুন করে তৈরি হয়নি। পরিবর্তন করতে আগে পেমেন্টগুলো বাতিল করুন।",
 "Registre o que o cliente comprou ou o serviço que você fez, e como ele paga.": "ক্লায়েন্ট কী কিনেছেন বা আপনি কী সেবা দিয়েছেন, এবং তিনি কীভাবে পরিশোধ করেন তা লিখুন।",
 "Débito": "ডেবিট",
 "Crédito à vista": "ক্রেডিট, এককালীন",
 "Crédito 2x": "ক্রেডিট, 2 কিস্তি",
 "Crédito 3x": "ক্রেডিট, 3 কিস্তি",
 "Crédito 4x": "ক্রেডিট, 4 কিস্তি",
 "Crédito 5x": "ক্রেডিট, 5 কিস্তি",
 "Crédito 6x": "ক্রেডিট, 6 কিস্তি",
 "Crédito 7x": "ক্রেডিট, 7 কিস্তি",
 "Crédito 8x": "ক্রেডিট, 8 কিস্তি",
 "Crédito 9x": "ক্রেডিট, 9 কিস্তি",
 "Crédito 10x": "ক্রেডিট, 10 কিস্তি",
 "Crédito 11x": "ক্রেডিট, 11 কিস্তি",
 "Crédito 12x": "ক্রেডিট, 12 কিস্তি",
 "ATRASADOS": "বকেয়া",
 "Atrasado (hoje): {v}": "বকেয়া (আজ পর্যন্ত): {v}",
 "Buscar um cliente": "ক্লায়েন্ট খুঁজুন",
 "CPF/CNPJ completo, endereço completo e data de nascimento. Pede a senha do app.": "পূর্ণ CPF/CNPJ, পূর্ণ ঠিকানা ও জন্মতারিখ। অ্যাপের পাসওয়ার্ড চাওয়া হবে।",
 "Cliente cadastrado": "ক্লায়েন্ট যোগ হয়েছে",
 "Com documentos: guarde o arquivo em lugar seguro.": "নথিসহ: ফাইলটি নিরাপদ জায়গায় রাখুন।",
 "Como pagou": "কীভাবে পরিশোধ করেছেন",
 "Esse contato não tem nome.": "এই পরিচিতির কোনো নাম নেই।",
 "Exportar planilha": "স্প্রেডশিট এক্সপোর্ট করুন",
 "Falta receber": "এখনও পাওনা",
 "Falta receber (hoje): {v}": "এখনও পাওনা (আজ পর্যন্ত): {v}",
 "Importar dos contatos": "পরিচিতি থেকে ইমপোর্ট করুন",
 "Importar dos contatos do celular": "ফোনের পরিচিতি থেকে ইমপোর্ট করুন",
 "Incluir documentos": "নথি অন্তর্ভুক্ত করুন",
 "Incluir documentos no relatório": "রিপোর্টে নথি অন্তর্ভুক্ত করুন",
 "MELHORES CLIENTES": "সেরা ক্লায়েন্ট",
 "Melhores clientes": "সেরা ক্লায়েন্ট",
 "Não foi possível gerar a planilha.": "স্প্রেডশিট তৈরি করা যায়নি।",
 "O que foi": "কী ছিল",
 "Pago em": "পরিশোধের তারিখ",
 "Para trazer clientes dos contatos do celular, atualize o My Planner pela loja de aplicativos.": "ফোনের পরিচিতি থেকে ক্লায়েন্ট আনতে অ্যাপ স্টোর থেকে My Planner আপডেট করুন।",
 "RECEBIDO POR DIA": "দিনপ্রতি প্রাপ্ত",
 "RECEBIDO POR MÊS": "মাসপ্রতি প্রাপ্ত",
 "Recebeu": "প্রাপ্ত",
 "Recebeu no período": "সময়কালে প্রাপ্ত",
 "Recebeu no período: {v}": "সময়কালে প্রাপ্ত: {v}",
 "Recebido no período": "সময়কালে প্রাপ্ত",
 "Relatório de clientes": "ক্লায়েন্ট রিপোর্ট",
 "Relatório deste cliente": "এই ক্লায়েন্টের রিপোর্ট",
 "Sem a permissão de contatos não dá para escolher um contato. Você pode liberar nos ajustes do celular.": "পরিচিতির অনুমতি ছাড়া কোনো পরিচিতি বেছে নেওয়া যায় না। ফোনের সেটিংসে এটি চালু করতে পারেন।",
 "Sem documentos: o CPF/CNPJ sai só com os 2 últimos números. As anotações nunca saem.": "নথি ছাড়া: CPF/CNPJ-এর শুধু শেষ ২টি সংখ্যা দেখাবে। নোট কখনও অন্তর্ভুক্ত হয় না।",
 "Todos os clientes": "সব ক্লায়েন্ট",
 "Trabalha em: {e}": "কর্মস্থল: {e}",
 "Trazer outro": "আরেকটি আনুন",
 "VENDAS E ATENDIMENTOS": "বিক্রি ও সেবা",
 "Vence": "নির্ধারিত তারিখ",
 "Venceu": "তারিখ পেরিয়েছে",
 "Vendas e atendimentos": "বিক্রি ও সেবা",
 "Vendeu": "বিক্রি",
 "Vendeu no período": "সময়কালে বিক্রি",
 "Vendeu no período: {v}": "সময়কালে বিক্রি: {v}",
 "venceu {d}": "{d} তারিখে দেয় ছিল",
 "vendido no período": "সময়কালে বিক্রি",
 "{nome} comprou no período": "{nome} সময়কালে কিনেছেন",
 "{nome} entrou em Meus clientes. Confira a ficha e marque se ele autorizou receber mensagens.": "{nome} আমার ক্লায়েন্ট-এ যোগ হয়েছেন। তথ্য দেখে নিন এবং বার্তা পাওয়ার অনুমতি দিয়েছেন কি না চিহ্নিত করুন।",
 "{n} compra(s)": "{n}টি কেনাকাটা",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir. Segure numa parte livre da caixa e arraste para mudar a ordem.": "আর্কাইভ করতে বাক্স বাঁয়ে আর মুছতে ডানে সোয়াইপ করুন। ক্রম বদলাতে বাক্সের ফাঁকা অংশ চেপে ধরে টানুন।",
 "Bloco": "ব্লক",
 "Confirme para apagar o grupo": "গ্রুপ মুছতে নিশ্চিত করুন",
 "Descer": "নিচে নামান",
 "Opções do bloco": "ব্লকের বিকল্প",
 "Exigências do destino": "গন্তব্যের প্রয়োজনীয়তা",
 "{n} para acertar": "{n}টি মেটানো বাকি",
 "{n} parada(s)": "{n}টি যাত্রাবিরতি",
 "Cor do item selecionado": "নির্বাচিত আইটেমের রং",
 "Abrir o grupo": "গ্রুপ খুলুন",
 "Recolher o grupo": "গ্রুপ গুটিয়ে নিন",
 "Arraste uma caixa para a direita para excluir ou para a esquerda para arquivar. Segure e arraste para mudar a ordem.": "মুছতে বাক্স ডানে আর আর্কাইভ করতে বাঁয়ে সোয়াইপ করুন। ক্রম বদলাতে চেপে ধরে টানুন।",
 "Editar subtítulo": "উপশিরোনাম সম্পাদনা",
 "Início da caixa": "বাক্সের শুরু",
 "Mover para…": "এখানে সরান…",
 "Mover {n} item(ns) para": "{n}টি আইটেম সরান",
 "Opções do item": "আইটেমের বিকল্প",
 "Transformar em subtítulo": "উপশিরোনামে রূপান্তর",
 "Transformar em texto": "টেক্সটে রূপান্তর",
 "esta caixa": "এই বাক্স",
 "{a} de {n} feitos": "{n}টির মধ্যে {a}টি সম্পন্ন",
 "1 documento pedido atrasado": "১টি চাওয়া ডকুমেন্ট দেরিতে",
 "1 pedido vence logo": "১টি অনুরোধের সময় শেষ হচ্ছে",
 "A lista vem de \"Meus clientes\".": "তালিকাটি \"আমার ক্লায়েন্ট\" থেকে আসে।",
 "Abrir Meus clientes": "আমার ক্লায়েন্ট খুলুন",
 "As abas Escritório e Portal do Cliente agora são uma aba só.": "অফিস ও ক্লায়েন্ট পোর্টাল ট্যাব এখন একটিই ট্যাব।",
 "Clientes com pendência": "বাকি কাজ আছে এমন ক্লায়েন্ট",
 "Com pendência ({n})": "বাকি ({n})",
 "Conversa da equipe": "টিম চ্যাট",
 "Crie o escritório e chame a equipe (amigos do app ou convite pelo link): conversa, reuniões de vídeo e documentos internos. Trabalha sozinho? Use só os Clientes.": "অফিস তৈরি করুন এবং টিমকে ডাকুন (অ্যাপের বন্ধু বা লিংকে আমন্ত্রণ): চ্যাট, ভিডিও মিটিং ও অভ্যন্তরীণ ডকুমেন্ট। একা কাজ করেন? শুধু ক্লায়েন্ট ব্যবহার করুন।",
 "Documentos internos": "অভ্যন্তরীণ ডকুমেন্ট",
 "Entrar com um código de convite": "আমন্ত্রণ কোড দিয়ে যোগ দিন",
 "Escritório & Clientes": "অফিস ও ক্লায়েন্ট",
 "Escritórios: {n}": "অফিস: {n}",
 "Esta parte é para quem trabalha com equipe": "এই অংশটি যারা টিমের সাথে কাজ করেন তাদের জন্য",
 "Guias vencendo": "মেয়াদ শেষ হওয়া ট্যাক্স স্লিপ",
 "Minhas tarefas": "আমার কাজ",
 "Nada foi apagado: a equipe, a conversa, as reuniões, os documentos e os clientes convidados continuam como estavam.": "কিছুই মোছা হয়নি: টিম, চ্যাট, মিটিং, ডকুমেন্ট ও আমন্ত্রিত ক্লায়েন্ট আগের মতোই আছে।",
 "Nenhum cliente ainda. Cadastre em \"Meus clientes\": ele aparece aqui na hora.": "এখনও কোনো ক্লায়েন্ট নেই। \"আমার ক্লায়েন্ট\"-এ যোগ করুন: সাথে সাথে এখানে দেখাবে।",
 "Para quem trabalha com clientes, sozinho ou com equipe: a pasta de cada cliente (documentos, pedidos, guias), equipe, conversa, reuniões e documentos internos.": "যারা ক্লায়েন্টের সাথে কাজ করেন, একা বা টিমে: প্রতিটি ক্লায়েন্টের ফোল্ডার (ডকুমেন্ট, অনুরোধ, ট্যাক্স স্লিপ), টিম, চ্যাট, মিটিং ও অভ্যন্তরীণ ডকুমেন্ট।",
 "Pastas de clientes do Portal: {c} (com {d} documentos e {p} pedidos)": "পোর্টালের ক্লায়েন্ট ফোল্ডার: {c} ({d}টি ডকুমেন্ট ও {p}টি অনুরোধ)",
 "Pessoa física": "ব্যক্তি",
 "Procurar por nome, CNPJ ou CPF": "নাম, CNPJ বা CPF দিয়ে খুঁজুন",
 "Reuniões hoje": "আজকের মিটিং",
 "Sem escritório (equipe). Toque para criar ou entrar com um código.": "কোনো অফিস (টিম) নেই। তৈরি করতে বা কোড দিয়ে যোগ দিতে ট্যাপ করুন।",
 "Só a equipe vê. Clientes nunca veem esta parte.": "শুধু টিম দেখতে পায়। ক্লায়েন্টরা এই অংশ কখনও দেখে না।",
 "Tudo em dia": "সব ঠিকঠাক",
 "Vencendo ({n})": "শিগগির দেয় ({n})",
 "chega na próxima versão": "পরের সংস্করণে আসছে",
 "nos próximos 7 dias": "আগামী ৭ দিনে",
 "vence amanhã": "আগামীকাল শেষ",
 "vence hoje": "আজ শেষ",
 "{doc} venceu em {d}": "{doc}-এর মেয়াদ {d}-এ শেষ হয়েছে",
 "{n} documentos pedidos atrasados": "{n}টি চাওয়া ডকুমেন্ট দেরিতে",
 "{n} pedidos vencem logo": "{n}টি অনুরোধের সময় শেষ হচ্ছে",
 "🟢 em dia · 🟡 algo vence logo · 🔴 pedido atrasado ou guia vencida": "🟢 ঠিকঠাক · 🟡 শিগগির কিছু দেয় · 🔴 অনুরোধ দেরিতে বা ট্যাক্স স্লিপের মেয়াদ শেষ",
 "Acesso ao gov.br": "gov.br অ্যাক্সেস",
 "Alvará": "ব্যবসায়িক লাইসেন্স",
 "Até o dia (do mês)": "তারিখ পর্যন্ত (মাসের)",
 "CCMEI (certificado do MEI)": "CCMEI (MEI সনদ)",
 "Cadastre o telefone do cliente para lembrar pelo WhatsApp.": "WhatsApp-এ মনে করাতে ক্লায়েন্টের ফোন নম্বর যোগ করুন।",
 "Cartão CNPJ": "CNPJ কার্ড",
 "Checklist criado": "চেকলিস্ট তৈরি হয়েছে",
 "Checklist de cliente novo": "নতুন ক্লায়েন্টের চেকলিস্ট",
 "Cliente viu {doc}": "ক্লায়েন্ট {doc} দেখেছেন",
 "Cole no app do banco, em Pix copia e cola.": "ব্যাংক অ্যাপে Pix কপি-পেস্টে পেস্ট করুন।",
 "Cole no app do banco.": "ব্যাংক অ্যাপে পেস্ট করুন।",
 "Comprovante de endereço": "ঠিকানার প্রমাণ",
 "Contrato social e alterações": "অংশীদারি চুক্তি ও সংশোধনী",
 "Copiado": "কপি হয়েছে",
 "Copiar Pix": "Pix কপি করুন",
 "Copiar código de barras": "বারকোড কপি করুন",
 "Código de barras (linha digitável)": "বারকোড (সংখ্যার লাইন)",
 "Dados bancários": "ব্যাংকের তথ্য",
 "Escreva o recado.": "বার্তা লিখুন।",
 "Escritório enviou {doc}": "অফিস {doc} পাঠিয়েছে",
 "Este cliente não autorizou receber mensagens (ficha em Meus clientes).": "এই ক্লায়েন্ট বার্তা পাওয়ার অনুমতি দেননি (আমার ক্লায়েন্ট-এ প্রোফাইল দেখুন)।",
 "Extratos bancários": "ব্যাংক স্টেটমেন্ট",
 "Ficha completa": "সম্পূর্ণ প্রোফাইল",
 "Guia": "কর পরিশোধের স্লিপ",
 "Guias a pagar": "বাকি কর স্লিপ",
 "Honorário": "ফি",
 "Honorário por": "ফি প্রতি",
 "Informes de rendimentos": "আয়ের বিবরণী",
 "Lembrar pelo WhatsApp": "WhatsApp-এ মনে করান",
 "Ler a guia ou o boleto com a minha IA": "কর স্লিপ বা বোলেতো আমার AI দিয়ে পড়ুন",
 "Lucro presumido": "অনুমিত মুনাফা",
 "Lucro real": "প্রকৃত মুনাফা",
 "Nada ainda.": "এখনও কিছু নেই।",
 "Nenhum pedido em aberto.": "কোনো খোলা অনুরোধ নেই।",
 "Notas fiscais emitidas": "ইস্যু করা ইনভয়েস",
 "O cliente": "ক্লায়েন্ট",
 "O pedido entrou em Pedidos de documentos.": "অনুরোধটি নথির অনুরোধে যোগ হয়েছে।",
 "Oi, {nome}! Falta: {itens}. Pode mandar por aqui?": "হ্যালো {nome}! এটি বাকি আছে: {itens}। এখানে পাঠাতে পারবেন?",
 "Oi, {nome}! Faltam: {itens}. Pode mandar por aqui?": "হ্যালো {nome}! এগুলো বাকি আছে: {itens}। এখানে পাঠাতে পারবেন?",
 "Oi, {nome}! Tudo certo por aí?": "হ্যালো {nome}! সব ঠিক আছে তো?",
 "Pedido criado": "অনুরোধ তৈরি হয়েছে",
 "Pedido feito: {o}": "অনুরোধ পাঠানো হয়েছে: {o}",
 "Pedido recebido: {o}": "অনুরোধ পাওয়া গেছে: {o}",
 "Pedidos pendentes": "বাকি অনুরোধ",
 "Pedir de novo todo mês": "প্রতি মাসে আবার চান",
 "Pedir nova ({c})": "নতুন চান ({c})",
 "Pendentes": "বাকি",
 "Que tipo de cliente?": "কোন ধরনের ক্লায়েন্ট?",
 "RG e CPF": "RG ও CPF",
 "RG e CPF do titular": "মালিকের RG ও CPF",
 "RG e CPF dos sócios": "অংশীদারদের RG ও CPF",
 "Recados": "বার্তা",
 "Recados entre você e o cliente, presos à pasta dele.": "আপনার ও ক্লায়েন্টের মধ্যে বার্তা, তাঁর ফোল্ডারে রাখা থাকে।",
 "Responde ao pedido": "অনুরোধের উত্তর",
 "Tipo / regime": "ধরন / কর ব্যবস্থা",
 "Visto pelo cliente em {d}": "ক্লায়েন্ট {d} তারিখে দেখেছেন",
 "Válido até": "মেয়াদ পর্যন্ত",
 "ano": "বছর",
 "código Pix copia e cola, se houver": "Pix কপি-পেস্ট কোড, যদি থাকে",
 "data de vencimento": "পরিশোধের শেষ তারিখ",
 "documento": "নথি",
 "linha digitável do boleto ou da guia, só números": "বোলেতো বা কর স্লিপের সংখ্যার লাইন, শুধু সংখ্যা",
 "mês": "মাস",
 "novo": "নতুন",
 "todo mês, até o dia {n}": "প্রতি মাসে, {n} তারিখের মধ্যে",
 "valor a pagar": "পরিশোধযোগ্য অর্থ",
 "válido até {d}": "{d} পর্যন্ত বৈধ",
 "{c} nova": "নতুন {c}",
 "{doc} pago": "{doc} পরিশোধিত",
 "{n} a pagar": "{n}টি পরিশোধ বাকি",
 "{n} enviou {doc}": "{n} {doc} পাঠিয়েছেন",
 "{n} novo(s)": "{n}টি নতুন",
 "{n} pedido(s) de documentos criados, com prazo de 7 dias.": "{n}টি নথির অনুরোধ তৈরি হয়েছে, সময়সীমা ৭ দিন।",
 "{n} vencida(s)": "{n}টি মেয়াদোত্তীর্ণ",
 "Última declaração do Imposto de Renda": "সর্বশেষ আয়কর রিটার্ন",
 "Últimas guias pagas": "সর্বশেষ পরিশোধিত কর স্লিপ",
 "Esta parte do Escritório ainda não foi ligada no servidor. No computador, rode o 56-SERVIDOR-0.96.bat (uma vez só).": "অফিসের এই অংশটি এখনও সার্ভারের সাথে যুক্ত হয়নি। কম্পিউটারে 56-SERVIDOR-0.96.bat চালান (শুধু একবার)।",
 "Só vê": "শুধু দেখে",
 "Nova versão": "নতুন সংস্করণ",
 "Já havia um arquivo com este nome: o anterior fica guardado como versão {n}.": "এই নামের একটি ফাইল আগে থেকেই ছিল: আগেরটি সংস্করণ {n} হিসেবে রাখা হয়েছে।",
 "Visto por e comentários": "যারা দেখেছেন ও মন্তব্য",
 "Arquivar (só neste aparelho)": "আর্কাইভ (শুধু এই ডিভাইসে)",
 "Tirar do topo": "উপর থেকে সরান",
 "Fixar no topo (para todos)": "উপরে পিন করুন (সবার জন্য)",
 "Mover para a pasta…": "ফোল্ডারে সরান…",
 "versão {n}": "সংস্করণ {n}",
 "visto por {n}": "{n} জন দেখেছেন",
 "Até 50 MB por arquivo. Enviar um arquivo com o mesmo nome guarda o anterior como versão.": "প্রতি ফাইলে ৫০ MB পর্যন্ত। একই নামের ফাইল পাঠালে আগেরটি একটি সংস্করণ হিসেবে রাখা হয়।",
 "Procurar documento ou pasta": "নথি বা ফোল্ডার খুঁজুন",
 "Fixados": "পিন করা",
 "Abrir o documento": "নথি খুলুন",
 "enviado por {nome}": "{nome} পাঠিয়েছেন",
 "Versões ({n})": "সংস্করণ ({n})",
 "Versão {n} (atual)": "সংস্করণ {n} (বর্তমান)",
 "Versão {n}": "সংস্করণ {n}",
 "Visto por ({n})": "যারা দেখেছেন ({n})",
 "Ninguém da equipe abriu ainda.": "দলের কেউ এখনও খোলেনি।",
 "{nome} em {d}": "{nome}, {d}",
 "Comentários ({n})": "মন্তব্য ({n})",
 "Escreva um comentário": "একটি মন্তব্য লিখুন",
 "Contratos": "চুক্তি",
 "Financeiro do escritório": "অফিসের আর্থিক",
 "RH": "এইচআর",
 "Mover para a pasta": "ফোল্ডারে সরান",
 "Ou escreva o nome de uma pasta nova": "অথবা নতুন ফোল্ডারের নাম লিখুন",
 "Ela se repete toda semana: cancelando, sai de todas as semanas, da lista e dos Recebidos da equipe.": "এটি প্রতি সপ্তাহে পুনরাবৃত্ত হয়: বাতিল করলে সব সপ্তাহ, তালিকা এবং দলের প্রাপ্ত থেকে সরে যাবে।",
 "a equipe toda": "পুরো দল",
 "Com {quem}": "{quem} এর সাথে",
 "toda semana": "প্রতি সপ্তাহে",
 "Vão: {n}": "যাচ্ছেন: {n}",
 "Não vão: {n}": "যাচ্ছেন না: {n}",
 "Vou": "আমি যাব",
 "Não vou": "আমি যাব না",
 "Pauta": "আলোচ্যসূচি",
 "Ata": "কার্যবিবরণী",
 "Escrever a ata": "কার্যবিবরণী লিখুন",
 "Abrir o link": "লিংক খুলুন",
 "Cada pessoa convidada recebe a reunião em Recebidos e coloca no Planner com um toque, com o alerta.": "আমন্ত্রিত প্রত্যেকে প্রাপ্তে মিটিংটি পান এবং এক ট্যাপে অ্যালার্টসহ Planner-এ যোগ করতে পারেন।",
 "Escreva primeiro as anotações da reunião (o que foi falado e decidido); a IA organiza em ata.": "প্রথমে মিটিংয়ের নোট লিখুন (কী বলা হয়েছে ও কী সিদ্ধান্ত হয়েছে); AI সেগুলো কার্যবিবরণীতে সাজিয়ে দেবে।",
 "Ata: {nome}": "কার্যবিবরণী: {nome}",
 "Gerando...": "তৈরি হচ্ছে...",
 "Gerar ata com a minha IA": "আমার AI দিয়ে কার্যবিবরণী তৈরি করুন",
 "A IA organiza a pauta e as suas anotações em ata. Confira antes de salvar.": "AI আলোচ্যসূচি ও আপনার নোট কার্যবিবরণীতে সাজায়। সংরক্ষণের আগে যাচাই করুন।",
 "Ainda sem ata.": "এখনও কোনো কার্যবিবরণী নেই।",
 "Tarefas da reunião ({n})": "মিটিংয়ের কাজ ({n})",
 "Tarefa da reunião": "মিটিংয়ের কাজ",
 "Salvar a ata": "কার্যবিবরণী সংরক্ষণ করুন",
 "Repetir toda semana ({dia})": "প্রতি সপ্তাহে পুনরাবৃত্তি ({dia})",
 "Quem participa": "কারা অংশ নিচ্ছেন",
 "A equipe toda": "পুরো দল",
 "Link externo (opcional: Meet, Zoom, Teams)": "বাহ্যিক লিংক (ঐচ্ছিক: Meet, Zoom, Teams)",
 "O link precisa começar com https://": "লিংক https:// দিয়ে শুরু হতে হবে",
 "Marcar e avisar quem participa": "নির্ধারণ করুন ও অংশগ্রহণকারীদের জানান",
 "Cargo e papel": "পদ ও ভূমিকা",
 "Passar o Admin": "অ্যাডমিন হস্তান্তর",
 "Passar o Admin para {nome}?": "অ্যাডমিন {nome}-কে হস্তান্তর করবেন?",
 "{nome} passa a ser quem cuida do escritório (pode apagá-lo). Você continua na equipe como administrador (quem recebe pode mudar isso depois).": "{nome} অফিসের দায়িত্বে থাকবেন (এটি মুছেও ফেলতে পারবেন)। আপনি প্রশাসক হিসেবে দলে থাকবেন (যিনি পাবেন তিনি পরে তা বদলাতে পারবেন)।",
 "Passar": "হস্তান্তর",
 "{nome} agora cuida do escritório.": "{nome} এখন অফিসের দায়িত্বে আছেন।",
 "Seu papel aqui é \"Só vê\": você acompanha avisos, tarefas, reuniões e documentos.": "এখানে আপনার ভূমিকা \"শুধু দেখে\": আপনি বিজ্ঞপ্তি, কাজ, মিটিং ও নথি অনুসরণ করতে পারেন।",
 "Edita": "সম্পাদনা করে",
 "Incluir": "যোগ করুন",
 "Novo aviso no mural": "নোটিশ বোর্ডে নতুন বিজ্ঞপ্তি",
 "Você só pode ver este escritório: quem administra escolheu o papel \"Só vê\" para você. Peça a quem administra para mudar, se precisar.": "আপনি এই অফিস শুধু দেখতে পারবেন: প্রশাসক আপনার জন্য \"শুধু দেখে\" ভূমিকা বেছে নিয়েছেন। প্রয়োজন হলে প্রশাসককে বদলাতে বলুন।",
 "Quem viu": "কে দেখেছেন",
 "Apagar aviso": "বিজ্ঞপ্তি মুছুন",
 "Mural de avisos": "নোটিশ বোর্ড",
 "Novo aviso": "নতুন বিজ্ঞপ্তি",
 "Ex.: Feriado na sexta: escritório fechado": "যেমন: শুক্রবার ছুটি: অফিস বন্ধ",
 "Fixar no mural": "বোর্ডে পিন করুন",
 "Nenhum aviso. Os avisos ficam fixados aqui para toda a equipe.": "কোনো বিজ্ঞপ্তি নেই। বিজ্ঞপ্তি এখানে পুরো দলের জন্য পিন করা থাকে।",
 "visto por {n} de {m}": "{m} জনের মধ্যে {n} জন দেখেছেন",
 "sem responsável": "দায়িত্বপ্রাপ্ত কেউ নেই",
 "atrasada desde {d}": "{d} থেকে দেরি",
 "prazo {d}": "শেষ তারিখ {d}",
 "Comecei": "শুরু করেছি",
 "Terminei": "শেষ করেছি",
 "Reabrir": "আবার খুলুন",
 "Tarefas da equipe": "দলের কাজ",
 "1 aberta": "১টি খোলা",
 "{n} abertas": "{n}টি খোলা",
 "Minhas tarefas ({n})": "আমার কাজ ({n})",
 "Nenhuma tarefa sua aberta. Toque em \"Eu faço\" numa tarefa da equipe.": "আপনার কোনো কাজ খোলা নেই। দলের কোনো কাজে \"আমি করব\" ট্যাপ করুন।",
 "Nenhuma tarefa aberta.": "কোনো কাজ খোলা নেই।",
 "Feitas ({n})": "সম্পন্ন ({n})",
 "Apagar a tarefa?": "কাজটি মুছবেন?",
 "O que precisa ser feito? (ex.: Apurar o DAS de março)": "কী করতে হবে? (যেমন: মার্চের DAS হিসাব করা)",
 "Cliente (opcional)": "ক্লায়েন্ট (ঐচ্ছিক)",
 "Prazo (opcional)": "শেষ তারিখ (ঐচ্ছিক)",
 "Responsável (opcional; senão, alguém toca em \"Eu faço\")": "দায়িত্বপ্রাপ্ত (ঐচ্ছিক; না হলে কেউ \"আমি করব\" ট্যাপ করবেন)",
 "Escreva a tarefa para poder salvar.": "সংরক্ষণ করতে কাজটি লিখুন।",
 "Membro": "সদস্য",
 "Cargo (livre)": "পদ (ঐচ্ছিক লেখা)",
 "Ex.: Advogada, Assistente, Estagiário": "যেমন: আইনজীবী, সহকারী, ইন্টার্ন",
 "Papel": "ভূমিকা",
 "Admin: pode tudo no escritório.": "অ্যাডমিন: অফিসে সবকিছু করতে পারেন।",
 "Edita: inclui tarefas, avisos, documentos e reuniões": "সম্পাদনা করে: কাজ, বিজ্ঞপ্তি, নথি ও মিটিং যোগ করতে পারে",
 "Só vê: acompanha tudo, sem incluir nem mudar": "শুধু দেখে: সবকিছু অনুসরণ করে, যোগ বা পরিবর্তন করতে পারে না",
 "Proposta": "প্রস্তাব",
 "Documento sensível (pede a senha do app para abrir)": "সংবেদনশীল নথি (খুলতে অ্যাপের পাসওয়ার্ড লাগে)",
 "Li e concordo: {d}": "পড়েছি ও সম্মত: {d}",
 "Li e concordo": "পড়েছি ও সম্মত",
 "Ao tocar em Concordo, o app guarda a data e a hora em que você leu e concordou com \"{doc}\". É um aceite simples: não substitui uma assinatura digital oficial.": "\"সম্মত\" চাপলে অ্যাপ সেই তারিখ ও সময় রাখে যখন আপনি \"{doc}\" পড়ে সম্মতি দিয়েছেন। এটি সাধারণ সম্মতি: এটি সরকারি ডিজিটাল স্বাক্ষরের বিকল্প নয়।",
 "Concordo": "সম্মত",
 "Fotos (escolha quais entram)": "ছবি (কোনগুলো যাবে বেছে নিন)",
 "1 foto não pôde ser lida neste dispositivo e ficou de fora.": "১টি ছবি এই ডিভাইসে পড়া যায়নি, তাই বাদ গেছে।",
 "{n} fotos não puderam ser lidas neste dispositivo e ficaram de fora.": "{n}টি ছবি এই ডিভাইসে পড়া যায়নি, তাই বাদ গেছে।",
 "Nenhuma foto no álbum desta viagem.": "এই ভ্রমণের অ্যালবামে কোনো ছবি নেই।",
 "Toque nas fotos para marcar ou desmarcar. Elas entram reduzidas, para o PDF ficar leve.": "বাছাই বা বাদ দিতে ছবিতে ট্যাপ করুন। PDF হালকা রাখতে ছবি ছোট করে যায়।",
 "Sugerir até 12": "১২টি পর্যন্ত প্রস্তাব",
 "1 foto marcada": "১টি ছবি বাছাই করা",
 "{n} fotos marcadas": "{n}টি ছবি বাছাই করা",
 "Com mais de 12 fotos o PDF fica mais pesado.": "১২টির বেশি ছবিতে PDF ভারী হয়।",
 "Confirme para abrir este documento": "এই নথি খুলতে নিশ্চিত করুন",
 "Como usar esta aba": "এই ট্যাব কীভাবে ব্যবহার করবেন",
 "1 cliente estava em mais de uma aba e virou uma ficha só.": "১ জন গ্রাহক একাধিক ট্যাবে ছিলেন, এখন একটি রেকর্ড হয়েছে।",
 "Juntar {n} fotos num PDF?": "{n}টি ছবি একটি PDF-এ যুক্ত করবেন?",
 "As fotos viram as páginas de um PDF só, na ordem da lista. As fotos soltas saem desta ficha.": "ছবিগুলো তালিকার ক্রমে একটি PDF-এর পাতা হয়ে যাবে। আলাদা ছবিগুলো এই ফাইল থেকে সরে যাবে।",
 "Não foi possível ler as fotos neste dispositivo.": "এই ডিভাইসে ছবিগুলো পড়া যায়নি।",
 "PDF criado": "PDF তৈরি হয়েছে",
 "Montando o PDF...": "PDF তৈরি হচ্ছে...",
 "Juntar as {n} fotos num PDF": "{n}টি ছবি একটি PDF-এ যুক্ত করুন",
 "Baixar o mês": "মাস ডাউনলোড করুন",
 "Os arquivos deste mês estão em outro dispositivo e não puderam ser lidos aqui.": "এই মাসের ফাইলগুলো অন্য ডিভাইসে আছে, এখানে পড়া যায়নি।",
 "Os documentos deste mês não têm arquivos.": "এই মাসের নথিগুলোতে কোনো ফাইল নেই।",
 "1 arquivo está em outro dispositivo e ficou de fora.": "১টি ফাইল অন্য ডিভাইসে আছে, তাই বাদ পড়েছে।",
 "{n} arquivos estão em outro dispositivo e ficaram de fora.": "{n}টি ফাইল অন্য ডিভাইসে আছে, তাই বাদ পড়েছে।",
 "Conversa sobre este documento": "এই নথি নিয়ে আলোচনা",
 "Pergunte ou responda algo sobre este documento. O escritório e o cliente veem.": "এই নথি সম্পর্কে প্রশ্ন করুন বা উত্তর দিন। অফিস ও ক্লায়েন্ট দুজনেই দেখতে পান।",
 "Escreva a mensagem": "বার্তা লিখুন",
 "Usar um modelo de pedido ({n})": "অনুরোধের টেমপ্লেট ব্যবহার করুন ({n})",
 "Lembrar {nome} pelo WhatsApp: {o}": "WhatsApp-এ {nome}-কে মনে করিয়ে দিন: {o}",
 "Sem honorário": "কোনো ফি নেই",
 "Cadastre o valor do honorário no bloco \"Escritório\" da ficha do cliente, em Meus clientes.": "\"আমার ক্লায়েন্ট\"-এ ক্লায়েন্টের ফাইলের \"অফিস\" ব্লকে ফির পরিমাণ লিখুন।",
 "Recebi de {c} a quantia de {v}, referente aos honorários da competência {m}.": "{c}-এর কাছ থেকে {v} পরিমাণ অর্থ পেয়েছি, যা {m} সময়কালের ফি বাবদ।",
 "Recibo honorário {m} {c}": "ফি রসিদ {m} {c}",
 "Recibo do honorário {m}": "ফি রসিদ {m}",
 "Recibo criado": "রসিদ তৈরি হয়েছে",
 "O recibo entrou em Documentos, na competência {m}.": "রসিদটি নথিতে {m} সময়কালে যুক্ত হয়েছে।",
 "Vendo como o cliente": "ক্লায়েন্ট হিসেবে দেখছেন",
 "É assim que o cliente vê a pasta dele: sem as anotações internas e sem o que é só da equipe. Nada pode ser mudado neste modo.": "ক্লায়েন্ট তাঁর ফোল্ডার এভাবেই দেখেন: অভ্যন্তরীণ নোট ও শুধু টিমের জন্য থাকা বিষয় ছাড়া। এই মোডে কিছুই পরিবর্তন করা যায় না।",
 "Voltar a ver como escritório": "আবার অফিস হিসেবে দেখুন",
 "Ver como o cliente": "ক্লায়েন্ট হিসেবে দেখুন",
 "🔒 Anotações internas (o cliente nunca vê)": "🔒 অভ্যন্তরীণ নোট (ক্লায়েন্ট কখনো দেখেন না)",
 "Recibo do honorário…": "ফি রসিদ…",
 "Competência do recibo": "রসিদের সময়কাল",
 "⬇️ Baixar o mês": "⬇️ মাস ডাউনলোড করুন",
 "Me avisar para lembrar o cliente": "ক্লায়েন্টকে মনে করাতে আমাকে জানান",
 "Guardar como modelo": "টেমপ্লেট হিসেবে সংরক্ষণ করুন",
 "Modelo guardado": "টেমপ্লেট সংরক্ষিত হয়েছে",
 "Ao criar um pedido para qualquer cliente, toque em \"Usar um modelo de pedido\".": "যেকোনো ক্লায়েন্টের জন্য অনুরোধ তৈরি করার সময় \"অনুরোধের টেমপ্লেট ব্যবহার করুন\"-এ ট্যাপ করুন।",
 "Relatório do mês": "মাসিক প্রতিবেদন",
 "Notas rápidas": "দ্রুত নোট",
 "Item completo: {o}": "সম্পূর্ণ আইটেম: {o}",
 "Reuniões do mês": "এই মাসের সভা",
 "Tarefas feitas e pendentes": "সম্পন্ন ও বাকি কাজ",
 "Documentos internos enviados": "পাঠানো অভ্যন্তরীণ নথি",
 "Documentos enviados e recebidos dos clientes": "ক্লায়েন্টদের পাঠানো ও তাঁদের কাছ থেকে পাওয়া নথি",
 "Documentos da competência": "সময়কালের নথি",
 "Guias pagas e vencidas": "পরিশোধিত ও মেয়াদোত্তীর্ণ ট্যাক্স স্লিপ",
 "Honorários": "ফি",
 "Relatório do mês · {m}": "মাসিক প্রতিবেদন · {m}",
 "Reuniões ({n})": "সভা ({n})",
 "Tarefas: {f} feitas no mês · {p} pendentes": "কাজ: মাসে {f}টি সম্পন্ন · {p}টি বাকি",
 "Quem fez": "কে করেছেন",
 "Feita em": "সম্পন্ন হয়েছে",
 "Documentos internos enviados ({n})": "পাঠানো অভ্যন্তরীণ নথি ({n})",
 "Documentos trocados com os clientes": "ক্লায়েন্টদের সঙ্গে আদান-প্রদান করা নথি",
 "Enviados pelo escritório": "অফিস থেকে পাঠানো",
 "Recebidos do cliente": "ক্লায়েন্টের কাছ থেকে পাওয়া",
 "Nenhum documento trocado neste mês.": "এই মাসে কোনো নথি আদান-প্রদান হয়নি।",
 "Clientes com pendência ({n})": "বাকি কাজ আছে এমন ক্লায়েন্ট ({n})",
 "Pendência": "বাকি বিষয়",
 "Nenhum cliente com pendência.": "কোনো ক্লায়েন্টের বাকি বিষয় নেই।",
 "Documentos da competência {m} ({n})": "{m} সময়কালের নথি ({n})",
 "Pedidos de documentos ({n})": "নথির অনুরোধ ({n})",
 "Guias do mês: {p} pagas · {v} vencidas": "মাসের ট্যাক্স স্লিপ: {p}টি পরিশোধিত · {v}টি মেয়াদোত্তীর্ণ",
 "Vencida": "মেয়াদোত্তীর্ণ",
 "Recebido no mês": "মাসে প্রাপ্ত",
 "Relatório {m} {q}": "প্রতিবেদন {m} {q}",
 "MÊS": "মাস",
 "DE QUEM": "কার",
 "O escritório": "অফিস",
 "Reuniões, tarefas e documentos internos entram quando há um escritório (equipe).": "অফিস (টিম) থাকলে সভা, কাজ ও অভ্যন্তরীণ নথি অন্তর্ভুক্ত হয়।",
 "CPF, CNPJ, anotações internas e conversas nunca vão para o relatório.": "CPF, CNPJ, অভ্যন্তরীণ নোট ও আলোচনা কখনো প্রতিবেদনে যায় না।",
 "Anotações recebidas": "প্রাপ্ত নোট",
 "Os valores a receber desta lista aparecem no My Planner, inclusive os novos.": "এই তালিকার পাওনা টাকা My Planner-এ দেখা যায়, নতুনগুলোও।",
 "Envia só os valores a receber desta lista (as consultas já vão sozinhas), inclusive os novos.": "এই তালিকার শুধু পাওনা টাকা পাঠায় (অ্যাপয়েন্টমেন্ট নিজে থেকেই যায়), নতুনগুলোও।",
 "Acrescentar": "যোগ করুন",
 "As {n} caixas estão em {aba}, em \"Anotações recebidas\".": "{n}টি বাক্স {aba}-এ, \"পাওয়া নোট\"-এ আছে।",
 "Enviadas": "পাঠানো হয়েছে",
 "Enviar para": "পাঠান",
 "Excluir 1 item?": "1টি আইটেম মুছবেন?",
 "Excluir {n} itens?": "{n}টি আইটেম মুছবেন?",
 "Inserir abaixo": "নিচে যোগ করুন",
 "Mover para": "সরান",
 "Mover {n} selecionados para": "{n}টি নির্বাচিত সরান",
 "adicionar aqui": "এখানে যোগ করুন",
 "continue segurando para selecionar": "নির্বাচন করতে ধরে রাখুন"
}
